(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as SS, getPartnerDevApiHeaders as NS, WidgetContextProvider as jS, makeExecuteQuery as wS, makeUseLazyQuery as CS, makeUseQuery as FS, makeUseMutation as IS, validateApiHostName as mb, useTracking as kn, useWidgetContext as un, hasDownstreamApiForbiddenError as Sm, hasDownstreamApiAuthorizationError as Nm, DisplayErrors as Fn, useCopyWithDelay as nr, defaultDateFormat as dt, displayAttributeValue as pb, OAuthSettings as Ja, useData as jm, isDownstreamApiNotFoundError as ES, isDownstreamApiAuthorizationError as fb, KlaviyoSubscribeSetting as TS, isDownstreamApiPermissionError as $S, capitalizeFirstCharacter as Is, hasDownstreamApiTooManyRequestsError as DS, hasDownstreamApiPermissionError as hb, hasDownstreamApiNotFoundError as Qa, getCountryNameFromCountryCode as RS, useInboundOAuthContext as OS } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Se, { useMemo as Kn, useState as se, useEffect as He, useRef as ui, useCallback as tt, useReducer as PS, useLayoutEffect as AS, useContext as wm, createContext as yb, isValidElement as LS, createElement as VS, Fragment as zS } from "react";
import { Modal as gt, ModalHead as vt, ModalBody as kt, ModalFoot as Ct, Text as A, FlexBox as b, Spinner as cn, Icon as ue, Tooltip as Ge, List as We, Badge as Un, Button as Wn, IconButton as Yt, Tag as Pn, NavigationButton as wt, Select as _r, CollapseCard as or, Box as Qn, FormGrid as Ut, FormField as tn, FieldWrapper as Ln, InputText as kr, Textarea as Bu, TagsInput as Es, Image as zi, Banner as Ts, Divider as Cm, InputSelectionList as Yr, SelectionList as ot, FieldText as sr, FieldTextarea as US, CopyToClipboardButton as MS, getSelectionListContext as BS, Avatar as Fm, Timestamp as qS, Attachment as HS, Switch as qu, FieldLabel as WS, EmptyState as os, Table as Xn, Checkbox as Bp, TextWithHighlight as KS, ErrorBoundaryContext as gb, FieldSwitch as vb } from "@dixa/lib-shared-habla";
import { ApolloLink as Im, Observable as kb, ApolloClient as GS, InMemoryCache as YS, createHttpLink as JS, ApolloProvider as QS, useApolloClient as XS, ApolloConsumer as ZS, NetworkStatus as Gt, isApolloError as bb, ApolloError as e0, gql as Zr, useQuery as n0, useMutation as qp } from "@apollo/client";
import t0 from "cross-fetch";
import { config as Wa } from "lib-shared-backend-config";
import ut from "classnames";
import An from "moment";
import { __rest as r0, __assign as Zs } from "tslib";
import "moment-timezone";
import { useLocation as i0 } from "react-router-dom";
function Em(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var uo = { exports: {} }, Yi = {};
var Hp;
function a0() {
  if (Hp) return Yi;
  Hp = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Yi.Fragment = r, Yi.jsx = s, Yi.jsxs = s, Yi;
}
var Ji = {};
var Wp;
function o0() {
  return Wp || (Wp = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c, P));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    Ji.Fragment = i, Ji.jsx = Rn, Ji.jsxs = Bn;
  })()), Ji;
}
var Kp;
function s0() {
  return Kp || (Kp = 1, process.env.NODE_ENV === "production" ? uo.exports = a0() : uo.exports = o0()), uo.exports;
}
var ze = s0();
function _b(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: l0 } = Object.prototype, { getPrototypeOf: Tm } = Object, { iterator: $s, toStringTag: xb } = Symbol, Ds = /* @__PURE__ */ ((e) => (n) => {
  const r = l0.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), xr = (e) => (e = e.toLowerCase(), (n) => Ds(n) === e), Rs = (e) => (n) => typeof n === e, { isArray: Ui } = Array, Pi = Rs("undefined");
function Xa(e) {
  return e !== null && !Pi(e) && e.constructor !== null && !Pi(e.constructor) && Ht(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Sb = xr("ArrayBuffer");
function c0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Sb(e.buffer), n;
}
const d0 = Rs("string"), Ht = Rs("function"), Nb = Rs("number"), Za = (e) => e !== null && typeof e == "object", u0 = (e) => e === !0 || e === !1, Bo = (e) => {
  if (Ds(e) !== "object")
    return !1;
  const n = Tm(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(xb in e) && !($s in e);
}, m0 = (e) => {
  if (!Za(e) || Xa(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, p0 = xr("Date"), f0 = xr("File"), h0 = xr("Blob"), y0 = xr("FileList"), g0 = (e) => Za(e) && Ht(e.pipe), v0 = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || Ht(e.append) && ((n = Ds(e)) === "formdata" || // detect form-data instance
  n === "object" && Ht(e.toString) && e.toString() === "[object FormData]"));
}, k0 = xr("URLSearchParams"), [b0, _0, x0, S0] = ["ReadableStream", "Request", "Response", "Headers"].map(xr), N0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function eo(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Ui(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Xa(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function jb(e, n) {
  if (Xa(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const si = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, wb = (e) => !Pi(e) && e !== si;
function Hu() {
  const { caseless: e, skipUndefined: n } = wb(this) && this || {}, r = {}, i = (a, o) => {
    const s = e && jb(r, o) || o;
    Bo(r[s]) && Bo(a) ? r[s] = Hu(r[s], a) : Bo(a) ? r[s] = Hu({}, a) : Ui(a) ? r[s] = a.slice() : (!n || !Pi(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && eo(arguments[a], i);
  return r;
}
const j0 = (e, n, r, { allOwnKeys: i } = {}) => (eo(n, (a, o) => {
  r && Ht(a) ? e[o] = _b(a, r) : e[o] = a;
}, { allOwnKeys: i }), e), w0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), C0 = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, F0 = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Tm(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, I0 = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, E0 = (e) => {
  if (!e) return null;
  if (Ui(e)) return e;
  let n = e.length;
  if (!Nb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, T0 = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Tm(Uint8Array)), $0 = (e, n) => {
  const i = (e && e[$s]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, D0 = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, R0 = xr("HTMLFormElement"), O0 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, i, a) {
    return i.toUpperCase() + a;
  }
), Gp = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), P0 = xr("RegExp"), Cb = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  eo(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, A0 = (e) => {
  Cb(e, (n, r) => {
    if (Ht(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Ht(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, L0 = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Ui(e) ? i(e) : i(String(e).split(n)), r;
}, V0 = () => {
}, z0 = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function U0(e) {
  return !!(e && Ht(e.append) && e[xb] === "FormData" && e[$s]);
}
const M0 = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (Za(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (Xa(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Ui(i) ? [] : {};
        return eo(i, (s, l) => {
          const d = r(s, a + 1);
          !Pi(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, B0 = xr("AsyncFunction"), q0 = (e) => e && (Za(e) || Ht(e)) && Ht(e.then) && Ht(e.catch), Fb = ((e, n) => e ? setImmediate : n ? ((r, i) => (si.addEventListener("message", ({ source: a, data: o }) => {
  a === si && o === r && i.length && i.shift()();
}, !1), (a) => {
  i.push(a), si.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Ht(si.postMessage)
), H0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(si) : typeof process < "u" && process.nextTick || Fb, W0 = (e) => e != null && Ht(e[$s]), ge = {
  isArray: Ui,
  isArrayBuffer: Sb,
  isBuffer: Xa,
  isFormData: v0,
  isArrayBufferView: c0,
  isString: d0,
  isNumber: Nb,
  isBoolean: u0,
  isObject: Za,
  isPlainObject: Bo,
  isEmptyObject: m0,
  isReadableStream: b0,
  isRequest: _0,
  isResponse: x0,
  isHeaders: S0,
  isUndefined: Pi,
  isDate: p0,
  isFile: f0,
  isBlob: h0,
  isRegExp: P0,
  isFunction: Ht,
  isStream: g0,
  isURLSearchParams: k0,
  isTypedArray: T0,
  isFileList: y0,
  forEach: eo,
  merge: Hu,
  extend: j0,
  trim: N0,
  stripBOM: w0,
  inherits: C0,
  toFlatObject: F0,
  kindOf: Ds,
  kindOfTest: xr,
  endsWith: I0,
  toArray: E0,
  forEachEntry: $0,
  matchAll: D0,
  isHTMLForm: R0,
  hasOwnProperty: Gp,
  hasOwnProp: Gp,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Cb,
  freezeMethods: A0,
  toObjectSet: L0,
  toCamelCase: O0,
  noop: V0,
  toFiniteNumber: z0,
  findKey: jb,
  global: si,
  isContextDefined: wb,
  isSpecCompliantForm: U0,
  toJSONObject: M0,
  isAsyncFn: B0,
  isThenable: q0,
  setImmediate: Fb,
  asap: H0,
  isIterable: W0
};
function Cn(e, n, r, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), r && (this.config = r), i && (this.request = i), a && (this.response = a, this.status = a.status ? a.status : null);
}
ge.inherits(Cn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ge.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ib = Cn.prototype, Eb = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Eb[e] = { value: e };
});
Object.defineProperties(Cn, Eb);
Object.defineProperty(Ib, "isAxiosError", { value: !0 });
Cn.from = (e, n, r, i, a, o) => {
  const s = Object.create(Ib);
  ge.toFlatObject(e, s, function(u) {
    return u !== Error.prototype;
  }, (m) => m !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", d = n == null && e ? e.code : n;
  return Cn.call(s, l, d, r, i, a), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", o && Object.assign(s, o), s;
};
const K0 = null;
function Wu(e) {
  return ge.isPlainObject(e) || ge.isArray(e);
}
function Tb(e) {
  return ge.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Yp(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Tb(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function G0(e) {
  return ge.isArray(e) && !e.some(Wu);
}
const Y0 = ge.toFlatObject(ge, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Os(e, n, r) {
  if (!ge.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ge.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(S, w) {
    return !ge.isUndefined(w[S]);
  });
  const i = r.metaTokens, a = r.visitor || u, o = r.dots, s = r.indexes, d = (r.Blob || typeof Blob < "u" && Blob) && ge.isSpecCompliantForm(n);
  if (!ge.isFunction(a))
    throw new TypeError("visitor must be a function");
  function m(N) {
    if (N === null) return "";
    if (ge.isDate(N))
      return N.toISOString();
    if (ge.isBoolean(N))
      return N.toString();
    if (!d && ge.isBlob(N))
      throw new Cn("Blob is not supported. Use a Buffer instead.");
    return ge.isArrayBuffer(N) || ge.isTypedArray(N) ? d && typeof Blob == "function" ? new Blob([N]) : Buffer.from(N) : N;
  }
  function u(N, S, w) {
    let C = N;
    if (N && !w && typeof N == "object") {
      if (ge.endsWith(S, "{}"))
        S = i ? S : S.slice(0, -2), N = JSON.stringify(N);
      else if (ge.isArray(N) && G0(N) || (ge.isFileList(N) || ge.endsWith(S, "[]")) && (C = ge.toArray(N)))
        return S = Tb(S), C.forEach(function(q, $) {
          !(ge.isUndefined(q) || q === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Yp([S], $, o) : s === null ? S : S + "[]",
            m(q)
          );
        }), !1;
    }
    return Wu(N) ? !0 : (n.append(Yp(w, S, o), m(N)), !1);
  }
  const f = [], h = Object.assign(Y0, {
    defaultVisitor: u,
    convertValue: m,
    isVisitable: Wu
  });
  function k(N, S) {
    if (!ge.isUndefined(N)) {
      if (f.indexOf(N) !== -1)
        throw Error("Circular reference detected in " + S.join("."));
      f.push(N), ge.forEach(N, function(C, g) {
        (!(ge.isUndefined(C) || C === null) && a.call(
          n,
          C,
          ge.isString(g) ? g.trim() : g,
          S,
          h
        )) === !0 && k(C, S ? S.concat(g) : [g]);
      }), f.pop();
    }
  }
  if (!ge.isObject(e))
    throw new TypeError("data must be an object");
  return k(e), n;
}
function Jp(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function $m(e, n) {
  this._pairs = [], e && Os(e, this, n);
}
const $b = $m.prototype;
$b.append = function(n, r) {
  this._pairs.push([n, r]);
};
$b.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, Jp);
  } : Jp;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function J0(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Db(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || J0;
  ge.isFunction(r) && (r = {
    serialize: r
  });
  const a = r && r.serialize;
  let o;
  if (a ? o = a(n, r) : o = ge.isURLSearchParams(n) ? n.toString() : new $m(n, r).toString(i), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Qp {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ge.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Rb = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Q0 = typeof URLSearchParams < "u" ? URLSearchParams : $m, X0 = typeof FormData < "u" ? FormData : null, Z0 = typeof Blob < "u" ? Blob : null, eN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Q0,
    FormData: X0,
    Blob: Z0
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Dm = typeof window < "u" && typeof document < "u", Ku = typeof navigator == "object" && navigator || void 0, nN = Dm && (!Ku || ["ReactNative", "NativeScript", "NS"].indexOf(Ku.product) < 0), tN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", rN = Dm && window.location.href || "http://localhost", iN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Dm,
  hasStandardBrowserEnv: nN,
  hasStandardBrowserWebWorkerEnv: tN,
  navigator: Ku,
  origin: rN
}, Symbol.toStringTag, { value: "Module" })), Ft = {
  ...iN,
  ...eN
};
function aN(e, n) {
  return Os(e, new Ft.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ft.isNode && ge.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function oN(e) {
  return ge.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function sN(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Ob(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ge.isArray(a) ? a.length : s, d ? (ge.hasOwnProp(a, s) ? a[s] = [a[s], i] : a[s] = i, !l) : ((!a[s] || !ge.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ge.isArray(a[s]) && (a[s] = sN(a[s])), !l);
  }
  if (ge.isFormData(e) && ge.isFunction(e.entries)) {
    const r = {};
    return ge.forEachEntry(e, (i, a) => {
      n(oN(i), a, r, 0);
    }), r;
  }
  return null;
}
function lN(e, n, r) {
  if (ge.isString(e))
    try {
      return (n || JSON.parse)(e), ge.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const no = {
  transitional: Rb,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, r) {
    const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ge.isObject(n);
    if (o && ge.isHTMLForm(n) && (n = new FormData(n)), ge.isFormData(n))
      return a ? JSON.stringify(Ob(n)) : n;
    if (ge.isArrayBuffer(n) || ge.isBuffer(n) || ge.isStream(n) || ge.isFile(n) || ge.isBlob(n) || ge.isReadableStream(n))
      return n;
    if (ge.isArrayBufferView(n))
      return n.buffer;
    if (ge.isURLSearchParams(n))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let l;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return aN(n, this.formSerializer).toString();
      if ((l = ge.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return Os(
          l ? { "files[]": n } : n,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r.setContentType("application/json", !1), lN(n)) : n;
  }],
  transformResponse: [function(n) {
    const r = this.transitional || no.transitional, i = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (ge.isResponse(n) || ge.isReadableStream(n))
      return n;
    if (n && ge.isString(n) && (i && !this.responseType || a)) {
      const s = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(n, this.parseReviver);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? Cn.from(l, Cn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ft.classes.FormData,
    Blob: Ft.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ge.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  no.headers[e] = {};
});
const cN = ge.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), dN = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && cN[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, Xp = Symbol("internals");
function Qi(e) {
  return e && String(e).trim().toLowerCase();
}
function qo(e) {
  return e === !1 || e == null ? e : ge.isArray(e) ? e.map(qo) : String(e);
}
function uN(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const mN = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function el(e, n, r, i, a) {
  if (ge.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ge.isString(n)) {
    if (ge.isString(i))
      return n.indexOf(i) !== -1;
    if (ge.isRegExp(i))
      return i.test(n);
  }
}
function pN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function fN(e, n) {
  const r = ge.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Wt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = Qi(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ge.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = qo(l));
    }
    const s = (l, d) => ge.forEach(l, (m, u) => o(m, u, d));
    if (ge.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ge.isString(n) && (n = n.trim()) && !mN(n))
      s(dN(n), r);
    else if (ge.isObject(n) && ge.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ge.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ge.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Qi(n), n) {
      const i = ge.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return uN(a);
        if (ge.isFunction(r))
          return r.call(this, a, i);
        if (ge.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Qi(n), n) {
      const i = ge.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || el(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Qi(s), s) {
        const l = ge.findKey(i, s);
        l && (!r || el(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || el(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ge.forEach(this, (a, o) => {
      const s = ge.findKey(i, o);
      if (s) {
        r[s] = qo(a), delete r[o];
        return;
      }
      const l = n ? pN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = qo(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ge.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ge.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Xp] = this[Xp] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Qi(s);
      i[l] || (fN(a, s), i[l] = !0);
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Wt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ge.reduceDescriptors(Wt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ge.freezeMethods(Wt);
function nl(e, n) {
  const r = this || no, i = n || r, a = Wt.from(i.headers);
  let o = i.data;
  return ge.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Pb(e) {
  return !!(e && e.__CANCEL__);
}
function Mi(e, n, r) {
  Cn.call(this, e ?? "canceled", Cn.ERR_CANCELED, n, r), this.name = "CanceledError";
}
ge.inherits(Mi, Cn, {
  __CANCEL__: !0
});
function Ab(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new Cn(
    "Request failed with status code " + r.status,
    [Cn.ERR_BAD_REQUEST, Cn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function hN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function yN(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const k = u && m - u;
    return k ? Math.round(h * 1e3 / k) : void 0;
  };
}
function gN(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const ss = (e, n, r = 3) => {
  let i = 0;
  const a = yN(50, 250);
  return gN((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = s - i, m = a(d), u = s <= l;
    i = s;
    const f = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: d,
      rate: m || void 0,
      estimated: m && l && u ? (l - s) / m : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, Zp = (e, n) => {
  const r = e != null;
  return [(i) => n[0]({
    lengthComputable: r,
    total: e,
    loaded: i
  }), n[1]];
}, ef = (e) => (...n) => ge.asap(() => e(...n)), vN = Ft.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ft.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ft.origin),
  Ft.navigator && /(msie|trident)/i.test(Ft.navigator.userAgent)
) : () => !0, kN = Ft.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o) {
      const s = [e + "=" + encodeURIComponent(n)];
      ge.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), ge.isString(i) && s.push("path=" + i), ge.isString(a) && s.push("domain=" + a), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function bN(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function _N(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function Lb(e, n, r) {
  let i = !bN(n);
  return e && (i || r == !1) ? _N(e, n) : n;
}
const nf = (e) => e instanceof Wt ? { ...e } : e;
function yi(e, n) {
  n = n || {};
  const r = {};
  function i(m, u, f, h) {
    return ge.isPlainObject(m) && ge.isPlainObject(u) ? ge.merge.call({ caseless: h }, m, u) : ge.isPlainObject(u) ? ge.merge({}, u) : ge.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ge.isUndefined(u)) {
      if (!ge.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ge.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ge.isUndefined(u)) {
      if (!ge.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (f in n)
      return i(m, u);
    if (f in e)
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(nf(m), nf(u), f, !0)
  };
  return ge.forEach(Object.keys({ ...e, ...n }), function(u) {
    const f = d[u] || a, h = f(e[u], n[u], u);
    ge.isUndefined(h) && f !== l || (r[u] = h);
  }), r;
}
const Vb = (e) => {
  const n = yi({}, e);
  let { data: r, withXSRFToken: i, xsrfHeaderName: a, xsrfCookieName: o, headers: s, auth: l } = n;
  if (n.headers = s = Wt.from(s), n.url = Db(Lb(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), ge.isFormData(r)) {
    if (Ft.hasStandardBrowserEnv || Ft.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (ge.isFunction(r.getHeaders)) {
      const d = r.getHeaders(), m = ["content-type", "content-length"];
      Object.entries(d).forEach(([u, f]) => {
        m.includes(u.toLowerCase()) && s.set(u, f);
      });
    }
  }
  if (Ft.hasStandardBrowserEnv && (i && ge.isFunction(i) && (i = i(n)), i || i !== !1 && vN(n.url))) {
    const d = a && o && kN.read(o);
    d && s.set(a, d);
  }
  return n;
}, xN = typeof XMLHttpRequest < "u", SN = xN && function(e) {
  return new Promise(function(r, i) {
    const a = Vb(e);
    let o = a.data;
    const s = Wt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, k, N;
    function S() {
      k && k(), N && N(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let w = new XMLHttpRequest();
    w.open(a.method.toUpperCase(), a.url, !0), w.timeout = a.timeout;
    function C() {
      if (!w)
        return;
      const q = Wt.from(
        "getAllResponseHeaders" in w && w.getAllResponseHeaders()
      ), E = {
        data: !l || l === "text" || l === "json" ? w.responseText : w.response,
        status: w.status,
        statusText: w.statusText,
        headers: q,
        config: e,
        request: w
      };
      Ab(function(z) {
        r(z), S();
      }, function(z) {
        i(z), S();
      }, E), w = null;
    }
    "onloadend" in w ? w.onloadend = C : w.onreadystatechange = function() {
      !w || w.readyState !== 4 || w.status === 0 && !(w.responseURL && w.responseURL.indexOf("file:") === 0) || setTimeout(C);
    }, w.onabort = function() {
      w && (i(new Cn("Request aborted", Cn.ECONNABORTED, e, w)), w = null);
    }, w.onerror = function($) {
      const E = $ && $.message ? $.message : "Network Error", D = new Cn(E, Cn.ERR_NETWORK, e, w);
      D.event = $ || null, i(D), w = null;
    }, w.ontimeout = function() {
      let $ = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const E = a.transitional || Rb;
      a.timeoutErrorMessage && ($ = a.timeoutErrorMessage), i(new Cn(
        $,
        E.clarifyTimeoutError ? Cn.ETIMEDOUT : Cn.ECONNABORTED,
        e,
        w
      )), w = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in w && ge.forEach(s.toJSON(), function($, E) {
      w.setRequestHeader(E, $);
    }), ge.isUndefined(a.withCredentials) || (w.withCredentials = !!a.withCredentials), l && l !== "json" && (w.responseType = a.responseType), m && ([h, N] = ss(m, !0), w.addEventListener("progress", h)), d && w.upload && ([f, k] = ss(d), w.upload.addEventListener("progress", f), w.upload.addEventListener("loadend", k)), (a.cancelToken || a.signal) && (u = (q) => {
      w && (i(!q || q.type ? new Mi(null, e, w) : q), w.abort(), w = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = hN(a.url);
    if (g && Ft.protocols.indexOf(g) === -1) {
      i(new Cn("Unsupported protocol " + g + ":", Cn.ERR_BAD_REQUEST, e));
      return;
    }
    w.send(o || null);
  });
}, NN = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(u instanceof Cn ? u : new Mi(u instanceof Error ? u.message : u));
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new Cn(`timeout ${n} of ms exceeded`, Cn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ge.asap(l), d;
  }
}, jN = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, wN = async function* (e, n) {
  for await (const r of CN(e))
    yield* jN(r, n);
}, CN = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, tf = (e, n, r, i) => {
  const a = wN(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: m, value: u } = await a.next();
        if (m) {
          l(), d.close();
          return;
        }
        let f = u.byteLength;
        if (r) {
          let h = o += f;
          r(h);
        }
        d.enqueue(new Uint8Array(u));
      } catch (m) {
        throw l(m), m;
      }
    },
    cancel(d) {
      return l(d), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, rf = 64 * 1024, { isFunction: mo } = ge, FN = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ge.global), {
  ReadableStream: af,
  TextEncoder: of
} = ge.global, sf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, IN = (e) => {
  e = ge.merge.call({
    skipUndefined: !0
  }, FN, e);
  const { fetch: n, Request: r, Response: i } = e, a = n ? mo(n) : typeof fetch == "function", o = mo(r), s = mo(i);
  if (!a)
    return !1;
  const l = a && mo(af), d = a && (typeof of == "function" ? /* @__PURE__ */ ((N) => (S) => N.encode(S))(new of()) : async (N) => new Uint8Array(await new r(N).arrayBuffer())), m = o && l && sf(() => {
    let N = !1;
    const S = new r(Ft.origin, {
      body: new af(),
      method: "POST",
      get duplex() {
        return N = !0, "half";
      }
    }).headers.has("Content-Type");
    return N && !S;
  }), u = s && l && sf(() => ge.isReadableStream(new i("").body)), f = {
    stream: u && ((N) => N.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((N) => {
    !f[N] && (f[N] = (S, w) => {
      let C = S && S[N];
      if (C)
        return C.call(S);
      throw new Cn(`Response type '${N}' is not supported`, Cn.ERR_NOT_SUPPORT, w);
    });
  });
  const h = async (N) => {
    if (N == null)
      return 0;
    if (ge.isBlob(N))
      return N.size;
    if (ge.isSpecCompliantForm(N))
      return (await new r(Ft.origin, {
        method: "POST",
        body: N
      }).arrayBuffer()).byteLength;
    if (ge.isArrayBufferView(N) || ge.isArrayBuffer(N))
      return N.byteLength;
    if (ge.isURLSearchParams(N) && (N = N + ""), ge.isString(N))
      return (await d(N)).byteLength;
  }, k = async (N, S) => {
    const w = ge.toFiniteNumber(N.getContentLength());
    return w ?? h(S);
  };
  return async (N) => {
    let {
      url: S,
      method: w,
      data: C,
      signal: g,
      cancelToken: q,
      timeout: $,
      onDownloadProgress: E,
      onUploadProgress: D,
      responseType: z,
      headers: Z,
      withCredentials: Q = "same-origin",
      fetchOptions: te
    } = Vb(N), Y = n || fetch;
    z = z ? (z + "").toLowerCase() : "text";
    let B = NN([g, q && q.toAbortSignal()], $), R = null;
    const H = B && B.unsubscribe && (() => {
      B.unsubscribe();
    });
    let ne;
    try {
      if (D && m && w !== "get" && w !== "head" && (ne = await k(Z, C)) !== 0) {
        let be = new r(S, {
          method: "POST",
          body: C,
          duplex: "half"
        }), Ce;
        if (ge.isFormData(C) && (Ce = be.headers.get("content-type")) && Z.setContentType(Ce), be.body) {
          const [K, qe] = Zp(
            ne,
            ss(ef(D))
          );
          C = tf(be.body, rf, K, qe);
        }
      }
      ge.isString(Q) || (Q = Q ? "include" : "omit");
      const ve = o && "credentials" in r.prototype, de = {
        ...te,
        signal: B,
        method: w.toUpperCase(),
        headers: Z.normalize().toJSON(),
        body: C,
        duplex: "half",
        credentials: ve ? Q : void 0
      };
      R = o && new r(S, de);
      let le = await (o ? Y(R, te) : Y(S, de));
      const fe = u && (z === "stream" || z === "response");
      if (u && (E || fe && H)) {
        const be = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          be[Be] = le[Be];
        });
        const Ce = ge.toFiniteNumber(le.headers.get("content-length")), [K, qe] = E && Zp(
          Ce,
          ss(ef(E), !0)
        ) || [];
        le = new i(
          tf(le.body, rf, K, () => {
            qe && qe(), H && H();
          }),
          be
        );
      }
      z = z || "text";
      let W = await f[ge.findKey(f, z) || "text"](le, N);
      return !fe && H && H(), await new Promise((be, Ce) => {
        Ab(be, Ce, {
          data: W,
          headers: Wt.from(le.headers),
          status: le.status,
          statusText: le.statusText,
          config: N,
          request: R
        });
      });
    } catch (ve) {
      throw H && H(), ve && ve.name === "TypeError" && /Load failed|fetch/i.test(ve.message) ? Object.assign(
        new Cn("Network Error", Cn.ERR_NETWORK, N, R),
        {
          cause: ve.cause || ve
        }
      ) : Cn.from(ve, ve && ve.code, N, R);
    }
  };
}, EN = /* @__PURE__ */ new Map(), zb = (e) => {
  let n = e ? e.env : {};
  const { fetch: r, Request: i, Response: a } = n, o = [
    i,
    a,
    r
  ];
  let s = o.length, l = s, d, m, u = EN;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : IN(n)), u = m;
  return m;
};
zb();
const Gu = {
  http: K0,
  xhr: SN,
  fetch: {
    get: zb
  }
};
ge.forEach(Gu, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const lf = (e) => `- ${e}`, TN = (e) => ge.isFunction(e) || e === null || e === !1, Ub = {
  getAdapter: (e, n) => {
    e = ge.isArray(e) ? e : [e];
    const { length: r } = e;
    let i, a;
    const o = {};
    for (let s = 0; s < r; s++) {
      i = e[s];
      let l;
      if (a = i, !TN(i) && (a = Gu[(l = String(i)).toLowerCase()], a === void 0))
        throw new Cn(`Unknown adapter '${l}'`);
      if (a && (ge.isFunction(a) || (a = a.get(n))))
        break;
      o[l || "#" + s] = a;
    }
    if (!a) {
      const s = Object.entries(o).map(
        ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = r ? s.length > 1 ? `since :
` + s.map(lf).join(`
`) : " " + lf(s[0]) : "as no adapter specified";
      throw new Cn(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: Gu
};
function tl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Mi(null, e);
}
function cf(e) {
  return tl(e), e.headers = Wt.from(e.headers), e.data = nl.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ub.getAdapter(e.adapter || no.adapter, e)(e).then(function(i) {
    return tl(e), i.data = nl.call(
      e,
      e.transformResponse,
      i
    ), i.headers = Wt.from(i.headers), i;
  }, function(i) {
    return Pb(i) || (tl(e), i && i.response && (i.response.data = nl.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = Wt.from(i.response.headers))), Promise.reject(i);
  });
}
const Mb = "1.12.2", Ps = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Ps[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const df = {};
Ps.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + Mb + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new Cn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        Cn.ERR_DEPRECATED
      );
    return r && !df[s] && (df[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Ps.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function $N(e, n, r) {
  if (typeof e != "object")
    throw new Cn("options must be an object", Cn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = n[o];
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new Cn("option " + o + " must be " + d, Cn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Cn("Unknown option " + o, Cn.ERR_BAD_OPTION);
  }
}
const Ho = {
  assertOptions: $N,
  validators: Ps
}, Sr = Ho.validators;
let mi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Qp(),
      response: new Qp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? o && !String(i.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + o) : i.stack = o;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = yi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Ho.assertOptions(i, {
      silentJSONParsing: Sr.transitional(Sr.boolean),
      forcedJSONParsing: Sr.transitional(Sr.boolean),
      clarifyTimeoutError: Sr.transitional(Sr.boolean)
    }, !1), a != null && (ge.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Ho.assertOptions(a, {
      encode: Sr.function,
      serialize: Sr.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Ho.assertOptions(r, {
      baseUrl: Sr.spelling("baseURL"),
      withXsrfToken: Sr.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ge.merge(
      o.common,
      o[r.method]
    );
    o && ge.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (N) => {
        delete o[N];
      }
    ), r.headers = Wt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(S) {
      typeof S.runWhen == "function" && S.runWhen(r) === !1 || (d = d && S.synchronous, l.unshift(S.fulfilled, S.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const N = [cf.bind(this), void 0];
      for (N.unshift(...l), N.push(...m), h = N.length, u = Promise.resolve(r); f < h; )
        u = u.then(N[f++], N[f++]);
      return u;
    }
    h = l.length;
    let k = r;
    for (; f < h; ) {
      const N = l[f++], S = l[f++];
      try {
        k = N(k);
      } catch (w) {
        S.call(this, w);
        break;
      }
    }
    try {
      u = cf.call(this, k);
    } catch (N) {
      return Promise.reject(N);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = yi(this.defaults, n);
    const r = Lb(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Db(r, n.params, n.paramsSerializer);
  }
};
ge.forEach(["delete", "get", "head", "options"], function(n) {
  mi.prototype[n] = function(r, i) {
    return this.request(yi(i || {}, {
      method: n,
      url: r,
      data: (i || {}).data
    }));
  };
});
ge.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(yi(l || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  mi.prototype[n] = r(), mi.prototype[n + "Form"] = r(!0);
});
let DN = class Bb {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Mi(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Bb(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function RN(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function ON(e) {
  return ge.isObject(e) && e.isAxiosError === !0;
}
const Yu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Yu).forEach(([e, n]) => {
  Yu[n] = e;
});
function qb(e) {
  const n = new mi(e), r = _b(mi.prototype.request, n);
  return ge.extend(r, mi.prototype, n, { allOwnKeys: !0 }), ge.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return qb(yi(e, a));
  }, r;
}
const mt = qb(no);
mt.Axios = mi;
mt.CanceledError = Mi;
mt.CancelToken = DN;
mt.isCancel = Pb;
mt.VERSION = Mb;
mt.toFormData = Os;
mt.AxiosError = Cn;
mt.Cancel = mt.CanceledError;
mt.all = function(n) {
  return Promise.all(n);
};
mt.spread = RN;
mt.isAxiosError = ON;
mt.mergeConfig = yi;
mt.AxiosHeaders = Wt;
mt.formToJSON = (e) => Ob(ge.isHTMLForm(e) ? new FormData(e) : e);
mt.getAdapter = Ub.getAdapter;
mt.HttpStatusCode = Yu;
mt.default = mt;
const {
  Axios: dM,
  AxiosError: uM,
  CanceledError: mM,
  isCancel: pM,
  CancelToken: fM,
  VERSION: hM,
  all: yM,
  Cancel: gM,
  isAxiosError: PN,
  spread: vM,
  toFormData: kM,
  AxiosHeaders: bM,
  HttpStatusCode: _M,
  formToJSON: xM,
  getAdapter: SM,
  mergeConfig: NM
} = mt;
class AN {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const uf = new AN();
function LN(e, n) {
  return mf(e), mf(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function mf(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const VN = Object.prototype.toString;
function zN(e, n) {
  return VN.call(e) === `[object ${n}]`;
}
function UN(e) {
  return zN(e, "Object");
}
function MN(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Oa = "8.36.0", qr = globalThis;
function Rm(e, n, r) {
  const i = r || qr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Oa] = a[Oa] || {};
  return o[e] || (o[e] = n());
}
const Hb = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, BN = "Sentry Logger ", pf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], ff = {};
function Wb(e) {
  if (!("console" in qr))
    return e();
  const n = qr.console, r = {}, i = Object.keys(ff);
  i.forEach((a) => {
    const o = ff[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function qN() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Hb ? pf.forEach((r) => {
    n[r] = (...i) => {
      e && Wb(() => {
        qr.console[r](`${BN}[${r}]:`, ...i);
      });
    };
  }) : pf.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Wo = Rm("logger", qN);
function HN(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Hb && Wo.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Kb = 1e3;
function Om() {
  return Date.now() / Kb;
}
function WN() {
  const { performance: e } = qr;
  if (!e || !e.now)
    return Om;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Kb;
}
const KN = WN();
(() => {
  const { performance: e } = qr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Ti() {
  const e = qr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function hf() {
  return {
    traceId: Ti(),
    spanId: Ti().substring(16)
  };
}
function Pm() {
  return Am(qr), qr;
}
function Am(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Oa, n[Oa] = n[Oa] || {};
}
function GN(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || KN(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Ti()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Ju = "_sentrySpan";
function yf(e, n) {
  n ? HN(e, Ju, n) : delete e[Ju];
}
function gf(e) {
  return e[Ju];
}
const YN = 100;
class Lm {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = hf();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Lm();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, yf(n, gf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && GN(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Ai ? [r.getScopeData(), r.getRequestSession()] : UN(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, yf(this, void 0), this._attachments = [], this._propagationContext = hf(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : YN;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Om(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: gf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Ti();
    if (!this._client)
      return Wo.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Ti();
    if (!this._client)
      return Wo.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Ti();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Wo.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Ai = Lm;
function JN() {
  return Rm("defaultCurrentScope", () => new Ai());
}
function QN() {
  return Rm("defaultIsolationScope", () => new Ai());
}
class XN {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Ai();
    let a;
    r ? a = r : a = new Ai(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return MN(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Li() {
  const e = Pm(), n = Am(e);
  return n.stack = n.stack || new XN(JN(), QN());
}
function ZN(e) {
  return Li().withScope(e);
}
function ej(e, n) {
  const r = Li();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function vf(e) {
  return Li().withScope(() => e(Li().getIsolationScope()));
}
function nj() {
  return {
    withIsolationScope: vf,
    withScope: ZN,
    withSetScope: ej,
    withSetIsolationScope: (e, n) => vf(n),
    getCurrentScope: () => Li().getScope(),
    getIsolationScope: () => Li().getIsolationScope()
  };
}
function Gb(e) {
  const n = Am(e);
  return n.acs ? n.acs : nj();
}
function Vm() {
  const e = Pm();
  return Gb(e).getCurrentScope();
}
function Yb() {
  const e = Pm();
  return Gb(e).getIsolationScope();
}
function tj() {
  return Vm().getClient();
}
function rj(e) {
  if (e)
    return ij(e) ? { captureContext: e } : oj(e) ? {
      captureContext: e
    } : e;
}
function ij(e) {
  return e instanceof Ai || typeof e == "function";
}
const aj = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function oj(e) {
  return Object.keys(e).some((n) => aj.includes(n));
}
function kf(e, n) {
  return Vm().captureException(e, rj(n));
}
function sj(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Vm().captureMessage(e, r, i);
}
function lj(e, n) {
  Yb().setContext(e, n);
}
const cj = 100;
function ii(e, n) {
  const r = tj(), i = Yb();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = cj } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Om(), ...e }, d = a ? Wb(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Ka;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Ka || (Ka = {}));
function $i(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const dj = Wa.backendDomain ? {
  "backend-domain": Wa.backendDomain
} : void 0;
function Ko() {
  const e = new URLSearchParams({
    noToken: "true",
    ...dj
  }).toString();
  document.location.href = `${Wa.url.logIn}?${e}`;
}
const rl = "authData", il = 30, uj = 600, al = 5;
class mj {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= al || this.clientServerTimeDiff <= -al ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + uj, a = $i(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > al) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(rl, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(rl), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(rl);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - il;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = $i(n), i = r.exp - il;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - il - this.estimatedServerTime()) * 1e3;
  }
}
const _t = new mj();
async function pj(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? $i(o).exp : "None", l = await As.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? $i(m).exp : "None", h = u ? $i(u).exp : "None", k = typeof s == "number" ? d - s : "Unknown", N = typeof f == "number" ? d - f : "Unknown", S = typeof h == "number" ? d - h : "Unknown", w = e.response.headers["x-dixa-rid"];
      lj("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: k,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: N,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: S,
        xDixaRid: w,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    sj("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Ka.Platform,
        domain: n
      }
    });
  }
}
const ol = /* @__PURE__ */ new Map(), fj = 3;
function hj(e) {
  e.interceptors.response.use((n) => (ol.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Qu.Unauthorized:
          if (!As.isRefreshTokenExpired() && n.config) {
            ii({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = ol.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= fj)
              return ol.set(n.config.url, i + 1), e(n.config);
          }
          pj(n), console.error("401 unauthorized interceptor"), Ko();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Jb = mt.create();
hj(Jb);
const Ar = console.log;
async function bf(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class yj extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function gj(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const vj = 5;
class kj {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      _t.setAuthData(r);
    else {
      const i = _t.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new yj("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = _t.getAccessToken();
    if (!n)
      return {};
    const r = $i(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return _t.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = _t.getAuthData();
    return r ? _t.isAccessTokenExpired() ? (ii({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && _t.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return _t.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return _t.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return _t.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = _t.getAuthData();
    return n ? _t.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!uf.isElectron())
      return !0;
    const n = await uf.getVersion();
    return LN(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = vj) {
    try {
      return await Jb.post(`${Wa.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Ar("AUTH", "Network connection offline - waiting..."), ii({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await bf(5);
    n && (Ar("AUTH", "Network connection restored"), ii({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = gj(this.retryCount);
    return Ar("AUTH", `Retrying in ${i} seconds`), await bf(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (_t.isRefreshTokenExpired(r))
      return Ar("AUTH", "Refresh token expired"), ii({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), _t.removeAuthData(), Ko(), null;
    if (PN(n)) {
      if (n.message === "timeout exceeded")
        return Ar("AUTH", "Timeout exceeded"), ii({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Ar("AUTH", "Network error"), ii({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Ar("AUTH", "Refresh token invalid (401)"), _t.removeAuthData(), Ko(), null;
      kf(n, {
        level: "error",
        tags: {
          team: Ka.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Ar("AUTH", "Retries exhausted, logging out"), kf(n, {
      level: "error",
      tags: {
        team: Ka.Platform,
        errorSource: "authManager.refresh"
      }
    }), _t.removeAuthData(), Ko(), null) : (Ar("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return _t.accessTokenExpiresInMs();
  }
}
const As = new kj();
var Qu;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Qu || (Qu = {}));
const bj = new Im((e, n) => new kb((r) => {
  As.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), _j = new Im(
  (e, n) => new kb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    As.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...SS(Wa.url.partnerIntegrations) && d?.access_token && NS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), xj = new AbortController(), Qb = (e) => new GS({
  queryDeduplication: !1,
  cache: new YS(),
  link: Im.from([
    bj,
    _j,
    JS({
      uri: `${e}/graphql`,
      fetch: t0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: xj.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), Sj = ({
  configuration: e,
  children: n
}) => {
  const r = Kn(
    () => Qb(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ ze.jsx(QS, { client: r, children: n });
};
function Nj() {
  try {
    return XS(), !0;
  } catch {
    return !1;
  }
}
const jj = ({
  configuration: e,
  children: n
}) => Nj() ? n : /* @__PURE__ */ ze.jsx(Sj, { configuration: e, children: n }), wj = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ ze.jsx(ZS, { children: (o) => /* @__PURE__ */ ze.jsx(
  jS,
  {
    value: {
      useMutation: IS(e, n),
      useQuery: FS(e, n),
      useLazyQuery: CS(e, n),
      executeQuery: wS(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Xb = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ ze.jsx(jj, { configuration: r, children: s ? /* @__PURE__ */ ze.jsx(
    wj,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, Zb = ({
  headline: e,
  text: n,
  children: r,
  onConfirm: i,
  onCancel: a,
  confirmLabel: o,
  cancelLabel: s = "Cancel",
  confirmVariant: l = "primary",
  cancelVariant: d = "secondary",
  isOpen: m,
  setIsOpen: u,
  showOnClose: f = !1
}) => /* @__PURE__ */ ze.jsxs(
  gt,
  {
    isOpen: m,
    onClose: () => {
      a && a(), u(!1);
    },
    children: [
      /* @__PURE__ */ ze.jsx(
        vt,
        {
          title: e,
          onClose: f ? a : void 0
        }
      ),
      /* @__PURE__ */ ze.jsxs(kt, { children: [
        n && /* @__PURE__ */ ze.jsx("div", { style: { width: "600px" }, children: n }),
        r
      ] }),
      /* @__PURE__ */ ze.jsx(
        Ct,
        {
          confirmOnClick: i ? () => {
            i(), u(!1);
          } : void 0,
          cancelOnClick: () => {
            a && a(), u(!1);
          },
          confirmName: o,
          cancelName: s,
          confirmProps: { variant: l },
          cancelProps: { variant: d }
        }
      )
    ]
  }
);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var sl = { exports: {} }, Xi = {}, _f;
function Cj() {
  if (_f) return Xi;
  _f = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Xi.Fragment = r, Xi.jsx = s, Xi.jsxs = s, Xi;
}
var po = {}, xf;
function Fj() {
  return xf || (xf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    po.Fragment = i, po.jsx = Rn, po.jsxs = Bn;
  })()), po;
}
var Sf;
function Ij() {
  return Sf || (Sf = 1, process.env.NODE_ENV === "production" ? sl.exports = Cj() : sl.exports = Fj()), sl.exports;
}
var ae = Ij();
const Ej = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, Tj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, $j = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": Ej,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": Tj
};
function e_(e) {
  return $j[e] ?? {};
}
const Dj = e_(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), Rj = e_(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), Oj = "_copyIcon_1wjfs_48", Pj = "_list_1wjfs_53", Aj = "_listItem_1wjfs_63", Lj = "_collapsible_1wjfs_72", Vj = "_collapsibleIsOpen_1wjfs_80", zj = "_collapsibleHeader_1wjfs_83", Uj = "_collapsibleIconTrue_1wjfs_86", Mj = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: Oj,
  list: Pj,
  listItem: Aj,
  collapsible: Lj,
  collapsibleIsOpen: Vj,
  collapsibleHeader: zj,
  collapsibleIconTrue: Uj,
  collapsibleIconFalse: Mj
}, Bj = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ut(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ae.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(We, { className: On.list, children: [
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(d).format(dt) })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(m).format(dt) })
          ] }) })
        ] })
      ]
    }
  );
}, qj = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Bj, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Hj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ae.jsx(We, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: i }),
          pb(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Wj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ae.jsx(We, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ge,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${An(a?.first).format(
                  dt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${An(a?.last).format(
                  dt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, ls = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ae.jsx(Ge, { content: n ? null : l(), children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(ue, { size: 14, name: o(), color: s() }) }) });
}, Kj = "_wrapper_1xucg_1", Gj = "_externalLink_1xucg_7", ll = {
  wrapper: Kj,
  externalLink: Gj
}, Yj = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = nr(), { isCopied: i, copy: a } = nr(), { isCopied: o, copy: s } = nr(), { isCopied: l, copy: d } = nr(), { isCopied: m, copy: u } = nr();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: k,
    last_name: N,
    home_city: S,
    country: w,
    email: C,
    phone: g,
    dob: q,
    created_at: $,
    email_subscribe: E,
    push_subscribe: D
  } = e, z = 14, Z = `${k || ""} ${N || ""}`.trim() || "A customer has no name", Q = `${S ? `${S} /` : ""} ${w || ""}`.trim(), te = q ? An(q).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { className: ll.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ll.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-2", children: Z }),
          te && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    $ && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: An($).format(dt) })
    ] }),
    Q && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: z, name: "map-pin" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Q })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy location", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: z,
          name: o ? "done" : "copy",
          onClick: () => s(Q),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    C && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: z, name: "mail" }),
        /* @__PURE__ */ ae.jsx("span", { className: ll.externalLink, children: C })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: z,
          name: n ? "done" : "copy",
          onClick: () => r(C),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: z, name: "phone" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: z,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: z, name: "user" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy Braze ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: z,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: z, name: "tag" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy External ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: z,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    E && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: z, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(ls, { state: E })
    ] }),
    D && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: z, name: "bell" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(ls, { isPush: !0, state: D })
    ] })
  ] }) });
}, Jj = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ut(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ae.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(We, { className: On.list, children: [
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ae.jsx(
              ue,
              {
                size: a,
                className: ut({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ge, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Ge, { content: "For iOS", children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, Qj = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Jj, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Zi = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, fo = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = kn(), { useMutation: a } = un(), [o, s] = se(!1), [l] = a(
    Rj,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Zi[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ae.jsx(Ge, { content: Zi[n].tooltipContent, children: /* @__PURE__ */ ae.jsx(
    Wn,
    {
      variant: "secondary",
      color: Zi[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(
          ls,
          {
            noTooltip: !0,
            state: Zi[n].parameter
          }
        ),
        Zi[n].label
      ] })
    }
  ) });
}, Xj = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ae.jsx(We, { className: On.list, children: /* @__PURE__ */ ae.jsx(We.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: 14, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(ls, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
        /* @__PURE__ */ ae.jsx(
          fo,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ae.jsx(
          fo,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ae.jsx(
        fo,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ae.jsx(
        fo,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Zj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ae.jsx(We, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      We.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ge,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${An(a?.first).format(
                  dt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${An(a?.last).format(
                  dt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, ew = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), { useMutation: i } = un(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, k = n.updateEmailSubscriptionState ?? !1, N = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, w = n.displayPuchases ?? !1, C = n.displayDevices ?? !1, g = n.displayApps ?? !1, q = !h && !k && !N && !S && !w, [$, { error: E }] = i(
    Dj,
    {
      onError: () => {
      },
      onCompleted: (z) => {
        const Z = z?.Braze?.exportUserDetails?.users?.[0];
        Z ? (o(Z), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), D = async () => {
    u || f ? await $({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (He(() => {
    async function z() {
      m(!0), await D();
    }
    z().finally(() => m(!1));
  }, [u, f]), E) {
    const z = E.graphQLErrors;
    return Sm({ errors: z }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Nm({ errors: z }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ae.jsx(Fn, { error: E });
  }
  return d ? /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ae.jsx(cn, {}) }) : q ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ae.jsx(Yj, { customerDetails: a }),
        k && !!a && /* @__PURE__ */ ae.jsx(
          Xj,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await D()
          }
        ),
        N && !!a && /* @__PURE__ */ ae.jsx(Hj, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ ae.jsx(Wj, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ ae.jsx(Zj, { customerDetails: a }),
        C && !!a && /* @__PURE__ */ ae.jsx(Qj, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ ae.jsx(qj, { apps: a?.apps })
      ]
    }
  );
}, nw = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => mb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function tw() {
  var e = ui(!1), n = tt(function() {
    return e.current;
  }, []);
  return He(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var rw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = tt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, iw = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Nf = function(e) {
  return PS(iw, e);
}, cl, jf;
function aw() {
  return jf || (jf = 1, cl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), cl;
}
var dl, wf;
function ow() {
  if (wf) return dl;
  wf = 1;
  var e = aw(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, k = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var w = n[s.format] || n.default;
            window.clipboardData.setData(w, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var N = document.execCommand("copy");
      if (!N)
        throw new Error("copy command was unsuccessful");
      k = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), k = !0;
      } catch (w) {
        l && console.error("unable to copy using clipboardData: ", w), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return k;
  }
  return dl = a, dl;
}
var sw = ow();
const lw = /* @__PURE__ */ Em(sw);
var n_ = function() {
  var e = tw(), n = rw({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = tt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = lw(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function cw(e, n) {
  n === void 0 && (n = 0);
  var r = ui(!1), i = ui(), a = ui(e), o = tt(function() {
    return r.current;
  }, []), s = tt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = tt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return He(function() {
    a.current = e;
  }, [e]), He(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function gi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = cw(e, n), a = i[0], o = i[1], s = i[2];
  return He(s, r), [a, o];
}
var dw = function(e) {
  He(e, []);
}, uw = function(e, n) {
  var r = ui(function() {
  });
  He(function() {
    r.current = e;
  }), He(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, mw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = Kn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return Zs(Zs({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = r0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = Zs({ get: tt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, pw = function(e) {
  var n = ui(e);
  n.current = e, dw(function() {
    return function() {
      return n.current();
    };
  });
}, to = (e) => e.type === "checkbox", li = (e) => e instanceof Date, Ot = (e) => e == null;
const t_ = (e) => typeof e == "object";
var st = (e) => !Ot(e) && !Array.isArray(e) && t_(e) && !li(e), r_ = (e) => st(e) && e.target ? to(e.target) ? e.target.checked : e.target.value : e, fw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, i_ = (e, n) => e.has(fw(n)), hw = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return st(n) && n.hasOwnProperty("isPrototypeOf");
}, zm = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function St(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(zm && (e instanceof Blob || i)) && (r || st(e)))
    if (n = r ? [] : {}, !r && !hw(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = St(e[a]));
  else
    return e;
  return n;
}
var Ls = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, Ye = (e, n, r) => {
  if (!n || !st(e))
    return r;
  const i = Ls(n.split(/[,[\].]+?/)).reduce((a, o) => Ot(a) ? a : a[o], e);
  return rt(i) || i === e ? rt(e[n]) ? r : e[n] : i;
}, Xt = (e) => typeof e == "boolean", Um = (e) => /^\w*$/.test(e), a_ = (e) => Ls(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = Um(n) ? [n] : a_(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = st(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const cs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, pr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Lr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, o_ = Se.createContext(null), Or = () => Se.useContext(o_), Mm = (e) => {
  const { children: n, ...r } = e;
  return Se.createElement(o_.Provider, { value: r }, n);
};
var s_ = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== pr.all && (n._proxyFormState[s] = !i || pr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function yw(e) {
  const n = Or(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => s_(s, r, d.current, !1), [s, r]);
}
var Er = (e) => typeof e == "string", l_ = (e, n, r, i, a) => Er(e) ? (i && n.watch.add(e), Ye(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(r, o))) : (i && (n.watchAll = !0), r);
function Go(e) {
  const n = Or(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(l_(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function Bm(e) {
  const n = Or(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = i_(a._names.array, r), l = Go({
    control: a,
    name: r,
    defaultValue: Ye(a._formValues, r, Ye(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = yw({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Xt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ye(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((w) => u.current.onChange({
    target: {
      value: r_(w),
      name: r
    },
    type: cs.CHANGE
  }), [r]), k = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Ye(a._formValues, r),
      name: r
    },
    type: cs.BLUR
  }), [r, a._formValues]), N = Se.useCallback((w) => {
    const C = Ye(a._fields, r);
    C && w && (C._f.ref = {
      focus: () => w.focus(),
      select: () => w.select(),
      setCustomValidity: (g) => w.setCustomValidity(g),
      reportValidity: () => w.reportValidity()
    });
  }, [a._fields, r]), S = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Xt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: N
  }), [r, i, d.disabled, h, k, N, l]);
  return Se.useEffect(() => {
    const w = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Xt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const C = (g, q) => {
      const $ = Ye(a._fields, g);
      $ && $._f && ($._f.mount = q);
    };
    if (C(r, !0), w) {
      const g = St(Ye(a._options.defaultValues, r));
      Gn(a._defaultValues, r, g), rt(Ye(a._formValues, r)) && Gn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? w && !a._state.action : w) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Lt = (e) => e.render(Bm(e));
var gw = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Pa = (e) => Array.isArray(e) ? e : [e], Cf = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Xu = (e) => Ot(e) || !t_(e);
function Jr(e, n) {
  if (Xu(e) || Xu(n))
    return e === n;
  if (li(e) && li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (li(o) && li(s) || st(o) && st(s) || Array.isArray(o) && Array.isArray(s) ? !Jr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var $t = (e) => st(e) && !Object.keys(e).length, qm = (e) => e.type === "file", fr = (e) => typeof e == "function", ds = (e) => {
  if (!zm)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, c_ = (e) => e.type === "select-multiple", Hm = (e) => e.type === "radio", vw = (e) => Hm(e) || to(e), ul = (e) => ds(e) && e.isConnected;
function kw(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = rt(e) ? i++ : e[n[i++]];
  return e;
}
function bw(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function ft(e, n) {
  const r = Array.isArray(n) ? n : Um(n) ? [n] : a_(n), i = r.length === 1 ? e : kw(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (st(i) && $t(i) || Array.isArray(i) && bw(i)) && ft(e, r.slice(0, -1)), e;
}
var d_ = (e) => {
  for (const n in e)
    if (fr(e[n]))
      return !0;
  return !1;
};
function us(e, n = {}) {
  const r = Array.isArray(e);
  if (st(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || st(e[i]) && !d_(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, us(e[i], n[i])) : Ot(e[i]) || (n[i] = !0);
  return n;
}
function u_(e, n, r) {
  const i = Array.isArray(e);
  if (st(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || st(e[a]) && !d_(e[a]) ? rt(n) || Xu(r[a]) ? r[a] = Array.isArray(e[a]) ? us(e[a], []) : { ...us(e[a]) } : u_(e[a], Ot(n) ? {} : n[a], r[a]) : r[a] = !Jr(e[a], n[a]);
  return r;
}
var ea = (e, n) => u_(e, n, us(n));
const Ff = {
  value: !1,
  isValid: !1
}, If = { value: !0, isValid: !0 };
var m_ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? If : { value: e[0].value, isValid: !0 } : If
    ) : Ff;
  }
  return Ff;
}, p_ = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : r && Er(e) ? new Date(e) : i ? i(e) : e;
const Ef = {
  isValid: !1,
  value: null
};
var f_ = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Ef) : Ef;
function Tf(e) {
  const n = e.ref;
  return qm(n) ? n.files : Hm(n) ? f_(e.refs).value : c_(n) ? [...n.selectedOptions].map(({ value: r }) => r) : to(n) ? m_(e.refs).value : p_(rt(n.value) ? e.ref.value : n.value, e);
}
var _w = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, ms = (e) => e instanceof RegExp, na = (e) => rt(e) ? e : ms(e) ? e.source : st(e) ? ms(e.value) ? e.value.source : e.value : e, $f = (e) => ({
  isOnSubmit: !e || e === pr.onSubmit,
  isOnBlur: e === pr.onBlur,
  isOnChange: e === pr.onChange,
  isOnAll: e === pr.all,
  isOnTouch: e === pr.onTouched
});
const Df = "AsyncFunction";
var xw = (e) => !!e && !!e.validate && !!(fr(e.validate) && e.validate.constructor.name === Df || st(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Df)), Sw = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Rf = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Aa = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Aa(l, n))
          break;
      } else if (st(l) && Aa(l, n))
        break;
    }
  }
};
function Of(e, n, r) {
  const i = Ye(e, r);
  if (i || Um(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var Nw = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return $t(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || pr.all));
}, jw = (e, n, r) => !e || !n || e === n || Pa(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), ww = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, Cw = (e, n) => !Ls(Ye(e, n)).length && ft(e, n), Fw = (e, n, r) => {
  const i = Pa(Ye(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, Yo = (e) => Er(e);
function Pf(e, n, r = "validate") {
  if (Yo(e) || Array.isArray(e) && e.every(Yo) || Xt(e) && !e)
    return {
      type: r,
      message: Yo(e) ? e : "",
      ref: n
    };
}
var xi = (e) => st(e) && !ms(e) ? e : {
  value: e,
  message: ""
}, Af = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: N, name: S, valueAsNumber: w, mount: C } = e._f, g = Ye(r, S);
  if (!C || n.has(S))
    return {};
  const q = l ? l[0] : s, $ = (B) => {
    a && q.reportValidity && (q.setCustomValidity(Xt(B) ? "" : B || ""), q.reportValidity());
  }, E = {}, D = Hm(s), z = to(s), Z = D || z, Q = (w || qm(s)) && rt(s.value) && rt(g) || ds(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, te = gw.bind(null, S, i, E), Y = (B, R, H, ne = Lr.maxLength, ve = Lr.minLength) => {
    const de = B ? R : H;
    E[S] = {
      type: B ? ne : ve,
      message: de,
      ref: s,
      ...te(B ? ne : ve, de)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || Ot(g)) || Xt(g) && !g || z && !m_(l).isValid || D && !f_(l).isValid)) {
    const { value: B, message: R } = Yo(d) ? { value: !!d, message: d } : xi(d);
    if (B && (E[S] = {
      type: Lr.required,
      message: R,
      ref: q,
      ...te(Lr.required, R)
    }, !i))
      return $(R), E;
  }
  if (!Q && (!Ot(f) || !Ot(h))) {
    let B, R;
    const H = xi(h), ne = xi(f);
    if (!Ot(g) && !isNaN(g)) {
      const ve = s.valueAsNumber || g && +g;
      Ot(H.value) || (B = ve > H.value), Ot(ne.value) || (R = ve < ne.value);
    } else {
      const ve = s.valueAsDate || new Date(g), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", fe = s.type == "week";
      Er(H.value) && g && (B = le ? de(g) > de(H.value) : fe ? g > H.value : ve > new Date(H.value)), Er(ne.value) && g && (R = le ? de(g) < de(ne.value) : fe ? g < ne.value : ve < new Date(ne.value));
    }
    if ((B || R) && (Y(!!B, H.message, ne.message, Lr.max, Lr.min), !i))
      return $(E[S].message), E;
  }
  if ((m || u) && !Q && (Er(g) || o && Array.isArray(g))) {
    const B = xi(m), R = xi(u), H = !Ot(B.value) && g.length > +B.value, ne = !Ot(R.value) && g.length < +R.value;
    if ((H || ne) && (Y(H, B.message, R.message), !i))
      return $(E[S].message), E;
  }
  if (k && !Q && Er(g)) {
    const { value: B, message: R } = xi(k);
    if (ms(B) && !g.match(B) && (E[S] = {
      type: Lr.pattern,
      message: R,
      ref: s,
      ...te(Lr.pattern, R)
    }, !i))
      return $(R), E;
  }
  if (N) {
    if (fr(N)) {
      const B = await N(g, r), R = Pf(B, q);
      if (R && (E[S] = {
        ...R,
        ...te(Lr.validate, R.message)
      }, !i))
        return $(R.message), E;
    } else if (st(N)) {
      let B = {};
      for (const R in N) {
        if (!$t(B) && !i)
          break;
        const H = Pf(await N[R](g, r), q, R);
        H && (B = {
          ...H,
          ...te(R, H.message)
        }, $(H.message), i && (E[S] = B));
      }
      if (!$t(B) && (E[S] = {
        ref: q,
        ...B
      }, !i))
        return E;
    }
  }
  return $(!0), E;
};
const Iw = {
  mode: pr.onSubmit,
  reValidateMode: pr.onChange,
  shouldFocusError: !0
};
function Ew(e = {}) {
  let n = {
    ...Iw,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: fr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = st(n.defaultValues) || st(n.values) ? St(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : St(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Cf(),
    state: Cf()
  }, k = $f(n.mode), N = $f(n.reValidateMode), S = n.criteriaMode === pr.all, w = (_) => (T) => {
    clearTimeout(m), m = setTimeout(_, T);
  }, C = async (_) => {
    if (!n.disabled && (u.isValid || f.isValid || _)) {
      const T = n.resolver ? $t((await Q()).errors) : await Y(i, !0);
      T !== r.isValid && h.state.next({
        isValid: T
      });
    }
  }, g = (_, T) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((G) => {
      G && (T ? Gn(r.validatingFields, G, T) : ft(r.validatingFields, G));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !$t(r.validatingFields)
    }));
  }, q = (_, T = [], G, J, O = !0, U = !0) => {
    if (J && G && !n.disabled) {
      if (s.action = !0, U && Array.isArray(Ye(i, _))) {
        const ie = G(Ye(i, _), J.argA, J.argB);
        O && Gn(i, _, ie);
      }
      if (U && Array.isArray(Ye(r.errors, _))) {
        const ie = G(Ye(r.errors, _), J.argA, J.argB);
        O && Gn(r.errors, _, ie), Cw(r.errors, _);
      }
      if ((u.touchedFields || f.touchedFields) && U && Array.isArray(Ye(r.touchedFields, _))) {
        const ie = G(Ye(r.touchedFields, _), J.argA, J.argB);
        O && Gn(r.touchedFields, _, ie);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = ea(a, o)), h.state.next({
        name: _,
        isDirty: R(_, T),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, _, T);
  }, $ = (_, T) => {
    Gn(r.errors, _, T), h.state.next({
      errors: r.errors
    });
  }, E = (_) => {
    r.errors = _, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (_, T, G, J) => {
    const O = Ye(i, _);
    if (O) {
      const U = Ye(o, _, rt(G) ? Ye(a, _) : G);
      rt(U) || J && J.defaultChecked || T ? Gn(o, _, T ? U : Tf(O._f)) : ve(_, U), s.mount && C();
    }
  }, z = (_, T, G, J, O) => {
    let U = !1, ie = !1;
    const pe = {
      name: _
    };
    if (!n.disabled) {
      if (!G || J) {
        (u.isDirty || f.isDirty) && (ie = r.isDirty, r.isDirty = pe.isDirty = R(), U = ie !== pe.isDirty);
        const ke = Jr(Ye(a, _), T);
        ie = !!Ye(r.dirtyFields, _), ke ? ft(r.dirtyFields, _) : Gn(r.dirtyFields, _, !0), pe.dirtyFields = r.dirtyFields, U = U || (u.dirtyFields || f.dirtyFields) && ie !== !ke;
      }
      if (G) {
        const ke = Ye(r.touchedFields, _);
        ke || (Gn(r.touchedFields, _, G), pe.touchedFields = r.touchedFields, U = U || (u.touchedFields || f.touchedFields) && ke !== G);
      }
      U && O && h.state.next(pe);
    }
    return U ? pe : {};
  }, Z = (_, T, G, J) => {
    const O = Ye(r.errors, _), U = (u.isValid || f.isValid) && Xt(T) && r.isValid !== T;
    if (n.delayError && G ? (d = w(() => $(_, G)), d(n.delayError)) : (clearTimeout(m), d = null, G ? Gn(r.errors, _, G) : ft(r.errors, _)), (G ? !Jr(O, G) : O) || !$t(J) || U) {
      const ie = {
        ...J,
        ...U && Xt(T) ? { isValid: T } : {},
        errors: r.errors,
        name: _
      };
      r = {
        ...r,
        ...ie
      }, h.state.next(ie);
    }
  }, Q = async (_) => {
    g(_, !0);
    const T = await n.resolver(o, n.context, _w(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(_), T;
  }, te = async (_) => {
    const { errors: T } = await Q(_);
    if (_)
      for (const G of _) {
        const J = Ye(T, G);
        J ? Gn(r.errors, G, J) : ft(r.errors, G);
      }
    else
      r.errors = T;
    return T;
  }, Y = async (_, T, G = {
    valid: !0
  }) => {
    for (const J in _) {
      const O = _[J];
      if (O) {
        const { _f: U, ...ie } = O;
        if (U) {
          const pe = l.array.has(U.name), ke = O._f && xw(O._f);
          ke && u.validatingFields && g([J], !0);
          const en = await Af(O, l.disabled, o, S, n.shouldUseNativeValidation && !T, pe);
          if (ke && u.validatingFields && g([J]), en[U.name] && (G.valid = !1, T))
            break;
          !T && (Ye(en, U.name) ? pe ? Fw(r.errors, en, U.name) : Gn(r.errors, U.name, en[U.name]) : ft(r.errors, U.name));
        }
        !$t(ie) && await Y(ie, T, G);
      }
    }
    return G.valid;
  }, B = () => {
    for (const _ of l.unMount) {
      const T = Ye(i, _);
      T && (T._f.refs ? T._f.refs.every((G) => !ul(G)) : !ul(T._f.ref)) && Le(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (_, T) => !n.disabled && (_ && T && Gn(o, _, T), !Jr(Ce(), a)), H = (_, T, G) => l_(_, l, {
    ...s.mount ? o : rt(T) ? a : Er(_) ? { [_]: T } : T
  }, G, T), ne = (_) => Ls(Ye(s.mount ? o : a, _, n.shouldUnregister ? Ye(a, _, []) : [])), ve = (_, T, G = {}) => {
    const J = Ye(i, _);
    let O = T;
    if (J) {
      const U = J._f;
      U && (!U.disabled && Gn(o, _, p_(T, U)), O = ds(U.ref) && Ot(T) ? "" : T, c_(U.ref) ? [...U.ref.options].forEach((ie) => ie.selected = O.includes(ie.value)) : U.refs ? to(U.ref) ? U.refs.length > 1 ? U.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(O) ? !!O.find((pe) => pe === ie.value) : O === ie.value)) : U.refs[0] && (U.refs[0].checked = !!O) : U.refs.forEach((ie) => ie.checked = ie.value === O) : qm(U.ref) ? U.ref.value = "" : (U.ref.value = O, U.ref.type || h.state.next({
        name: _,
        values: St(o)
      })));
    }
    (G.shouldDirty || G.shouldTouch) && z(_, O, G.shouldTouch, G.shouldDirty, !0), G.shouldValidate && be(_);
  }, de = (_, T, G) => {
    for (const J in T) {
      const O = T[J], U = `${_}.${J}`, ie = Ye(i, U);
      (l.array.has(_) || st(O) || ie && !ie._f) && !li(O) ? de(U, O, G) : ve(U, O, G);
    }
  }, le = (_, T, G = {}) => {
    const J = Ye(i, _), O = l.array.has(_), U = St(T);
    Gn(o, _, U), O ? (h.array.next({
      name: _,
      values: St(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && G.shouldDirty && h.state.next({
      name: _,
      dirtyFields: ea(a, o),
      isDirty: R(_, U)
    })) : J && !J._f && !Ot(U) ? de(_, U, G) : ve(_, U, G), Rf(_, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? _ : void 0,
      values: St(o)
    });
  }, fe = async (_) => {
    s.mount = !0;
    const T = _.target;
    let G = T.name, J = !0;
    const O = Ye(i, G), U = (ie) => {
      J = Number.isNaN(ie) || li(ie) && isNaN(ie.getTime()) || Jr(ie, Ye(o, G, ie));
    };
    if (O) {
      let ie, pe;
      const ke = T.type ? Tf(O._f) : r_(_), en = _.type === cs.BLUR || _.type === cs.FOCUS_OUT, mn = !Sw(O._f) && !n.resolver && !Ye(r.errors, G) && !O._f.deps || ww(en, Ye(r.touchedFields, G), r.isSubmitted, N, k), rn = Rf(G, l, en);
      Gn(o, G, ke), en ? (O._f.onBlur && O._f.onBlur(_), d && d(0)) : O._f.onChange && O._f.onChange(_);
      const dn = z(G, ke, en), pn = !$t(dn) || rn;
      if (!en && h.state.next({
        name: G,
        type: _.type,
        values: St(o)
      }), mn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? en && C() : en || C()), pn && h.state.next({ name: G, ...rn ? {} : dn });
      if (!en && rn && h.state.next({ ...r }), n.resolver) {
        const { errors: ln } = await Q([G]);
        if (U(ke), J) {
          const vn = Of(r.errors, i, G), Xe = Of(ln, i, vn.name || G);
          ie = Xe.error, G = Xe.name, pe = $t(ln);
        }
      } else
        g([G], !0), ie = (await Af(O, l.disabled, o, S, n.shouldUseNativeValidation))[G], g([G]), U(ke), J && (ie ? pe = !1 : (u.isValid || f.isValid) && (pe = await Y(i, !0)));
      J && (O._f.deps && be(O._f.deps), Z(G, pe, ie, dn));
    }
  }, W = (_, T) => {
    if (Ye(r.errors, T) && _.focus)
      return _.focus(), 1;
  }, be = async (_, T = {}) => {
    let G, J;
    const O = Pa(_);
    if (n.resolver) {
      const U = await te(rt(_) ? _ : O);
      G = $t(U), J = _ ? !O.some((ie) => Ye(U, ie)) : G;
    } else _ ? (J = (await Promise.all(O.map(async (U) => {
      const ie = Ye(i, U);
      return await Y(ie && ie._f ? { [U]: ie } : ie);
    }))).every(Boolean), !(!J && !r.isValid) && C()) : J = G = await Y(i);
    return h.state.next({
      ...!Er(_) || (u.isValid || f.isValid) && G !== r.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: G } : {},
      errors: r.errors
    }), T.shouldFocus && !J && Aa(i, W, _ ? O : l.mount), J;
  }, Ce = (_) => {
    const T = {
      ...s.mount ? o : a
    };
    return rt(_) ? T : Er(_) ? Ye(T, _) : _.map((G) => Ye(T, G));
  }, K = (_, T) => ({
    invalid: !!Ye((T || r).errors, _),
    isDirty: !!Ye((T || r).dirtyFields, _),
    error: Ye((T || r).errors, _),
    isValidating: !!Ye(r.validatingFields, _),
    isTouched: !!Ye((T || r).touchedFields, _)
  }), qe = (_) => {
    _ && Pa(_).forEach((T) => ft(r.errors, T)), h.state.next({
      errors: _ ? r.errors : {}
    });
  }, Be = (_, T, G) => {
    const J = (Ye(i, _, { _f: {} })._f || {}).ref, O = Ye(r.errors, _) || {}, { ref: U, message: ie, type: pe, ...ke } = O;
    Gn(r.errors, _, {
      ...ke,
      ...T,
      ref: J
    }), h.state.next({
      name: _,
      errors: r.errors,
      isValid: !1
    }), G && G.shouldFocus && J && J.focus && J.focus();
  }, Pe = (_, T) => fr(_) ? h.state.subscribe({
    next: (G) => _(H(void 0, T), G)
  }) : H(_, T, !0), Me = (_) => h.state.subscribe({
    next: (T) => {
      jw(_.name, T.name, _.exact) && Nw(T, _.formState || u, Re, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...r,
        ...T
      });
    }
  }).unsubscribe, je = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, Me({
    ..._,
    formState: f
  })), Le = (_, T = {}) => {
    for (const G of _ ? Pa(_) : l.mount)
      l.mount.delete(G), l.array.delete(G), T.keepValue || (ft(i, G), ft(o, G)), !T.keepError && ft(r.errors, G), !T.keepDirty && ft(r.dirtyFields, G), !T.keepTouched && ft(r.touchedFields, G), !T.keepIsValidating && ft(r.validatingFields, G), !n.shouldUnregister && !T.keepDefaultValue && ft(a, G);
    h.state.next({
      values: St(o)
    }), h.state.next({
      ...r,
      ...T.keepDirty ? { isDirty: R() } : {}
    }), !T.keepIsValid && C();
  }, Te = ({ disabled: _, name: T }) => {
    (Xt(_) && s.mount || _ || l.disabled.has(T)) && (_ ? l.disabled.add(T) : l.disabled.delete(T));
  }, an = (_, T = {}) => {
    let G = Ye(i, _);
    const J = Xt(T.disabled) || Xt(n.disabled);
    return Gn(i, _, {
      ...G || {},
      _f: {
        ...G && G._f ? G._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...T
      }
    }), l.mount.add(_), G ? Te({
      disabled: Xt(T.disabled) ? T.disabled : n.disabled,
      name: _
    }) : D(_, !0, T.value), {
      ...J ? { disabled: T.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!T.required,
        min: na(T.min),
        max: na(T.max),
        minLength: na(T.minLength),
        maxLength: na(T.maxLength),
        pattern: na(T.pattern)
      } : {},
      name: _,
      onChange: fe,
      onBlur: fe,
      ref: (O) => {
        if (O) {
          an(_, T), G = Ye(i, _);
          const U = rt(O.value) && O.querySelectorAll && O.querySelectorAll("input,select,textarea")[0] || O, ie = vw(U), pe = G._f.refs || [];
          if (ie ? pe.find((ke) => ke === U) : U === G._f.ref)
            return;
          Gn(i, _, {
            _f: {
              ...G._f,
              ...ie ? {
                refs: [
                  ...pe.filter(ul),
                  U,
                  ...Array.isArray(Ye(a, _)) ? [{}] : []
                ],
                ref: { type: U.type, name: _ }
              } : { ref: U }
            }
          }), D(_, !1, void 0, U);
        } else
          G = Ye(i, _, {}), G._f && (G._f.mount = !1), (n.shouldUnregister || T.shouldUnregister) && !(i_(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, we = () => n.shouldFocusError && Aa(i, W, l.mount), Ke = (_) => {
    Xt(_) && (h.state.next({ disabled: _ }), Aa(i, (T, G) => {
      const J = Ye(i, G);
      J && (T.disabled = J._f.disabled || _, Array.isArray(J._f.refs) && J._f.refs.forEach((O) => {
        O.disabled = J._f.disabled || _;
      }));
    }, 0, !1));
  }, Ze = (_, T) => async (G) => {
    let J;
    G && (G.preventDefault && G.preventDefault(), G.persist && G.persist());
    let O = St(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: U, values: ie } = await Q();
      r.errors = U, O = ie;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const U of l.disabled)
        Gn(O, U, void 0);
    if (ft(r.errors, "root"), $t(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(O, G);
      } catch (U) {
        J = U;
      }
    } else
      T && await T({ ...r.errors }, G), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: $t(r.errors) && !J,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), J)
      throw J;
  }, me = (_, T = {}) => {
    Ye(i, _) && (rt(T.defaultValue) ? le(_, St(Ye(a, _))) : (le(_, T.defaultValue), Gn(a, _, St(T.defaultValue))), T.keepTouched || ft(r.touchedFields, _), T.keepDirty || (ft(r.dirtyFields, _), r.isDirty = T.defaultValue ? R(_, St(Ye(a, _))) : R()), T.keepError || (ft(r.errors, _), u.isValid && C()), h.state.next({ ...r }));
  }, he = (_, T = {}) => {
    const G = _ ? St(_) : a, J = St(G), O = $t(_), U = O ? a : J;
    if (T.keepDefaultValues || (a = G), !T.keepValues) {
      if (T.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(ea(a, o))
        ]);
        for (const pe of Array.from(ie))
          Ye(r.dirtyFields, pe) ? Gn(U, pe, Ye(o, pe)) : le(pe, Ye(U, pe));
      } else {
        if (zm && rt(_))
          for (const ie of l.mount) {
            const pe = Ye(i, ie);
            if (pe && pe._f) {
              const ke = Array.isArray(pe._f.refs) ? pe._f.refs[0] : pe._f.ref;
              if (ds(ke)) {
                const en = ke.closest("form");
                if (en) {
                  en.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          le(ie, Ye(U, ie));
      }
      o = St(U), h.array.next({
        values: { ...U }
      }), h.state.next({
        values: { ...U }
      });
    }
    l = {
      mount: T.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!T.keepIsValid || !!T.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: T.keepSubmitCount ? r.submitCount : 0,
      isDirty: O ? !1 : T.keepDirty ? r.isDirty : !!(T.keepDefaultValues && !Jr(_, a)),
      isSubmitted: T.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: O ? {} : T.keepDirtyValues ? T.keepDefaultValues && o ? ea(a, o) : r.dirtyFields : T.keepDefaultValues && _ ? ea(a, _) : T.keepDirty ? r.dirtyFields : {},
      touchedFields: T.keepTouched ? r.touchedFields : {},
      errors: T.keepErrors ? r.errors : {},
      isSubmitSuccessful: T.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (_, T) => he(fr(_) ? _(o) : _, T), Ae = (_, T = {}) => {
    const G = Ye(i, _), J = G && G._f;
    if (J) {
      const O = J.refs ? J.refs[0] : J.ref;
      O.focus && (O.focus(), T.shouldSelect && fr(O.select) && O.select());
    }
  }, Re = (_) => {
    r = {
      ...r,
      ..._
    };
  }, F = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: H,
      _getDirty: R,
      _setValid: C,
      _setFieldArray: q,
      _setDisabledField: Te,
      _setErrors: E,
      _getFieldArray: ne,
      _reset: he,
      _resetDefaultValues: () => fr(n.defaultValues) && n.defaultValues().then((_) => {
        Ie(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ke,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: je,
    trigger: be,
    register: an,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...F,
    formControl: F
  };
}
function cr(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: fr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: fr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Ew(e),
    formState: i
  }, e.formControl && e.defaultValues && !fr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Jr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !$t(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = s_(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ml = { exports: {} }, ta = {}, Lf;
function Tw() {
  if (Lf) return ta;
  Lf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ta.Fragment = r, ta.jsx = s, ta.jsxs = s, ta;
}
var ho = {}, Vf;
function $w() {
  return Vf || (Vf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    ho.Fragment = i, ho.jsx = Rn, ho.jsxs = Bn;
  })()), ho;
}
var zf;
function Dw() {
  return zf || (zf = 1, process.env.NODE_ENV === "production" ? ml.exports = Tw() : ml.exports = $w()), ml.exports;
}
var _e = Dw();
const Rw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Ow = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Pw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, Aw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, Lw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, Vw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, zw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Uw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Mw = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Pw,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": Aw,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": Lw,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Rw,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Ow,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Vw,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": zw,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Uw
};
function Bi(e) {
  return Mw[e] ?? {};
}
const Bw = Bi(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), qw = Bi(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Hw = Bi(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Uf = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, ir = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, Ww = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Mf = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Zu = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ _e.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ _e.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function Kw({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: k, showModal: N, executeQuery: S } = un(), { track: w } = kn(), {
    loading: C,
    data: g,
    error: q,
    store: $
  } = jm(e ?? null), E = g?.github?.issues || [], D = g?.github?.pullRequests || [], [z, Z] = se(!1), [Q, te] = se();
  He(
    () => h(q || Q || void 0),
    [q, Q]
  ), He(
    () => {
      !C && (E?.length || D?.length) ? (a(E), s(D), B(E, D)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const Y = async (fe, W) => {
    await $(fe).then(() => {
      k({
        icon: "check-circle-filled",
        severity: "success",
        title: W.success.title,
        text: W.success.text
      });
    }).catch((be) => {
      k({
        title: W.error.title,
        text: `${W.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (fe, W) => {
    if (!fe?.length && !W?.length) {
      d([]), u([]);
      return;
    }
    const be = (fe || []).map(
      (qe) => S(qw, {
        owner: qe.owner,
        repositoryName: qe.repository,
        issueNumber: qe.number
      })
    ), Ce = (W || []).map(
      (qe) => S(Hw, {
        owner: qe.owner,
        repositoryName: qe.repository,
        prNumber: qe.number
      })
    ), K = [...be, ...Ce];
    Z(!0), Promise.all(K).then((qe) => {
      const Be = [], Pe = [];
      qe.forEach((Me) => {
        const je = Me?.data?.GitHub;
        if (!je) {
          d([]), u([]);
          return;
        }
        Object.keys(je).forEach((Le) => {
          if (Le.startsWith("repository")) {
            const Te = je[Le];
            Object.keys(Te).forEach((an) => {
              const we = Te[an], Ke = {
                number: we?.number,
                owner: we?.repository?.owner?.login,
                repository: we?.repository?.name
              };
              an.startsWith("issue") && Be.push({
                ...we,
                type: "ISSUE",
                key: Ke
              }), an.startsWith("pullRequest") && Pe.push({
                ...we,
                type: "PR",
                key: Ke
              });
            });
          }
        });
      }), d(Be), u(Pe);
    }).catch(te).finally(() => {
      Z(!1);
    });
  }, R = ({ key: fe, type: W }) => {
    w("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (E.length || D.length) ? g : r, Ce = W === "ISSUE" ? "issues" : "pullRequests";
    be.github[Ce] = Array.from(
      new Set(be.github[Ce]).add(fe)
    ), Y(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${ir(
          fe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ir(fe)} failed. Please try again.`
      }
    });
  }, H = async ({ key: fe, type: W }) => {
    w("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (E.length || D.length) ? g : r, Ce = W === "ISSUE" ? "issues" : "pullRequests";
    be.github[Ce] = Array.from(
      new Set(be.github[Ce]).add(fe)
    ), await $(be).catch((K) => {
      k({
        title: "Linking failed",
        text: `Linking ${fe} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ne = ({ key: fe, type: W }) => {
    w("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = W === "ISSUE" ? "issue" : "pull request";
    N({
      headline: `Unlink ${be} ${ir(fe)}?`,
      text: `You are about to unlink the ${be} ${ir(
        fe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ce = W === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const K = {
          ...g,
          github: {
            ...g?.github,
            [Ce]: g?.github?.[Ce].filter(
              (qe) => qe.number !== fe.number || qe.owner !== fe.owner || qe.repository !== fe.repository
            )
          }
        };
        w("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), Y(K, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${ir(
              fe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ir(fe)} failed.`
          }
        });
      },
      onCancel: () => {
        w("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ve = () => {
    w("github:unlink:all:clicked", {
      githubOrganization: n
    }), N({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        w("github:unlink:all:confirmed", {
          githubOrganization: n
        }), Y(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        w("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, de = E.filter(
    (fe) => !i?.includes(fe)
  ) || [], le = D.filter(
    (fe) => !o?.includes(fe)
  ) || [];
  return {
    linkGithubItem: R,
    linkGithubItemQuietly: H,
    unlinkGithubItem: ne,
    loadGithubItems: B,
    removeDanglingGithubItemLinks: () => {
      const fe = {
        ...g,
        github: {
          ...g?.github,
          issues: E.filter(
            (W) => !de.includes(W)
          ) || [],
          pullRequests: D.filter(
            (W) => !le.includes(W)
          ) || []
        }
      };
      $(fe);
    },
    unlinkAllGithubItems: ve,
    isLoadingGithubItemLinks: C,
    danglingIssueLinks: de,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: z,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const Gw = "_contentWrapper_1vx3c_1", Yw = "_contentWrapperHeadline_1vx3c_4", Jw = "_contentWrapperBody_1vx3c_11", Qw = "_contentWrapperAssigneeIcon_1vx3c_15", Xw = "_contentWrapperStatusTag_1vx3c_20", Vr = {
  contentWrapper: Gw,
  contentWrapperHeadline: Yw,
  contentWrapperBody: Jw,
  contentWrapperAssigneeIcon: Qw,
  contentWrapperStatusTag: Xw
}, h_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
  e && /* @__PURE__ */ _e.jsxs(Qn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ _e.jsxs(Qn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ _e.jsxs(Qn, { margin: "100 0", children: [
        /* @__PURE__ */ _e.jsx(
          "img",
          {
            className: Vr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ _e.jsx(
      Pn,
      {
        className: Vr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), Zw = "_collapse_1bdjy_1", eC = "_collapseHeader_1bdjy_10", nC = "_collapseHeaderKey_1bdjy_31", tC = "_collapseHeaderKeyIcon_1bdjy_36", rC = "_collapseHeaderKeyLink_1bdjy_41", iC = "_collapseHeaderIcon_1bdjy_44", aC = "_collapseHeaderTitle_1bdjy_49", oC = "_collapseContent_1bdjy_57", sC = "_collapseContentButtonSpacer_1bdjy_60", lC = "_collapseContentButtonLink_1bdjy_63", Nr = {
  collapse: Zw,
  collapseHeader: eC,
  collapseHeaderKey: nC,
  collapseHeaderKeyIcon: tC,
  collapseHeaderKeyLink: rC,
  collapseHeaderIcon: iC,
  collapseHeaderTitle: aC,
  collapseContent: oC,
  collapseContentButtonSpacer: sC,
  collapseContentButtonLink: lC
}, cC = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ _e.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: k,
      repository: N,
      type: S,
      state: w,
      assignees: C,
      labels: g
    } = d, q = a[m];
    return /* @__PURE__ */ _e.jsxs(
      or,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: q,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ _e.jsx(or.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ _e.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ _e.jsx(Qn, { children: /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: Nr.collapseHeaderKey, children: [
                  Zu(
                    S,
                    w,
                    Nr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ _e.jsxs(
                    "a",
                    {
                      href: Uf(f),
                      className: Nr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: ($) => {
                        $.stopPropagation();
                      },
                      children: [
                        ir(f),
                        /* @__PURE__ */ _e.jsx(
                          ue,
                          {
                            className: Nr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ _e.jsx(Qn, { className: Nr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ _e.jsx(or.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ _e.jsx(
              h_,
              {
                description: k,
                assignees: C,
                labels: g
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              Wn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: N?.owner.login,
                    repository: d.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  Mf(S)
                ]
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              wt,
              {
                slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Uf(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Mf(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ _e.jsx(_e.Fragment, {}) });
}, dC = "_result_1uaom_1", uC = "_resultName_1uaom_21", mC = "_resultItemIcon_1uaom_29", pC = "_resultDescription_1uaom_34", fC = "_resultLinkIcon_1uaom_46", hC = "_tooltip_1uaom_55", yC = "_tooltipName_1uaom_61", gC = "_tooltipTag_1uaom_71", zr = {
  result: dC,
  resultName: uC,
  resultItemIcon: mC,
  resultDescription: pC,
  resultLinkIcon: fC,
  tooltip: hC,
  tooltipName: yC,
  tooltipTag: gC
}, vC = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ _e.jsx(
    Ge,
    {
      className: zr.tooltip,
      content: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ _e.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: zr.tooltipName, children: [
                Zu(a, o, zr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ _e.jsx(Pn, { className: zr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ _e.jsx(
          h_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ _e.jsxs(
        "button",
        {
          className: zr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ _e.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: zr.resultName, children: [
                    Zu(a, o, zr.resultItemIcon),
                    ir(r)
                  ] }) }),
                  /* @__PURE__ */ _e.jsx(Qn, { className: zr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ _e.jsx(
              ue,
              {
                className: zr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, kC = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ _e.jsx(
  wt,
  {
    slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), ps = "[a-zA-z0-9_.-]+", y_ = "[0-9]+", bC = new RegExp(
  `(${ps})/(${ps})/(?:issues|pull)/(${y_})`,
  "i"
), Bf = new RegExp(`^${bC.source}$`), qf = new RegExp(
  `https://github.com/(${ps})/(${ps})/(?:issues|pull)/(${y_})`,
  "i"
), _C = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Kn(() => r?.map((D) => D.id) || [], [r]), o = Kn(() => i?.map((D) => D.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = un(), [m, u] = se(), [f, { loading: h, error: k, data: N, networkStatus: S }] = d(Bw, {
    notifyOnNetworkStatusChange: !0
  });
  gi(
    () => {
      !h && m && S === Gt.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), He(() => {
    let D = N?.GitHub?.issues?.nodes || [], z = N?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (D = D.filter((Z) => !a.includes(Z.id))), o.length > 0 && (z = z.filter(
      (Z) => !o.includes(Z.id)
    )), l([
      ...D.map((Z) => ({
        ...Z,
        type: "ISSUE",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      })),
      ...z.map((Z) => ({
        ...Z,
        type: "PR",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      }))
    ]);
  }, [N, a, o]);
  function w(D) {
    const z = D?.trim();
    if (Bf.test(z)) {
      const [Z, Q, te, Y] = z.match(Bf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(Y)
      };
    }
    if (qf.test(z)) {
      const [Z, Q, te, Y] = z.match(qf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(Y)
      };
    }
  }
  const C = (D) => {
    e({
      key: Ww(D),
      type: D.type
    }), u(void 0);
  }, g = (D) => {
    const z = w(D);
    u(
      z ? `org:${z.owner} repo:${z.repository} ${z.number}` : `org:${n} ${D}`
    );
  }, q = () => {
    u(void 0);
  }, $ = ({ className: D, searched: z }) => /* @__PURE__ */ _e.jsx(
    kC,
    {
      className: D,
      searched: z,
      githubOrganization: n
    }
  ), E = ({ item: D, onSelect: z }) => /* @__PURE__ */ _e.jsx(vC, { item: D, onSelect: z });
  return !h && k ? /* @__PURE__ */ _e.jsx(Fn, { error: k }) : /* @__PURE__ */ _e.jsx(
    _r,
    {
      items: s?.map((D) => ({ name: D.title, ...D })),
      loading: h,
      onSearch: g,
      onSelect: C,
      onClear: q,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: $,
      itemComponent: E,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, xC = "_itemButton_3sxfy_1", SC = "_result_3sxfy_6", NC = "_resultName_3sxfy_30", jC = "_resultCheckIcon_3sxfy_38", wC = "_resultAssigneeIcon_3sxfy_41", ra = {
  itemButton: xC,
  result: SC,
  resultName: NC,
  resultCheckIcon: jC,
  resultAssigneeIcon: wC
}, g_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ _e.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ _e.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: ra.itemButton,
        children: /* @__PURE__ */ _e.jsxs(b, { className: ra.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ _e.jsx(Qn, { margin: "100 0", children: /* @__PURE__ */ _e.jsx(
            "img",
            {
              className: ra.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ _e.jsx(Qn, { className: ra.resultName, children: e.name }),
          n && /* @__PURE__ */ _e.jsx(Qn, { className: ra.resultCheckIcon, children: /* @__PURE__ */ _e.jsx(ue, { name: "done" }) })
        ] })
      }
    )
  }
), CC = Bi(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), FC = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: k, networkStatus: N }] = a(
    CC,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return gi(
    () => {
      !f && l && l.length >= m && N === Gt.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const S = k?.GitHub?.organization?.teams || { edges: [] }, w = [];
    S?.edges?.forEach((C) => {
      const g = C?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((q) => {
        const $ = q?.node;
        $ && ($?.id && w.find((E) => E.id === $.id) || w.push($));
      });
    }), s(
      w.sort((C, g) => {
        const q = C.name?.toLowerCase() || C.login?.toLowerCase(), $ = g.name?.toLowerCase() || g.login?.toLowerCase();
        return q.localeCompare($, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [k]), !f && h ? /* @__PURE__ */ _e.jsx(Fn, { error: h }) : /* @__PURE__ */ _e.jsx(
    _r,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: w, login: C, avatarUrl: g }) => ({
        id: S,
        name: w || C,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (S) => d(S),
      onChange: (S, w) => {
        const C = S.id;
        i ? (w && !n.find(
          (g) => g.id === C
        ) && n.push(S), w || (n = n.filter(
          (g) => g.id !== C
        ))) : n = w ? [S] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: w, checked: C }) => /* @__PURE__ */ _e.jsx(
        g_,
        {
          item: S,
          checked: C,
          onSelectItem: w
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, IC = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ _e.jsx(kr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ _e.jsx(
        _r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ _e.jsx(
        Es,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ _e.jsx(kr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ _e.jsx(
        _r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ _e.jsx(kr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ _e.jsx(Bu, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ _e.jsx(
        FC,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, EC = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ _e.jsx(_e.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ _e.jsx(
  Lt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ _e.jsx(
      Ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: IC({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), TC = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ _e.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ _e.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ _e.jsx(ue, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ _e.jsx(Ln, { label: "GitHub issue link", children: /* @__PURE__ */ _e.jsx(
          kr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, $C = "_modalBody_1hk1o_1", DC = "_modalBodyFormFields_1hk1o_4", pl = {
  modalBody: $C,
  modalBodyFormFields: DC
}, RC = Bi(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), OC = Bi(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), PC = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], AC = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = un(), { track: d } = kn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: k
  } = cr(), [N, S] = se(""), [w, C] = se([]), [g, q] = se(), [$, E] = se(!1), [D, z] = se(!1), [Z, Q] = n_(), [
    te,
    {
      loading: Y,
      error: B,
      networkStatus: R
    }
  ] = s(RC, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ce) => {
      C(
        Ce.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), C([]);
    }
  });
  gi(
    () => {
      !Y && N && R === Gt.ready ? te({
        variables: {
          query: N,
          maxResults: 10
        }
      }) : C([]);
    },
    500,
    [N]
  );
  const [H, { error: ne }] = l(
    OC,
    {
      onError: (Ce) => {
        E(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ce);
      },
      onCompleted: (Ce) => {
        E(!1);
        const K = Ce.GitHub.createIssue?.issue;
        q(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ve = (Ce) => {
    S(`org:${a} ${Ce}`);
  }, de = (Ce, K) => {
    K(Ce), S("");
  }, le = () => {
    S("");
  }, fe = (Ce) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), E(!0), H({
      variables: {
        input: {
          repositoryId: Ce.repository.id,
          title: Ce.title,
          body: Ce.body,
          assigneeIds: Ce.assignees?.length > 0 ? Ce.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  He(() => {
    const Ce = D ? window.setTimeout(() => z(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ce);
  }, [D]);
  const W = () => {
    S(""), C([]), q(void 0), E(!1), z(!1);
  }, be = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), W(), h(), n();
  };
  return /* @__PURE__ */ _e.jsxs(
    gt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ _e.jsx(
          vt,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ _e.jsxs(kt, { className: pl.modalBody, children: [
          !Y && B && /* @__PURE__ */ _e.jsx(Fn, { error: B }),
          !$ && ne && /* @__PURE__ */ _e.jsx(Fn, { error: ne }),
          g ? /* @__PURE__ */ _e.jsx(
            TC,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: D,
              setIssueLinkCopied: z,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ _e.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(fe),
              children: /* @__PURE__ */ _e.jsxs(Ut, { children: [
                /* @__PURE__ */ _e.jsx(tn, { children: /* @__PURE__ */ _e.jsx(Ln, { label: "Repository", required: !0, children: /* @__PURE__ */ _e.jsx(
                  Lt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ce, value: K } }) => /* @__PURE__ */ _e.jsx(
                      _r,
                      {
                        className: pl.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: Y,
                        onSearch: ve,
                        onSelect: (qe) => de(qe, Ce),
                        onClear: le,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: B ? "No repositories found" : "No repositories available",
                        items: w || [],
                        itemComponent: ({ item: qe, onSelect: Be, checked: Pe }) => /* @__PURE__ */ _e.jsx(
                          g_,
                          {
                            item: qe,
                            checked: Pe,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ _e.jsx(tn, { className: pl.modalBodyFormFields, children: /* @__PURE__ */ _e.jsx(
                  EC,
                  {
                    control: m,
                    errors: f,
                    getValues: k,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: PC
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ _e.jsx(
          Ct,
          {
            confirmOnClick: g ? be : u(fe),
            confirmProps: {
              isLoading: $,
              loadingIndicator: /* @__PURE__ */ _e.jsx(cn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : be
          }
        )
      ]
    }
  );
}, LC = "_wrapper_19v8w_1", VC = "_inputWrapper_19v8w_6", zC = "_buttonLink_19v8w_19", UC = "_noItemsFound_19v8w_23", MC = "_createIssueButton_19v8w_28", Si = {
  wrapper: LC,
  inputWrapper: VC,
  buttonLink: zC,
  noItemsFound: UC,
  createIssueButton: MC
}, BC = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = kn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: k,
    danglingIssueLinks: N,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: w,
    issues: C,
    pullRequests: g,
    error: q
  } = Kw({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), $ = (Q) => d({ key: Q, type: "ISSUE" }), E = !(!!C?.length).valueOf() && !(!!g?.length).valueOf() && !(!!N?.length).valueOf() && !(!!S?.length).valueOf(), D = !k && !w && !!N?.length && !!S?.length && !!n?.showDanglingLinks, z = n?.enableCreateIssue, Z = !!C?.length || !!g?.length;
  return !w && q ? /* @__PURE__ */ _e.jsx(Fn, { error: q, retry: () => u() }) : /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsxs(b, { className: Si.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ _e.jsxs(b, { className: Si.inputWrapper, flexDirection: "column", children: [
        z && /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
          /* @__PURE__ */ _e.jsx(
            Wn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Si.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ _e.jsx("div", { className: Si.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ _e.jsx(
          _C,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: C,
            linkedPullRequests: g
          }
        )
      ] }),
      w ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ _e.jsx(cn, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ _e.jsx(
        cC,
        {
          items: [...C, ...g],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ _e.jsx(A.Paragraph, { align: "center", className: Si.noItemsFound, children: "No linked items found." }),
      D && /* @__PURE__ */ _e.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ _e.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ _e.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              N.map((Q) => /* @__PURE__ */ _e.jsx(
                Pn,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: ir(Q)
                },
                ir(Q)
              )),
              S.map((Q) => /* @__PURE__ */ _e.jsx(
                Pn,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: ir(Q)
                },
                ir(Q)
              ))
            ] }),
            /* @__PURE__ */ _e.jsx(
              Wn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ _e.jsx(
        Wn,
        {
          variant: "secondary",
          disabled: E,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ _e.jsx(
        wt,
        {
          slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: Si.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ _e.jsx(
      AC,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: $,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, qC = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ja
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fl = { exports: {} }, ia = {}, Hf;
function HC() {
  if (Hf) return ia;
  Hf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ia.Fragment = r, ia.jsx = s, ia.jsxs = s, ia;
}
var yo = {}, Wf;
function WC() {
  return Wf || (Wf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    yo.Fragment = i, yo.jsx = Rn, yo.jsxs = Bn;
  })()), yo;
}
var Kf;
function KC() {
  return Kf || (Kf = 1, process.env.NODE_ENV === "production" ? fl.exports = HC() : fl.exports = WC()), fl.exports;
}
var Ee = KC(), Da = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Da || {}), ai = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ai || {}), Mt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Mt || {});
const GC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, YC = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": GC
};
function JC(e) {
  return YC[e] ?? {};
}
const QC = JC(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Gf = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, v_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, XC = "_listItem_16pij_4", ZC = "_clickableIcon_16pij_15", fs = {
  listItem: XC,
  clickableIcon: ZC
}, k_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ Ee.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: fs.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ Ee.jsx(We, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: k } = l, N = l.currency ?? r;
      return /* @__PURE__ */ Ee.jsx(
        We.Item,
        {
          contentLeft: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ Ee.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: v_(f / 100, N) })
          ] }),
          contentRight: h && /* @__PURE__ */ Ee.jsx(zi, { src: h, alt: m ?? "Product image" }),
          className: fs.listItem
        },
        `item-${d}-${k}`
      );
    }) })
  ] }) });
}, e1 = "_boxWrapper_89s7l_1", n1 = "_trackButton_89s7l_10", Yf = {
  boxWrapper: e1,
  trackButton: n1
}, t1 = {
  [Mt.StepUnknown]: "Unknown",
  [Mt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Mt.StepPreparedByMerchant]: "Prepared by merchant",
  [Mt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Mt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Mt.StepOnRoute]: "On route",
  [Mt.StepDeliveredToPickupPoint]: "At pickup point",
  [Mt.StepDeliveredToConsumer]: "Delivered to customer",
  [Mt.StepDeliveredToMerchant]: "Returned to merchant",
  [Mt.StepReturnRequested]: "Return requested",
  [Mt.StepSentBack]: "Sent back",
  [Mt.StepTerminated]: "Terminated",
  [Mt.StepAwaitingSupplier]: "Awaiting supplier"
}, r1 = {
  [ai.Delivery]: "Home delivery",
  [ai.Pickup]: "Pickup point",
  [ai.Instore]: "In-store pickup",
  [ai.Mailbox]: "Mailbox",
  [ai.Inwarehouse]: "Warehouse",
  [ai.Unknown]: "Unknown"
}, i1 = {
  [Da.Outbound]: "From merchant to customer",
  [Da.Return]: "Return from customer to merchant",
  [Da.Unspecified]: "Unspecified",
  [Da.UnknownDirectionType]: "Unknown"
}, a1 = (e) => e ? t1[e] ?? e : "", o1 = (e) => e ? r1[e] ?? e : "", s1 = (e) => e ? i1[e] ?? e : "", l1 = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, c1 = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = nr();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, k = m || l || i, N = a?.filter(($) => $?.time !== ""), S = a1(N?.[0]?.step), w = o1(u), C = s1(f), g = l1(e.location?.address), q = 14;
  return /* @__PURE__ */ Ee.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Yf.boxWrapper,
      children: [
        /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-4", children: k }),
        /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: q,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ Ee.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ee.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ Ee.jsx(
            ue,
            {
              size: q,
              name: n ? "done" : "copy",
              className: fs.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        S && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: q, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        C && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: q, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: C })
          ] })
        ] }),
        h && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: q, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Gf(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Gf(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: q, name: "info", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        g && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: q, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ Ee.jsx(k_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ Ee.jsxs(
          wt,
          {
            variant: "secondary",
            className: Yf.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ Ee.jsx(ue, { name: "external-link" }),
            children: [
              "Track on ",
              k ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, d1 = "_order_135ze_1", u1 = "_orderIsOpen_135ze_9", m1 = "_orderHeader_135ze_12", hl = {
  order: d1,
  orderIsOpen: u1,
  orderHeader: m1
}, p1 = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = nr();
  if (!e)
    return null;
  const {
    cart: s,
    parcels: l,
    external_id: d,
    sender_name: m,
    tos_id: u
  } = e, f = s?.currency || "", h = s?.prices?.total?.price ?? 0, k = v_(h / 100, f), N = 14, S = m && m.trim() !== "" ? m : "unknown sender";
  return /* @__PURE__ */ Ee.jsxs(
    b,
    {
      className: ut(hl.order, {
        [hl.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ee.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: hl.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  S
                ] }),
                /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "3", children: [
                  "#",
                  d
                ] })
              ] }),
              /* @__PURE__ */ Ee.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Ee.jsx(
                ue,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !u && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  u && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: u })
                ] })
              ] })
            ] }),
            u && /* @__PURE__ */ Ee.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ee.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: N,
                name: a ? "done" : "copy",
                className: fs.clickableIcon,
                onClick: () => o(u)
              }
            ) }) })
          ] }),
          m && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: m })
            ] })
          ] }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: k })
            ] })
          ] }),
          /* @__PURE__ */ Ee.jsx(
            k_,
            {
              openByDefault: !0,
              title: "Order items",
              items: s?.items?.map((w) => w),
              currency: s?.currency
            }
          ),
          l && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              l.length > 0 && /* @__PURE__ */ Ee.jsx(Un, { variant: "success", size: "small", children: l.length })
            ] }),
            l.length === 0 && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            l.map((w, C) => /* @__PURE__ */ Ee.jsx(
              c1,
              {
                parcel: w
              },
              `parcel-${C}-${w?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, f1 = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, h1 = ({
  customerEmail: e
}) => {
  const { useQuery: n } = un(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(QC, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? ES({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? fb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return He(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(f1(f.orders));
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ee.jsx(cn, {}) }) : m || !d && !l ? /* @__PURE__ */ Ee.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ Ee.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ Ee.jsx(Fn, { error: l }) : /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ Ee.jsx(Un, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ Ee.jsx(
      p1,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, y1 = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ Ee.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ Ee.jsx(h1, { customerEmail: n })
    }
  );
}, g1 = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var yl = { exports: {} }, aa = {}, Jf;
function v1() {
  if (Jf) return aa;
  Jf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return aa.Fragment = r, aa.jsx = s, aa.jsxs = s, aa;
}
var go = {}, Qf;
function k1() {
  return Qf || (Qf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    go.Fragment = i, go.jsx = Rn, go.jsxs = Bn;
  })()), go;
}
var Xf;
function b1() {
  return Xf || (Xf = 1, process.env.NODE_ENV === "production" ? yl.exports = v1() : yl.exports = k1()), yl.exports;
}
var ye = b1();
const Wm = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Wm(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, _1 = "_jiraCode_h30p6_1", x1 = "_jiraCodeInline_h30p6_8", gl = {
  jiraCode: _1,
  jiraCodeInline: x1
}, b_ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ye.jsx(ye.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ye.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ye.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ye.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ye.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ye.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ye.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ye.jsx("pre", { children: /* @__PURE__ */ ye.jsx("code", { className: gl.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ye.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ye.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ye.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ye.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ye.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ye.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ye.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ye.jsx("code", { className: ut(gl.jiraCode, gl.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, hs = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ ye.jsx(ue, { size: r, name: "question", className: n }) : /* @__PURE__ */ ye.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, S1 = "_collapse_m2gjh_1", N1 = "_collapseHeader_m2gjh_10", j1 = "_collapseHeaderLink_m2gjh_31", w1 = "_collapseHeaderStatus_m2gjh_40", C1 = "_collapseHeaderTitle_m2gjh_51", F1 = "_collapseContent_m2gjh_59", I1 = "_collapseContentHeadline_m2gjh_62", E1 = "_collapseContentButtonSpacer_m2gjh_68", T1 = "_collapseContentButtonLink_m2gjh_71", $1 = "_collapseContentStatusTag_m2gjh_74", D1 = "_collapseContentDescription_m2gjh_77", mr = {
  collapse: S1,
  collapseHeader: N1,
  collapseHeaderLink: j1,
  collapseHeaderStatus: w1,
  collapseHeaderTitle: C1,
  collapseContent: F1,
  collapseContentHeadline: I1,
  collapseContentButtonSpacer: E1,
  collapseContentButtonLink: T1,
  collapseContentStatusTag: $1,
  collapseContentDescription: D1
}, __ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, R1 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ye.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, k = __({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), N = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ ye.jsxs(
      or,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: N,
        className: mr.collapse,
        children: [
          /* @__PURE__ */ ye.jsx(or.Header, { className: mr.collapseHeader, children: /* @__PURE__ */ ye.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ye.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ye.jsx(hs, { width: 16, iconUrl: k }),
                    /* @__PURE__ */ ye.jsx(
                      "a",
                      {
                        className: mr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ ye.jsx(ue, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ ye.jsx("span", { className: mr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ye.jsx(Pn, { className: mr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ye.jsx("div", { className: mr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ ye.jsx(or.Content, { className: mr.collapseContent, children: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ye.jsx("div", { className: mr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ye.jsx(Qn, { className: mr.collapseContentDescription, children: u ? Wm(u, b_) : "" }),
            /* @__PURE__ */ ye.jsx(
              Wn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: mr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ye.jsx(
              wt,
              {
                slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: mr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ ye.jsx(ye.Fragment, {}) });
}, O1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, P1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, A1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, L1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, V1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, z1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, U1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, M1 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': O1,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": P1,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": A1,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": L1,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': V1,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': z1,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": U1
};
function vi(e) {
  return M1[e] ?? {};
}
const x_ = vi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), B1 = vi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), q1 = vi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), H1 = vi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), W1 = vi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), K1 = vi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), G1 = vi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Km = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), Y1 = new RegExp(`^${Km.source}$`), J1 = new RegExp(`/${Km.source}$`), Zf = new RegExp(
  `.+?[&?]selectedIssue=(${Km.source})[&?]?.*`
);
function S_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = kn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: k } = un(), {
    loading: N,
    data: S,
    error: w,
    store: C
  } = jm(e ?? null), [
    g,
    { loading: q, error: $, data: E }
  ] = h(x_, {
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    const le = E?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((fe) => fe?.key).filter(Boolean)));
  }, [E]), He(
    () => d(w || $ || void 0),
    [w, $]
  ), He(
    () => {
      N || B();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, N]
  );
  const D = async (le, fe) => {
    await C(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: fe.success.title,
        text: fe.success.text
      });
    }).catch((W) => {
      u({
        title: fe.error.title,
        text: `${fe.error.text} ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [z] = k(B1, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Z = (le, fe) => {
    const W = window.location.href, be = fe ? W.replace(
      e?.toString() ?? "",
      fe?.toString()
    ) : W, Ce = fe ? `# ${fe}` : `# ${e}`;
    z({
      variables: {
        issueKey: le,
        title: Ce,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [Q] = k(q1, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), te = (le) => {
    const fe = window.location.href;
    Q({
      variables: {
        issueKey: le,
        globalId: `system=${fe}`
      }
    });
  }, Y = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), B = () => {
    S && S.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, R = async (le, fe) => {
    m("jira:issue:link:clicked", Y(le));
    const W = S?.jira?.issues ? S : r;
    W.jira.issues = Array.from(
      new Set(W.jira.issues).add(le)
    ), await C(W, fe?.toString()).then(() => Z(le, fe)).catch((be) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, H = (le) => {
    m("jira:issue:link:clicked", Y(le));
    const fe = S?.jira?.issues ? S : r;
    fe.jira.issues = Array.from(
      new Set(fe.jira.issues).add(le)
    ), D(fe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => Z(le));
  }, ne = (le) => {
    m("jira:issue:unlink:clicked", Y(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", Y(le));
        const fe = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((W) => W !== le) || []
          }
        };
        D(fe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => te(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", Y(le))
    });
  }, ve = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && te(le.key)), D(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, de = S?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: H,
    linkIssueQuietly: R,
    unlinkIssue: ne,
    loadIssues: B,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (fe) => !de.includes(fe)
          ) || []
        }
      };
      C(le);
    },
    unlinkAllIssues: ve,
    maybeExtractIssueKey: (le) => {
      const fe = le.replace(/\s/g, "");
      if (Y1.test(fe))
        return fe;
      if (Zf.test(le))
        return le.match(Zf)?.[1];
      if (le.startsWith(n) && J1.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: N,
    danglingIssueLinks: de,
    isLoadingIssues: q,
    issues: o,
    error: l
  };
}
function Q1(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const X1 = "_result_axxxc_48", Z1 = "_resultName_axxxc_68", eF = "_resultNameIcon_axxxc_76", nF = "_resultDescription_axxxc_81", tF = "_resultLinkIcon_axxxc_93", rF = "_tooltip_axxxc_102", iF = "_tooltipContent_axxxc_108", aF = "_tooltipName_axxxc_115", oF = "_tooltipNameIcon_axxxc_120", sF = "_tooltipDescription_axxxc_125", lF = "_tooltipSummary_axxxc_133", cF = "_tooltipTag_axxxc_137", rr = {
  result: X1,
  resultName: Z1,
  resultNameIcon: eF,
  resultDescription: nF,
  resultLinkIcon: tF,
  tooltip: rF,
  tooltipContent: iF,
  tooltipName: aF,
  tooltipNameIcon: oF,
  tooltipDescription: sF,
  tooltipSummary: lF,
  tooltipTag: cF
}, dF = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = __({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ye.jsx(
    Ge,
    {
      disabled: i,
      className: rr.tooltip,
      content: /* @__PURE__ */ ye.jsxs("div", { className: rr.tooltipContent, children: [
        /* @__PURE__ */ ye.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ye.jsxs("span", { className: rr.tooltipName, children: [
                /* @__PURE__ */ ye.jsx(
                  hs,
                  {
                    width: 16,
                    iconUrl: h,
                    className: rr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ye.jsx(Pn, { className: rr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ ye.jsx("div", { className: rr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ ye.jsx("div", { className: rr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ye.jsxs(
        "button",
        {
          ...a,
          className: rr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ye.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ye.jsxs("span", { className: rr.resultName, children: [
                    /* @__PURE__ */ ye.jsx(
                      hs,
                      {
                        width: 16,
                        iconUrl: h,
                        className: rr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ ye.jsx("div", { className: rr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ ye.jsx(
              ue,
              {
                className: rr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, uF = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ye.jsx(
  wt,
  {
    slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), mF = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: k }] = a(x_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: N } = S_(null, n);
  gi(
    () => {
      !u && l && k === Gt.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const $ = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      $.map((E) => ({
        id: E?.key ?? "",
        name: E?.key ?? "",
        description: E?.fields.summary,
        status: E?.fields.status,
        issuetype: E?.fields.issuetype,
        text: E?.fields.description ? Wm(E?.fields.description, b_) : /* @__PURE__ */ ye.jsx(ye.Fragment, {})
      }))
    );
  }, [h]);
  const S = ($) => {
    e($.id), d("");
  }, w = ($) => {
    const E = $.trim(), D = N(E);
    if (D) {
      const z = D.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${z}'`);
    } else E !== "" && d(
      `text ~ '${E}'${r ? " and project = " + r : ""}`
    );
  }, C = () => {
    d("");
  }, g = ($) => /* @__PURE__ */ ye.jsx(uF, { ...$, jiraInstanceUrl: n }), q = ($) => /* @__PURE__ */ ye.jsx(
    dF,
    {
      ...$,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ ye.jsx(Fn, { error: f }) : /* @__PURE__ */ ye.jsx(
    _r,
    {
      items: o,
      loading: u,
      onSearch: w,
      onSelect: S,
      onClear: C,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: q,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, pF = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return He(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ye.jsx(
    _r,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, fF = "_itemButton_1hl53_1", hF = "_result_1hl53_6", yF = "_resultIcon_1hl53_26", gF = "_resultName_1hl53_30", vF = "_resultCheckIcon_1hl53_38", oa = {
  itemButton: fF,
  result: hF,
  resultIcon: yF,
  resultName: gF,
  resultCheckIcon: vF
}, em = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ye.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ye.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: oa.itemButton,
          children: /* @__PURE__ */ ye.jsxs(b, { className: oa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ye.jsx(
              hs,
              {
                width: 36,
                iconUrl: o || "",
                className: oa.resultIcon
              }
            ),
            /* @__PURE__ */ ye.jsx(Qn, { className: oa.resultName, children: e.name }),
            n && /* @__PURE__ */ ye.jsx(Qn, { className: oa.resultCheckIcon, children: /* @__PURE__ */ ye.jsx(ue, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, kF = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: k, networkStatus: N }] = a(G1, {
    notifyOnNetworkStatusChange: !0
  });
  return gi(
    () => {
      !f && l && l.length >= m && N === Gt.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const w = S?.data?.Jira?.findUsers[0];
        r(w.accountId), s([
          {
            id: w.accountId,
            name: w.displayName
          }
        ]);
      }
    });
  }, []), He(() => {
    const S = k?.Jira?.findUsers || [];
    s(
      S.filter(({ active: w }) => w).map(({ accountId: w, displayName: C, avatarUrls: g, active: q }) => ({
        id: w,
        name: C,
        avatarUrls: g,
        active: q
      }))
    );
  }, [k]), !f && h ? /* @__PURE__ */ ye.jsx(Fn, { error: h }) : /* @__PURE__ */ ye.jsx(
    _r,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => d(S),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: w, checked: C }) => /* @__PURE__ */ ye.jsx(
        em,
        {
          item: S,
          checked: C,
          onSelectItem: w,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, eh = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = n_();
  return He(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ye.jsx(b, { children: /* @__PURE__ */ ye.jsx(ue, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ye.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ye.jsx(Ge, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ye.jsx(
      Yt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, bF = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ye.jsx(eh, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ye.jsx(Bu, { onChange: n, value: r }) : /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ye.jsx(Bu, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ye.jsx(kr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ye.jsx(
        kF,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ye.jsx(
        _r,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ye.jsx(pF, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ye.jsx(eh, { field: e });
  }
}, _F = ["description", "reporter", "summary"], xF = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ye.jsx(ye.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || _F.includes(o)
).map((o) => /* @__PURE__ */ ye.jsx(
  Lt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ye.jsx(
      Ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: bF({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), SF = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ye.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ye.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ye.jsx(ue, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ye.jsx(Ln, { label: "Jira issue link", children: /* @__PURE__ */ ye.jsx(
        kr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), NF = "_modalBody_1hk1o_1", jF = "_modalBodyFormFields_1hk1o_4", nh = {
  modalBody: NF,
  modalBodyFormFields: jF
}, wF = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), CF = (e) => e?.custom?.split(":")?.[1] || null, FF = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, IF = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = FF(a, n), l = CF(s) ?? a;
        return r.includes(l) ? i[a] = wF(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, EF = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [k, N] = se([]), [S, w] = se([]), [C, g] = se(!1), [q, $] = se(!1), [E, D] = se({}), { track: z } = kn(), { isCopied: Z, copyToClipboard: Q } = Q1(), te = Kn(() => i?.conversationId, [e]), { useMutation: Y, useLazyQuery: B, showNotification: R } = un(), {
    control: H,
    handleSubmit: ne,
    formState: { errors: ve },
    reset: de,
    setValue: le,
    getValues: fe
  } = cr({
    defaultValues: s
  }), W = S.length > 0, be = `${a}/browse`, Ce = Object.keys(E).length > 0, [K, { loading: qe, error: Be }] = B(H1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      d(he.Jira.getAllProjects);
    },
    onError: (he) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", he), d([]);
    }
  }), [
    Pe,
    { loading: Me, error: je }
  ] = B(W1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      h(0);
      const Ie = he?.Jira?.getCreateIssueMeta?.projects[0];
      if (Ie) {
        const Ae = Ie?.issuetypes.filter(
          ({ subtask: Re }) => !Re
        );
        N(Ae || []), le(
          "issuetype",
          Ae.length > 0 ? Ae[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), N([]), w([]);
    },
    onError: (he) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", he), N([]), w([]), h(0);
    }
  }), [Le, { error: Te }] = Y(
    K1,
    {
      onError: () => {
        g(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), z("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (he) => {
        if (g(!1), he?.Jira && "key" in he.Jira.createIssue)
          u(he?.Jira?.createIssue), R({
            title: "Success",
            text: `Jira issue '${he.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), z("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: he.Jira.createIssue.key
          }), te && r(
            he.Jira.createIssue.key,
            te
          );
        else if ("errorMessages" in he.Jira.createIssue || "errors" in he.Jira.createIssue) {
          const Ie = he?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Ie), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), an = (he) => {
    g(!0), D({}), Le({
      variables: {
        input: IF(he, S)
      }
    });
  };
  He(() => {
    if (e)
      try {
        K();
      } catch (he) {
        console.warn("Error when fetching initial projects", he);
      }
  }, [e]), He(() => {
    const he = q ? window.setTimeout(() => $(!1), 2e3) : void 0;
    return () => window.clearTimeout(he);
  }, [q]), He(() => {
    if (k?.length > 0) {
      le("issuetype", k[f]);
      const he = k[f]?.fields?.additionalProperties;
      if (he?.length > 0) {
        const Ie = he.map(
          ({ value: F }) => F
        ), Ae = (o ? Ie.sort(({ name: F }, { name: _ }) => F.localeCompare(_)) : Ie).sort(
          ({ required: F }, { required: _ }) => Number(_) - Number(F)
        ), { project: Re, issuetype: Ue } = fe();
        de({ project: Re, issuetype: Ue }), w(Ae);
      }
    } else
      w([]), le("issuetype", void 0);
  }, [k, le, f]), He(() => {
    if (Te && bb(Te)) {
      if (Te?.graphQLErrors?.length > 0) {
        const { graphQLErrors: he } = Te, Ie = he[0].extensions?.integration?.responseBody;
        try {
          const Ae = JSON.parse(Ie);
          if (Ae?.errors) {
            const Re = Object.keys(Ae.errors).reduce(
              (Ue, F) => ({
                ...Ue,
                [F]: {
                  type: "required",
                  message: Ae.errors[F],
                  ref: {
                    name: F
                  }
                }
              }),
              {}
            );
            D(Re);
          }
        } catch {
        }
      }
    } else
      D({});
  }, [Te]);
  const we = () => {
    d([]), w([]), N([]), u(void 0), h(0), g(!1), D({});
  }, Ke = () => {
    we(), de(s), n();
  }, Ze = (he) => {
    he && Pe({
      variables: {
        projectKey: he
      }
    });
  }, me = (he) => {
    const Ie = k.map((Ae) => Ae.id).indexOf(he);
    h(Ie ?? 0);
  };
  return /* @__PURE__ */ ye.jsxs(
    gt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Ke,
      children: [
        /* @__PURE__ */ ye.jsx(
          vt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Ke
          }
        ),
        /* @__PURE__ */ ye.jsxs(kt, { className: nh.modalBody, children: [
          !qe && Be && /* @__PURE__ */ ye.jsx(Fn, { error: Be, retry: K }),
          !Me && je && /* @__PURE__ */ ye.jsx(
            Fn,
            {
              error: je,
              retry: Pe
            }
          ),
          !C && Ce && /* @__PURE__ */ ye.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ye.jsx(
            Ts,
            {
              variant: "warning",
              description: /* @__PURE__ */ ye.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ye.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ye.jsx(
                      Wn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ ye.jsx(
            SF,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: q,
              setIssueLinkCopied: $,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ ye.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ne(an),
              children: /* @__PURE__ */ ye.jsxs(Ut, { children: [
                /* @__PURE__ */ ye.jsx(tn, { span: 3, children: /* @__PURE__ */ ye.jsx(Ln, { label: "Project", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Lt,
                  {
                    control: H,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: he, value: Ie } }) => /* @__PURE__ */ ye.jsx(
                      _r,
                      {
                        searchable: !0,
                        loading: qe,
                        onSelect: (Ae) => {
                          Ze(Ae.key), he(Ae);
                        },
                        selectedItems: [Ie],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ae, onSelect: Re, checked: Ue }) => /* @__PURE__ */ ye.jsx(
                          em,
                          {
                            item: Ae,
                            checked: Ue,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ye.jsx(tn, { span: 3, children: /* @__PURE__ */ ye.jsx(Ln, { label: "Issue type", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Lt,
                  {
                    control: H,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: he, value: Ie } }) => /* @__PURE__ */ ye.jsx(
                      _r,
                      {
                        disabled: k.length === 0,
                        loading: Me,
                        onSelect: (Ae) => {
                          me(Ae.id), he(Ae);
                        },
                        selectedItems: [Ie],
                        placeholder: k.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: je ? "No issues found" : "No issues available",
                        items: k,
                        itemComponent: ({ item: Ae, onSelect: Re, checked: Ue }) => /* @__PURE__ */ ye.jsx(
                          em,
                          {
                            item: Ae,
                            checked: Ue,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                W && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ye.jsx(tn, { className: nh.modalBodyFormFields, children: /* @__PURE__ */ ye.jsx(
                  xF,
                  {
                    control: H,
                    errors: { ...ve, ...E },
                    getValues: fe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ye.jsx(
          Ct,
          {
            confirmOnClick: m ? Ke : ne(an),
            confirmProps: {
              disabled: !W,
              isLoading: C,
              loadingIndicator: /* @__PURE__ */ ye.jsx(cn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Ke
          }
        )
      ]
    }
  );
}, TF = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, $F = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, DF = "_wrapper_1bylq_1", RF = "_inputWrapper_1bylq_6", OF = "_inputSeparator_1bylq_18", PF = "_buttonLink_1bylq_23", AF = "_noIssuesFound_1bylq_27", sa = {
  wrapper: DF,
  inputWrapper: RF,
  inputSeparator: OF,
  buttonLink: PF,
  noIssuesFound: AF
}, LF = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), i = TF(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: k,
    isLoadingIssueLinks: N,
    isLoadingIssues: S,
    issues: w,
    error: C
  } = S_(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, q = !!n?.enableSortIssueTypeByLabel, $ = !!(w?.length || k?.length), E = !!n?.enableRemoveAllLinks && $, D = !N && !S && k?.length > 0 && !!n?.showDanglingLinks;
  return !S && C ? /* @__PURE__ */ ye.jsx(Fn, { error: C, retry: () => f() }) : /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
    /* @__PURE__ */ ye.jsxs(b, { className: sa.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ye.jsxs(b, { className: sa.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
          /* @__PURE__ */ ye.jsx(
            Wn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ye.jsx("div", { className: sa.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ye.jsx(
          mF,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ ye.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ye.jsx(cn, { "data-testid": "jira-widget-issue-spinner" }) }) : w?.length ? /* @__PURE__ */ ye.jsx(
        R1,
        {
          issues: w,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ ye.jsx(A.Paragraph, { align: "center", className: sa.noIssuesFound, children: "No linked issues found" }),
      E && w?.length > 0 && /* @__PURE__ */ ye.jsx(
        Wn,
        {
          variant: "secondary",
          disabled: !w?.length && !k?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      D && /* @__PURE__ */ ye.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ye.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: k.map((z) => /* @__PURE__ */ ye.jsx(Pn, { onDelete: () => m(z), children: z }, z)) }),
            /* @__PURE__ */ ye.jsx(
              Wn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ye.jsx(
        wt,
        {
          slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: sa.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ye.jsx(
      EF,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: q
      }
    )
  ] });
}, th = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => $F(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ja
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vl = { exports: {} }, la = {}, rh;
function VF() {
  if (rh) return la;
  rh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return la.Fragment = r, la.jsx = s, la.jsxs = s, la;
}
var vo = {}, ih;
function zF() {
  return ih || (ih = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    vo.Fragment = i, vo.jsx = Rn, vo.jsxs = Bn;
  })()), vo;
}
var ah;
function UF() {
  return ah || (ah = 1, process.env.NODE_ENV === "production" ? vl.exports = VF() : vl.exports = zF()), vl.exports;
}
var $e = UF();
function MF({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = un(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return He(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((N) => {
        const S = setTimeout(N, r);
        d([...l, S]);
      });
      const k = await s({
        variables: h
      });
      u.push(k);
    }
    o(u);
  }, a];
}
const BF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, qF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, WF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, KF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, GF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, YF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, JF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, QF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, XF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ZF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, eI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, nI = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": BF,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": qF,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": WF,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": KF,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": HF,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": GF,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": YF,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": JF,
  "\n  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": QF,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": XF,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ZF,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": eI
};
function Hr(e) {
  return nI[e] ?? {};
}
const tI = Hr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), rI = Hr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), iI = Hr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), aI = Hr(
  /* GraphQL */
  `
  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), oI = Hr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), sI = Hr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), lI = Hr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), cI = Hr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), dI = Hr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function nm(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function oh(e) {
  return nm(e) && e?.attributes?.event_properties?.$message;
}
function uI(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function sh(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function mI(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function pI(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function fI(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function hI(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function yI(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function gI(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function lh(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function vI(e) {
  return e?.attributes?.content?.__typename === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function kI(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const bI = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function _I(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function xI(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function SI({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = un(), { track: a } = kn(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [k, N] = se(
    null
  ), [S, w] = se([]), {
    data: C,
    error: g,
    loading: q,
    networkStatus: $
  } = i(iI, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    E,
    {
      data: D,
      error: z,
      loading: Z,
      networkStatus: Q
    }
  ] = r(tI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return He(() => {
    if (C && !q && $ === Gt.ready) {
      const te = mI(C);
      s(
        te.find((Y) => Y?.attributes?.name === "Received Email")?.id || null
      ), d(
        te.find((Y) => Y?.attributes?.name === "Opened Email")?.id || null
      ), u(
        te.find((Y) => Y?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        te.find((Y) => Y?.attributes?.name === "Bounced Email")?.id || null
      ), N(
        te.find((Y) => Y?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), N(null);
  }, [C]), He(() => {
    o && l && m && f && k && !Z && Q === Gt.ready ? E({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${k}")`,
        pageSize: n
      }
    }) : w([]);
  }, [
    o,
    l,
    m,
    f,
    k
  ]), He(() => {
    if (!Z && D) {
      const te = pI(D), Y = hI(
        D
      ).map(
        (de) => de?.attributes?.event_properties.$message
      ), B = yI(
        D
      ).map(
        (de) => de?.attributes?.event_properties.$message
      );
      te.forEach((de) => {
        const le = de.attributes?.event_properties.$message;
        de.opened = Y.includes(le), de.clicked = B.includes(le);
      });
      const R = fI(D), H = gI(D), ne = [
        ...te,
        ...H,
        ...R
      ].sort((de, le) => {
        const fe = sh(de), W = sh(le);
        return fe == null && W == null ? 0 : fe == null ? 1 : W == null ? -1 : W - fe;
      }).slice(0, n);
      w(ne);
      const ve = ne.map((de) => de.id);
      a("klaviyo:messages:received", {
        emailsReceived: te.filter(
          (de) => ve.includes(de.id)
        ).length,
        emailsBounced: H.filter(
          (de) => ve.includes(de.id)
        ).length,
        smsReceived: R.filter(
          (de) => ve.includes(de.id)
        ).length,
        total: ve.length
      });
    } else
      w([]);
  }, [Z, D]), Kn(
    () => ({
      receivedMessages: S,
      isLoading: q || Z,
      error: g || z
    }),
    [
      S,
      q,
      Z,
      g,
      z
    ]
  );
}
function NI({ profileId: e }) {
  const { useQuery: n } = un(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(oI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  He(() => {
    l && o(l);
  }, [l]), He(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Kn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function jI({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = kn(), { useLazyQuery: i } = un(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(aI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    if (!f && m) {
      const k = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, N = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(k, N);
    }
  }, [f, m]);
  const h = (k, N) => {
    const S = k?.data?.length === 1 && k.data[0]?.id || void 0, w = N?.data?.length === 1 && N.data[0]?.id || void 0, C = S || w, g = !S || !w || S === w;
    if (C && g) {
      o(S || w), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${w}).`
      )
    );
  };
  return Kn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const ch = 800, wI = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, CI = 3, FI = 1.5, II = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = CI,
  useDelayRange: a = !1
}) => {
  const o = (z) => Math.floor(Math.random() * (z.max - z.min) + z.min), [s, l] = se(0), [d, m] = se(n || ch), [u, f] = se(r || wI), [h, k] = se(!1), [N, S] = se(!1), w = a || !!r, C = w ? o(u) : n || ch, [g, q] = se(C);
  uw(
    async () => {
      const z = s + 1, Z = FI ** z;
      l(z), q(
        (w ? o(u) : d) * Z
      ), await e().then(() => {
        S(!0), D();
      });
    },
    h ? g : null
  ), pw(() => D());
  const $ = tt(() => {
    l(0), q(C);
  }, [C]), E = tt(
    (z = {}) => {
      const { delay: Z, delayRange: Q } = z;
      S(!1), $(), Q && (f(Q), q(o(Q))), Z && (m(Z), q(Z)), k(!0);
    },
    [$]
  ), D = tt(() => {
    k(!1), $();
  }, [$]);
  return He(() => {
    s >= i && D();
  }, [s, i, D]), Kn(
    () => ({ isRunning: h, isSuccessful: N, start: E, stop: D }),
    [h, N, E, D]
  );
}, EI = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, TI = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function $I({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = un(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? sI : lI,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: k,
    stop: N
  } = II({
    query: u,
    useDelayRange: !0
  }), S = m || h;
  return He(() => {
    if (d)
      if (DS({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const w = EI(d);
          k({
            ...w && {
              delayRange: TI(w)
            }
          });
        }
      } else
        s(d);
  }, [d]), He(() => {
    if (!m && l?.Klaviyo) {
      let w = {}, C = {};
      n === "lists" && (w = l?.Klaviyo?.get_profile_lists), n === "segments" && (C = l?.Klaviyo?.get_profile_segments), (w?.data || C?.data) && (N(), a(
        (n === "lists" ? w?.data : C?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Kn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: k,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, k]
  );
}
const DI = "_notificationText_1polx_1", Gm = {
  notificationText: DI
}, Vs = ({ error: e }) => {
  const { track: n } = kn();
  let r = e;
  if (bb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && fb({ error: i[0] }), o = i.length === 1 && $S({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ $e.jsx(Fn, { error: e });
  }
  return /* @__PURE__ */ $e.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ $e.jsx(
    We.Item,
    {
      contentLeft: /* @__PURE__ */ $e.jsx(ue, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, RI = "_message_1vrar_48", OI = "_messageIsOpen_1vrar_56", PI = "_messageHeader_1vrar_59", AI = "_messageLabel_1vrar_65", LI = "_messageText_1vrar_68", Di = {
  message: RI,
  messageIsOpen: OI,
  messageHeader: PI,
  messageLabel: AI,
  messageText: LI
}, VI = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && vI(e.flowMessage);
  return /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: Di.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ $e.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ $e.jsx(cn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ $e.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Di.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: Di.messageText, children: i })
        ]
      }
    )
  ] });
}, zI = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ $e.jsx($e.Fragment, { children: /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ $e.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, UI = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Kn(
    () => () => l ? An(l).format(m) : d ? An.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", k = f && e.opened, N = f && e.clicked, S = f && o?.event_properties.Subject, w = h && o?.event_properties["Message Name"], C = f ? "mail" : "sms";
  return /* @__PURE__ */ $e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ut(Di.message, {
        [Di.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ $e.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Di.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ $e.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ $e.jsx(ue, { size: 16, name: C }),
                  " ",
                  bI(s),
                  u && /* @__PURE__ */ $e.jsx(Un, { size: "small", variant: "info", children: u })
                ] }),
                S && S,
                w && w
              ] }),
              /* @__PURE__ */ $e.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ $e.jsx(Cm, {}),
          uI(e) && /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(Un, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
            /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ $e.jsx(Pn, { children: /* @__PURE__ */ $e.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  ue,
                  {
                    size: 16,
                    color: k ? "green.400" : "red.400",
                    name: k ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ $e.jsx(Pn, { children: /* @__PURE__ */ $e.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  ue,
                  {
                    size: 16,
                    color: N ? "green.400" : "red.400",
                    name: N ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ $e.jsx(VI, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ $e.jsx(zI, { event: e })
        ] })
      ]
    }
  );
}, MI = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, BI = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = SI({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = MF({
    query: rI,
    options: MI,
    delayMs: 1e3
  }), [m, u] = se([]);
  He(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((k) => nm(k)).map((k) => oh(k));
      h.length > 0 && (i(!0), l(
        h.map((k) => ({
          messageId: k
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), He(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && nm(h) && !h.flowMessage) {
          const k = oh(h), N = d.find((w) => (w.data && lh(w.data))?.id === k), S = N?.data && lh(N.data);
          if (S)
            return {
              ...kI(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: f.map((h, k) => h.graphQLErrors ? /* @__PURE__ */ $e.jsx(
    Fn,
    {
      error: h
    },
    `lastMessagesError${k}`
  ) : /* @__PURE__ */ $e.jsx(
    Vs,
    {
      error: h
    },
    `lastMessagesError${k}`
  )) }) : /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : /* @__PURE__ */ $e.jsx($e.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ $e.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, k) => /* @__PURE__ */ $e.jsx(
      UI,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: k === 0
      },
      h.id
    )) }) : /* @__PURE__ */ $e.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Gm.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, qI = "_list_ld0hf_1", HI = "_listItem_ld0hf_4", Ra = {
  list: qI,
  listItem: HI
}, dh = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = $I({ profileId: e, query: n });
  He(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ $e.jsx(Vs, { error: o }) : s ? /* @__PURE__ */ $e.jsx(We.Text, { variant: "dense", className: Ra.listItem, children: /* @__PURE__ */ $e.jsx(cn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: u.map(
    ({ attributes: f, type: h }, k) => /* @__PURE__ */ $e.jsx(We.Text, { variant: "dense", className: Ra.listItem, children: /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ $e.jsx(Pn, { children: Is(h) })
    ] }) }, k)
  ) }) : r && !a ? /* @__PURE__ */ $e.jsx(We.Text, { variant: "dense", className: Ra.listItem, children: /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ $e.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ $e.jsx(ue, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ $e.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ $e.jsx(Ge, { content: "Refresh lists and segments", children: /* @__PURE__ */ $e.jsx(Wn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ $e.jsx(We.Text, { variant: "dense", className: Ra.listItem, children: /* @__PURE__ */ $e.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ $e.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, WI = "_tagHover_kzbzk_1", KI = "_channelUnsubscribed_kzbzk_6", uh = {
  tagHover: WI,
  channelUnsubscribed: KI
}, mh = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ $e.jsx(
    Ge,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ $e.jsx(
        Pn,
        {
          className: uh.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ $e.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ut({
                [uh.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ $e.jsx(cn, { size: 16 }) : /* @__PURE__ */ $e.jsx(ue, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, GI = "_subscriptionError_1qhhx_1", YI = {
  subscriptionError: GI
}, JI = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = kn(), [k, N] = mw({
    channel: null,
    request: null
  }), S = _I(n), w = xI(n), C = !!e, { useMutation: g } = un(), [q] = g(
    cI
  ), [$] = g(
    dI
  ), E = (Z) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Z }), N.setAll({
      channel: Z,
      request: "subscribed"
    }), ((Q) => q({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: "profile",
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  phone_number: i,
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: e
            }
          }
        }
      }
    }))(Z).then(
      (Q) => z({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => z({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, D = (Z) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Z }), N.setAll({
      channel: Z,
      request: "unsubscribed"
    }), $({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: "profile",
                attributes: {
                  ...Z === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Z === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => z({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => z({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, z = async ({
    channel: Z,
    mutationResponse: Q,
    mutationErrorResponse: te,
    isSubscriptionRequest: Y
  }) => {
    const B = te?.networkError, R = B ? B?.statusCode : NaN, H = Q?.errors, ne = !!H && hb({
      errors: H
    });
    R === 202 ? (h(
      Y ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Z }
    ), await o()) : ne ? (h(
      Y ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${Y ? "opt-in" : "opt-out"}.`
    )) : (h(
      Y ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: B?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${Y ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return He(() => {
    if (k.request === "subscribed") {
      const Z = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${k.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      k.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Z), N.reset()), k.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Z), N.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ $e.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(
            mh,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: C,
              handleAction: () => {
                l(!0), f(void 0), S ? D("EMAIL") : E("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ $e.jsx(
            mh,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: w,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: C,
              handleAction: () => {
                m(!0), f(void 0), w ? D("SMS") : E("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ $e.jsx(b, { className: YI.subscriptionError, children: u })
      ] })
    }
  );
}, QI = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: d,
    error: m,
    isLoading: u,
    refetchProfile: f
  } = NI({ profileId: e });
  return m ? /* @__PURE__ */ $e.jsx(Vs, { error: m }) : u ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : !d && !u ? /* @__PURE__ */ $e.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Gm.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ $e.jsxs(We, { className: Ra.list, children: [
        i && /* @__PURE__ */ $e.jsx(dh, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ $e.jsx(
          dh,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ $e.jsx(
      JI,
      {
        profile: d,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: f,
        email: n,
        phoneNumber: r
      }
    ),
    /* @__PURE__ */ $e.jsx(
      BI,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, XI = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: m,
    getProfileId: u,
    isLoading: f,
    error: h
  } = jI({ email: r, phoneNumber: i });
  return AS(() => {
    (r || i) && u({
      variables: {
        emailFilter: `equals(email,"${r}")`,
        phoneNumberFilter: `equals(phone_number,"${i}")`
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : f ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : h ? /* @__PURE__ */ $e.jsx(Vs, { error: h }) : m ? /* @__PURE__ */ $e.jsx(
    QI,
    {
      profileId: m,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      noOfMessagesToShow: l,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ $e.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Gm.notificationText,
      children: "No profile ID found"
    }
  );
}, ZI = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: TS
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
];
function eE(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const nE = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, tE = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, rE = {};
function ph(e, n) {
  return (rE.jsx ? tE : nE).test(e);
}
const iE = /[ \t\n\f\r]/g;
function aE(e) {
  return typeof e == "object" ? e.type === "text" ? fh(e.value) : !1 : fh(e);
}
function fh(e) {
  return e.replace(iE, "") === "";
}
class ro {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
ro.prototype.property = {};
ro.prototype.normal = {};
ro.prototype.space = null;
function N_(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new ro(r, i, n);
}
function tm(e) {
  return e.toLowerCase();
}
class dr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
dr.prototype.space = null;
dr.prototype.boolean = !1;
dr.prototype.booleanish = !1;
dr.prototype.overloadedBoolean = !1;
dr.prototype.number = !1;
dr.prototype.commaSeparated = !1;
dr.prototype.spaceSeparated = !1;
dr.prototype.commaOrSpaceSeparated = !1;
dr.prototype.mustUseProperty = !1;
dr.prototype.defined = !1;
let oE = 0;
const wn = ki(), pt = ki(), j_ = ki(), Ve = ki(), Zn = ki(), Ri = ki(), Jt = ki();
function ki() {
  return 2 ** ++oE;
}
const rm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: wn,
  booleanish: pt,
  commaOrSpaceSeparated: Jt,
  commaSeparated: Ri,
  number: Ve,
  overloadedBoolean: j_,
  spaceSeparated: Zn
}, Symbol.toStringTag, { value: "Module" })), kl = Object.keys(rm);
class Ym extends dr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), hh(this, "space", a), typeof i == "number")
      for (; ++o < kl.length; ) {
        const s = kl[o];
        hh(this, kl[o], (i & rm[s]) === rm[s]);
      }
  }
}
Ym.prototype.defined = !0;
function hh(e, n, r) {
  r && (e[n] = r);
}
const sE = {}.hasOwnProperty;
function qi(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (sE.call(e.properties, i)) {
      const a = e.properties[i], o = new Ym(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[tm(i)] = i, r[tm(o.attribute)] = i;
    }
  return new ro(n, r, e.space);
}
const w_ = qi({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), C_ = qi({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function F_(e, n) {
  return n in e ? e[n] : n;
}
function I_(e, n) {
  return F_(e, n.toLowerCase());
}
const E_ = qi({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: I_,
  properties: { xmlns: null, xmlnsXLink: null }
}), T_ = qi({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: pt,
    ariaAutoComplete: null,
    ariaBusy: pt,
    ariaChecked: pt,
    ariaColCount: Ve,
    ariaColIndex: Ve,
    ariaColSpan: Ve,
    ariaControls: Zn,
    ariaCurrent: null,
    ariaDescribedBy: Zn,
    ariaDetails: null,
    ariaDisabled: pt,
    ariaDropEffect: Zn,
    ariaErrorMessage: null,
    ariaExpanded: pt,
    ariaFlowTo: Zn,
    ariaGrabbed: pt,
    ariaHasPopup: null,
    ariaHidden: pt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Zn,
    ariaLevel: Ve,
    ariaLive: null,
    ariaModal: pt,
    ariaMultiLine: pt,
    ariaMultiSelectable: pt,
    ariaOrientation: null,
    ariaOwns: Zn,
    ariaPlaceholder: null,
    ariaPosInSet: Ve,
    ariaPressed: pt,
    ariaReadOnly: pt,
    ariaRelevant: null,
    ariaRequired: pt,
    ariaRoleDescription: Zn,
    ariaRowCount: Ve,
    ariaRowIndex: Ve,
    ariaRowSpan: Ve,
    ariaSelected: pt,
    ariaSetSize: Ve,
    ariaSort: null,
    ariaValueMax: Ve,
    ariaValueMin: Ve,
    ariaValueNow: Ve,
    ariaValueText: null,
    role: null
  }
}), lE = qi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: I_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Ri,
    acceptCharset: Zn,
    accessKey: Zn,
    action: null,
    allow: null,
    allowFullScreen: wn,
    allowPaymentRequest: wn,
    allowUserMedia: wn,
    alt: null,
    as: null,
    async: wn,
    autoCapitalize: null,
    autoComplete: Zn,
    autoFocus: wn,
    autoPlay: wn,
    blocking: Zn,
    capture: null,
    charSet: null,
    checked: wn,
    cite: null,
    className: Zn,
    cols: Ve,
    colSpan: null,
    content: null,
    contentEditable: pt,
    controls: wn,
    controlsList: Zn,
    coords: Ve | Ri,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: wn,
    defer: wn,
    dir: null,
    dirName: null,
    disabled: wn,
    download: j_,
    draggable: pt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: wn,
    formTarget: null,
    headers: Zn,
    height: Ve,
    hidden: wn,
    high: Ve,
    href: null,
    hrefLang: null,
    htmlFor: Zn,
    httpEquiv: Zn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: wn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: wn,
    itemId: null,
    itemProp: Zn,
    itemRef: Zn,
    itemScope: wn,
    itemType: Zn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: wn,
    low: Ve,
    manifest: null,
    max: null,
    maxLength: Ve,
    media: null,
    method: null,
    min: null,
    minLength: Ve,
    multiple: wn,
    muted: wn,
    name: null,
    nonce: null,
    noModule: wn,
    noValidate: wn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: wn,
    optimum: Ve,
    pattern: null,
    ping: Zn,
    placeholder: null,
    playsInline: wn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: wn,
    referrerPolicy: null,
    rel: Zn,
    required: wn,
    reversed: wn,
    rows: Ve,
    rowSpan: Ve,
    sandbox: Zn,
    scope: null,
    scoped: wn,
    seamless: wn,
    selected: wn,
    shadowRootClonable: wn,
    shadowRootDelegatesFocus: wn,
    shadowRootMode: null,
    shape: null,
    size: Ve,
    sizes: null,
    slot: null,
    span: Ve,
    spellCheck: pt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ve,
    step: null,
    style: null,
    tabIndex: Ve,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: wn,
    useMap: null,
    value: pt,
    width: Ve,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Zn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ve,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ve,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: wn,
    // Lists. Use CSS to reduce space between items instead
    declare: wn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ve,
    // `<img>` and `<object>`
    leftMargin: Ve,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ve,
    // `<body>`
    marginWidth: Ve,
    // `<body>`
    noResize: wn,
    // `<frame>`
    noHref: wn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: wn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: wn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ve,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: pt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ve,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ve,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: wn,
    disableRemotePlayback: wn,
    prefix: null,
    property: null,
    results: Ve,
    security: null,
    unselectable: null
  }
}), cE = qi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: F_,
  properties: {
    about: Jt,
    accentHeight: Ve,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ve,
    amplitude: Ve,
    arabicForm: null,
    ascent: Ve,
    attributeName: null,
    attributeType: null,
    azimuth: Ve,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ve,
    by: null,
    calcMode: null,
    capHeight: Ve,
    className: Zn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ve,
    diffuseConstant: Ve,
    direction: null,
    display: null,
    dur: null,
    divisor: Ve,
    dominantBaseline: null,
    download: wn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ve,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ve,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ve,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Ri,
    g2: Ri,
    glyphName: Ri,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ve,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ve,
    horizOriginX: Ve,
    horizOriginY: Ve,
    id: null,
    ideographic: Ve,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ve,
    k: Ve,
    k1: Ve,
    k2: Ve,
    k3: Ve,
    k4: Ve,
    kernelMatrix: Jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ve,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ve,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ve,
    overlineThickness: Ve,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ve,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Zn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ve,
    pointsAtY: Ve,
    pointsAtZ: Ve,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Jt,
    rev: Jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Jt,
    requiredFeatures: Jt,
    requiredFonts: Jt,
    requiredFormats: Jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ve,
    specularExponent: Ve,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ve,
    strikethroughThickness: Ve,
    string: null,
    stroke: null,
    strokeDashArray: Jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ve,
    strokeOpacity: Ve,
    strokeWidth: null,
    style: null,
    surfaceScale: Ve,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Jt,
    tabIndex: Ve,
    tableValues: null,
    target: null,
    targetX: Ve,
    targetY: Ve,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ve,
    underlineThickness: Ve,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ve,
    values: null,
    vAlphabetic: Ve,
    vMathematical: Ve,
    vectorEffect: null,
    vHanging: Ve,
    vIdeographic: Ve,
    version: null,
    vertAdvY: Ve,
    vertOriginX: Ve,
    vertOriginY: Ve,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ve,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), dE = /^data[-\w.:]+$/i, yh = /-[a-z]/g, uE = /[A-Z]/g;
function mE(e, n) {
  const r = tm(n);
  let i = n, a = dr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && dE.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(yh, fE);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!yh.test(o)) {
        let s = o.replace(uE, pE);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Ym;
  }
  return new a(i, n);
}
function pE(e) {
  return "-" + e.toLowerCase();
}
function fE(e) {
  return e.charAt(1).toUpperCase();
}
const hE = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, yE = N_([C_, w_, E_, T_, lE], "html"), Jm = N_([C_, w_, E_, T_, cE], "svg");
function gE(e) {
  return e.join(" ").trim();
}
var Ni = {}, bl, gh;
function vE() {
  if (gh) return bl;
  gh = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", k = "declaration";
  bl = function(S, w) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    w = w || {};
    var C = 1, g = 1;
    function q(R) {
      var H = R.match(n);
      H && (C += H.length);
      var ne = R.lastIndexOf(d);
      g = ~ne ? R.length - ne : g + R.length;
    }
    function $() {
      var R = { line: C, column: g };
      return function(H) {
        return H.position = new E(R), Z(), H;
      };
    }
    function E(R) {
      this.start = R, this.end = { line: C, column: g }, this.source = w.source;
    }
    E.prototype.content = S;
    function D(R) {
      var H = new Error(
        w.source + ":" + C + ":" + g + ": " + R
      );
      if (H.reason = R, H.filename = w.source, H.line = C, H.column = g, H.source = S, !w.silent) throw H;
    }
    function z(R) {
      var H = R.exec(S);
      if (H) {
        var ne = H[0];
        return q(ne), S = S.slice(ne.length), H;
      }
    }
    function Z() {
      z(r);
    }
    function Q(R) {
      var H;
      for (R = R || []; H = te(); )
        H !== !1 && R.push(H);
      return R;
    }
    function te() {
      var R = $();
      if (!(m != S.charAt(0) || u != S.charAt(1))) {
        for (var H = 2; f != S.charAt(H) && (u != S.charAt(H) || m != S.charAt(H + 1)); )
          ++H;
        if (H += 2, f === S.charAt(H - 1))
          return D("End of comment missing");
        var ne = S.slice(2, H - 2);
        return g += 2, q(ne), S = S.slice(H), g += 2, R({
          type: h,
          comment: ne
        });
      }
    }
    function Y() {
      var R = $(), H = z(i);
      if (H) {
        if (te(), !z(a)) return D("property missing ':'");
        var ne = z(o), ve = R({
          type: k,
          property: N(H[0].replace(e, f)),
          value: ne ? N(ne[0].replace(e, f)) : f
        });
        return z(s), ve;
      }
    }
    function B() {
      var R = [];
      Q(R);
      for (var H; H = Y(); )
        H !== !1 && (R.push(H), Q(R));
      return R;
    }
    return Z(), B();
  };
  function N(S) {
    return S ? S.replace(l, f) : f;
  }
  return bl;
}
var vh;
function kE() {
  if (vh) return Ni;
  vh = 1;
  var e = Ni && Ni.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.default = r;
  var n = e(vE());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Ni;
}
var bE = kE();
const kh = /* @__PURE__ */ Em(bE), _E = kh.default || kh, $_ = D_("end"), Qm = D_("start");
function D_(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function xE(e) {
  const n = Qm(e), r = $_(e);
  if (n && r)
    return { start: n, end: r };
}
function La(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? bh(e.position) : "start" in e || "end" in e ? bh(e) : "line" in e || "column" in e ? im(e) : "";
}
function im(e) {
  return _h(e && e.line) + ":" + _h(e && e.column);
}
function bh(e) {
  return im(e && e.start) + "-" + im(e && e.end);
}
function _h(e) {
  return e && typeof e == "number" ? e : 1;
}
class Et extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = La(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Et.prototype.file = "";
Et.prototype.name = "";
Et.prototype.reason = "";
Et.prototype.message = "";
Et.prototype.stack = "";
Et.prototype.column = void 0;
Et.prototype.line = void 0;
Et.prototype.ancestors = void 0;
Et.prototype.cause = void 0;
Et.prototype.fatal = void 0;
Et.prototype.place = void 0;
Et.prototype.ruleId = void 0;
Et.prototype.source = void 0;
const Xm = {}.hasOwnProperty, SE = /* @__PURE__ */ new Map(), NE = /[A-Z]/g, jE = /-([a-z])/g, wE = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), CE = /* @__PURE__ */ new Set(["td", "th"]), R_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function FE(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = PE(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = OE(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Jm : yE,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = O_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function O_(e, n, r) {
  if (n.type === "element")
    return IE(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return EE(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return $E(e, n, r);
  if (n.type === "mdxjsEsm")
    return TE(e, n);
  if (n.type === "root")
    return DE(e, n, r);
  if (n.type === "text")
    return RE(e, n);
}
function IE(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Jm, e.schema = a), e.ancestors.push(n);
  const o = A_(e, n.tagName, !1), s = AE(e, n);
  let l = ep(e, n);
  return wE.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !aE(d) : !0;
  })), P_(e, s, o, n), Zm(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function EE(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Ga(e, n.position);
}
function TE(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Ga(e, n.position);
}
function $E(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Jm, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : A_(e, n.name, !0), s = LE(e, n), l = ep(e, n);
  return P_(e, s, o, n), Zm(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function DE(e, n, r) {
  const i = {};
  return Zm(i, ep(e, n)), e.create(n, e.Fragment, i, r);
}
function RE(e, n) {
  return n.value;
}
function P_(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function Zm(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function OE(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function PE(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = Qm(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function AE(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Xm.call(n.properties, a)) {
      const o = VE(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && CE.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function LE(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Ga(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Ga(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function ep(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : SE;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = O_(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function VE(e, n, r) {
  const i = mE(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? eE(r) : gE(r)), i.property === "style") {
      let a = typeof r == "object" ? r : zE(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = UE(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? hE[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function zE(e, n) {
  const r = {};
  try {
    _E(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Et("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = R_ + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(jE, BE)), r[s] = o;
  }
}
function A_(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = ph(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = ph(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Xm.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Ga(e);
}
function Ga(e, n) {
  const r = new Et(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = R_ + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function UE(e) {
  const n = {};
  let r;
  for (r in e)
    Xm.call(e, r) && (n[ME(r)] = e[r]);
  return n;
}
function ME(e) {
  let n = e.replace(NE, qE);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function BE(e, n) {
  return n.toUpperCase();
}
function qE(e) {
  return "-" + e.toLowerCase();
}
const _l = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, HE = {};
function WE(e, n) {
  const r = HE, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return L_(e, i, a);
}
function L_(e, n, r) {
  if (KE(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return xh(e.children, n, r);
  }
  return Array.isArray(e) ? xh(e, n, r) : "";
}
function xh(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = L_(e[a], n, r);
  return i.join("");
}
function KE(e) {
  return !!(e && typeof e == "object");
}
const Sh = document.createElement("i");
function np(e) {
  const n = "&" + e + ";";
  Sh.innerHTML = n;
  const r = Sh.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Rr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function ar(e, n) {
  return e.length > 0 ? (Rr(e, e.length, 0, n), e) : n;
}
const Nh = {}.hasOwnProperty;
function GE(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    YE(n, e[r]);
  return n;
}
function YE(e, n) {
  let r;
  for (r in n) {
    const a = (Nh.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Nh.call(a, s) || (a[s] = []);
        const l = o[s];
        JE(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function JE(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Rr(e, 0, 0, i);
}
function V_(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Oi(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Fr = ei(/[A-Za-z]/), tr = ei(/[\dA-Za-z]/), QE = ei(/[#-'*+\--9=?A-Z^-~]/);
function am(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const om = ei(/\d/), XE = ei(/[\dA-Fa-f]/), ZE = ei(/[!-/:-@[-`{-~]/);
function gn(e) {
  return e !== null && e < -2;
}
function Kt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const eT = ei(new RegExp("\\p{P}|\\p{S}", "u")), nT = ei(/\s/);
function ei(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Hi(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && tr(e.charCodeAt(r + 1)) && tr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const tT = {
  tokenize: rT
};
function rT(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return gn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const iT = {
  tokenize: aT
}, jh = {
  tokenize: oT
};
function aT(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(q) {
    if (i < r.length) {
      const $ = r[i];
      return n.containerState = $[1], e.attempt($[0].continuation, d, m)(q);
    }
    return m(q);
  }
  function d(q) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const $ = n.events.length;
      let E = $, D;
      for (; E--; )
        if (n.events[E][0] === "exit" && n.events[E][1].type === "chunkFlow") {
          D = n.events[E][1].end;
          break;
        }
      C(i);
      let z = $;
      for (; z < n.events.length; )
        n.events[z][1].end = {
          ...D
        }, z++;
      return Rr(n.events, E + 1, 0, n.events.slice($)), n.events.length = z, m(q);
    }
    return l(q);
  }
  function m(q) {
    if (i === r.length) {
      if (!a)
        return h(q);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return N(q);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(jh, u, f)(q);
  }
  function u(q) {
    return a && g(), C(i), h(q);
  }
  function f(q) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, N(q);
  }
  function h(q) {
    return n.containerState = {}, e.attempt(jh, k, N)(q);
  }
  function k(q) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(q);
  }
  function N(q) {
    if (q === null) {
      a && g(), C(0), e.consume(q);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(q);
  }
  function S(q) {
    if (q === null) {
      w(e.exit("chunkFlow"), !0), C(0), e.consume(q);
      return;
    }
    return gn(q) ? (e.consume(q), w(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(q), S);
  }
  function w(q, $) {
    const E = n.sliceStream(q);
    if ($ && E.push(null), q.previous = o, o && (o.next = q), o = q, a.defineSkip(q.start), a.write(E), n.parser.lazy[q.start.line]) {
      let D = a.events.length;
      for (; D--; )
        if (
          // The token starts before the line ending…
          a.events[D][1].start.offset < s && // …and either is not ended yet…
          (!a.events[D][1].end || // …or ends after it.
          a.events[D][1].end.offset > s)
        )
          return;
      const z = n.events.length;
      let Z = z, Q, te;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Q) {
            te = n.events[Z][1].end;
            break;
          }
          Q = !0;
        }
      for (C(i), D = z; D < n.events.length; )
        n.events[D][1].end = {
          ...te
        }, D++;
      Rr(n.events, Z + 1, 0, n.events.slice(z)), n.events.length = D;
    }
  }
  function C(q) {
    let $ = r.length;
    for (; $-- > q; ) {
      const E = r[$];
      n.containerState = E[1], E[0].exit.call(n, e);
    }
    r.length = q;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function oT(e, n, r) {
  return et(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function wh(e) {
  if (e === null || Kt(e) || nT(e))
    return 1;
  if (eT(e))
    return 2;
}
function tp(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const sm = {
  name: "attention",
  resolveAll: sT,
  tokenize: lT
};
function sT(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Ch(f, -d), Ch(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = ar(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = ar(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = ar(m, tp(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = ar(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = ar(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Rr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function lT(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = wh(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = wh(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function Ch(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const cT = {
  name: "autolink",
  tokenize: dT
};
function dT(e, n, r) {
  let i = 0;
  return a;
  function a(k) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(k) {
    return Fr(k) ? (e.consume(k), s) : k === 64 ? r(k) : m(k);
  }
  function s(k) {
    return k === 43 || k === 45 || k === 46 || tr(k) ? (i = 1, l(k)) : m(k);
  }
  function l(k) {
    return k === 58 ? (e.consume(k), i = 0, d) : (k === 43 || k === 45 || k === 46 || tr(k)) && i++ < 32 ? (e.consume(k), l) : (i = 0, m(k));
  }
  function d(k) {
    return k === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : k === null || k === 32 || k === 60 || am(k) ? r(k) : (e.consume(k), d);
  }
  function m(k) {
    return k === 64 ? (e.consume(k), u) : QE(k) ? (e.consume(k), m) : r(k);
  }
  function u(k) {
    return tr(k) ? f(k) : r(k);
  }
  function f(k) {
    return k === 46 ? (e.consume(k), i = 0, u) : k === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(k);
  }
  function h(k) {
    if ((k === 45 || tr(k)) && i++ < 63) {
      const N = k === 45 ? h : f;
      return e.consume(k), N;
    }
    return r(k);
  }
}
const zs = {
  partial: !0,
  tokenize: uT
};
function uT(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || gn(o) ? n(o) : r(o);
  }
}
const z_ = {
  continuation: {
    tokenize: pT
  },
  exit: fT,
  name: "blockQuote",
  tokenize: mT
};
function mT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function pT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(z_, n, r)(s);
  }
}
function fT(e) {
  e.exit("blockQuote");
}
const U_ = {
  name: "characterEscape",
  tokenize: hT
};
function hT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return ZE(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const M_ = {
  name: "characterReference",
  tokenize: yT
};
function yT(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = tr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = XE, u) : (e.enter("characterReferenceValue"), o = 7, s = om, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === tr && !np(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Fh = {
  partial: !0,
  tokenize: vT
}, Ih = {
  concrete: !0,
  name: "codeFenced",
  tokenize: gT
};
function gT(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: E
  };
  let o = 0, s = 0, l;
  return d;
  function d(D) {
    return m(D);
  }
  function m(D) {
    const z = i.events[i.events.length - 1];
    return o = z && z[1].type === "linePrefix" ? z[2].sliceSerialize(z[1], !0).length : 0, l = D, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(D);
  }
  function u(D) {
    return D === l ? (s++, e.consume(D), u) : s < 3 ? r(D) : (e.exit("codeFencedFenceSequence"), zn(D) ? et(e, f, "whitespace")(D) : f(D));
  }
  function f(D) {
    return D === null || gn(D) ? (e.exit("codeFencedFence"), i.interrupt ? n(D) : e.check(Fh, S, $)(D)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(D));
  }
  function h(D) {
    return D === null || gn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(D)) : zn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, k, "whitespace")(D)) : D === 96 && D === l ? r(D) : (e.consume(D), h);
  }
  function k(D) {
    return D === null || gn(D) ? f(D) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), N(D));
  }
  function N(D) {
    return D === null || gn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(D)) : D === 96 && D === l ? r(D) : (e.consume(D), N);
  }
  function S(D) {
    return e.attempt(a, $, w)(D);
  }
  function w(D) {
    return e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), C;
  }
  function C(D) {
    return o > 0 && zn(D) ? et(e, g, "linePrefix", o + 1)(D) : g(D);
  }
  function g(D) {
    return D === null || gn(D) ? e.check(Fh, S, $)(D) : (e.enter("codeFlowValue"), q(D));
  }
  function q(D) {
    return D === null || gn(D) ? (e.exit("codeFlowValue"), g(D)) : (e.consume(D), q);
  }
  function $(D) {
    return e.exit("codeFenced"), n(D);
  }
  function E(D, z, Z) {
    let Q = 0;
    return te;
    function te(ne) {
      return D.enter("lineEnding"), D.consume(ne), D.exit("lineEnding"), Y;
    }
    function Y(ne) {
      return D.enter("codeFencedFence"), zn(ne) ? et(D, B, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ne) : B(ne);
    }
    function B(ne) {
      return ne === l ? (D.enter("codeFencedFenceSequence"), R(ne)) : Z(ne);
    }
    function R(ne) {
      return ne === l ? (Q++, D.consume(ne), R) : Q >= s ? (D.exit("codeFencedFenceSequence"), zn(ne) ? et(D, H, "whitespace")(ne) : H(ne)) : Z(ne);
    }
    function H(ne) {
      return ne === null || gn(ne) ? (D.exit("codeFencedFence"), z(ne)) : Z(ne);
    }
  }
}
function vT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const xl = {
  name: "codeIndented",
  tokenize: bT
}, kT = {
  partial: !0,
  tokenize: _T
};
function bT(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : gn(m) ? e.attempt(kT, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || gn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function _T(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : gn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : gn(s) ? a(s) : r(s);
  }
}
const xT = {
  name: "codeText",
  previous: NT,
  resolve: ST,
  tokenize: jT
};
function ST(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function NT(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function jT(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : gn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || gn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class wT {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && ca(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), ca(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), ca(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        ca(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        ca(this.left, r.reverse());
      }
  }
}
function ca(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function B_(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new wT(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, CT(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Rr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function CT(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, k = r, N = 0, S = 0;
  const w = [S];
  for (; k; ) {
    for (; e.get(++a)[1] !== k; )
      ;
    o.push(a), k._tokenizer || (u = i.sliceStream(k), k.next || u.push(null), f && s.defineSkip(k.start), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = k, k = k.next;
  }
  for (k = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, w.push(S), k._tokenizer = void 0, k.previous = void 0, k = k.next);
  for (s.events = [], k ? (k._tokenizer = void 0, k.previous = void 0) : w.pop(), h = w.length; h--; ) {
    const C = l.slice(w[h], w[h + 1]), g = o.pop();
    d.push([g, g + C.length - 1]), e.splice(g, 2, C);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[N + d[h][0]] = N + d[h][1], N += d[h][1] - d[h][0] - 1;
  return m;
}
const FT = {
  resolve: ET,
  tokenize: TT
}, IT = {
  partial: !0,
  tokenize: $T
};
function ET(e) {
  return B_(e), e;
}
function TT(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : gn(l) ? e.check(IT, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function $T(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || gn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function q_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(C) {
    return C === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(C), e.exit(o), h) : C === null || C === 32 || C === 41 || am(C) ? r(C) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(C));
  }
  function h(C) {
    return C === 62 ? (e.enter(o), e.consume(C), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), k(C));
  }
  function k(C) {
    return C === 62 ? (e.exit("chunkString"), e.exit(l), h(C)) : C === null || C === 60 || gn(C) ? r(C) : (e.consume(C), C === 92 ? N : k);
  }
  function N(C) {
    return C === 60 || C === 62 || C === 92 ? (e.consume(C), k) : k(C);
  }
  function S(C) {
    return !u && (C === null || C === 41 || Kt(C)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(C)) : u < m && C === 40 ? (e.consume(C), u++, S) : C === 41 ? (e.consume(C), u--, S) : C === null || C === 32 || C === 40 || am(C) ? r(C) : (e.consume(C), C === 92 ? w : S);
  }
  function w(C) {
    return C === 40 || C === 41 || C === 92 ? (e.consume(C), S) : S(C);
  }
}
function H_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(k) {
    return e.enter(i), e.enter(a), e.consume(k), e.exit(a), e.enter(o), u;
  }
  function u(k) {
    return l > 999 || k === null || k === 91 || k === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    k === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(k) : k === 93 ? (e.exit(o), e.enter(a), e.consume(k), e.exit(a), e.exit(i), n) : gn(k) ? (e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(k));
  }
  function f(k) {
    return k === null || k === 91 || k === 93 || gn(k) || l++ > 999 ? (e.exit("chunkString"), u(k)) : (e.consume(k), d || (d = !zn(k)), k === 92 ? h : f);
  }
  function h(k) {
    return k === 91 || k === 92 || k === 93 ? (e.consume(k), l++, f) : f(k);
  }
}
function W_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : gn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || gn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Va(e, n) {
  let r;
  return i;
  function i(a) {
    return gn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? et(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const DT = {
  name: "definition",
  tokenize: OT
}, RT = {
  partial: !0,
  tokenize: PT
};
function OT(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(k) {
    return e.enter("definition"), s(k);
  }
  function s(k) {
    return H_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(k);
  }
  function l(k) {
    return a = Oi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), k === 58 ? (e.enter("definitionMarker"), e.consume(k), e.exit("definitionMarker"), d) : r(k);
  }
  function d(k) {
    return Kt(k) ? Va(e, m)(k) : m(k);
  }
  function m(k) {
    return q_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(k);
  }
  function u(k) {
    return e.attempt(RT, f, f)(k);
  }
  function f(k) {
    return zn(k) ? et(e, h, "whitespace")(k) : h(k);
  }
  function h(k) {
    return k === null || gn(k) ? (e.exit("definition"), i.parser.defined.push(a), n(k)) : r(k);
  }
}
function PT(e, n, r) {
  return i;
  function i(l) {
    return Kt(l) ? Va(e, a)(l) : r(l);
  }
  function a(l) {
    return W_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || gn(l) ? n(l) : r(l);
  }
}
const AT = {
  name: "hardBreakEscape",
  tokenize: LT
};
function LT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return gn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const VT = {
  name: "headingAtx",
  resolve: zT,
  tokenize: UT
};
function zT(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Rr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function UT(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Kt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || gn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? et(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Kt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const MT = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Eh = ["pre", "script", "style", "textarea"], BT = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: WT,
  tokenize: KT
}, qT = {
  partial: !0,
  tokenize: YT
}, HT = {
  partial: !0,
  tokenize: GT
};
function WT(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function KT(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, S) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : W) : Fr(K) ? (e.consume(K), s = String.fromCharCode(K), w) : r(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, k) : K === 91 ? (e.consume(K), a = 5, l = 0, N) : Fr(K) ? (e.consume(K), a = 4, i.interrupt ? n : W) : r(K);
  }
  function k(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : W) : r(K);
  }
  function N(K) {
    const qe = "CDATA[";
    return K === qe.charCodeAt(l++) ? (e.consume(K), l === qe.length ? i.interrupt ? n : B : N) : r(K);
  }
  function S(K) {
    return Fr(K) ? (e.consume(K), s = String.fromCharCode(K), w) : r(K);
  }
  function w(K) {
    if (K === null || K === 47 || K === 62 || Kt(K)) {
      const qe = K === 47, Be = s.toLowerCase();
      return !qe && !o && Eh.includes(Be) ? (a = 1, i.interrupt ? n(K) : B(K)) : MT.includes(s.toLowerCase()) ? (a = 6, qe ? (e.consume(K), C) : i.interrupt ? n(K) : B(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(K) : o ? g(K) : q(K));
    }
    return K === 45 || tr(K) ? (e.consume(K), s += String.fromCharCode(K), w) : r(K);
  }
  function C(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : B) : r(K);
  }
  function g(K) {
    return zn(K) ? (e.consume(K), g) : te(K);
  }
  function q(K) {
    return K === 47 ? (e.consume(K), te) : K === 58 || K === 95 || Fr(K) ? (e.consume(K), $) : zn(K) ? (e.consume(K), q) : te(K);
  }
  function $(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || tr(K) ? (e.consume(K), $) : E(K);
  }
  function E(K) {
    return K === 61 ? (e.consume(K), D) : zn(K) ? (e.consume(K), E) : q(K);
  }
  function D(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), d = K, z) : zn(K) ? (e.consume(K), D) : Z(K);
  }
  function z(K) {
    return K === d ? (e.consume(K), d = null, Q) : K === null || gn(K) ? r(K) : (e.consume(K), z);
  }
  function Z(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Kt(K) ? E(K) : (e.consume(K), Z);
  }
  function Q(K) {
    return K === 47 || K === 62 || zn(K) ? q(K) : r(K);
  }
  function te(K) {
    return K === 62 ? (e.consume(K), Y) : r(K);
  }
  function Y(K) {
    return K === null || gn(K) ? B(K) : zn(K) ? (e.consume(K), Y) : r(K);
  }
  function B(K) {
    return K === 45 && a === 2 ? (e.consume(K), ve) : K === 60 && a === 1 ? (e.consume(K), de) : K === 62 && a === 4 ? (e.consume(K), be) : K === 63 && a === 3 ? (e.consume(K), W) : K === 93 && a === 5 ? (e.consume(K), fe) : gn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(qT, Ce, R)(K)) : K === null || gn(K) ? (e.exit("htmlFlowData"), R(K)) : (e.consume(K), B);
  }
  function R(K) {
    return e.check(HT, H, Ce)(K);
  }
  function H(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ne;
  }
  function ne(K) {
    return K === null || gn(K) ? R(K) : (e.enter("htmlFlowData"), B(K));
  }
  function ve(K) {
    return K === 45 ? (e.consume(K), W) : B(K);
  }
  function de(K) {
    return K === 47 ? (e.consume(K), s = "", le) : B(K);
  }
  function le(K) {
    if (K === 62) {
      const qe = s.toLowerCase();
      return Eh.includes(qe) ? (e.consume(K), be) : B(K);
    }
    return Fr(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), le) : B(K);
  }
  function fe(K) {
    return K === 93 ? (e.consume(K), W) : B(K);
  }
  function W(K) {
    return K === 62 ? (e.consume(K), be) : K === 45 && a === 2 ? (e.consume(K), W) : B(K);
  }
  function be(K) {
    return K === null || gn(K) ? (e.exit("htmlFlowData"), Ce(K)) : (e.consume(K), be);
  }
  function Ce(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function GT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return gn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function YT(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(zs, n, r);
  }
}
const JT = {
  name: "htmlText",
  tokenize: QT
};
function QT(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(W) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (e.consume(W), m) : W === 47 ? (e.consume(W), E) : W === 63 ? (e.consume(W), q) : Fr(W) ? (e.consume(W), Z) : r(W);
  }
  function m(W) {
    return W === 45 ? (e.consume(W), u) : W === 91 ? (e.consume(W), o = 0, N) : Fr(W) ? (e.consume(W), g) : r(W);
  }
  function u(W) {
    return W === 45 ? (e.consume(W), k) : r(W);
  }
  function f(W) {
    return W === null ? r(W) : W === 45 ? (e.consume(W), h) : gn(W) ? (s = f, de(W)) : (e.consume(W), f);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), k) : f(W);
  }
  function k(W) {
    return W === 62 ? ve(W) : W === 45 ? h(W) : f(W);
  }
  function N(W) {
    const be = "CDATA[";
    return W === be.charCodeAt(o++) ? (e.consume(W), o === be.length ? S : N) : r(W);
  }
  function S(W) {
    return W === null ? r(W) : W === 93 ? (e.consume(W), w) : gn(W) ? (s = S, de(W)) : (e.consume(W), S);
  }
  function w(W) {
    return W === 93 ? (e.consume(W), C) : S(W);
  }
  function C(W) {
    return W === 62 ? ve(W) : W === 93 ? (e.consume(W), C) : S(W);
  }
  function g(W) {
    return W === null || W === 62 ? ve(W) : gn(W) ? (s = g, de(W)) : (e.consume(W), g);
  }
  function q(W) {
    return W === null ? r(W) : W === 63 ? (e.consume(W), $) : gn(W) ? (s = q, de(W)) : (e.consume(W), q);
  }
  function $(W) {
    return W === 62 ? ve(W) : q(W);
  }
  function E(W) {
    return Fr(W) ? (e.consume(W), D) : r(W);
  }
  function D(W) {
    return W === 45 || tr(W) ? (e.consume(W), D) : z(W);
  }
  function z(W) {
    return gn(W) ? (s = z, de(W)) : zn(W) ? (e.consume(W), z) : ve(W);
  }
  function Z(W) {
    return W === 45 || tr(W) ? (e.consume(W), Z) : W === 47 || W === 62 || Kt(W) ? Q(W) : r(W);
  }
  function Q(W) {
    return W === 47 ? (e.consume(W), ve) : W === 58 || W === 95 || Fr(W) ? (e.consume(W), te) : gn(W) ? (s = Q, de(W)) : zn(W) ? (e.consume(W), Q) : ve(W);
  }
  function te(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || tr(W) ? (e.consume(W), te) : Y(W);
  }
  function Y(W) {
    return W === 61 ? (e.consume(W), B) : gn(W) ? (s = Y, de(W)) : zn(W) ? (e.consume(W), Y) : Q(W);
  }
  function B(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? r(W) : W === 34 || W === 39 ? (e.consume(W), a = W, R) : gn(W) ? (s = B, de(W)) : zn(W) ? (e.consume(W), B) : (e.consume(W), H);
  }
  function R(W) {
    return W === a ? (e.consume(W), a = void 0, ne) : W === null ? r(W) : gn(W) ? (s = R, de(W)) : (e.consume(W), R);
  }
  function H(W) {
    return W === null || W === 34 || W === 39 || W === 60 || W === 61 || W === 96 ? r(W) : W === 47 || W === 62 || Kt(W) ? Q(W) : (e.consume(W), H);
  }
  function ne(W) {
    return W === 47 || W === 62 || Kt(W) ? Q(W) : r(W);
  }
  function ve(W) {
    return W === 62 ? (e.consume(W), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(W);
  }
  function de(W) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), le;
  }
  function le(W) {
    return zn(W) ? et(e, fe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : fe(W);
  }
  function fe(W) {
    return e.enter("htmlTextData"), s(W);
  }
}
const rp = {
  name: "labelEnd",
  resolveAll: n$,
  resolveTo: t$,
  tokenize: r$
}, XT = {
  tokenize: i$
}, ZT = {
  tokenize: a$
}, e$ = {
  tokenize: o$
};
function n$(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Rr(e, 0, e.length, r), e;
}
function t$(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = ar(l, e.slice(o + 1, o + i + 3)), l = ar(l, [["enter", u, n]]), l = ar(l, tp(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = ar(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = ar(l, e.slice(s + 1)), l = ar(l, [["exit", d, n]]), Rr(e, o, e.length, l), e;
}
function r$(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Oi(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(XT, u, s ? u : f)(h) : h === 91 ? e.attempt(ZT, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(e$, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function i$(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Kt(f) ? Va(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : q_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Kt(f) ? Va(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? W_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Kt(f) ? Va(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function a$(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return H_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Oi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function o$(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const s$ = {
  name: "labelStartImage",
  resolveAll: rp.resolveAll,
  tokenize: l$
};
function l$(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const c$ = {
  name: "labelStartLink",
  resolveAll: rp.resolveAll,
  tokenize: d$
};
function d$(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const Sl = {
  name: "lineEnding",
  tokenize: u$
};
function u$(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const Jo = {
  name: "thematicBreak",
  tokenize: m$
};
function m$(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || gn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const Bt = {
  continuation: {
    tokenize: y$
  },
  exit: v$,
  name: "list",
  tokenize: h$
}, p$ = {
  partial: !0,
  tokenize: k$
}, f$ = {
  partial: !0,
  tokenize: g$
};
function h$(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(k) {
    const N = i.containerState.type || (k === 42 || k === 43 || k === 45 ? "listUnordered" : "listOrdered");
    if (N === "listUnordered" ? !i.containerState.marker || k === i.containerState.marker : om(k)) {
      if (i.containerState.type || (i.containerState.type = N, e.enter(N, {
        _container: !0
      })), N === "listUnordered")
        return e.enter("listItemPrefix"), k === 42 || k === 45 ? e.check(Jo, r, m)(k) : m(k);
      if (!i.interrupt || k === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(k);
    }
    return r(k);
  }
  function d(k) {
    return om(k) && ++s < 10 ? (e.consume(k), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? k === i.containerState.marker : k === 41 || k === 46) ? (e.exit("listItemValue"), m(k)) : r(k);
  }
  function m(k) {
    return e.enter("listItemMarker"), e.consume(k), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || k, e.check(
      zs,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(p$, h, f)
    );
  }
  function u(k) {
    return i.containerState.initialBlankLine = !0, o++, h(k);
  }
  function f(k) {
    return zn(k) ? (e.enter("listItemPrefixWhitespace"), e.consume(k), e.exit("listItemPrefixWhitespace"), h) : r(k);
  }
  function h(k) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(k);
  }
}
function y$(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(zs, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(f$, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(Bt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function g$(e, n, r) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function v$(e) {
  e.exit(this.containerState.type);
}
function k$(e, n, r) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Th = {
  name: "setextUnderline",
  resolveTo: b$,
  tokenize: _$
};
function b$(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function _$(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || gn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const x$ = {
  tokenize: S$
};
function S$(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    zs,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt(FT, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const N$ = {
  resolveAll: G_()
}, j$ = K_("string"), w$ = K_("text");
function K_(e) {
  return {
    resolveAll: G_(e === "text" ? C$ : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const k = f[h];
          if (!k.previous || k.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function G_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function C$(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const F$ = {
  42: Bt,
  43: Bt,
  45: Bt,
  48: Bt,
  49: Bt,
  50: Bt,
  51: Bt,
  52: Bt,
  53: Bt,
  54: Bt,
  55: Bt,
  56: Bt,
  57: Bt,
  62: z_
}, I$ = {
  91: DT
}, E$ = {
  [-2]: xl,
  [-1]: xl,
  32: xl
}, T$ = {
  35: VT,
  42: Jo,
  45: [Th, Jo],
  60: BT,
  61: Th,
  95: Jo,
  96: Ih,
  126: Ih
}, $$ = {
  38: M_,
  92: U_
}, D$ = {
  [-5]: Sl,
  [-4]: Sl,
  [-3]: Sl,
  33: s$,
  38: M_,
  42: sm,
  60: [cT, JT],
  91: c$,
  92: [AT, U_],
  93: rp,
  95: sm,
  96: xT
}, R$ = {
  null: [sm, N$]
}, O$ = {
  null: [42, 95]
}, P$ = {
  null: []
}, A$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: O$,
  contentInitial: I$,
  disable: P$,
  document: F$,
  flow: T$,
  flowInitial: E$,
  insideSpan: R$,
  string: $$,
  text: D$
}, Symbol.toStringTag, { value: "Module" }));
function L$(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: z(E),
    check: z(D),
    consume: g,
    enter: q,
    exit: $,
    interrupt: z(D, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: N,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: k,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(Y) {
    return s = ar(s, Y), w(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = tp(o, m.events, m), m.events);
  }
  function h(Y, B) {
    return z$(k(Y), B);
  }
  function k(Y) {
    return V$(s, Y);
  }
  function N() {
    const {
      _bufferIndex: Y,
      _index: B,
      line: R,
      column: H,
      offset: ne
    } = i;
    return {
      _bufferIndex: Y,
      _index: B,
      line: R,
      column: H,
      offset: ne
    };
  }
  function S(Y) {
    a[Y.line] = Y.column, te();
  }
  function w() {
    let Y;
    for (; i._index < s.length; ) {
      const B = s[i._index];
      if (typeof B == "string")
        for (Y = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === Y && i._bufferIndex < B.length; )
          C(B.charCodeAt(i._bufferIndex));
      else
        C(B);
    }
  }
  function C(Y) {
    u = u(Y);
  }
  function g(Y) {
    gn(Y) ? (i.line++, i.column = 1, i.offset += Y === -3 ? 2 : 1, te()) : Y !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = Y;
  }
  function q(Y, B) {
    const R = B || {};
    return R.type = Y, R.start = N(), m.events.push(["enter", R, m]), l.push(R), R;
  }
  function $(Y) {
    const B = l.pop();
    return B.end = N(), m.events.push(["exit", B, m]), B;
  }
  function E(Y, B) {
    Z(Y, B.from);
  }
  function D(Y, B) {
    B.restore();
  }
  function z(Y, B) {
    return R;
    function R(H, ne, ve) {
      let de, le, fe, W;
      return Array.isArray(H) ? (
        /* c8 ignore next 1 */
        Ce(H)
      ) : "tokenize" in H ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          H
        ])
      ) : be(H);
      function be(Pe) {
        return Me;
        function Me(je) {
          const Le = je !== null && Pe[je], Te = je !== null && Pe.null, an = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Le) ? Le : Le ? [Le] : [],
            ...Array.isArray(Te) ? Te : Te ? [Te] : []
          ];
          return Ce(an)(je);
        }
      }
      function Ce(Pe) {
        return de = Pe, le = 0, Pe.length === 0 ? ve : K(Pe[le]);
      }
      function K(Pe) {
        return Me;
        function Me(je) {
          return W = Q(), fe = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Be() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            B ? Object.assign(Object.create(m), B) : m,
            d,
            qe,
            Be
          )(je);
        }
      }
      function qe(Pe) {
        return Y(fe, W), ne;
      }
      function Be(Pe) {
        return W.restore(), ++le < de.length ? K(de[le]) : ve;
      }
    }
  }
  function Z(Y, B) {
    Y.resolveAll && !o.includes(Y) && o.push(Y), Y.resolve && Rr(m.events, B, m.events.length - B, Y.resolve(m.events.slice(B), m)), Y.resolveTo && (m.events = Y.resolveTo(m.events, m));
  }
  function Q() {
    const Y = N(), B = m.previous, R = m.currentConstruct, H = m.events.length, ne = Array.from(l);
    return {
      from: H,
      restore: ve
    };
    function ve() {
      i = Y, m.previous = B, m.currentConstruct = R, m.events.length = H, l = ne, te();
    }
  }
  function te() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function V$(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function z$(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function U$(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      GE([A$, ...(e || {}).extensions || []])
    ),
    content: a(tT),
    defined: [],
    document: a(iT),
    flow: a(x$),
    lazy: {},
    string: a(j$),
    text: a(w$)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return L$(i, o, l);
    }
  }
}
function M$(e) {
  for (; !B_(e); )
    ;
  return e;
}
const $h = /[\0\t\n\r]/g;
function B$() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, k;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if ($h.lastIndex = f, m = $h.exec(o), h = m && m.index !== void 0 ? m.index : o.length, k = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (k === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), k) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const q$ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function H$(e) {
  return e.replace(q$, W$);
}
function W$(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return V_(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return np(r) || e;
}
const Y_ = {}.hasOwnProperty;
function K$(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), G$(r)(M$(U$(r).document().write(B$()(e, n, !0))));
}
function G$(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Re),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(me),
      blockQuote: o(Te),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(an),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(an, s),
      codeText: o(we, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(Ke),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ze),
      hardBreakEscape: o(he),
      hardBreakTrailing: o(he),
      htmlFlow: o(Ie, s),
      htmlFlowData: Q,
      htmlText: o(Ie, s),
      htmlTextData: Q,
      image: o(Ae),
      label: s,
      link: o(Re),
      listItem: o(F),
      listItemValue: h,
      listOrdered: o(Ue, f),
      listUnordered: o(Ue),
      paragraph: o(_),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(me),
      strong: o(T),
      thematicBreak: o(J)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: E,
      autolink: d(),
      autolinkEmail: Le,
      autolinkProtocol: je,
      blockQuote: d(),
      characterEscapeValue: te,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Pe,
      characterReference: Me,
      codeFenced: d(w),
      codeFencedFence: S,
      codeFencedFenceInfo: k,
      codeFencedFenceMeta: N,
      codeFlowValue: te,
      codeIndented: d(C),
      codeText: d(ne),
      codeTextData: te,
      data: te,
      definition: d(),
      definitionDestinationString: $,
      definitionLabelString: g,
      definitionTitleString: q,
      emphasis: d(),
      hardBreakEscape: d(B),
      hardBreakTrailing: d(B),
      htmlFlow: d(R),
      htmlFlowData: te,
      htmlText: d(H),
      htmlTextData: te,
      image: d(de),
      label: fe,
      labelText: le,
      lineEnding: Y,
      link: d(ve),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: qe,
      resourceDestinationString: W,
      resourceTitleString: be,
      resource: Ce,
      setextHeading: d(Z),
      setextHeadingLineSequence: z,
      setextHeadingText: D,
      strong: d(),
      thematicBreak: d()
    }
  };
  J_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(O) {
    let U = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [U],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, pe = [];
    let ke = -1;
    for (; ++ke < O.length; )
      if (O[ke][1].type === "listOrdered" || O[ke][1].type === "listUnordered")
        if (O[ke][0] === "enter")
          pe.push(ke);
        else {
          const en = pe.pop();
          ke = a(O, en, ke);
        }
    for (ke = -1; ++ke < O.length; ) {
      const en = n[O[ke][0]];
      Y_.call(en, O[ke][1].type) && en[O[ke][1].type].call(Object.assign({
        sliceSerialize: O[ke][2].sliceSerialize
      }, ie), O[ke][1]);
    }
    if (ie.tokenStack.length > 0) {
      const en = ie.tokenStack[ie.tokenStack.length - 1];
      (en[1] || Dh).call(ie, void 0, en[0]);
    }
    for (U.position = {
      start: Kr(O.length > 0 ? O[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Kr(O.length > 0 ? O[O.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, ke = -1; ++ke < n.transforms.length; )
      U = n.transforms[ke](U) || U;
    return U;
  }
  function a(O, U, ie) {
    let pe = U - 1, ke = -1, en = !1, mn, rn, dn, pn;
    for (; ++pe <= ie; ) {
      const ln = O[pe];
      switch (ln[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          ln[0] === "enter" ? ke++ : ke--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          ln[0] === "enter" && (mn && !pn && !ke && !dn && (dn = pe), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!ke && ln[0] === "enter" && ln[1].type === "listItemPrefix" || ke === -1 && ln[0] === "exit" && (ln[1].type === "listUnordered" || ln[1].type === "listOrdered")) {
        if (mn) {
          let vn = pe;
          for (rn = void 0; vn--; ) {
            const Xe = O[vn];
            if (Xe[1].type === "lineEnding" || Xe[1].type === "lineEndingBlank") {
              if (Xe[0] === "exit") continue;
              rn && (O[rn][1].type = "lineEndingBlank", en = !0), Xe[1].type = "lineEnding", rn = vn;
            } else if (!(Xe[1].type === "linePrefix" || Xe[1].type === "blockQuotePrefix" || Xe[1].type === "blockQuotePrefixWhitespace" || Xe[1].type === "blockQuoteMarker" || Xe[1].type === "listItemIndent")) break;
          }
          dn && (!rn || dn < rn) && (mn._spread = !0), mn.end = Object.assign({}, rn ? O[rn][1].start : ln[1].end), O.splice(rn || pe, 0, ["exit", mn, ln[2]]), pe++, ie++;
        }
        if (ln[1].type === "listItemPrefix") {
          const vn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, ln[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          mn = vn, O.splice(pe, 0, ["enter", vn, ln[2]]), pe++, ie++, dn = void 0, pn = !0;
        }
      }
    }
    return O[U][1]._spread = en, ie;
  }
  function o(O, U) {
    return ie;
    function ie(pe) {
      l.call(this, O(pe), pe), U && U.call(this, pe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(O, U, ie) {
    this.stack[this.stack.length - 1].children.push(O), this.stack.push(O), this.tokenStack.push([U, ie || void 0]), O.position = {
      start: Kr(U.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(O) {
    return U;
    function U(ie) {
      O && O.call(this, ie), m.call(this, ie);
    }
  }
  function m(O, U) {
    const ie = this.stack.pop(), pe = this.tokenStack.pop();
    if (pe)
      pe[0].type !== O.type && (U ? U.call(this, O, pe[0]) : (pe[1] || Dh).call(this, O, pe[0]));
    else throw new Error("Cannot close `" + O.type + "` (" + La({
      start: O.start,
      end: O.end
    }) + "): it’s not open");
    ie.position.end = Kr(O.end);
  }
  function u() {
    return WE(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(O) {
    if (this.data.expectingFirstListItemValue) {
      const U = this.stack[this.stack.length - 2];
      U.start = Number.parseInt(this.sliceSerialize(O), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function k() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.lang = O;
  }
  function N() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.meta = O;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function w() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = O.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function C() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = O.replace(/(\r?\n|\r)$/g, "");
  }
  function g(O) {
    const U = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = U, ie.identifier = Oi(this.sliceSerialize(O)).toLowerCase();
  }
  function q() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.title = O;
  }
  function $() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.url = O;
  }
  function E(O) {
    const U = this.stack[this.stack.length - 1];
    if (!U.depth) {
      const ie = this.sliceSerialize(O).length;
      U.depth = ie;
    }
  }
  function D() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function z(O) {
    const U = this.stack[this.stack.length - 1];
    U.depth = this.sliceSerialize(O).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(O) {
    const ie = this.stack[this.stack.length - 1].children;
    let pe = ie[ie.length - 1];
    (!pe || pe.type !== "text") && (pe = G(), pe.position = {
      start: Kr(O.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(pe)), this.stack.push(pe);
  }
  function te(O) {
    const U = this.stack.pop();
    U.value += this.sliceSerialize(O), U.position.end = Kr(O.end);
  }
  function Y(O) {
    const U = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = U.children[U.children.length - 1];
      ie.position.end = Kr(O.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(U.type) && (Q.call(this, O), te.call(this, O));
  }
  function B() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = O;
  }
  function H() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = O;
  }
  function ne() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = O;
  }
  function ve() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const U = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = U, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function de() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const U = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = U, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function le(O) {
    const U = this.sliceSerialize(O), ie = this.stack[this.stack.length - 2];
    ie.label = H$(U), ie.identifier = Oi(U).toLowerCase();
  }
  function fe() {
    const O = this.stack[this.stack.length - 1], U = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const pe = O.children;
      ie.children = pe;
    } else
      ie.alt = U;
  }
  function W() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.url = O;
  }
  function be() {
    const O = this.resume(), U = this.stack[this.stack.length - 1];
    U.title = O;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function qe(O) {
    const U = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = U, ie.identifier = Oi(this.sliceSerialize(O)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(O) {
    this.data.characterReferenceType = O.type;
  }
  function Pe(O) {
    const U = this.sliceSerialize(O), ie = this.data.characterReferenceType;
    let pe;
    ie ? (pe = V_(U, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : pe = np(U);
    const ke = this.stack[this.stack.length - 1];
    ke.value += pe;
  }
  function Me(O) {
    const U = this.stack.pop();
    U.position.end = Kr(O.end);
  }
  function je(O) {
    te.call(this, O);
    const U = this.stack[this.stack.length - 1];
    U.url = this.sliceSerialize(O);
  }
  function Le(O) {
    te.call(this, O);
    const U = this.stack[this.stack.length - 1];
    U.url = "mailto:" + this.sliceSerialize(O);
  }
  function Te() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function an() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function we() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ke() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ze() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function me() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function he() {
    return {
      type: "break"
    };
  }
  function Ie() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ae() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Re() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ue(O) {
    return {
      type: "list",
      ordered: O.type === "listOrdered",
      start: null,
      spread: O._spread,
      children: []
    };
  }
  function F(O) {
    return {
      type: "listItem",
      spread: O._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function T() {
    return {
      type: "strong",
      children: []
    };
  }
  function G() {
    return {
      type: "text",
      value: ""
    };
  }
  function J() {
    return {
      type: "thematicBreak"
    };
  }
}
function Kr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function J_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? J_(e, i) : Y$(e, i);
  }
}
function Y$(e, n) {
  let r;
  for (r in n)
    if (Y_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Dh(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + La({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + La({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + La({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function J$(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return K$(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function Q$(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function X$(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function Z$(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function eD(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function nD(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function tD(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Hi(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function rD(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function iD(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function Q_(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function aD(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Q_(e, n);
  const a = { src: Hi(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function oD(e, n) {
  const r = { src: Hi(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function sD(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function lD(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Q_(e, n);
  const a = { href: Hi(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function cD(e, n) {
  const r = { href: Hi(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function dD(e, n, r) {
  const i = e.all(n), a = r ? uD(r) : X_(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function uD(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = X_(r[i]);
  }
  return n;
}
function X_(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function mD(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function pD(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function fD(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function hD(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function yD(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Qm(n.children[1]), d = $_(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function gD(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, k = s ? s[d] : void 0;
    k && (h.align = k);
    let N = { type: "element", tagName: o, properties: h, children: [] };
    f && (N.children = e.all(f), e.patch(f, N), N = e.applyData(f, N)), m.push(N);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function vD(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Rh = 9, Oh = 32;
function kD(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Ph(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Ph(n.slice(a), a > 0, !1)), o.join("");
}
function Ph(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Rh || o === Oh; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Rh || o === Oh; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function bD(e, n) {
  const r = { type: "text", value: kD(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function _D(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const xD = {
  blockquote: Q$,
  break: X$,
  code: Z$,
  delete: eD,
  emphasis: nD,
  footnoteReference: tD,
  heading: rD,
  html: iD,
  imageReference: aD,
  image: oD,
  inlineCode: sD,
  linkReference: lD,
  link: cD,
  listItem: dD,
  list: mD,
  paragraph: pD,
  // @ts-expect-error: root is different, but hard to type.
  root: fD,
  strong: hD,
  table: yD,
  tableCell: vD,
  tableRow: gD,
  text: bD,
  thematicBreak: _D,
  toml: ko,
  yaml: ko,
  definition: ko,
  footnoteDefinition: ko
};
function ko() {
}
const Z_ = -1, Us = 0, ys = 1, gs = 2, ip = 3, ap = 4, op = 5, sp = 6, ex = 7, nx = 8, Ah = typeof self == "object" ? self : globalThis, SD = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Us:
      case Z_:
        return r(s, a);
      case ys: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case gs: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case ip:
        return r(new Date(s), a);
      case ap: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case op: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case sp: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case ex: {
        const { name: l, message: d } = s;
        return r(new Ah[l](d), a);
      }
      case nx:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Ah[o](s), a);
  };
  return i;
}, Lh = (e) => SD(/* @__PURE__ */ new Map(), e)(0), ji = "", { toString: ND } = {}, { keys: jD } = Object, da = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Us, n];
  const r = ND.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [ys, ji];
    case "Object":
      return [gs, ji];
    case "Date":
      return [ip, ji];
    case "RegExp":
      return [ap, ji];
    case "Map":
      return [op, ji];
    case "Set":
      return [sp, ji];
  }
  return r.includes("Array") ? [ys, r] : r.includes("Error") ? [ex, r] : [gs, r];
}, bo = ([e, n]) => e === Us && (n === "function" || n === "symbol"), wD = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = da(s);
    switch (l) {
      case Us: {
        let u = s;
        switch (d) {
          case "bigint":
            l = nx, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([Z_], s);
        }
        return a([l, u], s);
      }
      case ys: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case gs: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of jD(s))
          (e || !bo(da(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case ip:
        return a([l, s.toISOString()], s);
      case ap: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case op: {
        const u = [], f = a([l, u], s);
        for (const [h, k] of s)
          (e || !(bo(da(h)) || bo(da(k)))) && u.push([o(h), o(k)]);
        return f;
      }
      case sp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !bo(da(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Vh = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return wD(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, vs = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Lh(Vh(e, n)) : structuredClone(e)
) : (e, n) => Lh(Vh(e, n));
function CD(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function FD(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function ID(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || CD, i = e.options.footnoteBackLabel || FD, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Hi(f.toLowerCase());
    let k = 0;
    const N = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++k <= S; ) {
      N.length > 0 && N.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(d, k);
      typeof g == "string" && (g = { type: "text", value: g }), N.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (k > 1 ? "-" + k : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, k),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const w = u[u.length - 1];
    if (w && w.type === "element" && w.tagName === "p") {
      const g = w.children[w.children.length - 1];
      g && g.type === "text" ? g.value += " " : w.children.push({ type: "text", value: " " }), w.children.push(...N);
    } else
      u.push(...N);
    const C = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, C), l.push(C);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...vs(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const tx = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return DD;
    if (typeof e == "function")
      return Ms(e);
    if (typeof e == "object")
      return Array.isArray(e) ? ED(e) : TD(e);
    if (typeof e == "string")
      return $D(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function ED(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = tx(e[r]);
  return Ms(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function TD(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Ms(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function $D(e) {
  return Ms(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Ms(e) {
  return n;
  function n(r, i, a) {
    return !!(RD(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function DD() {
  return !0;
}
function RD(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const rx = [], OD = !0, zh = !1, PD = "skip";
function AD(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = tx(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const k = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (k ? "<" + k + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let k = rx, N, S, w;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (k = LD(r(d, u)), k[0] === zh))
        return k;
      if ("children" in d && d.children) {
        const C = (
          /** @type {UnistParent} */
          d
        );
        if (C.children && k[0] !== PD)
          for (S = (i ? C.children.length : -1) + s, w = u.concat(C); S > -1 && S < C.children.length; ) {
            const g = C.children[S];
            if (N = l(g, S, w)(), N[0] === zh)
              return N;
            S = typeof N[1] == "number" ? N[1] : S + s;
          }
      }
      return k;
    }
  }
}
function LD(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [OD, e] : e == null ? rx : [e];
}
function ix(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), AD(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const lm = {}.hasOwnProperty, VD = {};
function zD(e, n) {
  const r = n || VD, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...xD, ...r.handlers }, l = {
    all: m,
    applyData: MD,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: UD,
    wrap: qD
  };
  return ix(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, k = l.handlers[h];
    if (lm.call(l.handlers, h) && k)
      return k(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: S, ...w } = u, C = vs(w);
        return C.children = l.all(u), C;
      }
      return vs(u);
    }
    return (l.options.unknownHandler || BD)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let k = -1;
      for (; ++k < h.length; ) {
        const N = l.one(h[k], u);
        if (N) {
          if (k && h[k - 1].type === "break" && (!Array.isArray(N) && N.type === "text" && (N.value = Uh(N.value)), !Array.isArray(N) && N.type === "element")) {
            const S = N.children[0];
            S && S.type === "text" && (S.value = Uh(S.value));
          }
          Array.isArray(N) ? f.push(...N) : f.push(N);
        }
      }
    }
    return f;
  }
}
function UD(e, n) {
  e.position && (n.position = xE(e));
}
function MD(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, vs(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function BD(e, n) {
  const r = n.data || {}, i = "value" in n && !(lm.call(r, "hProperties") || lm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function qD(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Uh(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Mh(e, n) {
  const r = zD(e, n), i = r.one(e, void 0), a = ID(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function HD(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Mh(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Mh(r, { file: i, ...e || n })
    );
  };
}
function Bh(e) {
  if (e)
    throw e;
}
var Nl, qh;
function WD() {
  if (qh) return Nl;
  qh = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return Nl = function d() {
    var m, u, f, h, k, N, S = arguments[0], w = 1, C = arguments.length, g = !1;
    for (typeof S == "boolean" && (g = S, S = arguments[1] || {}, w = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); w < C; ++w)
      if (m = arguments[w], m != null)
        for (u in m)
          f = l(S, u), h = l(m, u), S !== h && (g && h && (o(h) || (k = a(h))) ? (k ? (k = !1, N = f && a(f) ? f : []) : N = f && o(f) ? f : {}, s(S, { name: u, newValue: d(g, N, h) })) : typeof h < "u" && s(S, { name: u, newValue: h }));
    return S;
  }, Nl;
}
var KD = WD();
const jl = /* @__PURE__ */ Em(KD);
function cm(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function GD() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? YD(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function YD(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const wr = { basename: JD, dirname: QD, extname: XD, join: ZD, sep: "/" };
function JD(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  io(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function QD(e) {
  if (io(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function XD(e) {
  io(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function ZD(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    io(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : eR(r);
}
function eR(e) {
  io(e);
  const n = e.codePointAt(0) === 47;
  let r = nR(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function nR(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function io(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const tR = { cwd: rR };
function rR() {
  return "/";
}
function dm(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function iR(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!dm(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return aR(e);
}
function aR(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const wl = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class ax {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? dm(n) ? r = { path: n } : typeof n == "string" || oR(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : tR.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < wl.length; ) {
      const o = wl[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      wl.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? wr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Fl(n, "basename"), Cl(n, "basename"), this.path = wr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? wr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Hh(this.basename, "dirname"), this.path = wr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? wr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Cl(n, "extname"), Hh(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = wr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    dm(n) && (n = iR(n)), Fl(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? wr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Fl(n, "stem"), Cl(n, "stem"), this.path = wr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Et(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Cl(e, n) {
  if (e && e.includes(wr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + wr.sep + "`"
    );
}
function Fl(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Hh(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function oR(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const sR = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), lR = {}.hasOwnProperty;
class lp extends sR {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = GD();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new lp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(jl(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Tl("data", this.frozen), this.namespace[n] = r, this) : lR.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Tl("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = _o(n), i = this.parser || this.Parser;
    return Il("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Il("process", this.parser || this.Parser), El("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = _o(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const k = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), N = i.stringify(k, h);
        uR(N) ? h.value = N : h.result = N, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Il("processSync", this.parser || this.Parser), El("processSync", this.compiler || this.Compiler), this.process(n, a), Kh("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Bh(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Wh(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = _o(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const k = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(k) : i(void 0, k, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Kh("runSync", "run", i), a;
    function o(s, l) {
      Bh(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = _o(r), a = this.compiler || this.Compiler;
    return El("stringify", a), Wh(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Tl("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = jl(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [k, ...N] = u;
        const S = i[h][1];
        cm(S) && cm(k) && (k = jl(!0, S, k)), i[h] = [m, k, ...N];
      }
    }
  }
}
const cR = new lp().freeze();
function Il(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function El(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Tl(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Wh(e) {
  if (!cm(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Kh(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function _o(e) {
  return dR(e) ? e : new ax(e);
}
function dR(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function uR(e) {
  return typeof e == "string" || mR(e);
}
function mR(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const pR = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Gh = [], Yh = { allowDangerousHtml: !0 }, fR = /^(https?|ircs?|mailto|xmpp)$/i, hR = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function yR(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Gh, d = e.remarkPlugins || Gh, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Yh } : Yh, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || gR, k = cR().use(J$).use(d).use(HD, m).use(l), N = new ax();
  typeof i == "string" && (N.value = i);
  for (const g of hR)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + pR + g.id, void 0);
  const S = k.parse(N);
  let w = k.runSync(S, N);
  return a && (w = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      w.type === "root" ? w.children : [w]
    )
  }), ix(w, C), FE(w, {
    Fragment: ze.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: ze.jsx,
    jsxs: ze.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function C(g, q, $) {
    if (g.type === "raw" && $ && typeof q == "number")
      return u ? $.children.splice(q, 1) : $.children[q] = { type: "text", value: g.value }, q;
    if (g.type === "element") {
      let E;
      for (E in _l)
        if (Object.hasOwn(_l, E) && Object.hasOwn(g.properties, E)) {
          const D = g.properties[E], z = _l[E];
          (z === null || z.includes(g.tagName)) && (g.properties[E] = h(String(D || ""), E, g));
        }
    }
    if (g.type === "element") {
      let E = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!E && r && typeof q == "number" && (E = !r(g, q, $)), E && $ && typeof q == "number")
        return f && g.children ? $.children.splice(q, 1, ...g.children) : $.children.splice(q, 1), q;
    }
  }
}
function gR(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    fR.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var $l = { exports: {} }, ua = {}, Jh;
function vR() {
  if (Jh) return ua;
  Jh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ua.Fragment = r, ua.jsx = s, ua.jsxs = s, ua;
}
var xo = {}, Qh;
function kR() {
  return Qh || (Qh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    xo.Fragment = i, xo.jsx = Rn, xo.jsxs = Bn;
  })()), xo;
}
var Xh;
function bR() {
  return Xh || (Xh = 1, process.env.NODE_ENV === "production" ? $l.exports = vR() : $l.exports = kR()), $l.exports;
}
var oe = bR();
const _R = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, xR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, SR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, NR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, jR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, wR = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": _R,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": xR,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": SR,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": NR,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": jR
};
function ao(e) {
  return wR[e] ?? {};
}
const CR = ao(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), FR = ao(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), So = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), IR = "_issueAvatar_kc0sw_1", ER = "_issueField_kc0sw_9", TR = "_issueDescription_kc0sw_12", No = {
  issueAvatar: IR,
  issueField: ER,
  issueDescription: TR
}, ox = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(So, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: No.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          Fm,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(So, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: No.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(So, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: No.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(So, { title: "Description", children: /* @__PURE__ */ oe.jsx(yR, { className: No.issueDescription, children: e.description }) })
] }), $R = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), DR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), RR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), OR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), PR = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), sx = {
  0: $R,
  1: PR,
  2: OR,
  3: RR,
  4: DR
}, AR = (e) => e in sx, ks = ({ priority: e }) => AR(e) ? sx[e] : /* @__PURE__ */ oe.jsx(Pn, { "data-testid": "defaultPriorityTag", children: e }), LR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), VR = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), zR = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), UR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), MR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), BR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), um = {
  backlog: (e, n) => LR(e, n),
  unstarted: (e, n) => VR(e, n),
  started: (e, n) => zR(e, n),
  done: (e, n) => UR(e, n),
  canceled: (e, n) => MR(e, n),
  completed: (e, n) => BR(e, n)
}, qR = (e) => e in um, bs = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => qR(e) ? um[e](n, r) : um.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), HR = "_wrapper_e0qj3_1", WR = "_resultTitle_e0qj3_21", KR = "_resultTooltipTitle_e0qj3_28", GR = "_resultLinkIcon_e0qj3_31", ma = {
  wrapper: HR,
  resultTitle: WR,
  resultTooltipTitle: KR,
  resultLinkIcon: GR
}, YR = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = wm(BS()), o = tt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Ge,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: ma.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              bs,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(ks, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Pn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: ma.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(ox, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        ot.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ma.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    bs,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(ks, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", className: ma.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  ue,
                  {
                    className: ma.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, JR = "_loader_13xpk_1", QR = "_dropdown_13xpk_8", XR = "_loadMore_13xpk_13", Dl = {
  loader: JR,
  dropdown: QR,
  loadMore: XR
}, ZR = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = un(), [f, { data: h, loading: k, networkStatus: N }] = u(
    CR,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  gi(
    () => {
      !k && s !== "" && N === Gt.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), He(() => {
    k || o([]);
  }, [s]), He(() => {
    if (h && Object.keys(h).length > 0) {
      const w = h.Linear.searchIssues.edges.map(
        ({ node: $ }) => $
      ), C = a.filter(
        ($) => !n.find((E) => E.id === $.id)
      ), g = C.filter(
        ($) => !w.find(
          (E) => E.id === $.id
        )
      ), q = w.filter(
        ($) => !n.find((E) => E.id === $.id)
      );
      n.length > 0 ? o(
        d ? [...g, ...q] : q
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...C, ...w] : w
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !k && s !== "" && N === Gt.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    Yr,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (w) => w?.title,
      onChange: (w) => e(w.selectedValues[0]),
      dropdownProps: { className: Dl.dropdown },
      filter: {
        value: s,
        onChange: (w) => {
          const C = w.target.value;
          l(C);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((w) => /* @__PURE__ */ oe.jsx(YR, { issue: w }, w.id)),
        r?.hasNextPage && !k && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: Dl.loadMore,
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        k && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: Dl.loader, children: /* @__PURE__ */ oe.jsx(cn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !k && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, eO = "_collapse_su0f9_1", nO = "_collapseHeader_su0f9_8", tO = "_collapseContent_su0f9_31", rO = "_url_su0f9_35", iO = "_externalLink_su0f9_51", aO = "_emptyState_su0f9_55", Gr = {
  collapse: eO,
  collapseHeader: nO,
  collapseContent: tO,
  url: rO,
  externalLink: iO,
  emptyState: aO
}, oO = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = kn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Gr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          wt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Gr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            or,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Gr.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(or.Header, { className: Gr.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ge, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        bs,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        A.ExternalLink,
                        {
                          className: Gr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(ue, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ge, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(ks, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Pn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(or.Content, { className: Gr.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(Pn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(ox, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    Wn,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    wt,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
                      variant: "tertiary",
                      className: Gr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          Wn,
          {
            slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          wt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Gr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, sO = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, lx = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => lx(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, lO = "_modalBody_iv3ua_1", cO = "_error_iv3ua_5", dO = "_dropdown_iv3ua_16", wi = {
  modalBody: lO,
  error: cO,
  dropdown: dO
}, uO = ao(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), mO = ao(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), pO = ao(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), fO = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = un(), { control: m, handleSubmit: u, reset: f } = cr(), [h, k] = se([]), [N, S] = se(), [w, C] = se([]), [g, q] = se(), [$, E] = se([]), [D, z] = se(), [Z, Q] = se([]), [te, Y] = se(), [B, R] = se([]), [H, ne] = se(), [ve, de] = se(!1), { useMutation: le } = un(), { track: fe } = kn(), [W, { loading: be }] = le(
    uO,
    {
      onError: () => {
        de(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (we) => {
        const Ke = {
          identifier: we.Linear?.issueCreate?.issue?.identifier,
          url: we.Linear?.issueCreate?.issue?.url
        };
        we.Linear && we.Linear?.issueCreate?.issue?.id && (a(we.Linear?.issueCreate?.issue?.id), Le(Ke), de(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${we.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), fe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ce,
    { data: K, loading: qe, error: Be }
  ] = l(mO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (we) => {
      const Ke = we.Linear.teams.edges.map(
        ({ node: Ze }) => Ze
      );
      k(Ke), Q(we.Linear.issuePriorityValues), s(`${SO}${we.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: Me, loading: je }] = l(pO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (we) => {
      const Ke = we?.Linear?.team?.projects?.edges?.map(
        ({ node: he }) => he
      );
      C(Ke);
      const Ze = we?.Linear?.team?.states?.edges?.map(
        ({ node: he }) => he
      );
      E(Ze);
      const me = we?.Linear?.team?.templates?.edges?.map(
        ({ node: he }) => he
      );
      R(
        me.filter(
          (he) => he.type === "issue"
        )
      );
    }
  }), Le = (we) => {
    r(!1), q(void 0), S(void 0), z(void 0), Y(void 0), ne(void 0), we && (e(we), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Te = (we) => {
    K && !qe && (W({
      variables: {
        issueTitle: we.title,
        issueDescription: we?.description,
        teamId: we.team.id,
        projectId: we?.project?.id,
        statusId: we?.status?.id,
        priority: we?.priority?.priority
      }
    }), de(!0));
  };
  He(() => {
    n && Ce();
  }, [n]);
  const an = () => {
    fe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    gt,
    {
      isOpen: n,
      onClose: () => {
        an(), Le();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          vt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              an(), Le();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          kt,
          {
            className: wi.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ oe.jsx(Fn, { error: Be }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u(Te), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(Ut, { children: [
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: we, onChange: Ke },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ oe.jsx(
                    Ln,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Ze?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        Yr,
                        {
                          dropdownProps: { className: wi.dropdown },
                          placeholder: "Select Linear team",
                          className: ut({ [wi.error]: Ze }),
                          getItemTitleByValue: (me) => me?.name,
                          onChange: (me) => {
                            q(void 0), z(void 0), Y(void 0), ne(void 0), S(me.selectedValues[0]), Pe({
                              variables: { teamId: me.selectedValues[0].id }
                            }), Ke(me.selectedValues[0]);
                          },
                          value: N ? [we] : void 0,
                          children: h?.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                            },
                            me.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: we, onChange: Ke } }) => {
                    const Ze = je ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.name,
                        disabled: N === void 0,
                        placeholder: N ? "Select Linear project" : "Select a Team first",
                        onChange: (me) => {
                          q(me.selectedValues[0]), Ke(me.selectedValues[0]);
                        },
                        value: g ? [we] : Ze,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          Me && !je && w.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                            },
                            me.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 6, children: /* @__PURE__ */ oe.jsx(Ln, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                Yr,
                {
                  clearable: !0,
                  dropdownProps: { className: wi.dropdown },
                  disabled: !N || je,
                  placeholder: N ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (we) => we?.name,
                  onChange: (we) => {
                    if (we.selectedValues.length > 0) {
                      ne(we.selectedValues[0]);
                      const Ke = JSON.parse(
                        we.selectedValues[0].templateData
                      ), Ze = Z.filter(
                        (Ae) => Ae.priority === Ke.priority
                      );
                      Y(
                        Ze ? Ze[0] : void 0
                      );
                      const me = $.filter(
                        (Ae) => Ae.id === Ke.stateId
                      );
                      z(
                        me ? me[0] : void 0
                      );
                      const he = w.filter(
                        (Ae) => Ae.id === Ke.projectId
                      );
                      q(
                        he ? he[0] : void 0
                      );
                      const Ie = Ke.description;
                      f({
                        title: Ke?.title,
                        priority: Ze[0],
                        status: me[0],
                        project: he[0],
                        description: Ie ? lx(Ie, sO) : "",
                        team: N
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: N
                      }), q(void 0), Y(void 0), z(void 0), ne(void 0);
                  },
                  value: H ? [H] : void 0,
                  children: B?.map((we) => /* @__PURE__ */ oe.jsx(
                    ot.Item,
                    {
                      value: we,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: we.name })
                    },
                    we.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 6, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: we, value: Ke },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ oe.jsx(
                    sr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Ke || "",
                        onChange: we
                      },
                      meta: {
                        error: Ze?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: we, onChange: Ke } }) => {
                    const Ze = je ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.name,
                        disabled: N === void 0,
                        placeholder: N ? "Select Issue status" : "Select a Team first",
                        onChange: (me) => {
                          z(me.selectedValues[0]), Ke(me.selectedValues[0]);
                        },
                        value: D ? [we] : Ze,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          Me && !je && $.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      bs,
                                      {
                                        type: me.type,
                                        color: me.color,
                                        name: me.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                                  ]
                                }
                              )
                            },
                            me.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: we, onChange: Ke } }) => {
                    const Ze = qe ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.label,
                        disabled: N === void 0,
                        placeholder: N ? "Select Issue priority" : "Select a Team first",
                        onChange: (me) => {
                          Y(me.selectedValues[0]), Ke(me.selectedValues[0]);
                        },
                        value: te ? [we] : Ze,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          K && !qe && Z.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      ks,
                                      {
                                        priority: me.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.label })
                                  ]
                                }
                              )
                            },
                            me.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: we, value: Ke },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ oe.jsx(
                    US,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Ke || "",
                        onChange: we
                      },
                      meta: {
                        error: Ze?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Ct,
          {
            confirmOnClick: u(Te),
            confirmProps: {
              disabled: be || !K,
              isLoading: ve || qe || je,
              loadingIndicator: /* @__PURE__ */ oe.jsx(cn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              an(), Le();
            }
          }
        )
      ]
    }
  );
}, hO = "_modalWrapper_4kh9u_1", yO = "_copyButton_4kh9u_6", gO = "_copyWrapper_4kh9u_15", vO = "_copyField_4kh9u_24", kO = "_externalLink_4kh9u_47", bO = "_externalLinkIcon_4kh9u_52", _O = "_textWrapper_4kh9u_56", ti = {
  modalWrapper: hO,
  copyButton: yO,
  copyWrapper: gO,
  copyField: vO,
  externalLink: kO,
  externalLinkIcon: bO,
  textWrapper: _O
}, xO = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  gt,
  {
    isOpen: !!n && e,
    className: ti.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        vt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(kt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(A.Paragraph, { className: ti.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ti.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(ue, { name: "external-link", className: ti.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(Ln, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ti.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    kr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ti.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    MS,
                    {
                      className: ti.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        Ct,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), SO = "https://linear.app/", NO = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, k] = se(), { useLazyQuery: N } = un(), [S, w] = se(""), C = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: q } = kn(), {
    loading: $,
    data: E,
    error: D,
    store: z
  } = jm(e?.conversationId ?? null), [
    Z,
    {
      data: Q,
      loading: te,
      networkStatus: Y,
      error: B
    }
  ] = N(FR, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    !$ && !D && E && E?.linear?.issues?.length > 0 ? (o(E.linear.issues), Z({
      variables: {
        linkedIssues: E.linear.issues
      }
    })) : !$ && !D && (i([]), o([]));
  }, [E, $, D]), He(() => {
    Q && Q?.Linear && !te && Y === Gt.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: de }) => de));
  }, [Q, te, Y]);
  const R = (de) => {
    de && de?.team?.organization?.urlKey && q("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: de.id
    });
    const le = (fe) => fe.id === de?.id;
    r.some((fe) => fe && le(fe)) || (E && a.length === 0 && o([]), z({
      linear: {
        issues: [...a, de.id]
      }
    }));
  }, H = (de) => {
    const le = E?.linear.issues.filter((fe) => fe !== de) || [];
    q("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: de
    }), i(r.filter(({ id: fe }) => fe !== de)), o(le), z({
      linear: {
        issues: le
      }
    });
  }, ne = () => {
    l(!1), i([]), o([]), z({
      linear: {
        issues: []
      }
    });
  }, ve = $ || te || !E && !D || (E?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !$ && !te && (B || D) ? /* @__PURE__ */ oe.jsx(Fn, { error: B || D }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      gt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            vt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(kt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            Ct,
            {
              confirmOnClick: () => ne(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      fO,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (de) => m(de),
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        addToLinkedIssueIds: (de) => {
          z({
            linear: {
              issues: [...a, de]
            }
          });
        },
        setCreatedIssue: (de) => k(de),
        organizationUrl: S,
        setOrganizationUrl: (de) => w(de)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      xO,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          C && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              Wn,
              {
                variant: "primary",
                onClick: () => {
                  q("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(ZR, { handleSelect: R, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      oO,
      {
        linkedIssues: r,
        isLoading: ve,
        handleUnlinkIssue: H,
        showUnlinkAllModal: (de) => l(de),
        showUnlinkAllButton: g,
        organizationUrl: S
      }
    )
  ] });
}, jO = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ja
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Rl = { exports: {} }, pa = {}, Zh;
function wO() {
  if (Zh) return pa;
  Zh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return pa.Fragment = r, pa.jsx = s, pa.jsxs = s, pa;
}
var jo = {}, ey;
function CO() {
  return ey || (ey = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    jo.Fragment = i, jo.jsx = Rn, jo.jsxs = Bn;
  })()), jo;
}
var ny;
function FO() {
  return ny || (ny = 1, process.env.NODE_ENV === "production" ? Rl.exports = wO() : Rl.exports = CO()), Rl.exports;
}
var De = FO();
const IO = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, EO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, TO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, $O = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, DO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, RO = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": IO,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": EO,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": TO,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": $O,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": DO
};
function Bs(e) {
  return RO[e] ?? {};
}
const OO = Bs(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), PO = Bs(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), AO = Bs(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), LO = Bs(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Ol(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const VO = "_wrapper_27vny_1", zO = "_copyIcon_27vny_12", fa = {
  wrapper: VO,
  copyIcon: zO
}, UO = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Ol(), { isCopied: i, copy: a } = Ol(), { isCopied: o, copy: s } = Ol();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: k,
    enrolled_at: N,
    referral_url: S
  } = e, w = f ? An(f).isSame(Date.now(), "day") : !1, { name: C, first_name: g, last_name: q } = m ?? {}, $ = C ?? (`${g} ${q}`.trim() || "A customer has no name"), E = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ De.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ De.jsxs(b, { className: fa.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: fa.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-2", children: $ }),
          w && /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: An(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    k && /* @__PURE__ */ De.jsx(b, { gap: "200", children: /* @__PURE__ */ De.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      An(N).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "mail" }),
        /* @__PURE__ */ De.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: fa.copyIcon
        }
      ) })
    ] }),
    E && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "link" }),
        /* @__PURE__ */ De.jsx(Ge, { content: "Shopify shop", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: E,
            target: "_blank",
            rel: "noreferrer",
            children: E.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(E),
          className: fa.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "external-link" }),
        /* @__PURE__ */ De.jsx(Ge, { content: "Referral link", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: fa.copyIcon
        }
      ) })
    ] })
  ] }) });
}, MO = "_list_1q5b5_5", BO = "_listItem_1q5b5_8", qO = "_listItemEdit_1q5b5_15", HO = "_notificationText_1q5b5_19", Vi = {
  list: MO,
  listItem: BO,
  listItemEdit: qO,
  notificationText: HO
}, WO = "_modalBody_1clhs_1", KO = {
  modalBody: WO
}, GO = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = kn(), [d, m] = se(n), [u, f] = se(""), [h, k] = se(), [N, { loading: S }] = o(
    AO,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), Y();
      }
    }
  ), [w, { loading: C }] = o(LO), g = S || C, q = !!h, $ = n === d ? "Change the value to update the points" : "", E = isNaN(d), D = E ? "Points can not be empty" : "", z = d > n && d - n > 1e6, Z = z ? "Points can not exceed 1,000,000" : "", Q = () => {
    d > n && N({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((B) => {
      const R = B?.networkError;
      (R ? R?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Y()) : (l("loyaltylion:add:points:failed"), k(["Failed to add points, try again later."]));
    }), d < n && w({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((B) => {
      B.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), Y()) : "errors" in B && (l("loyaltylion:remove:points:failed"), k(
        B.errors?.map((R) => R.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), k(["Failed to remove points, try again later."]);
    });
  }, te = () => {
    E && m(n), f(""), i();
  }, Y = () => {
    a(), te();
  };
  return /* @__PURE__ */ De.jsxs(
    gt,
    {
      isOpen: e,
      onClose: te,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ De.jsx(vt, { title: "Change points", onClose: te }),
        /* @__PURE__ */ De.jsxs(kt, { className: KO.modalBody, children: [
          /* @__PURE__ */ De.jsxs(Ut, { children: [
            /* @__PURE__ */ De.jsx(tn, { span: 6, children: /* @__PURE__ */ De.jsx(
              sr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || D,
                  warning: $
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (B) => m(B?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ De.jsx(tn, { span: 6, children: /* @__PURE__ */ De.jsx(
              sr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (B) => f(B?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && q && /* @__PURE__ */ De.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ De.jsx(We, { children: h?.map((B, R) => /* @__PURE__ */ De.jsx(
            We.Item,
            {
              variant: "dense",
              title: B,
              contentLeft: /* @__PURE__ */ De.jsx(
                ue,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            R
          )) }) })
        ] }),
        /* @__PURE__ */ De.jsx(
          Ct,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: g,
              disabled: E || z || n === d,
              loadingIndicator: /* @__PURE__ */ De.jsx(cn, { size: 16 })
            },
            cancelOnClick: te
          }
        )
      ]
    }
  );
}, YO = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ De.jsx(We.Text, { variant: "dense", className: Vi.listItem, children: /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ De.jsx(Ge, { content: "Edit points", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Vi.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ De.jsx(Un, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, JO = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ De.jsx(We, { className: Vi.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: k }) => /* @__PURE__ */ De.jsx(
      YO,
      {
        points: f,
        label: h,
        setIsModalOpen: k
      },
      u
    )) }),
    /* @__PURE__ */ De.jsx(
      GO,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, QO = "_reward_1wxia_1", XO = {
  reward: QO
}, ZO = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ De.jsx(b, { gap: "100", flexDirection: "column", className: XO.reward, children: /* @__PURE__ */ De.jsx(Ge, { content: a ?? "No description", children: /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ De.jsx(ue, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ De.jsxs(Un, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: 14, name: "external-link" }),
      /* @__PURE__ */ De.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, eP = ({ customer: e }) => {
  const { useQuery: n } = un(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(PO, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (He(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return Qa({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Vi.notificationText,
        children: "No rewards found"
      }
    ) : hb({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Vi.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ De.jsx(Fn, { error: s });
  }
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(cn, {}) }) : /* @__PURE__ */ De.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ De.jsx(ZO, { reward: d }, d.id)) })
  ] });
}, nP = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(
        ue,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Ge, { content: "Insights segment", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, tP = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), { track: i } = kn(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: k,
    data: N,
    refetch: S
  } = r(OO, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return He(() => {
    if (N && !h) {
      const w = (N?.LoyaltyLion?.getCustomers).customers;
      w && w.length > 0 && (o(w[0]), i("loyaltylion:customer:received"));
    }
  }, [N, h]), s?.email ? k ? Qa({
    errors: k.graphQLErrors
  }) ? /* @__PURE__ */ De.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Vi.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ De.jsx(Fn, { error: k }) : h ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(cn, {}) }) : f ? /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ De.jsxs(De.Fragment, { children: [
        l && /* @__PURE__ */ De.jsx(UO, { customer: a }),
        d && /* @__PURE__ */ De.jsx(nP, { customer: a }),
        m && /* @__PURE__ */ De.jsx(
          JO,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        u && /* @__PURE__ */ De.jsx(eP, { customer: a })
      ] }) : /* @__PURE__ */ De.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, rP = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Pl = { exports: {} }, ha = {}, ty;
function iP() {
  if (ty) return ha;
  ty = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ha.Fragment = r, ha.jsx = s, ha.jsxs = s, ha;
}
var wo = {}, ry;
function aP() {
  return ry || (ry = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    wo.Fragment = i, wo.jsx = Rn, wo.jsxs = Bn;
  })()), wo;
}
var iy;
function oP() {
  return iy || (iy = 1, process.env.NODE_ENV === "production" ? Pl.exports = iP() : Pl.exports = aP()), Pl.exports;
}
var jn = oP();
const sP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, lP = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": sP
};
function cP(e) {
  return lP[e] ?? {};
}
const {
  entries: cx,
  setPrototypeOf: ay,
  isFrozen: dP,
  getPrototypeOf: uP,
  getOwnPropertyDescriptor: mP
} = Object;
let {
  freeze: Vt,
  seal: lr,
  create: Qo
} = Object, {
  apply: mm,
  construct: pm
} = typeof Reflect < "u" && Reflect;
Vt || (Vt = function(e) {
  return e;
});
lr || (lr = function(e) {
  return e;
});
mm || (mm = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
pm || (pm = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const Co = zt(Array.prototype.forEach), pP = zt(Array.prototype.lastIndexOf), oy = zt(Array.prototype.pop), ya = zt(Array.prototype.push), fP = zt(Array.prototype.splice), Xo = zt(String.prototype.toLowerCase), Al = zt(String.prototype.toString), Ll = zt(String.prototype.match), ga = zt(String.prototype.replace), hP = zt(String.prototype.indexOf), yP = zt(String.prototype.trim), Qt = zt(Object.prototype.hasOwnProperty), Tt = zt(RegExp.prototype.test), va = gP(TypeError);
function zt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return mm(e, n, i);
  };
}
function gP(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return pm(e, r);
  };
}
function Tn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Xo;
  ay && ay(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (dP(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function vP(e) {
  for (let n = 0; n < e.length; n++)
    Qt(e, n) || (e[n] = null);
  return e;
}
function jr(e) {
  const n = Qo(null);
  for (const [r, i] of cx(e))
    Qt(e, r) && (Array.isArray(i) ? n[r] = vP(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = jr(i) : n[r] = i);
  return n;
}
function ka(e, n) {
  for (; e !== null; ) {
    const i = mP(e, n);
    if (i) {
      if (i.get)
        return zt(i.get);
      if (typeof i.value == "function")
        return zt(i.value);
    }
    e = uP(e);
  }
  function r() {
    return null;
  }
  return r;
}
const sy = Vt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Vl = Vt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), zl = Vt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), kP = Vt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ul = Vt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), bP = Vt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), ly = Vt(["#text"]), cy = Vt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ml = Vt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), dy = Vt(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Fo = Vt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), _P = lr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), xP = lr(/<%[\w\W]*|[\w\W]*%>/gm), SP = lr(/\$\{[\w\W]*/gm), NP = lr(/^data-[\-\w.\u00B7-\uFFFF]+$/), jP = lr(/^aria-[\-\w]+$/), dx = lr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), wP = lr(/^(?:\w+script|data):/i), CP = lr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), ux = lr(/^html$/i), FP = lr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var uy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: jP,
  ATTR_WHITESPACE: CP,
  CUSTOM_ELEMENT: FP,
  DATA_ATTR: NP,
  DOCTYPE_NAME: ux,
  ERB_EXPR: xP,
  IS_ALLOWED_URI: dx,
  IS_SCRIPT_OR_DATA: wP,
  MUSTACHE_EXPR: _P,
  TMPLIT_EXPR: SP
});
const ba = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, IP = function() {
  return typeof window > "u" ? null : window;
}, EP = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, my = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function mx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : IP();
  const n = (x) => mx(x);
  if (n.version = "3.3.3", n.removed = [], !e || !e.document || e.document.nodeType !== ba.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: k
  } = e, N = d.prototype, S = ka(N, "cloneNode"), w = ka(N, "remove"), C = ka(N, "nextSibling"), g = ka(N, "childNodes"), q = ka(N, "parentNode");
  if (typeof s == "function") {
    const x = r.createElement("template");
    x.content && x.content.ownerDocument && (r = x.content.ownerDocument);
  }
  let $, E = "";
  const {
    implementation: D,
    createNodeIterator: z,
    createDocumentFragment: Z,
    getElementsByTagName: Q
  } = r, {
    importNode: te
  } = i;
  let Y = my();
  n.isSupported = typeof cx == "function" && typeof q == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: B,
    ERB_EXPR: R,
    TMPLIT_EXPR: H,
    DATA_ATTR: ne,
    ARIA_ATTR: ve,
    IS_SCRIPT_OR_DATA: de,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: fe
  } = uy;
  let {
    IS_ALLOWED_URI: W
  } = uy, be = null;
  const Ce = Tn({}, [...sy, ...Vl, ...zl, ...Ul, ...ly]);
  let K = null;
  const qe = Tn({}, [...cy, ...Ml, ...dy, ...Fo]);
  let Be = Object.seal(Qo(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, Me = null;
  const je = Object.seal(Qo(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Le = !0, Te = !0, an = !1, we = !0, Ke = !1, Ze = !0, me = !1, he = !1, Ie = !1, Ae = !1, Re = !1, Ue = !1, F = !0, _ = !1;
  const T = "user-content-";
  let G = !0, J = !1, O = {}, U = null;
  const ie = Tn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let pe = null;
  const ke = Tn({}, ["audio", "video", "img", "source", "image", "track"]);
  let en = null;
  const mn = Tn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rn = "http://www.w3.org/1998/Math/MathML", dn = "http://www.w3.org/2000/svg", pn = "http://www.w3.org/1999/xhtml";
  let ln = pn, vn = !1, Xe = null;
  const xn = Tn({}, [rn, dn, pn], Al);
  let Oe = Tn({}, ["mi", "mo", "mn", "ms", "mtext"]), on = Tn({}, ["annotation-xml"]);
  const sn = Tn({}, ["title", "style", "font", "a", "script"]);
  let hn = null;
  const qn = ["application/xhtml+xml", "text/html"], Sn = "text/html";
  let yn = null, fn = null;
  const Nn = r.createElement("form"), Mn = function(x) {
    return x instanceof RegExp || x instanceof Function;
  }, Vn = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(fn && fn === x)) {
      if ((!x || typeof x != "object") && (x = {}), x = jr(x), hn = // eslint-disable-next-line unicorn/prefer-includes
      qn.indexOf(x.PARSER_MEDIA_TYPE) === -1 ? Sn : x.PARSER_MEDIA_TYPE, yn = hn === "application/xhtml+xml" ? Al : Xo, be = Qt(x, "ALLOWED_TAGS") ? Tn({}, x.ALLOWED_TAGS, yn) : Ce, K = Qt(x, "ALLOWED_ATTR") ? Tn({}, x.ALLOWED_ATTR, yn) : qe, Xe = Qt(x, "ALLOWED_NAMESPACES") ? Tn({}, x.ALLOWED_NAMESPACES, Al) : xn, en = Qt(x, "ADD_URI_SAFE_ATTR") ? Tn(jr(mn), x.ADD_URI_SAFE_ATTR, yn) : mn, pe = Qt(x, "ADD_DATA_URI_TAGS") ? Tn(jr(ke), x.ADD_DATA_URI_TAGS, yn) : ke, U = Qt(x, "FORBID_CONTENTS") ? Tn({}, x.FORBID_CONTENTS, yn) : ie, Pe = Qt(x, "FORBID_TAGS") ? Tn({}, x.FORBID_TAGS, yn) : jr({}), Me = Qt(x, "FORBID_ATTR") ? Tn({}, x.FORBID_ATTR, yn) : jr({}), O = Qt(x, "USE_PROFILES") ? x.USE_PROFILES : !1, Le = x.ALLOW_ARIA_ATTR !== !1, Te = x.ALLOW_DATA_ATTR !== !1, an = x.ALLOW_UNKNOWN_PROTOCOLS || !1, we = x.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ke = x.SAFE_FOR_TEMPLATES || !1, Ze = x.SAFE_FOR_XML !== !1, me = x.WHOLE_DOCUMENT || !1, Ae = x.RETURN_DOM || !1, Re = x.RETURN_DOM_FRAGMENT || !1, Ue = x.RETURN_TRUSTED_TYPE || !1, Ie = x.FORCE_BODY || !1, F = x.SANITIZE_DOM !== !1, _ = x.SANITIZE_NAMED_PROPS || !1, G = x.KEEP_CONTENT !== !1, J = x.IN_PLACE || !1, W = x.ALLOWED_URI_REGEXP || dx, ln = x.NAMESPACE || pn, Oe = x.MATHML_TEXT_INTEGRATION_POINTS || Oe, on = x.HTML_INTEGRATION_POINTS || on, Be = x.CUSTOM_ELEMENT_HANDLING || {}, x.CUSTOM_ELEMENT_HANDLING && Mn(x.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Be.tagNameCheck = x.CUSTOM_ELEMENT_HANDLING.tagNameCheck), x.CUSTOM_ELEMENT_HANDLING && Mn(x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Be.attributeNameCheck = x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), x.CUSTOM_ELEMENT_HANDLING && typeof x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ke && (Te = !1), Re && (Ae = !0), O && (be = Tn({}, ly), K = Qo(null), O.html === !0 && (Tn(be, sy), Tn(K, cy)), O.svg === !0 && (Tn(be, Vl), Tn(K, Ml), Tn(K, Fo)), O.svgFilters === !0 && (Tn(be, zl), Tn(K, Ml), Tn(K, Fo)), O.mathMl === !0 && (Tn(be, Ul), Tn(K, dy), Tn(K, Fo))), Qt(x, "ADD_TAGS") || (je.tagCheck = null), Qt(x, "ADD_ATTR") || (je.attributeCheck = null), x.ADD_TAGS && (typeof x.ADD_TAGS == "function" ? je.tagCheck = x.ADD_TAGS : (be === Ce && (be = jr(be)), Tn(be, x.ADD_TAGS, yn))), x.ADD_ATTR && (typeof x.ADD_ATTR == "function" ? je.attributeCheck = x.ADD_ATTR : (K === qe && (K = jr(K)), Tn(K, x.ADD_ATTR, yn))), x.ADD_URI_SAFE_ATTR && Tn(en, x.ADD_URI_SAFE_ATTR, yn), x.FORBID_CONTENTS && (U === ie && (U = jr(U)), Tn(U, x.FORBID_CONTENTS, yn)), x.ADD_FORBID_CONTENTS && (U === ie && (U = jr(U)), Tn(U, x.ADD_FORBID_CONTENTS, yn)), G && (be["#text"] = !0), me && Tn(be, ["html", "head", "body"]), be.table && (Tn(be, ["tbody"]), delete Pe.tbody), x.TRUSTED_TYPES_POLICY) {
        if (typeof x.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw va('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof x.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw va('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        $ = x.TRUSTED_TYPES_POLICY, E = $.createHTML("");
      } else
        $ === void 0 && ($ = EP(k, a)), $ !== null && typeof E == "string" && (E = $.createHTML(""));
      Vt && Vt(x), fn = x;
    }
  }, bn = Tn({}, [...Vl, ...zl, ...kP]), _n = Tn({}, [...Ul, ...bP]), Hn = function(x) {
    let V = q(x);
    (!V || !V.tagName) && (V = {
      namespaceURI: ln,
      tagName: "template"
    });
    const X = Xo(x.tagName), Ne = Xo(V.tagName);
    return Xe[x.namespaceURI] ? x.namespaceURI === dn ? V.namespaceURI === pn ? X === "svg" : V.namespaceURI === rn ? X === "svg" && (Ne === "annotation-xml" || Oe[Ne]) : !!bn[X] : x.namespaceURI === rn ? V.namespaceURI === pn ? X === "math" : V.namespaceURI === dn ? X === "math" && on[Ne] : !!_n[X] : x.namespaceURI === pn ? V.namespaceURI === dn && !on[Ne] || V.namespaceURI === rn && !Oe[Ne] ? !1 : !_n[X] && (sn[X] || !bn[X]) : !!(hn === "application/xhtml+xml" && Xe[x.namespaceURI]) : !1;
  }, Dn = function(x) {
    ya(n.removed, {
      element: x
    });
    try {
      q(x).removeChild(x);
    } catch {
      w(x);
    }
  }, Rn = function(x, V) {
    try {
      ya(n.removed, {
        attribute: V.getAttributeNode(x),
        from: V
      });
    } catch {
      ya(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute(x), x === "is")
      if (Ae || Re)
        try {
          Dn(V);
        } catch {
        }
      else
        try {
          V.setAttribute(x, "");
        } catch {
        }
  }, Bn = function(x) {
    let V = null, X = null;
    if (Ie)
      x = "<remove></remove>" + x;
    else {
      const ee = Ll(x, /^[\r\n\t ]+/);
      X = ee && ee[0];
    }
    hn === "application/xhtml+xml" && ln === pn && (x = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + x + "</body></html>");
    const Ne = $ ? $.createHTML(x) : x;
    if (ln === pn)
      try {
        V = new h().parseFromString(Ne, hn);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = D.createDocument(ln, "template", null);
      try {
        V.documentElement.innerHTML = vn ? E : Ne;
      } catch {
      }
    }
    const xe = V.body || V.documentElement;
    return x && X && xe.insertBefore(r.createTextNode(X), xe.childNodes[0] || null), ln === pn ? Q.call(V, me ? "html" : "body")[0] : me ? V.documentElement : xe;
  }, t = function(x) {
    return z.call(
      x.ownerDocument || x,
      x,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(x) {
    return x instanceof f && (typeof x.nodeName != "string" || typeof x.textContent != "string" || typeof x.removeChild != "function" || !(x.attributes instanceof u) || typeof x.removeAttribute != "function" || typeof x.setAttribute != "function" || typeof x.namespaceURI != "string" || typeof x.insertBefore != "function" || typeof x.hasChildNodes != "function");
  }, p = function(x) {
    return typeof l == "function" && x instanceof l;
  };
  function y(x, V, X) {
    Co(x, (Ne) => {
      Ne.call(n, V, X, fn);
    });
  }
  const P = function(x) {
    let V = null;
    if (y(Y.beforeSanitizeElements, x, null), c(x))
      return Dn(x), !0;
    const X = yn(x.nodeName);
    if (y(Y.uponSanitizeElement, x, {
      tagName: X,
      allowedTags: be
    }), Ze && x.hasChildNodes() && !p(x.firstElementChild) && Tt(/<[/\w!]/g, x.innerHTML) && Tt(/<[/\w!]/g, x.textContent) || x.nodeType === ba.progressingInstruction || Ze && x.nodeType === ba.comment && Tt(/<[/\w]/g, x.data))
      return Dn(x), !0;
    if (!(je.tagCheck instanceof Function && je.tagCheck(X)) && (!be[X] || Pe[X])) {
      if (!Pe[X] && I(X) && (Be.tagNameCheck instanceof RegExp && Tt(Be.tagNameCheck, X) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(X)))
        return !1;
      if (G && !U[X]) {
        const Ne = q(x) || x.parentNode, xe = g(x) || x.childNodes;
        if (xe && Ne) {
          const ee = xe.length;
          for (let nn = ee - 1; nn >= 0; --nn) {
            const In = S(xe[nn], !0);
            In.__removalCount = (x.__removalCount || 0) + 1, Ne.insertBefore(In, C(x));
          }
        }
      }
      return Dn(x), !0;
    }
    return x instanceof d && !Hn(x) || (X === "noscript" || X === "noembed" || X === "noframes") && Tt(/<\/no(script|embed|frames)/i, x.innerHTML) ? (Dn(x), !0) : (Ke && x.nodeType === ba.text && (V = x.textContent, Co([B, R, H], (Ne) => {
      V = ga(V, Ne, " ");
    }), x.textContent !== V && (ya(n.removed, {
      element: x.cloneNode()
    }), x.textContent = V)), y(Y.afterSanitizeElements, x, null), !1);
  }, L = function(x, V, X) {
    if (Me[V] || F && (V === "id" || V === "name") && (X in r || X in Nn))
      return !1;
    if (!(Te && !Me[V] && Tt(ne, V)) && !(Le && Tt(ve, V)) && !(je.attributeCheck instanceof Function && je.attributeCheck(V, x))) {
      if (!K[V] || Me[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(I(x) && (Be.tagNameCheck instanceof RegExp && Tt(Be.tagNameCheck, x) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(x)) && (Be.attributeNameCheck instanceof RegExp && Tt(Be.attributeNameCheck, V) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(V, x)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && Tt(Be.tagNameCheck, X) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(X)))
        ) return !1;
      } else if (!en[V] && !Tt(W, ga(X, le, "")) && !((V === "src" || V === "xlink:href" || V === "href") && x !== "script" && hP(X, "data:") === 0 && pe[x]) && !(an && !Tt(de, ga(X, le, ""))) && X)
        return !1;
    }
    return !0;
  }, I = function(x) {
    return x !== "annotation-xml" && Ll(x, fe);
  }, j = function(x) {
    y(Y.beforeSanitizeAttributes, x, null);
    const {
      attributes: V
    } = x;
    if (!V || c(x))
      return;
    const X = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let Ne = V.length;
    for (; Ne--; ) {
      const xe = V[Ne], {
        name: ee,
        namespaceURI: nn,
        value: In
      } = xe, En = yn(ee), Xs = In;
      let bt = ee === "value" ? Xs : yP(Xs);
      if (X.attrName = En, X.attrValue = bt, X.keepAttr = !0, X.forceKeepAttr = void 0, y(Y.uponSanitizeAttribute, x, X), bt = X.attrValue, _ && (En === "id" || En === "name") && (Rn(ee, x), bt = T + bt), Ze && Tt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, bt)) {
        Rn(ee, x);
        continue;
      }
      if (En === "attributename" && Ll(bt, "href")) {
        Rn(ee, x);
        continue;
      }
      if (X.forceKeepAttr)
        continue;
      if (!X.keepAttr) {
        Rn(ee, x);
        continue;
      }
      if (!we && Tt(/\/>/i, bt)) {
        Rn(ee, x);
        continue;
      }
      Ke && Co([B, R, H], (xS) => {
        bt = ga(bt, xS, " ");
      });
      const Mp = yn(x.nodeName);
      if (!L(Mp, En, bt)) {
        Rn(ee, x);
        continue;
      }
      if ($ && typeof k == "object" && typeof k.getAttributeType == "function" && !nn)
        switch (k.getAttributeType(Mp, En)) {
          case "TrustedHTML": {
            bt = $.createHTML(bt);
            break;
          }
          case "TrustedScriptURL": {
            bt = $.createScriptURL(bt);
            break;
          }
        }
      if (bt !== Xs)
        try {
          nn ? x.setAttributeNS(nn, ee, bt) : x.setAttribute(ee, bt), c(x) ? Dn(x) : oy(n.removed);
        } catch {
          Rn(ee, x);
        }
    }
    y(Y.afterSanitizeAttributes, x, null);
  }, re = function x(V) {
    let X = null;
    const Ne = t(V);
    for (y(Y.beforeSanitizeShadowDOM, V, null); X = Ne.nextNode(); )
      y(Y.uponSanitizeShadowNode, X, null), P(X), j(X), X.content instanceof o && x(X.content);
    y(Y.afterSanitizeShadowDOM, V, null);
  };
  return n.sanitize = function(x) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, X = null, Ne = null, xe = null, ee = null;
    if (vn = !x, vn && (x = "<!-->"), typeof x != "string" && !p(x))
      if (typeof x.toString == "function") {
        if (x = x.toString(), typeof x != "string")
          throw va("dirty is not a string, aborting");
      } else
        throw va("toString is not a function");
    if (!n.isSupported)
      return x;
    if (he || Vn(V), n.removed = [], typeof x == "string" && (J = !1), J) {
      if (x.nodeName) {
        const En = yn(x.nodeName);
        if (!be[En] || Pe[En])
          throw va("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (x instanceof l)
      X = Bn("<!---->"), Ne = X.ownerDocument.importNode(x, !0), Ne.nodeType === ba.element && Ne.nodeName === "BODY" || Ne.nodeName === "HTML" ? X = Ne : X.appendChild(Ne);
    else {
      if (!Ae && !Ke && !me && // eslint-disable-next-line unicorn/prefer-includes
      x.indexOf("<") === -1)
        return $ && Ue ? $.createHTML(x) : x;
      if (X = Bn(x), !X)
        return Ae ? null : Ue ? E : "";
    }
    X && Ie && Dn(X.firstChild);
    const nn = t(J ? x : X);
    for (; xe = nn.nextNode(); )
      P(xe), j(xe), xe.content instanceof o && re(xe.content);
    if (J)
      return x;
    if (Ae) {
      if (Re)
        for (ee = Z.call(X.ownerDocument); X.firstChild; )
          ee.appendChild(X.firstChild);
      else
        ee = X;
      return (K.shadowroot || K.shadowrootmode) && (ee = te.call(i, ee, !0)), ee;
    }
    let In = me ? X.outerHTML : X.innerHTML;
    return me && be["!doctype"] && X.ownerDocument && X.ownerDocument.doctype && X.ownerDocument.doctype.name && Tt(ux, X.ownerDocument.doctype.name) && (In = "<!DOCTYPE " + X.ownerDocument.doctype.name + `>
` + In), Ke && Co([B, R, H], (En) => {
      In = ga(In, En, " ");
    }), $ && Ue ? $.createHTML(In) : In;
  }, n.setConfig = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(x), he = !0;
  }, n.clearConfig = function() {
    fn = null, he = !1;
  }, n.isValidAttribute = function(x, V, X) {
    fn || Vn({});
    const Ne = yn(x), xe = yn(V);
    return L(Ne, xe, X);
  }, n.addHook = function(x, V) {
    typeof V == "function" && ya(Y[x], V);
  }, n.removeHook = function(x, V) {
    if (V !== void 0) {
      const X = pP(Y[x], V);
      return X === -1 ? void 0 : fP(Y[x], X, 1)[0];
    }
    return oy(Y[x]);
  }, n.removeHooks = function(x) {
    Y[x] = [];
  }, n.removeAllHooks = function() {
    Y = my();
  }, n;
}
var TP = mx();
const $P = "_messageContainer_1rxr4_1", DP = "_chip_1rxr4_7", RP = "_chipLabel_1rxr4_10", OP = "_chipValue_1rxr4_13", Io = {
  messageContainer: $P,
  chip: DP,
  chipLabel: RP,
  chipValue: OP
}, py = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, PP = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  He(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ jn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ jn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ jn.jsx(Ge, { content: "Conversation Attributes", children: /* @__PURE__ */ jn.jsx(
        Fm,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ jn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ jn.jsx(Pn, { className: Io.chip, children: /* @__PURE__ */ jn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ jn.jsxs(Qn, { className: Io.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ jn.jsx(Qn, { className: Io.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ jn.jsx(
      b,
      {
        className: Io.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? py[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? py[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ jn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ jn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ jn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ jn.jsx(qS, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ jn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: TP.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ jn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ jn.jsx(
      HS,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ jn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, AP = "_conversation_1draa_1", LP = "_conversationSubLine_1draa_9", VP = "_modal_1draa_14", Bl = {
  conversation: AP,
  conversationSubLine: LP,
  modal: VP
}, zP = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), UP = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), MP = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ jn.jsxs(b, { className: Bl.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ jn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ jn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ jn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ jn.jsx(Un, { size: "small", variant: "info", children: An(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ jn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Bl.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ jn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ jn.jsx(Pn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ jn.jsx(Ge, { content: "Show conversation preview", children: /* @__PURE__ */ jn.jsx(
        Yt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ jn.jsxs(
      gt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Bl.modal,
        children: [
          /* @__PURE__ */ jn.jsx(
            vt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ jn.jsx(kt, { children: /* @__PURE__ */ jn.jsx(
            PP,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: zP(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: UP(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, BP = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Kn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ jn.jsx(
      MP,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ jn.jsxs(
      Wn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, qP = cP(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), HP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = un(), { data: l, loading: d, error: m } = s(qP, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return He(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ jn.jsx(Fn, { error: m }) : d ? /* @__PURE__ */ jn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ jn.jsx(cn, {}) }) : r?.length === 0 ? /* @__PURE__ */ jn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ jn.jsx(
    BP,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, WP = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ja
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ql = { exports: {} }, _a = {}, fy;
function KP() {
  if (fy) return _a;
  fy = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return _a.Fragment = r, _a.jsx = s, _a.jsxs = s, _a;
}
var Eo = {}, hy;
function GP() {
  return hy || (hy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    Eo.Fragment = i, Eo.jsx = Rn, Eo.jsxs = Bn;
  })()), Eo;
}
var yy;
function YP() {
  return yy || (yy = 1, process.env.NODE_ENV === "production" ? ql.exports = KP() : ql.exports = GP()), ql.exports;
}
var Fe = YP();
const JP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, QP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, XP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, ZP = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": JP,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": QP,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": XP
};
function cp(e) {
  return ZP[e] ?? {};
}
const eA = cp(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), nA = cp(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), tA = cp(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function fm(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const rA = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, px = "DD MMM YYYY @ HH:mm", iA = "_list_2c4dq_1", aA = "_listItem_2c4dq_4", oA = "_copyIcon_2c4dq_12", pi = {
  list: iA,
  listItem: aA,
  copyIcon: oA
}, hm = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = fm(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: k,
    country_code: N
  } = e ?? {}, S = `${d} ${m}`.trim() || void 0, w = `${h} ${k}`.trim() || void 0, C = [S, u, f, w, N].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ue, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(cn, { size: l }) : /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: C.map((g, q) => /* @__PURE__ */ Fe.jsx(Qn, { children: g }, q)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(Ge, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: l,
          name: "exclamation",
          className: pi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(C.join(", ")),
          className: pi.copyIcon
        }
      ) })
    ] })
  ] });
}, sA = "_wrapper_1nher_1", lA = {
  wrapper: sA
}, cA = ({
  customer: e,
  store: n
}) => {
  const { track: r } = kn(), { isCopied: i, copy: a } = fm(), { isCopied: o, copy: s } = fm(), { useQuery: l } = un(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(nA, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, k = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, N = (h?.addresses?.length ?? 0) > 1;
  if (He(() => {
    k && r("recharge:profile:received");
  }, [k, r]), u)
    return /* @__PURE__ */ Fe.jsx(Fn, { error: u });
  if (!e)
    return null;
  const {
    id: S,
    phone: w,
    email: C,
    first_name: g,
    last_name: q,
    created_at: $,
    has_valid_payment_method: E
  } = e, D = 14, z = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, Z = `${g || ""} ${q || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: lA.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-2", children: Z }),
    $ && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: An($).format(px) })
    ] }),
    C && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(A.ExternalLink, { href: `mailto:${C}`, children: C })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: pi.copyIcon
        }
      ) })
    ] }),
    w && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: w })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: o ? "done" : "copy",
          onClick: () => s(w),
          className: pi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      hm,
      {
        address: k,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: N
      }
    ),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: E ? "check-circle" : "close-circle-filled",
          color: E ? "green.500" : "red.500"
        }
      )
    ] }),
    z && /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        A.ExternalLink,
        {
          href: z,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, dA = "_order_1dlaa_1", uA = "_orderIsOpen_1dlaa_9", mA = "_orderHeader_1dlaa_12", pA = "_note_1dlaa_16", To = {
  order: dA,
  orderIsOpen: uA,
  orderHeader: mA,
  note: pA
}, fA = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = kn(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: k,
    total_price: N,
    is_prepaid: S
  } = e, w = 14, C = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    b,
    {
      className: ut(To.order, {
        [To.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: To.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Fe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: An(f).format(px) }) }),
                /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Fe.jsx(Ge, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: To.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: w, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: rA(l) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: w, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: w, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: w, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "4", children: [
                N,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            hm,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            hm,
            {
              address: k,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          C && /* @__PURE__ */ Fe.jsx(
            wt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(C, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Fe.jsx(ue, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, hA = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = kn(), { useQuery: i } = un(), {
    loading: a,
    error: o,
    data: s
  } = i(tA, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Fe.jsx(Fn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Fe.jsx(Un, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(cn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Fe.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Fe.jsx(
        fA,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Fe.jsx(
        wt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Fe.jsx(ue, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, yA = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(We, { className: pi.list, children: [
      /* @__PURE__ */ Fe.jsx(We.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(We.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, gA = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(eA, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const k = m.graphQLErrors;
    return Sm({ errors: k }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Nm({ errors: k }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Fe.jsx(Fn, { error: m });
  }
  return d ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(cn, {}) }) : f ? l ? /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Fe.jsx(cA, { customer: f, store: h }),
        o && /* @__PURE__ */ Fe.jsx(yA, { customer: f }),
        s && /* @__PURE__ */ Fe.jsx(hA, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, vA = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var $o = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Hl = { exports: {} }, xa = {}, gy;
function kA() {
  if (gy) return xa;
  gy = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return xa.Fragment = r, xa.jsx = s, xa.jsxs = s, xa;
}
var Do = {}, vy;
function bA() {
  return vy || (vy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    Do.Fragment = i, Do.jsx = Rn, Do.jsxs = Bn;
  })()), Do;
}
var ky;
function _A() {
  return ky || (ky = 1, process.env.NODE_ENV === "production" ? Hl.exports = kA() : Hl.exports = bA()), Hl.exports;
}
var fi = _A();
function xA(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Wl, by;
function ni() {
  if (by) return Wl;
  by = 1;
  var e = Array.isArray;
  return Wl = e, Wl;
}
var Kl, _y;
function hx() {
  if (_y) return Kl;
  _y = 1;
  var e = typeof $o == "object" && $o && $o.Object === Object && $o;
  return Kl = e, Kl;
}
var Gl, xy;
function Pr() {
  if (xy) return Gl;
  xy = 1;
  var e = hx(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Gl = r, Gl;
}
var Yl, Sy;
function oo() {
  if (Sy) return Yl;
  Sy = 1;
  var e = Pr(), n = e.Symbol;
  return Yl = n, Yl;
}
var Jl, Ny;
function SA() {
  if (Ny) return Jl;
  Ny = 1;
  var e = oo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Jl = o, Jl;
}
var Ql, jy;
function NA() {
  if (jy) return Ql;
  jy = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Ql = r, Ql;
}
var Xl, wy;
function Wi() {
  if (wy) return Xl;
  wy = 1;
  var e = oo(), n = SA(), r = NA(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Xl = s, Xl;
}
var Zl, Cy;
function bi() {
  if (Cy) return Zl;
  Cy = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Zl = e, Zl;
}
var ec, Fy;
function dp() {
  if (Fy) return ec;
  Fy = 1;
  var e = Wi(), n = bi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return ec = i, ec;
}
var nc, Iy;
function jA() {
  if (Iy) return nc;
  Iy = 1;
  var e = ni(), n = dp(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return nc = a, nc;
}
var tc, Ey;
function Ki() {
  if (Ey) return tc;
  Ey = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return tc = e, tc;
}
var rc, Ty;
function yx() {
  if (Ty) return rc;
  Ty = 1;
  var e = Wi(), n = Ki(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return rc = s, rc;
}
var ic, $y;
function wA() {
  if ($y) return ic;
  $y = 1;
  var e = Pr(), n = e["__core-js_shared__"];
  return ic = n, ic;
}
var ac, Dy;
function CA() {
  if (Dy) return ac;
  Dy = 1;
  var e = wA(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return ac = r, ac;
}
var oc, Ry;
function gx() {
  if (Ry) return oc;
  Ry = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return oc = r, oc;
}
var sc, Oy;
function FA() {
  if (Oy) return sc;
  Oy = 1;
  var e = yx(), n = CA(), r = Ki(), i = gx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return sc = f, sc;
}
var lc, Py;
function IA() {
  if (Py) return lc;
  Py = 1;
  function e(n, r) {
    return n?.[r];
  }
  return lc = e, lc;
}
var cc, Ay;
function _i() {
  if (Ay) return cc;
  Ay = 1;
  var e = FA(), n = IA();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return cc = r, cc;
}
var dc, Ly;
function qs() {
  if (Ly) return dc;
  Ly = 1;
  var e = _i(), n = e(Object, "create");
  return dc = n, dc;
}
var uc, Vy;
function EA() {
  if (Vy) return uc;
  Vy = 1;
  var e = qs();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return uc = n, uc;
}
var mc, zy;
function TA() {
  if (zy) return mc;
  zy = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return mc = e, mc;
}
var pc, Uy;
function $A() {
  if (Uy) return pc;
  Uy = 1;
  var e = qs(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return pc = a, pc;
}
var fc, My;
function DA() {
  if (My) return fc;
  My = 1;
  var e = qs(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return fc = i, fc;
}
var hc, By;
function RA() {
  if (By) return hc;
  By = 1;
  var e = qs(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return hc = r, hc;
}
var yc, qy;
function OA() {
  if (qy) return yc;
  qy = 1;
  var e = EA(), n = TA(), r = $A(), i = DA(), a = RA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, yc = o, yc;
}
var gc, Hy;
function PA() {
  if (Hy) return gc;
  Hy = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return gc = e, gc;
}
var vc, Wy;
function vx() {
  if (Wy) return vc;
  Wy = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return vc = e, vc;
}
var kc, Ky;
function Hs() {
  if (Ky) return kc;
  Ky = 1;
  var e = vx();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return kc = n, kc;
}
var bc, Gy;
function AA() {
  if (Gy) return bc;
  Gy = 1;
  var e = Hs(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return bc = i, bc;
}
var _c, Yy;
function LA() {
  if (Yy) return _c;
  Yy = 1;
  var e = Hs();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return _c = n, _c;
}
var xc, Jy;
function VA() {
  if (Jy) return xc;
  Jy = 1;
  var e = Hs();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return xc = n, xc;
}
var Sc, Qy;
function zA() {
  if (Qy) return Sc;
  Qy = 1;
  var e = Hs();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Sc = n, Sc;
}
var Nc, Xy;
function Ws() {
  if (Xy) return Nc;
  Xy = 1;
  var e = PA(), n = AA(), r = LA(), i = VA(), a = zA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Nc = o, Nc;
}
var jc, Zy;
function up() {
  if (Zy) return jc;
  Zy = 1;
  var e = _i(), n = Pr(), r = e(n, "Map");
  return jc = r, jc;
}
var wc, eg;
function UA() {
  if (eg) return wc;
  eg = 1;
  var e = OA(), n = Ws(), r = up();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return wc = i, wc;
}
var Cc, ng;
function MA() {
  if (ng) return Cc;
  ng = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Cc = e, Cc;
}
var Fc, tg;
function Ks() {
  if (tg) return Fc;
  tg = 1;
  var e = MA();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Fc = n, Fc;
}
var Ic, rg;
function BA() {
  if (rg) return Ic;
  rg = 1;
  var e = Ks();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Ic = n, Ic;
}
var Ec, ig;
function qA() {
  if (ig) return Ec;
  ig = 1;
  var e = Ks();
  function n(r) {
    return e(this, r).get(r);
  }
  return Ec = n, Ec;
}
var Tc, ag;
function HA() {
  if (ag) return Tc;
  ag = 1;
  var e = Ks();
  function n(r) {
    return e(this, r).has(r);
  }
  return Tc = n, Tc;
}
var $c, og;
function WA() {
  if (og) return $c;
  og = 1;
  var e = Ks();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return $c = n, $c;
}
var Dc, sg;
function kx() {
  if (sg) return Dc;
  sg = 1;
  var e = UA(), n = BA(), r = qA(), i = HA(), a = WA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Dc = o, Dc;
}
var Rc, lg;
function KA() {
  if (lg) return Rc;
  lg = 1;
  var e = kx(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Rc = r, Rc;
}
var Oc, cg;
function GA() {
  if (cg) return Oc;
  cg = 1;
  var e = KA(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Oc = r, Oc;
}
var Pc, dg;
function YA() {
  if (dg) return Pc;
  dg = 1;
  var e = GA(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Pc = i, Pc;
}
var Ac, ug;
function bx() {
  if (ug) return Ac;
  ug = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Ac = e, Ac;
}
var Lc, mg;
function JA() {
  if (mg) return Lc;
  mg = 1;
  var e = oo(), n = bx(), r = ni(), i = dp(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return Lc = s, Lc;
}
var Vc, pg;
function QA() {
  if (pg) return Vc;
  pg = 1;
  var e = JA();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Vc = n, Vc;
}
var zc, fg;
function Gi() {
  if (fg) return zc;
  fg = 1;
  var e = ni(), n = jA(), r = YA(), i = QA();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return zc = a, zc;
}
var Uc, hg;
function Gs() {
  if (hg) return Uc;
  hg = 1;
  var e = dp();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Uc = n, Uc;
}
var Mc, yg;
function _x() {
  if (yg) return Mc;
  yg = 1;
  var e = Gi(), n = Gs();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Mc = r, Mc;
}
var Bc, gg;
function xx() {
  if (gg) return Bc;
  gg = 1;
  var e = _i(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Bc = n, Bc;
}
var qc, vg;
function Sx() {
  if (vg) return qc;
  vg = 1;
  var e = xx();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return qc = n, qc;
}
var Hc, kg;
function mp() {
  if (kg) return Hc;
  kg = 1;
  var e = Sx(), n = vx(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Hc = a, Hc;
}
var Wc, bg;
function pp() {
  if (bg) return Wc;
  bg = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Wc = r, Wc;
}
var Kc, _g;
function XA() {
  if (_g) return Kc;
  _g = 1;
  var e = mp(), n = Gi(), r = pp(), i = Ki(), a = Gs();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var N = a(l[u]), S = d;
      if (N === "__proto__" || N === "constructor" || N === "prototype")
        return s;
      if (u != h) {
        var w = k[N];
        S = m ? m(w, N, k) : void 0, S === void 0 && (S = i(w) ? w : r(l[u + 1]) ? [] : {});
      }
      e(k, N, S), k = k[N];
    }
    return s;
  }
  return Kc = o, Kc;
}
var Gc, xg;
function ZA() {
  if (xg) return Gc;
  xg = 1;
  var e = _x(), n = XA(), r = Gi();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Gc = i, Gc;
}
var Yc, Sg;
function e2() {
  if (Sg) return Yc;
  Sg = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Yc = e, Yc;
}
var Jc, Ng;
function n2() {
  if (Ng) return Jc;
  Ng = 1;
  var e = Wi(), n = bi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jc = i, Jc;
}
var Qc, jg;
function fp() {
  if (jg) return Qc;
  jg = 1;
  var e = n2(), n = bi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Qc = o, Qc;
}
var Xc, wg;
function hp() {
  if (wg) return Xc;
  wg = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Xc = n, Xc;
}
var Zc, Cg;
function t2() {
  if (Cg) return Zc;
  Cg = 1;
  var e = Gi(), n = fp(), r = ni(), i = pp(), a = hp(), o = Gs();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return Zc = s, Zc;
}
var ed, Fg;
function r2() {
  if (Fg) return ed;
  Fg = 1;
  var e = e2(), n = t2();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return ed = r, ed;
}
var nd, Ig;
function i2() {
  if (Ig) return nd;
  Ig = 1;
  var e = ZA(), n = r2();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return nd = r, nd;
}
var td, Eg;
function yp() {
  if (Eg) return td;
  Eg = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return td = e, td;
}
var rd, Tg;
function a2() {
  if (Tg) return rd;
  Tg = 1;
  var e = oo(), n = fp(), r = ni(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return rd = a, rd;
}
var id, $g;
function o2() {
  if ($g) return id;
  $g = 1;
  var e = yp(), n = a2();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return id = r, id;
}
var ad, Dg;
function s2() {
  if (Dg) return ad;
  Dg = 1;
  var e = o2();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return ad = n, ad;
}
var od, Rg;
function l2() {
  if (Rg) return od;
  Rg = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return od = e, od;
}
var sd, Og;
function c2() {
  if (Og) return sd;
  Og = 1;
  var e = l2(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return sd = r, sd;
}
var ld, Pg;
function d2() {
  if (Pg) return ld;
  Pg = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return ld = e, ld;
}
var cd, Ag;
function Nx() {
  if (Ag) return cd;
  Ag = 1;
  function e(n) {
    return n;
  }
  return cd = e, cd;
}
var dd, Lg;
function u2() {
  if (Lg) return dd;
  Lg = 1;
  var e = d2(), n = xx(), r = Nx(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return dd = i, dd;
}
var ud, Vg;
function m2() {
  if (Vg) return ud;
  Vg = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return ud = i, ud;
}
var md, zg;
function p2() {
  if (zg) return md;
  zg = 1;
  var e = u2(), n = m2(), r = n(e);
  return md = r, md;
}
var pd, Ug;
function jx() {
  if (Ug) return pd;
  Ug = 1;
  var e = s2(), n = c2(), r = p2();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return pd = i, pd;
}
var fd, Mg;
function f2() {
  if (Mg) return fd;
  Mg = 1;
  var e = i2(), n = jx(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return fd = r, fd;
}
var h2 = f2();
const wx = /* @__PURE__ */ fx(h2), y2 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function Cx(e) {
  const n = wx(e, y2);
  return {
    controller: Bm(n),
    controllerProps: n
  };
}
const g2 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function Fx(e) {
  const { controller: n, controllerProps: r } = Cx(e), i = {
    ...wx(e, g2),
    required: xA(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var hd, Bg;
function v2() {
  if (Bg) return hd;
  Bg = 1;
  var e = Ws();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return hd = n, hd;
}
var yd, qg;
function k2() {
  if (qg) return yd;
  qg = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return yd = e, yd;
}
var gd, Hg;
function b2() {
  if (Hg) return gd;
  Hg = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return gd = e, gd;
}
var vd, Wg;
function _2() {
  if (Wg) return vd;
  Wg = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return vd = e, vd;
}
var kd, Kg;
function x2() {
  if (Kg) return kd;
  Kg = 1;
  var e = Ws(), n = up(), r = kx(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return kd = a, kd;
}
var bd, Gg;
function S2() {
  if (Gg) return bd;
  Gg = 1;
  var e = Ws(), n = v2(), r = k2(), i = b2(), a = _2(), o = x2();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, bd = s, bd;
}
var _d, Yg;
function N2() {
  if (Yg) return _d;
  Yg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return _d = e, _d;
}
var xd, Jg;
function so() {
  if (Jg) return xd;
  Jg = 1;
  var e = mp(), n = Sx();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return xd = r, xd;
}
var Sd, Qg;
function j2() {
  if (Qg) return Sd;
  Qg = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Sd = e, Sd;
}
var Zo = { exports: {} }, Nd, Xg;
function w2() {
  if (Xg) return Nd;
  Xg = 1;
  function e() {
    return !1;
  }
  return Nd = e, Nd;
}
Zo.exports;
var Zg;
function Ix() {
  return Zg || (Zg = 1, (function(e, n) {
    var r = Pr(), i = w2(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(Zo, Zo.exports)), Zo.exports;
}
var jd, ev;
function C2() {
  if (ev) return jd;
  ev = 1;
  var e = Wi(), n = hp(), r = bi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", N = "[object String]", S = "[object WeakMap]", w = "[object ArrayBuffer]", C = "[object DataView]", g = "[object Float32Array]", q = "[object Float64Array]", $ = "[object Int8Array]", E = "[object Int16Array]", D = "[object Int32Array]", z = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", te = "[object Uint32Array]", Y = {};
  Y[g] = Y[q] = Y[$] = Y[E] = Y[D] = Y[z] = Y[Z] = Y[Q] = Y[te] = !0, Y[i] = Y[a] = Y[w] = Y[o] = Y[C] = Y[s] = Y[l] = Y[d] = Y[m] = Y[u] = Y[f] = Y[h] = Y[k] = Y[N] = Y[S] = !1;
  function B(R) {
    return r(R) && n(R.length) && !!Y[e(R)];
  }
  return jd = B, jd;
}
var wd, nv;
function gp() {
  if (nv) return wd;
  nv = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return wd = e, wd;
}
var es = { exports: {} };
es.exports;
var tv;
function vp() {
  return tv || (tv = 1, (function(e, n) {
    var r = hx(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(es, es.exports)), es.exports;
}
var Cd, rv;
function F2() {
  if (rv) return Cd;
  rv = 1;
  var e = C2(), n = gp(), r = vp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Cd = a, Cd;
}
var Fd, iv;
function Ex() {
  if (iv) return Fd;
  iv = 1;
  var e = j2(), n = fp(), r = ni(), i = Ix(), a = pp(), o = F2(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), N = !f && !h && !k && o(m), S = f || h || k || N, w = S ? e(m.length, String) : [], C = w.length;
    for (var g in m)
      (u || l.call(m, g)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      N && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, C))) && w.push(g);
    return w;
  }
  return Fd = d, Fd;
}
var Id, av;
function kp() {
  if (av) return Id;
  av = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Id = n, Id;
}
var Ed, ov;
function Tx() {
  if (ov) return Ed;
  ov = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Ed = e, Ed;
}
var Td, sv;
function I2() {
  if (sv) return Td;
  sv = 1;
  var e = Tx(), n = e(Object.keys, Object);
  return Td = n, Td;
}
var $d, lv;
function E2() {
  if (lv) return $d;
  lv = 1;
  var e = kp(), n = I2(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return $d = a, $d;
}
var Dd, cv;
function $x() {
  if (cv) return Dd;
  cv = 1;
  var e = yx(), n = hp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Dd = r, Dd;
}
var Rd, dv;
function bp() {
  if (dv) return Rd;
  dv = 1;
  var e = Ex(), n = E2(), r = $x();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Rd = i, Rd;
}
var Od, uv;
function T2() {
  if (uv) return Od;
  uv = 1;
  var e = so(), n = bp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Od = r, Od;
}
var Pd, mv;
function $2() {
  if (mv) return Pd;
  mv = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Pd = e, Pd;
}
var Ad, pv;
function D2() {
  if (pv) return Ad;
  pv = 1;
  var e = Ki(), n = kp(), r = $2(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Ad = o, Ad;
}
var Ld, fv;
function _p() {
  if (fv) return Ld;
  fv = 1;
  var e = Ex(), n = D2(), r = $x();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Ld = i, Ld;
}
var Vd, hv;
function R2() {
  if (hv) return Vd;
  hv = 1;
  var e = so(), n = _p();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Vd = r, Vd;
}
var ns = { exports: {} };
ns.exports;
var yv;
function O2() {
  return yv || (yv = 1, (function(e, n) {
    var r = Pr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(ns, ns.exports)), ns.exports;
}
var zd, gv;
function P2() {
  if (gv) return zd;
  gv = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return zd = e, zd;
}
var Ud, vv;
function A2() {
  if (vv) return Ud;
  vv = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Ud = e, Ud;
}
var Md, kv;
function Dx() {
  if (kv) return Md;
  kv = 1;
  function e() {
    return [];
  }
  return Md = e, Md;
}
var Bd, bv;
function xp() {
  if (bv) return Bd;
  bv = 1;
  var e = A2(), n = Dx(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Bd = o, Bd;
}
var qd, _v;
function L2() {
  if (_v) return qd;
  _v = 1;
  var e = so(), n = xp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return qd = r, qd;
}
var Hd, xv;
function Sp() {
  if (xv) return Hd;
  xv = 1;
  var e = Tx(), n = e(Object.getPrototypeOf, Object);
  return Hd = n, Hd;
}
var Wd, Sv;
function Rx() {
  if (Sv) return Wd;
  Sv = 1;
  var e = yp(), n = Sp(), r = xp(), i = Dx(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Wd = o, Wd;
}
var Kd, Nv;
function V2() {
  if (Nv) return Kd;
  Nv = 1;
  var e = so(), n = Rx();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Kd = r, Kd;
}
var Gd, jv;
function Ox() {
  if (jv) return Gd;
  jv = 1;
  var e = yp(), n = ni();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Gd = r, Gd;
}
var Yd, wv;
function z2() {
  if (wv) return Yd;
  wv = 1;
  var e = Ox(), n = xp(), r = bp();
  function i(a) {
    return e(a, r, n);
  }
  return Yd = i, Yd;
}
var Jd, Cv;
function Px() {
  if (Cv) return Jd;
  Cv = 1;
  var e = Ox(), n = Rx(), r = _p();
  function i(a) {
    return e(a, r, n);
  }
  return Jd = i, Jd;
}
var Qd, Fv;
function U2() {
  if (Fv) return Qd;
  Fv = 1;
  var e = _i(), n = Pr(), r = e(n, "DataView");
  return Qd = r, Qd;
}
var Xd, Iv;
function M2() {
  if (Iv) return Xd;
  Iv = 1;
  var e = _i(), n = Pr(), r = e(n, "Promise");
  return Xd = r, Xd;
}
var Zd, Ev;
function B2() {
  if (Ev) return Zd;
  Ev = 1;
  var e = _i(), n = Pr(), r = e(n, "Set");
  return Zd = r, Zd;
}
var eu, Tv;
function q2() {
  if (Tv) return eu;
  Tv = 1;
  var e = _i(), n = Pr(), r = e(n, "WeakMap");
  return eu = r, eu;
}
var nu, $v;
function Np() {
  if ($v) return nu;
  $v = 1;
  var e = U2(), n = up(), r = M2(), i = B2(), a = q2(), o = Wi(), s = gx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), N = s(n), S = s(r), w = s(i), C = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(q) {
    var $ = o(q), E = $ == d ? q.constructor : void 0, D = E ? s(E) : "";
    if (D)
      switch (D) {
        case k:
          return h;
        case N:
          return l;
        case S:
          return m;
        case w:
          return u;
        case C:
          return f;
      }
    return $;
  }), nu = g, nu;
}
var tu, Dv;
function H2() {
  if (Dv) return tu;
  Dv = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return tu = r, tu;
}
var ru, Rv;
function W2() {
  if (Rv) return ru;
  Rv = 1;
  var e = Pr(), n = e.Uint8Array;
  return ru = n, ru;
}
var iu, Ov;
function jp() {
  if (Ov) return iu;
  Ov = 1;
  var e = W2();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return iu = n, iu;
}
var au, Pv;
function K2() {
  if (Pv) return au;
  Pv = 1;
  var e = jp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return au = n, au;
}
var ou, Av;
function G2() {
  if (Av) return ou;
  Av = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return ou = n, ou;
}
var su, Lv;
function Y2() {
  if (Lv) return su;
  Lv = 1;
  var e = oo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return su = i, su;
}
var lu, Vv;
function J2() {
  if (Vv) return lu;
  Vv = 1;
  var e = jp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return lu = n, lu;
}
var cu, zv;
function Q2() {
  if (zv) return cu;
  zv = 1;
  var e = jp(), n = K2(), r = G2(), i = Y2(), a = J2(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", N = "[object DataView]", S = "[object Float32Array]", w = "[object Float64Array]", C = "[object Int8Array]", g = "[object Int16Array]", q = "[object Int32Array]", $ = "[object Uint8Array]", E = "[object Uint8ClampedArray]", D = "[object Uint16Array]", z = "[object Uint32Array]";
  function Z(Q, te, Y) {
    var B = Q.constructor;
    switch (te) {
      case k:
        return e(Q);
      case o:
      case s:
        return new B(+Q);
      case N:
        return n(Q, Y);
      case S:
      case w:
      case C:
      case g:
      case q:
      case $:
      case E:
      case D:
      case z:
        return a(Q, Y);
      case l:
        return new B();
      case d:
      case f:
        return new B(Q);
      case m:
        return r(Q);
      case u:
        return new B();
      case h:
        return i(Q);
    }
  }
  return cu = Z, cu;
}
var du, Uv;
function X2() {
  if (Uv) return du;
  Uv = 1;
  var e = Ki(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return du = r, du;
}
var uu, Mv;
function Z2() {
  if (Mv) return uu;
  Mv = 1;
  var e = X2(), n = Sp(), r = kp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return uu = i, uu;
}
var mu, Bv;
function eL() {
  if (Bv) return mu;
  Bv = 1;
  var e = Np(), n = bi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return mu = i, mu;
}
var pu, qv;
function nL() {
  if (qv) return pu;
  qv = 1;
  var e = eL(), n = gp(), r = vp(), i = r && r.isMap, a = i ? n(i) : e;
  return pu = a, pu;
}
var fu, Hv;
function tL() {
  if (Hv) return fu;
  Hv = 1;
  var e = Np(), n = bi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return fu = i, fu;
}
var hu, Wv;
function rL() {
  if (Wv) return hu;
  Wv = 1;
  var e = tL(), n = gp(), r = vp(), i = r && r.isSet, a = i ? n(i) : e;
  return hu = a, hu;
}
var yu, Kv;
function iL() {
  if (Kv) return yu;
  Kv = 1;
  var e = S2(), n = N2(), r = mp(), i = T2(), a = R2(), o = O2(), s = P2(), l = L2(), d = V2(), m = z2(), u = Px(), f = Np(), h = H2(), k = Q2(), N = Z2(), S = ni(), w = Ix(), C = nL(), g = Ki(), q = rL(), $ = bp(), E = _p(), D = 1, z = 2, Z = 4, Q = "[object Arguments]", te = "[object Array]", Y = "[object Boolean]", B = "[object Date]", R = "[object Error]", H = "[object Function]", ne = "[object GeneratorFunction]", ve = "[object Map]", de = "[object Number]", le = "[object Object]", fe = "[object RegExp]", W = "[object Set]", be = "[object String]", Ce = "[object Symbol]", K = "[object WeakMap]", qe = "[object ArrayBuffer]", Be = "[object DataView]", Pe = "[object Float32Array]", Me = "[object Float64Array]", je = "[object Int8Array]", Le = "[object Int16Array]", Te = "[object Int32Array]", an = "[object Uint8Array]", we = "[object Uint8ClampedArray]", Ke = "[object Uint16Array]", Ze = "[object Uint32Array]", me = {};
  me[Q] = me[te] = me[qe] = me[Be] = me[Y] = me[B] = me[Pe] = me[Me] = me[je] = me[Le] = me[Te] = me[ve] = me[de] = me[le] = me[fe] = me[W] = me[be] = me[Ce] = me[an] = me[we] = me[Ke] = me[Ze] = !0, me[R] = me[H] = me[K] = !1;
  function he(Ie, Ae, Re, Ue, F, _) {
    var T, G = Ae & D, J = Ae & z, O = Ae & Z;
    if (Re && (T = F ? Re(Ie, Ue, F, _) : Re(Ie)), T !== void 0)
      return T;
    if (!g(Ie))
      return Ie;
    var U = S(Ie);
    if (U) {
      if (T = h(Ie), !G)
        return s(Ie, T);
    } else {
      var ie = f(Ie), pe = ie == H || ie == ne;
      if (w(Ie))
        return o(Ie, G);
      if (ie == le || ie == Q || pe && !F) {
        if (T = J || pe ? {} : N(Ie), !G)
          return J ? d(Ie, a(T, Ie)) : l(Ie, i(T, Ie));
      } else {
        if (!me[ie])
          return F ? Ie : {};
        T = k(Ie, ie, G);
      }
    }
    _ || (_ = new e());
    var ke = _.get(Ie);
    if (ke)
      return ke;
    _.set(Ie, T), q(Ie) ? Ie.forEach(function(rn) {
      T.add(he(rn, Ae, Re, rn, Ie, _));
    }) : C(Ie) && Ie.forEach(function(rn, dn) {
      T.set(dn, he(rn, Ae, Re, dn, Ie, _));
    });
    var en = O ? J ? u : m : J ? E : $, mn = U ? void 0 : en(Ie);
    return n(mn || Ie, function(rn, dn) {
      mn && (dn = rn, rn = Ie[dn]), r(T, dn, he(rn, Ae, Re, dn, Ie, _));
    }), T;
  }
  return yu = he, yu;
}
var gu, Gv;
function aL() {
  if (Gv) return gu;
  Gv = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return gu = e, gu;
}
var vu, Yv;
function oL() {
  if (Yv) return vu;
  Yv = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return vu = e, vu;
}
var ku, Jv;
function sL() {
  if (Jv) return ku;
  Jv = 1;
  var e = _x(), n = oL();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return ku = r, ku;
}
var bu, Qv;
function lL() {
  if (Qv) return bu;
  Qv = 1;
  var e = Gi(), n = aL(), r = sL(), i = Gs(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return bu = s, bu;
}
var _u, Xv;
function cL() {
  if (Xv) return _u;
  Xv = 1;
  var e = Wi(), n = Sp(), r = bi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return _u = m, _u;
}
var xu, Zv;
function dL() {
  if (Zv) return xu;
  Zv = 1;
  var e = cL();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return xu = n, xu;
}
var Su, ek;
function uL() {
  if (ek) return Su;
  ek = 1;
  var e = bx(), n = iL(), r = lL(), i = Gi(), a = so(), o = dL(), s = jx(), l = Px(), d = 1, m = 2, u = 4, f = s(function(h, k) {
    var N = {};
    if (h == null)
      return N;
    var S = !1;
    k = e(k, function(C) {
      return C = i(C, h), S || (S = C.length > 1), C;
    }), a(h, l(h), N), S && (N = n(N, d | m | u, o));
    for (var w = k.length; w--; )
      r(N, k[w]);
    return N;
  });
  return Su = f, Su;
}
uL();
const br = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = Fx(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ fi.jsx(Ln, { ...a, children: /* @__PURE__ */ fi.jsx(
    Yr,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: Ln.getStatus(a.meta),
      children: e
    }
  ) });
};
var mL = Nx();
const pL = /* @__PURE__ */ fx(mL), Nu = ({
  transformValue: e = pL,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = Cx(a);
  return /* @__PURE__ */ fi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ fi.jsx(
      qu,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ fi.jsx(WS, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, qt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = Fx(e);
  return /* @__PURE__ */ fi.jsx(Ln, { ...i, children: /* @__PURE__ */ fi.jsx(
    kr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: Ln.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ju = { exports: {} }, Sa = {}, nk;
function fL() {
  if (nk) return Sa;
  nk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Sa.Fragment = r, Sa.jsx = s, Sa.jsxs = s, Sa;
}
var Ro = {}, tk;
function hL() {
  return tk || (tk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    Ro.Fragment = i, Ro.jsx = Rn, Ro.jsxs = Bn;
  })()), Ro;
}
var rk;
function yL() {
  return rk || (rk = 1, process.env.NODE_ENV === "production" ? ju.exports = fL() : ju.exports = hL()), ju.exports;
}
var v = yL();
const ik = "__PairingContext__", gL = () => globalThis[ik] ?? (() => {
  const e = yb({});
  return globalThis[ik] = e, e;
})(), vL = gL(), kL = () => wm(vL), bL = "_banner_d9pot_1", _L = "_list_d9pot_8", ak = {
  banner: bL,
  list: _L
}, ok = "https://apps.shopify.com/dixa-dashboard", xL = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, Ax = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = kL(), [i, a] = se(!1), [o, s] = se(null), l = xL[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? ok,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(ok, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", className: ak.banner, children: [
    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(ue, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ v.jsx(A.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ v.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ v.jsx(m, { className: ak.list, children: l.listItems.map((u, f) => /* @__PURE__ */ v.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ v.jsx(A.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ v.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ v.jsx(
      Wn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(cn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, SL = (e) => /* @__PURE__ */ v.jsx(Ax, { ...e, bannerVariant: "install" }), NL = (e) => /* @__PURE__ */ v.jsx(Ax, { ...e, bannerVariant: "migration" }), jL = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], wL = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], CL = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: SL
  }
], FL = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], sk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: NL,
    additionalProperties: { renderAboveForm: !0 }
  }
], Lx = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], lk = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => mb(e)
  },
  ...Lx
];
var Ei = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ei || {}), hi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(hi || {}), Ir = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ir || {}), Vx = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(Vx || {}), oi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(oi || {}), Br = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Br || {}), ts = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(ts || {});
const IL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, EL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, TL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, $L = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, DL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, RL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, OL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, PL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, AL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, LL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, VL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, zL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, UL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, ML = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, BL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, qL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, HL = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": IL,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": EL,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": TL,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": $L,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": DL,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": RL,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": OL,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": PL,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": AL,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": LL,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": VL,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": zL,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": UL,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": ML,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": BL,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": qL
};
function ur(e) {
  return HL[e] ?? {};
}
const WL = ur(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), KL = ur(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  image {
                    url
                  }
                  product {
                    id
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), GL = ur(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), YL = ur(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), wp = ur(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), JL = ur(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), QL = ur(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), XL = ur(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), ZL = ur(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), eV = ur(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), nV = ur(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), tV = ur(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), zx = Zr`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, rV = Zr`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, iV = ({
  conversationContext: e
}) => {
  const { useQuery: n } = un(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(WL, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, aV = () => {
  const { useLazyQuery: e } = un(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(KL);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Ya(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const oV = "_list_alvh6_1", sV = "_listItem_alvh6_4", lV = "_fullWidth_alvh6_15", cV = "_boxWrapper_alvh6_19", It = {
  list: oV,
  listItem: sV,
  fullWidth: lV,
  boxWrapper: cV
}, dV = "_modal_1vkwz_1", uV = "_disabled_1vkwz_5", wu = {
  modal: dV,
  disabled: uV
}, ck = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: hi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: hi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: hi.Unknown
  }
], dk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Ir.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Ir.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Ir.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Ir.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Ir.Unsubscribed
  }
], mV = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = kn(), { useMutation: l, showNotification: d } = un(), [m, u] = se(), [f, h] = se(), [k, N] = Nf(!0), [S, w] = Nf(!0), C = !!m, g = e.customer?.email, q = e.customer?.phone_number, $ = e.customer?.given_name, E = e.customer?.family_name, D = {
    email: g ?? "",
    phone: q ?? "",
    firstName: $ ?? "",
    lastName: E ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, z = cr({
    defaultValues: D
  });
  He(() => {
    f?.forEach((R) => {
      const H = R?.field?.[0];
      H && (z.setError(H, {
        type: "server",
        message: R.message
      }), z.setFocus(H));
    });
  }, [f, z]);
  const [Z, { error: Q, reset: te }] = l(nV, {
    onError: (R) => {
      u(R.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (R) => {
      const H = R?.Shopify?.customerCreate?.userErrors || [];
      H.length > 0 ? (h(H), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), Y = tt(
    (R) => {
      a(!0), u(void 0), Z({
        variables: {
          input: {
            firstName: R.firstName,
            lastName: R.lastName,
            ...k && { email: R.email },
            ...S && { phone: R.phone },
            ...R.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: R.smsMarketingState,
                marketingOptInLevel: R.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Z, a, S, k]
  ), B = () => {
    r(!1), te(), u(void 0), z.reset(D);
  };
  return /* @__PURE__ */ v.jsxs(gt, { isOpen: n, onClose: B, className: wu.modal, children: [
    /* @__PURE__ */ v.jsx(vt, { title: "Create new customer", onClose: B }),
    /* @__PURE__ */ v.jsx(kt, { children: /* @__PURE__ */ v.jsxs(Ut, { children: [
      /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
        qt,
        {
          label: "First name",
          name: "firstName",
          control: z.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
        qt,
        {
          label: "Last name",
          name: "lastName",
          control: z.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
        qt,
        {
          label: "Email",
          name: "email",
          control: z.control,
          rules: {
            required: k ? "Email is required" : void 0
          },
          componentProps: {
            className: ut({
              [wu.disabled]: !k
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                qu,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: k,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
        qt,
        {
          label: "Phone",
          name: "phone",
          control: z.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: ut({
              [wu.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                qu,
                {
                  disabled: !k,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => w()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
        br,
        {
          control: z.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (R, H) => R === H,
            getItemTitleByValue: (R) => {
              const H = dk.find(
                (ne) => ne.value === R
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: H.label }),
                    /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: H.description })
                  ]
                }
              );
            }
          },
          children: dk.map((R) => /* @__PURE__ */ v.jsx(ot.Item, { value: R.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
        br,
        {
          control: z.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (R, H) => R === H,
            getItemTitleByValue: (R) => {
              const H = ck.find(
                (ne) => ne.value === R
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: H.label }),
                    /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: H.description })
                  ]
                }
              );
            }
          },
          children: ck.map((R) => /* @__PURE__ */ v.jsx(ot.Item, { value: R.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      C && /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ v.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Ct,
      {
        confirmProps: {
          disabled: !(z.formState.isValid && z.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 })
        },
        confirmOnClick: z.handleSubmit(Y),
        cancelOnClick: B,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, pV = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      Wn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 }),
        slotStart: /* @__PURE__ */ v.jsx(ue, { size: 14, name: "user-plus", color: "green.500" }),
        className: It.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ v.jsx(
      mV,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Cp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, ym = "DD MMM YYYY @ HH:mm", fV = "_wrapper_10fld_1", hV = "_copyIcon_10fld_7", Oo = {
  wrapper: fV,
  copyIcon: hV
}, yV = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Ya(), { isCopied: l, copy: d } = Ya(), { track: m } = kn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: k,
    tags: N = [],
    verifiedEmail: S
  } = e, w = h?.emailAddress, C = k?.phoneNumber, g = Cp(u), q = `https://${n}/admin/customers/${g ?? ""}`, $ = i && a === Gt.refetch, E = 14;
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { className: Oo.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: f }),
        $ ? /* @__PURE__ */ v.jsx(cn, { size: E }) : /* @__PURE__ */ v.jsx(Ge, { content: "Reload customer", children: /* @__PURE__ */ v.jsx(
          ue,
          {
            size: E,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Oo.copyIcon
          }
        ) })
      ] }),
      w && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ue, { size: E, name: "mail" }),
          /* @__PURE__ */ v.jsx(A.ExternalLink, { href: `mailto:${w}`, children: w }),
          /* @__PURE__ */ v.jsx(
            Ge,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
                ue,
                {
                  size: E,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(Ge, { content: "Copy Email", children: /* @__PURE__ */ v.jsx(
          ue,
          {
            size: E,
            name: o ? "done" : "copy",
            onClick: () => s(w),
            className: Oo.copyIcon
          }
        ) })
      ] }),
      C && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ue, { size: E, name: "phone" }),
          /* @__PURE__ */ v.jsx(A.ExternalLink, { href: `tel:${C}`, children: C })
        ] }),
        /* @__PURE__ */ v.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ v.jsx(
          ue,
          {
            size: E,
            name: l ? "done" : "copy",
            onClick: () => d(C),
            className: Oo.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(ue, { size: E, name: "external-link" }),
        /* @__PURE__ */ v.jsx(
          A.ExternalLink,
          {
            href: q,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    N.length > 0 && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: N.map((D) => /* @__PURE__ */ v.jsx(Pn, { children: D }, `${u}-${D}`)) })
    ] })
  ] });
}, gV = "_creationModal_pbe64_1", vV = "_detailsModal_pbe64_5", kV = "_percentageSuffix_pbe64_9", Cu = {
  creationModal: gV,
  detailsModal: vV,
  percentageSuffix: kV
}, bV = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, _V = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: Vx.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, uk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], mk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], pk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], xV = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = nr(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ v.jsxs(We, { children: [
      /* @__PURE__ */ v.jsx(We.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ v.jsx(We.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(
            ue,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ v.jsx(We.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ v.jsx(We.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ v.jsx(We.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "2", color: "secondary", children: An(e?.startsAt).format(dt) })
      ] }) })
    ] }),
    /* @__PURE__ */ v.jsx(Ln, { label: "Discount code", children: /* @__PURE__ */ v.jsx(
      kr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, SV = "shopify-discount-code-form", fk = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, NV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = kn(), { useMutation: i, showNotification: a } = un(), [o, s] = se(
    []
  ), [l, d] = se(), m = cr({
    mode: "all",
    defaultValues: fk
  });
  He(() => {
    o?.forEach((E) => {
      const D = E?.field?.[1];
      D && m.setError(D, {
        type: "server",
        message: E.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), k = Kn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    N,
    {
      loading: S,
      error: w,
      reset: C
    }
  ] = i(tV, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (E) => {
      const D = E?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (D && D.length > 0)
        s(D);
      else {
        const z = E?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        z && "codes" in z && d(z), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    m.setValue("code", bV(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, q = (E) => {
    N({
      variables: {
        input: _V(E)
      }
    });
  }, $ = () => {
    m.reset(fk), s([]), C(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    gt,
    {
      isOpen: e,
      onClose: $,
      className: ut({
        [Cu.creationModal]: !u,
        [Cu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ v.jsx(
          vt,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: $
          }
        ),
        /* @__PURE__ */ v.jsxs(kt, { children: [
          u && /* @__PURE__ */ v.jsx(xV, { codeDiscount: l }),
          !u && /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: SV, onSubmit: m.handleSubmit(q), children: [
            /* @__PURE__ */ v.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ v.jsx(
              Ts,
              {
                variant: "info",
                description: /* @__PURE__ */ v.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ v.jsxs(Ut, { children: [
              /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
                qt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
                br,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (E) => {
                      const D = uk.find(
                        (z) => z.value === E
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: uk.map((E) => /* @__PURE__ */ v.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
                qt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (E) => {
                      if (E) {
                        if (h === "percentage" && (E < 0 || E > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && E < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ v.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Cu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
                qt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
                br,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (E, D) => E === D,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (E) => {
                      const D = mk.find(
                        (z) => z.value === E
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: mk.map((E) => /* @__PURE__ */ v.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
                qt,
                {
                  name: "minimumRequirementValue",
                  label: k,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (E) => {
                      if (E && f !== "none" && E < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
                br,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (E, D) => E === D,
                    getItemTitleByValue: (E) => {
                      const D = pk.find(
                        (z) => z.value === E
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: pk.map((E) => /* @__PURE__ */ v.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) })
            ] })
          ] }),
          w && /* @__PURE__ */ v.jsx(Fn, { error: w })
        ] }),
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? $ : m.handleSubmit(q),
            cancelOnClick: u ? void 0 : $
          }
        )
      ]
    }
  );
}, jV = ({ code: e }) => {
  const { isCopied: n, copy: r } = Ya();
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(ue, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ v.jsx(
          Yt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, wV = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ v.jsx(We, { children: i.map((a) => /* @__PURE__ */ v.jsx(We.Item, { className: It.listItem, children: /* @__PURE__ */ v.jsx(jV, { code: a.code }, a.id) }, a.id)) })
  ] });
}, CV = "_modal_11d6e_1", FV = "_modalBody_11d6e_4", IV = "_codeContainer_11d6e_9", Fu = {
  modal: CV,
  modalBody: FV,
  codeContainer: IV
}, EV = [50, 100, 250], Ux = 50, TV = {
  maxNumberOfCodesToDisplay: Ux
}, $V = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = un(), [i, a] = se(
    Ux
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = cr({
    mode: "all",
    defaultValues: TV
  }), { loading: u, error: f } = r(JL, {
    variables: {
      first: i
    },
    onCompleted: (k) => {
      const N = k?.Shopify?.codeDiscountNodes?.nodes ?? [];
      N && N.length > 0 && s(N);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ v.jsxs(gt, { isOpen: e, onClose: h, className: Fu.modal, children: [
    /* @__PURE__ */ v.jsx(vt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ v.jsxs(kt, { className: Fu.modalBody, children: [
      d && /* @__PURE__ */ v.jsx(Ut, { children: /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
        br,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (k) => {
              a(k.selectedValues[0]);
            },
            getItemTitleByValue: (k) => /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: k }) })
          },
          children: EV.map((k) => /* @__PURE__ */ v.jsx(ot.Item, { value: k, children: /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: k }) }, k))
        }
      ) }) }),
      u && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(cn, {}) }),
      f && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ v.jsx(
        os,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((k) => /* @__PURE__ */ v.jsx("div", { className: Fu.codeContainer, children: /* @__PURE__ */ v.jsx(wV, { discountCode: k }) }, k.id))
    ] }),
    /* @__PURE__ */ v.jsx(Ct, { confirmName: "Close", confirmOnClick: h })
  ] });
}, DV = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          Wn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          Wn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      $V,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ v.jsx(
      NV,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, RV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? Is(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Ei.Invalid:
      case Ei.NotSubscribed:
      case Ir.NotSubscribed:
        return "red.500";
      case Ei.Pending:
      case Ir.Pending:
      case Ei.Unsubscribed:
      case Ir.Unsubscribed:
        return "orange.500";
      case Ei.Subscribed:
      case Ir.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case hi.SingleOptIn:
      case hi.ConfirmedOptIn:
        return "green.500";
      case hi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ue, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ v.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Un, { size: "small", variant: "info", children: An(l).format(ym) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Pn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ v.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Pn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ue, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ v.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Un, { size: "small", variant: "info", children: An(u).format(ym) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Pn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ v.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Pn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, OV = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a || void 0,
          kind: "REFUND",
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    tags: r.tags,
    refunds: r.refunds
  }));
}, hk = [
  {
    value: Br.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Br.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Br.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Br.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Br.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Br.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Br.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], yk = [
  {
    value: ts.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: ts.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: ts.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], Mx = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), Po = (e) => gm(PV(e)), gm = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), PV = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ri = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ v.jsx(
  Lt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ v.jsx(
      sr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), AV = "_modal_1wlra_1", LV = {
  modal: AV
};
function gk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const vk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], kk = "shopify-shiping-address-form", VV = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = un(), { track: f } = kn(), [h, k] = se(!1), [N, S] = se({}), w = !l, [
    C,
    { error: g, reset: q }
  ] = m(QL, {
    onError: () => {
      k(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (Y) => {
      k(!1);
      const B = Y?.Shopify?.orderUpdate?.userErrors;
      if (B?.length > 0) {
        const R = B.reduce((H, ne) => (H[ne.field[ne.field.length - 1]] = ne.message, H), {});
        S(R);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), te();
    }
  }), $ = tt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: vk.find(
        (Y) => Y === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: E, handleSubmit: D, formState: z, reset: Z } = cr({
    mode: "all",
    defaultValues: $()
  }), Q = D((Y) => {
    if (w) {
      k(!0), o && a && f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: B, ...R } = Y, H = { ...R, countryCode: B };
      C({
        variables: {
          input: {
            id: a,
            shippingAddress: H
          }
        }
      });
    } else
      l(Y), te();
  });
  He(() => {
    r && Z($());
  }, [r, n, Z, $]);
  const te = () => {
    Z($()), S({}), q(), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    gt,
    {
      isOpen: r,
      onClose: te,
      className: LV.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ v.jsx(vt, { title: e, onClose: () => te() }),
        /* @__PURE__ */ v.jsx(kt, { children: /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: kk, onSubmit: Q, children: [
          g && /* @__PURE__ */ v.jsx(Fn, { error: g }),
          /* @__PURE__ */ v.jsxs(Ut, { children: [
            /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 6, children: /* @__PURE__ */ v.jsx(
              ri,
              {
                control: E,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 6, children: /* @__PURE__ */ v.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 6, children: /* @__PURE__ */ v.jsx(
              ri,
              {
                control: E,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 3, children: /* @__PURE__ */ v.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 6, children: /* @__PURE__ */ v.jsx(
              br,
              {
                name: "countryCodeV2",
                control: E,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (Y) => Y ? gk(Y) : ""
                },
                children: vk.filter((Y) => s.includes(Y)).map((Y) => /* @__PURE__ */ v.jsx(ot.Item, { value: Y, children: /* @__PURE__ */ v.jsx(A.Paragraph, { children: gk(Y) }) }, Y))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            confirmProps: {
              disabled: !(z.isValid && z.isDirty),
              type: "submit",
              form: kk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 })
            },
            confirmOnClick: () => {
              g && te();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), te();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, zV = "_clickableIcon_33mqm_1", Iu = {
  clickableIcon: zV
}, bk = ({
  formFieldName: e,
  ...n
}) => {
  const r = Or(), { field: i } = Bm({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ v.jsx(
    vm,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, vm = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, k] = se(m), { isCopied: N, copy: S } = Ya(), { track: w } = kn(), C = 14, g = o && (!!r || !!l), q = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), $ = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), E = n?.countryCodeV2 && RS(n.countryCodeV2), D = tt(() => [
    $,
    n?.company,
    n?.address1,
    n?.address2,
    q,
    n?.province,
    E
  ].filter(Boolean).join(`
`), [n, $, q, E]);
  if (!n)
    return null;
  const z = () => {
    i && r && w("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ue, { size: C, name: s, color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => k(!h),
              className: Iu.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ v.jsx(
                  ue,
                  {
                    size: C,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
            $ && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: $ }),
            n?.company && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            q && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: q }),
            n?.province && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: n.province }),
            E && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: E })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ v.jsx(Ge, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ue,
          {
            size: C,
            name: "pen",
            onClick: () => z(),
            className: Iu.clickableIcon
          }
        ) }),
        /* @__PURE__ */ v.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ue,
          {
            size: C,
            name: N ? "done" : "copy",
            onClick: () => S(D()),
            className: Iu.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ v.jsx(
      VV,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, Fp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Or(), i = Go({ control: r.control, name: "lineItems" }), a = Go({
    control: r.control,
    name: "billingAddress"
  }), o = Go({
    control: r.control,
    name: "shippingAddress"
  }), s = Kn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Kn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ v.jsx(
        bk,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ v.jsx(
        bk,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ v.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, UV = "_productTableHeader_6h6pl_1", MV = "_productImage_6h6pl_5", za = {
  productTableHeader: UV,
  productImage: MV
}, Ip = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, BV = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Or(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Ip(e);
  return /* @__PURE__ */ v.jsxs(Xn.Tr, { children: [
    /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ v.jsx(
        zi,
        {
          src: d,
          alt: e.title,
          className: za.productImage
        }
      ),
      /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(
      qt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(Yt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, qV = 300, Na = 2, HV = 25, WV = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = un(), [i, a] = se(""), [o, s] = se([]), l = Or(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(wp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (S) => {
      const w = S?.Shopify?.products?.nodes || [];
      s(
        w.filter((C) => !!C).sort((C, g) => C.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  gi(
    () => {
      i.trim().length >= Na && !u && f === Gt.ready ? m({
        variables: {
          query: i.trim(),
          productCount: HV,
          mediaCount: 1
        }
      }) : i.trim().length < Na && s([]);
    },
    qV,
    [i]
  ), He(() => {
    if (!d) return;
    const S = o.find(
      (w) => w.id === d
    );
    S && e(S), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== Gt.ready, k = i.trim().length >= Na, N = !o.length && !h && k;
  return /* @__PURE__ */ v.jsx(
    br,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Na} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (S) => {
          const w = o.find(
            (C) => C.id === S
          );
          return w ? /* @__PURE__ */ v.jsx(A.Paragraph, { children: w.title }) : null;
        },
        filter: {
          value: i,
          onChange: (S) => {
            a(S.target.value);
          }
        },
        onToggleDropdown: (S) => {
          !S && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(cn, {}) }) }),
        !h && o.map((S) => {
          const w = S.totalInventory <= 0, C = Ip(S);
          return /* @__PURE__ */ v.jsx(
            ot.Item,
            {
              value: S.id,
              isDisabled: w,
              children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                  C && /* @__PURE__ */ v.jsx(
                    zi,
                    {
                      src: C,
                      alt: S.title,
                      className: za.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ v.jsx(
                    KS,
                    {
                      text: S.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: S.title })
                ] }),
                /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "5", children: w ? "Out of stock" : `${S.totalInventory} in stock` })
              ] })
            },
            S.id
          );
        }),
        N && /* @__PURE__ */ v.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          os,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !k && !h && /* @__PURE__ */ v.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          os,
          {
            title: "Search for products",
            description: `Type at least ${Na} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Ep = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  onToggleSelect: s,
  onToggleSelectAll: l
}) => {
  const d = Or(), m = d.watch("lineItems"), u = !!m?.length, f = n && u ? m.filter(
    (S) => !o.includes(S?.id)
  ) : [], h = f.length > 0 && f.every(
    (S) => a.includes(S?.id)
  ), k = f.some(
    (S) => a.includes(S?.id)
  ) && !h, N = tt(
    (S) => {
      const w = d.getValues("lineItems"), C = w.findIndex(
        (g) => g?.id === S.id
      );
      if (C > -1) {
        const g = d.getValues(`lineItems.${C}.quantity`) || 0, q = [...w];
        q[C] = {
          ...q[C],
          quantity: g + 1
        }, d.setValue("lineItems", q);
      } else
        d.setValue("lineItems", [
          ...w,
          { ...S, quantity: 1 }
        ]);
    },
    [d]
  );
  return /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ v.jsx(WV, { onProductSelected: N }),
    !u && e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: It.boxWrapper,
        children: /* @__PURE__ */ v.jsx(cn, {})
      }
    ),
    !u && !e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: It.boxWrapper,
        children: /* @__PURE__ */ v.jsx(
          os,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    u && /* @__PURE__ */ v.jsx(b, { margin: "300 0", children: /* @__PURE__ */ v.jsxs(
      Xn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: za.productTable,
        children: [
          /* @__PURE__ */ v.jsx(Xn.Thead, { className: za.productTableHeader, children: /* @__PURE__ */ v.jsxs(Xn.Tr, { children: [
            n && /* @__PURE__ */ v.jsx(Xn.Th, { children: /* @__PURE__ */ v.jsx(
              Bp,
              {
                checked: h,
                indeterminate: k,
                onChange: () => l?.(!h)
              }
            ) }),
            /* @__PURE__ */ v.jsx(Xn.Th, { children: "Product" }),
            /* @__PURE__ */ v.jsx(Xn.Th, { children: "In stock" }),
            /* @__PURE__ */ v.jsx(Xn.Th, { children: "Price" }),
            /* @__PURE__ */ v.jsx(Xn.Th, { children: "Quantity" }),
            /* @__PURE__ */ v.jsx(Xn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ v.jsx(Xn.Th, {})
          ] }) }),
          /* @__PURE__ */ v.jsx(Xn.Tbody, { children: m?.map((S, w) => {
            if (!n)
              return /* @__PURE__ */ v.jsx(
                BV,
                {
                  product: S,
                  index: w,
                  onRemove: () => {
                    const te = m.filter(
                      (Y, B) => B !== w
                    );
                    d.setValue("lineItems", te);
                  }
                },
                `${S?.id}-${w}`
              );
            const C = S, g = C.priceRangeV2.minVariantPrice.amount, q = C.priceRangeV2.minVariantPrice.currencyCode, $ = `lineItems.${w}.quantity`, E = d.watch($) || 0, D = g * E, z = Ip(C), Z = a.includes(C.id), Q = o.includes(C.id);
            return /* @__PURE__ */ v.jsxs(
              Xn.Tr,
              {
                style: Q ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(
                    Bp,
                    {
                      checked: Z,
                      disabled: Q,
                      onChange: () => s?.(C.id, !Z)
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                    z && /* @__PURE__ */ v.jsx(
                      zi,
                      {
                        src: z,
                        alt: C.title,
                        className: za.productImage
                      }
                    ),
                    /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: C.title }),
                      Q && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: C.totalInventory }) }),
                  /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: `${g} ${q}` }) }),
                  /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(
                    qt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: Q,
                      name: $,
                      control: d.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: C.totalInventory,
                        tabIndex: 0
                      }
                    },
                    `${$}-${d.watch($)}`
                  ) }),
                  /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: `${D} ${q}` }) }),
                  !r && /* @__PURE__ */ v.jsx(Xn.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(
                    Yt,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const te = m.filter(
                          (Y, B) => B !== w
                        );
                        d.setValue("lineItems", te), Z && s?.(C.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${C.id}-${w}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, Bx = ({
  previousOrderStatus: e
} = {}) => {
  const n = Or();
  return /* @__PURE__ */ v.jsx(
    br,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = hk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ v.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ v.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: hk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ v.jsx(ot.Item, { value: r.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, qx = () => {
  const e = Or();
  return /* @__PURE__ */ v.jsx(
    br,
    {
      label: "Fulfillment Status",
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = yk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ v.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: yk.map((n) => /* @__PURE__ */ v.jsx(ot.Item, { value: n.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, KV = "_modal_1mprq_1", GV = {
  modal: KV
}, Eu = "create-shopify-order-form", YV = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = kn(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, k = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Br.Pending,
    fulfillmentStatus: void 0
  }, [N, S] = se([]), w = cr({
    mode: "all",
    defaultValues: k
  }), C = w.watch("lineItems").length > 0, g = () => {
    w.reset(k), S([]), i(!1);
  };
  He(() => {
    N.length > 0 && w.setValue("tags", N, { shouldDirty: !0 });
  }, [N, w]);
  const [q, { error: $ }] = o(
    zx,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), g();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), g();
      }
    }
  ), [E, { error: D }] = o(
    rV,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), z = (Q) => {
    const te = Q.lineItems.map((R) => ({
      productId: R.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: R.priceRangeV2.maxVariantPrice.amount,
          currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: R.quantity
    }));
    m(!0);
    const Y = Po(Q?.billingAddress), B = Po(
      Q?.shippingAddress
    );
    q({
      variables: {
        order: {
          lineItems: te,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Q.customNote,
          tags: Q.tags,
          financialStatus: Q.financialStatus,
          fulfillmentStatus: Q.fulfillmentStatus,
          shippingAddress: B,
          billingAddress: Y
        }
      }
    });
  }, Z = (Q) => {
    const te = Q.lineItems.map((R) => ({
      title: R.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: R.priceRangeV2.maxVariantPrice.amount,
        currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: R.quantity
    }));
    f(!0);
    const Y = Po(Q?.billingAddress), B = Po(
      Q?.shippingAddress
    );
    E({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Q.customNote,
          tags: Q.tags,
          lineItems: te,
          shippingAddress: B,
          billingAddress: Y
        }
      }
    });
  };
  return /* @__PURE__ */ v.jsxs(
    gt,
    {
      isOpen: e,
      onClose: g,
      className: GV.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(vt, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ v.jsxs(kt, { children: [
          /* @__PURE__ */ v.jsx(Mm, { ...w, children: /* @__PURE__ */ v.jsx("form", { id: Eu, children: /* @__PURE__ */ v.jsxs(Ut, { children: [
            /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(Ep, {}) }),
            /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
              Lt,
              {
                name: "tags",
                render: ({ fieldState: { error: Q } }) => /* @__PURE__ */ v.jsx(
                  Ln,
                  {
                    label: "Tags",
                    meta: {
                      error: Q?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (te) => {
                          te.key === "Enter" && (te.preventDefault(), te.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Es,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: N,
                            onChange: (te) => {
                              S(te);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(Bx, {}),
              /* @__PURE__ */ v.jsx(qx, {}),
              /* @__PURE__ */ v.jsx(
                qt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(tn, { span: 2, children: /* @__PURE__ */ v.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: It.boxWrapper,
                children: /* @__PURE__ */ v.jsx(Fp, {})
              }
            ) }) })
          ] }) }) }),
          ($ || D) && /* @__PURE__ */ v.jsx(Fn, { error: $ || D })
        ] }),
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            confirmProps: {
              type: "submit",
              form: Eu,
              disabled: !C || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: w.handleSubmit(z),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                w.handleSubmit(Z)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Eu,
                disabled: !C || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, JV = "_modal_al73g_1", QV = {
  modal: JV
}, _k = [
  {
    label: "Customer",
    value: oi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: oi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: oi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: oi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: oi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: oi.Staff,
    description: "Staff made an error."
  }
], XV = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = kn(), { useMutation: d, showNotification: m } = un(), [u, f] = se([]), h = u.length > 0, k = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, N = cr({
    defaultValues: k
  }), [S, { error: w, reset: C }] = d(ZL, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async ($) => {
      const E = $.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (E.length > 0)
        o(!1), f(E), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const D = $.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, D ? 0 : 4e3), m({
          title: "Success",
          text: `${D ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = tt(
    ($) => {
      o(!0), S({
        variables: $
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), q = () => {
    i(!1), C(), f([]), N.reset(k);
  };
  return /* @__PURE__ */ v.jsxs(gt, { isOpen: n, onClose: q, className: QV.modal, children: [
    /* @__PURE__ */ v.jsx(vt, { title: `Cancel order ${r}`, onClose: q }),
    /* @__PURE__ */ v.jsx(kt, { children: /* @__PURE__ */ v.jsxs(Ut, { children: [
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
        br,
        {
          control: N.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: ($, E) => $ === E,
            getItemTitleByValue: ($) => {
              if (!$)
                return "";
              const E = _k.find(
                (D) => D.value === $
              );
              return /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: E.description })
              ] });
            }
          },
          children: _k.map(($) => /* @__PURE__ */ v.jsx(ot.Item, { value: $.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: $.label }),
            /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: $.description })
          ] }) }, $.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(Ln, { label: "Refund order", children: /* @__PURE__ */ v.jsx(
        Nu,
        {
          control: N.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(Ln, { label: "Restock items", children: /* @__PURE__ */ v.jsx(Nu, { control: N.control, name: "restock" }) }) }),
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(Ln, { label: "Notify the customer", children: /* @__PURE__ */ v.jsx(Nu, { control: N.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
        qt,
        {
          name: "staffNote",
          label: "Staff note",
          control: N.control
        }
      ) }),
      h && /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: u.map(($) => /* @__PURE__ */ v.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ v.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: $.code }),
            /* @__PURE__ */ v.jsxs(A.Paragraph, { children: [
              "(",
              $.field?.join(","),
              ") ",
              $.message
            ] })
          ]
        },
        $.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Ct,
      {
        confirmProps: {
          disabled: !(N.formState.isValid && N.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 })
        },
        confirmOnClick: N.handleSubmit(g),
        cancelOnClick: q,
        confirmName: w ? "Close" : "Cancel order",
        cancelName: w ? void 0 : "Cancel"
      }
    )
  ] });
}, ZV = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      Wn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ v.jsx(
          ue,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: It.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ v.jsx(
      XV,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, ez = "_modal_1mprq_1", nz = {
  modal: ez
}, tz = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = un(), { track: m } = kn(), [u, f] = se(!1), [h, k] = se(e?.tags || []), N = "duplicate-shopify-order-form", S = (B) => ({
    firstName: B?.firstName,
    lastName: B?.lastName,
    address1: B?.address1,
    address2: B?.address2,
    city: B?.city,
    provinceCode: B?.provinceCode,
    zip: B?.zip,
    countryCode: B?.countryCodeV2
  }), w = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, C = cr({
    mode: "all",
    defaultValues: w
  }), g = C.watch("lineItems").length > 0, q = Kn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), $ = Kn(
    () => Mx(q),
    [q]
  ), {
    data: E,
    loading: D,
    error: z
  } = d(wp, {
    skip: !$,
    variables: {
      query: $,
      productCount: q.length,
      mediaCount: 1
    }
  });
  He(() => {
    z && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [z, l]), He(() => {
    if (!r || D || !E || C.getValues("lineItems")?.length)
      return;
    const B = E?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((H) => {
      const ne = B.find(
        (ve) => ve.id === H.product?.id
      );
      ne && R.push({ ...ne, quantity: H.quantity || 1 });
    }), R.length > 0 && C.setValue("lineItems", R, { shouldDirty: !0 });
  }, [r, E, D, e, C]), He(() => {
    (h.length > 0 || (C.getValues("tags") || []).length > 0) && C.setValue("tags", h, { shouldDirty: !0 });
  }, [h, C]);
  const [Z, { error: Q }] = s(
    zx,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Y();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Y();
      }
    }
  ), te = (B) => {
    const R = B.lineItems.map((H) => ({
      productId: H.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: H.priceRangeV2.maxVariantPrice.amount,
          currencyCode: H.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: H.quantity
    }));
    f(!0), Z({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: R,
          note: B.customNote,
          tags: B.tags,
          financialStatus: B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          shippingAddress: gm(B?.shippingAddress),
          billingAddress: gm(B?.billingAddress)
        }
      }
    });
  }, Y = () => {
    C.reset(w), k(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    gt,
    {
      isOpen: r,
      onClose: Y,
      className: nz.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(vt, { title: `Duplicate order ${n}`, onClose: Y }),
        /* @__PURE__ */ v.jsxs(kt, { children: [
          /* @__PURE__ */ v.jsx(Mm, { ...C, children: /* @__PURE__ */ v.jsx("form", { id: N, children: /* @__PURE__ */ v.jsxs(Ut, { children: [
            /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(Ep, { loading: D }) }),
            /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
              Lt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ v.jsx(
                  Ln,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (R) => {
                          R.key === "Enter" && (R.preventDefault(), R.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Es,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (R) => {
                              k(R);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(tn, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(
                Bx,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ v.jsx(qx, {}),
              /* @__PURE__ */ v.jsx(
                qt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(tn, { span: 2, children: /* @__PURE__ */ v.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: It.boxWrapper,
                children: /* @__PURE__ */ v.jsx(Fp, {})
              }
            ) }) })
          ] }) }) }),
          Q && /* @__PURE__ */ v.jsx(Fn, { error: Q })
        ] }),
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            confirmProps: {
              type: "submit",
              form: N,
              disabled: !g || u || D,
              isLoading: u || D,
              loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: C.handleSubmit(te)
          }
        )
      ]
    }
  );
}, rz = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(r).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ v.jsx(ue, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ v.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ v.jsx(Pn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ v.jsx(We, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: d }) => {
      const m = r[a], u = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ v.jsx(
        We.Item,
        {
          contentLeft: /* @__PURE__ */ v.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ v.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ v.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ v.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            u && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: d?.url && /* @__PURE__ */ v.jsx(zi, { src: `${d?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, iz = Zr`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, az = "_modal_21e62_1", oz = {
  modal: az
}, xk = "partial-refund-shopify-order-form", sz = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = kn(), { useQuery: d } = un(), [m, u] = se(!1), [f, h] = se([]), k = Kn(() => {
    const te = /* @__PURE__ */ new Map();
    return e?.refunds?.forEach((Y) => {
      Y.refundLineItems?.edges?.forEach(({ node: B }) => {
        const R = te.get(B.lineItem.id) || 0;
        te.set(
          B.lineItem.id,
          R + B.quantity
        );
      });
    }), (e?.lineItems || []).filter((Y) => (te.get(Y.id) || 0) >= (Y.quantity || 0)).map((Y) => Y.product?.id).filter((Y) => !!Y);
  }, [e]), N = Kn(
    () => (e?.lineItems || []).map((te) => te.product?.id).filter((te) => !!te),
    [e]
  ), S = Kn(
    () => Mx(N),
    [N]
  ), {
    data: w,
    loading: C,
    error: g
  } = d(wp, {
    skip: !S,
    variables: {
      query: S,
      productCount: N.length,
      mediaCount: 1
    }
  });
  He(() => {
    g && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [g, s]);
  const q = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, $ = cr({
    mode: "all",
    defaultValues: q
  }), E = f.length > 0, [D, { error: z }] = o(
    iz,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), Q();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), Q();
      }
    }
  );
  He(() => {
    if (!r || C || !w || $.getValues("lineItems")?.length)
      return;
    const te = w?.Shopify?.products?.nodes || [], Y = [];
    e?.lineItems?.forEach((B) => {
      const R = te.find(
        (H) => H.id === B.product?.id
      );
      R && Y.push({ ...R, quantity: B.quantity || 1 });
    }), Y.length > 0 && ($.setValue("lineItems", Y, { shouldDirty: !0 }), h([]));
  }, [r, w, C, e, $]);
  const Z = (te) => {
    u(!0);
    const Y = (te.lineItems || []).filter(
      (B) => f.includes(B.id)
    ).map((B) => {
      const R = e?.lineItems?.find(
        (ve) => ve.product?.id === B.id
      ), H = R?.quantity || 0, ne = Math.max(
        0,
        Math.min(H, B.quantity || 0)
      );
      return R && ne > 0 ? { lineItemId: R.id, quantity: ne } : void 0;
    }).filter((B) => !!B);
    D({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: Y,
          note: te.customNote || void 0,
          notify: !0
        }
      }
    });
  }, Q = () => {
    $.reset(q), u(!1), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(gt, { isOpen: r, onClose: Q, className: oz.modal, children: [
    /* @__PURE__ */ v.jsx(vt, { title: `Refund order ${n}`, onClose: Q }),
    /* @__PURE__ */ v.jsxs(kt, { children: [
      /* @__PURE__ */ v.jsx(Mm, { ...$, children: /* @__PURE__ */ v.jsx("form", { id: xk, children: /* @__PURE__ */ v.jsxs(Ut, { children: [
        /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
          Ep,
          {
            loading: C,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: k,
            onToggleSelect: (te, Y) => {
              h((B) => Y ? Array.from(/* @__PURE__ */ new Set([...B, te])) : B.filter((R) => R !== te));
            },
            onToggleSelectAll: (te) => {
              const Y = ($.getValues("lineItems") || []).map((B) => B.id).filter((B) => !k.includes(B));
              h(te ? Y : []);
            }
          }
        ) }),
        /* @__PURE__ */ v.jsx(tn, { span: 4, children: /* @__PURE__ */ v.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ v.jsx(
          qt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ v.jsx(tn, { span: 2, children: /* @__PURE__ */ v.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: It.boxWrapper,
            children: /* @__PURE__ */ v.jsx(
              Fp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      z && /* @__PURE__ */ v.jsx(Fn, { error: z })
    ] }),
    /* @__PURE__ */ v.jsx(
      Ct,
      {
        confirmProps: {
          type: "submit",
          form: xk,
          disabled: !E || m || C,
          isLoading: m || C,
          loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: $.handleSubmit(Z)
      }
    )
  ] });
}, lz = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = un(), { track: l } = kn(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, [h] = a(XL, {
    onError: (S) => {
      setTimeout(() => N(S), 500);
    },
    onCompleted: (S) => {
      const w = S.Shopify?.refundCreate?.userErrors;
      w && w.length > 0 ? N(
        new e0({
          graphQLErrors: w.map((C) => ({
            message: C.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), k = tt(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: S, ...w } = d, C = parseFloat(String(S)) > 0;
    s(C ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ v.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        S,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), h({
          variables: {
            input: w
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ v.jsx(A.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    s,
    h,
    l
  ]), N = tt(
    (S) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ v.jsx(Fn, { error: S }),
          /* @__PURE__ */ v.jsx(
            wt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ v.jsx(ue, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
    Wn,
    {
      variant: "secondary",
      onClick: k,
      disabled: d?.refundLineItems?.length === 0,
      slotStart: /* @__PURE__ */ v.jsx(ue, { size: 14, name: "undo" }),
      className: It.fullWidth,
      children: "Full refund"
    }
  ) });
}, cz = "_modal_al73g_1", dz = {
  modal: cz
}, uz = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = kn(), { useMutation: s, showNotification: l } = un(), [d, m] = se(n), [u, f] = se(!1), h = cr({
    defaultValues: {
      tags: n
    }
  });
  He(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [k, { error: N, reset: S }] = s(eV, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), w = tt(
    (g) => {
      f(!0), k({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((q) => {
        h.reset({ tags: q.data.Shopify.orderUpdate.order.tags });
      });
    },
    [e]
  ), C = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ v.jsxs(gt, { isOpen: r, onClose: C, className: dz.modal, children: [
    /* @__PURE__ */ v.jsx(vt, { title: "Manage tags for order", onClose: C }),
    /* @__PURE__ */ v.jsxs(kt, { children: [
      /* @__PURE__ */ v.jsx(Ut, { children: /* @__PURE__ */ v.jsx(tn, { children: /* @__PURE__ */ v.jsx(
        Lt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ v.jsx(
            Ln,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ v.jsx(
                Es,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (q) => m(q)
                }
              )
            }
          )
        }
      ) }) }),
      N && /* @__PURE__ */ v.jsx(Fn, { error: N })
    ] }),
    /* @__PURE__ */ v.jsx(
      Ct,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ v.jsx(cn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(w),
        cancelOnClick: C,
        confirmName: N ? "Close" : "Save",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, mz = "_editIcon_1dntr_1", pz = {
  editIcon: mz
}, fz = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ue, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, d) => /* @__PURE__ */ v.jsx(Un, { size: "small", variant: "primary", children: l }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ v.jsx(Ge, { content: "Edit tags", children: /* @__PURE__ */ v.jsx(
        ue,
        {
          size: o,
          name: "pen",
          className: pz.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ v.jsx(
      uz,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, hz = "_icon_cddi1_1", yz = "_link_cddi1_6", Sk = {
  icon: hz,
  link: yz
}, gz = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Ya(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ v.jsx(
    We.Item,
    {
      contentLeft: /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ v.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Sk.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ v.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ v.jsx(
        ue,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Sk.icon
        }
      ) })
    }
  );
}, vz = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ v.jsx(ue, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ v.jsx(We, { children: e.map((n) => /* @__PURE__ */ v.jsx(gz, { trackingInfo: n }, n.number)) })
] }), kz = "_order_135ze_1", bz = "_orderIsOpen_135ze_9", _z = "_orderHeader_135ze_12", Tu = {
  order: kz,
  orderIsOpen: bz,
  orderHeader: _z
}, xz = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, Sz = (e) => {
  const n = {}, r = xz(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, Nz = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = kn(), [h, k] = se(!1), [N, S] = se(!1), [w, C] = se(r), {
    id: g,
    name: q,
    createdAt: $,
    status: E,
    currentTotalPriceSet: D,
    currencyCode: z,
    lineItems: Z,
    billingAddress: Q,
    shippingAddress: te,
    trackingInfos: Y,
    tags: B
  } = e, R = !!te, H = Cp(g), ne = `https://${l}/admin/orders/${H ?? ""}`, ve = D?.shopMoney?.amount ?? 0, de = E.includes("cancelled"), le = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: z
  }).format(ve), fe = e?.refunds ? Sz(e) : {};
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      className: ut(Tu.order, {
        [Tu.orderIsOpen]: w
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Tu.orderHeader,
            onClick: () => C(!w),
            children: [
              /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
                $ && /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: An($).format(ym) }) }),
                /* @__PURE__ */ v.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  q
                ] })
              ] }),
              /* @__PURE__ */ v.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: w ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        w && /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ v.jsx(ue, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: E })
            ] })
          ] }),
          /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ v.jsx(ue, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: le })
            ] })
          ] }),
          /* @__PURE__ */ v.jsx(
            fz,
            {
              orderId: g,
              tags: B,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            vm,
            {
              openByDefault: !R,
              labelText: "Billing address",
              address: Q,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            vm,
            {
              openByDefault: R,
              shopifyId: n,
              orderId: g,
              icon: "map-pin",
              labelText: "Shipping address",
              address: te,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            rz,
            {
              orderId: g,
              lineItems: Z,
              refundedQuantities: fe
            }
          ),
          /* @__PURE__ */ v.jsx(vz, { trackingInfos: Y }),
          (o || m) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ v.jsx(
              lz,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: ne
              }
            ),
            m && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              Wn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => S(!0),
                className: It.fullWidth,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              Wn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => k(!0),
                className: It.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ v.jsx(
              ZV,
              {
                orderId: g,
                orderName: q,
                disabled: de,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx(
            wt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(ne, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ v.jsx(ue, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: g
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ v.jsx(
          tz,
          {
            order: e,
            shopifyId: n,
            orderName: q,
            isOpen: h,
            setIsOpen: k,
            refetchOrders: u
          }
        ),
        N && /* @__PURE__ */ v.jsx(
          sz,
          {
            order: e,
            orderName: q,
            isOpen: N,
            setIsOpen: S,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, jz = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = kn(), [f, h] = se([]), [k, N] = se(!1), S = Cp(m?.id), w = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: C,
    isCustomerOrdersLoading: g,
    customerOrdersError: q,
    customerOrders: $,
    refetchCustomerOrders: E
  } = aV();
  return He(() => {
    !g && S && C({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), He(() => {
    const D = $?.Shopify?.orders?.edges;
    D && h(OV({ ordersData: D }));
  }, [$]), m ? q ? /* @__PURE__ */ v.jsx(Fn, { error: q }) : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ v.jsx(Un, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ v.jsx(
      Wn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => N(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(cn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ v.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: f.map((D, z) => /* @__PURE__ */ v.jsx(
        Nz,
        {
          order: D,
          openByDefault: z === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: E,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${z}-${D.id}`
      )) }),
      /* @__PURE__ */ v.jsx(
        wt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(w, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ v.jsx(ue, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ v.jsx(
      YV,
      {
        isOpen: k,
        setIsOpen: N,
        shopifyCustomer: m,
        refetchCustomerOrders: E,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, wz = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ v.jsxs(We, { className: It.list, children: [
      /* @__PURE__ */ v.jsx(We.Text, { variant: "dense", className: It.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ v.jsx(We.Text, { variant: "dense", className: It.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, Cz = "_segmentName_1dkhk_1", Fz = {
  segmentName: Cz
}, Iz = 100, Ao = 10, Ez = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = un(), [i, a] = se([]), [o, s] = se(Ao), [l, d] = se(!1), m = Kn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    GL,
    {
      skip: !e,
      variables: {
        first: Iz
      },
      onCompleted: (S) => {
        const w = S?.Shopify?.segments?.edges;
        if (w && w.length > 0) {
          const C = w.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, q) => g.name.localeCompare(q.name));
          a(C), h({
            variables: {
              customerId: e,
              segmentIds: C.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: k, error: N }
  ] = r(YL, {
    onCompleted: (S) => {
      const w = S?.Shopify?.customerSegmentMembership?.memberships;
      if (w && w.length > 0) {
        const C = i.map((g) => {
          const q = w.find(
            ($) => $.segmentId === g.id
          );
          return {
            ...g,
            ...q?.isMember && { isMember: q.isMember }
          };
        }).sort(
          (g, q) => g.isMember === q.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(C);
      }
    }
  });
  return He(() => {
    s(l ? i.length : Ao);
  }, [l]), e ? /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ v.jsx(Un, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(cn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ v.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ v.jsx(Fn, { error: f }),
    N && /* @__PURE__ */ v.jsx(Fn, { error: N }),
    !u && i.length > 0 && /* @__PURE__ */ v.jsxs(We, { className: It.list, children: [
      i.slice(0, o).map(({ id: S, name: w, isMember: C }) => /* @__PURE__ */ v.jsx(We.Text, { className: It.listItem, children: /* @__PURE__ */ v.jsx(
        Ge,
        {
          content: `${C ? "Member of" : "Not a member of"} ${w}`,
          children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ v.jsx(A.Paragraph, { variant: "4", className: Fz.segmentName, children: w }),
            k && /* @__PURE__ */ v.jsx(cn, { size: 12 }),
            !k && /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(
              ue,
              {
                color: C ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > Ao && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ v.jsx(
        Wn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Ao} more`
        }
      ) })
    ] })
  ] }) : null;
}, Tz = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = iV({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, k = n.displayCancelOrder ?? !1, N = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, w = n.displayOrdersOverview ?? !1, C = n.displaySegmentMembership ?? !1, g = n.displayDiscountCodeCreation ?? !1, q = n.displayDiscountCodes ?? !1, $ = n.displayCreateOrder ?? !1, E = n.displayDuplicateOrder ?? !1, D = n.displayCreateDraftOrder ?? !1, z = n.displayPartialRefundOrder ?? !1;
  if (He(() => {
    const Z = a?.Shopify?.customers?.edges[0]?.node;
    Z && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Z)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ v.jsx(Fn, { error: i, retry: o });
  if (!r && !i && !l) {
    const Z = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ v.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ v.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ v.jsx(
              pV,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ v.jsx(
              wt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Z, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ v.jsx(ue, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== Gt.refetch ? /* @__PURE__ */ v.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ v.jsx(cn, {}) }) : /* @__PURE__ */ v.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ v.jsx(
          yV,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        w && /* @__PURE__ */ v.jsx(
          wz,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        C && /* @__PURE__ */ v.jsx(Ez, { shopifyId: l?.id }),
        S && /* @__PURE__ */ v.jsx(RV, { customer: l }),
        q && /* @__PURE__ */ v.jsx(
          DV,
          {
            displayDiscountCodeCreation: g
          }
        ),
        /* @__PURE__ */ v.jsx(
          jz,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: k,
            displayCreateOrder: $,
            displayCreateDraftOrder: D,
            enableEditShippingAddress: N,
            customerCountryCodes: m,
            displayDuplicateOrder: E,
            displayPartialRefundOrder: z
          }
        )
      ]
    }
  );
}, xt = [];
for (let e = 0; e < 256; ++e)
  xt.push((e + 256).toString(16).slice(1));
function $z(e, n = 0) {
  return (xt[e[n + 0]] + xt[e[n + 1]] + xt[e[n + 2]] + xt[e[n + 3]] + "-" + xt[e[n + 4]] + xt[e[n + 5]] + "-" + xt[e[n + 6]] + xt[e[n + 7]] + "-" + xt[e[n + 8]] + xt[e[n + 9]] + "-" + xt[e[n + 10]] + xt[e[n + 11]] + xt[e[n + 12]] + xt[e[n + 13]] + xt[e[n + 14]] + xt[e[n + 15]]).toLowerCase();
}
let $u;
const Dz = new Uint8Array(16);
function Rz() {
  if (!$u) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    $u = crypto.getRandomValues.bind(crypto);
  }
  return $u(Dz);
}
const Oz = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Nk = { randomUUID: Oz };
function Pz(e, n, r) {
  if (Nk.randomUUID && !e)
    return Nk.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? Rz();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, $z(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Du = { exports: {} }, ja = {}, jk;
function Az() {
  if (jk) return ja;
  jk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ja.Fragment = r, ja.jsx = s, ja.jsxs = s, ja;
}
var Lo = {}, wk;
function Lz() {
  return wk || (wk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    Lo.Fragment = i, Lo.jsx = Rn, Lo.jsxs = Bn;
  })()), Lo;
}
var Ck;
function Vz() {
  return Ck || (Ck = 1, process.env.NODE_ENV === "production" ? Du.exports = Az() : Du.exports = Lz()), Du.exports;
}
var M = Vz(), Hx = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(Hx || {}), km = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(km || {});
const zz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, Uz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Mz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, Bz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, qz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, Hz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, Wz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, Kz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, Gz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, Yz = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": zz,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": Uz,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": Mz,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": Bz,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": qz,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": Hz,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": Wz,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Kz,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": Gz
};
function Wr(e) {
  return Yz[e] ?? {};
}
const Jz = Wr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), Qz = Wr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), Xz = Wr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), Zz = Wr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), e3 = Wr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), n3 = Wr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), t3 = Wr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), r3 = Wr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), i3 = Wr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), a3 = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = kn(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(Jz, {
    skip: !e,
    variables: { contactId: e }
  });
  return He(() => {
    const k = f?.Voyado?.ContactsV_GetContactById;
    !m && k && typeof k == "object" && ("id" in k && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in k && a(k.attributes), "preferences" in k && s(k.preferences), "consents" in k && d(
      k?.consents?.filter(
        (N) => N !== null
      ) || void 0
    )), !m && (!k || typeof k != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Kn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function rs(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const o3 = {
  count: 0,
  items: []
}, s3 = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = kn(), [i, a] = se(o3), {
    loading: o,
    error: s,
    data: l
  } = n(Zz, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, l3 = {
  count: 0,
  totalCount: 0,
  items: []
}, c3 = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = kn(), [i, a] = se(
    l3
  ), {
    loading: o,
    error: s,
    data: l
  } = n(e3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, d3 = ({
  conversationContext: e
}) => {
  const { useQuery: n } = un(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(Xz, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return He(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, u3 = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = un(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(Qz, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return He(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Kn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, m3 = "_pointer_ls8kj_48", p3 = "_list_ls8kj_53", f3 = "_listItem_ls8kj_63", nt = {
  pointer: m3,
  list: p3,
  listItem: f3
};
var lo = (e) => e.type === "checkbox", ci = (e) => e instanceof Date, Pt = (e) => e == null;
const Wx = (e) => typeof e == "object";
var lt = (e) => !Pt(e) && !Array.isArray(e) && Wx(e) && !ci(e), Kx = (e) => lt(e) && e.target ? lo(e.target) ? e.target.checked : e.target.value : e, h3 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Gx = (e, n) => e.has(h3(n)), y3 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return lt(n) && n.hasOwnProperty("isPrototypeOf");
}, Tp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Nt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Tp && (e instanceof Blob || i)) && (r || lt(e)))
    if (n = r ? [] : {}, !r && !y3(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Nt(e[a]));
  else
    return e;
  return n;
}
var Ys = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !lt(e))
    return r;
  const i = Ys(n.split(/[,[\].]+?/)).reduce((a, o) => Pt(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? r : e[n] : i;
}, Zt = (e) => typeof e == "boolean", $p = (e) => /^\w*$/.test(e), Yx = (e) => Ys(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = $p(n) ? [n] : Yx(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = lt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const _s = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, hr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, g3 = Se.createContext(null), Dp = () => Se.useContext(g3);
var Jx = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== hr.all && (n._proxyFormState[s] = !i || hr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function v3(e) {
  const n = Dp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => Jx(s, r, d.current, !1), [s, r]);
}
var Tr = (e) => typeof e == "string", Qx = (e, n, r, i, a) => Tr(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function Xx(e) {
  const n = Dp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Qx(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function k3(e) {
  const n = Dp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Gx(a._names.array, r), l = Xx({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = v3({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Zt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((w) => u.current.onChange({
    target: {
      value: Kx(w),
      name: r
    },
    type: _s.CHANGE
  }), [r]), k = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: _s.BLUR
  }), [r, a._formValues]), N = Se.useCallback((w) => {
    const C = Je(a._fields, r);
    C && w && (C._f.ref = {
      focus: () => w.focus(),
      select: () => w.select(),
      setCustomValidity: (g) => w.setCustomValidity(g),
      reportValidity: () => w.reportValidity()
    });
  }, [a._fields, r]), S = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Zt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: N
  }), [r, i, d.disabled, h, k, N, l]);
  return Se.useEffect(() => {
    const w = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Zt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const C = (g, q) => {
      const $ = Je(a._fields, g);
      $ && $._f && ($._f.mount = q);
    };
    if (C(r, !0), w) {
      const g = Nt(Je(a._options.defaultValues, r));
      Yn(a._defaultValues, r, g), it(Je(a._formValues, r)) && Yn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? w && !a._state.action : w) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Fk = (e) => e.render(k3(e));
var b3 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ua = (e) => Array.isArray(e) ? e : [e], Ik = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, bm = (e) => Pt(e) || !Wx(e);
function Qr(e, n) {
  if (bm(e) || bm(n))
    return e === n;
  if (ci(e) && ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ci(o) && ci(s) || lt(o) && lt(s) || Array.isArray(o) && Array.isArray(s) ? !Qr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Dt = (e) => lt(e) && !Object.keys(e).length, Rp = (e) => e.type === "file", yr = (e) => typeof e == "function", xs = (e) => {
  if (!Tp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Zx = (e) => e.type === "select-multiple", Op = (e) => e.type === "radio", _3 = (e) => Op(e) || lo(e), Ru = (e) => xs(e) && e.isConnected;
function x3(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function S3(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function ht(e, n) {
  const r = Array.isArray(n) ? n : $p(n) ? [n] : Yx(n), i = r.length === 1 ? e : x3(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (lt(i) && Dt(i) || Array.isArray(i) && S3(i)) && ht(e, r.slice(0, -1)), e;
}
var eS = (e) => {
  for (const n in e)
    if (yr(e[n]))
      return !0;
  return !1;
};
function Ss(e, n = {}) {
  const r = Array.isArray(e);
  if (lt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || lt(e[i]) && !eS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ss(e[i], n[i])) : Pt(e[i]) || (n[i] = !0);
  return n;
}
function nS(e, n, r) {
  const i = Array.isArray(e);
  if (lt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || lt(e[a]) && !eS(e[a]) ? it(n) || bm(r[a]) ? r[a] = Array.isArray(e[a]) ? Ss(e[a], []) : { ...Ss(e[a]) } : nS(e[a], Pt(n) ? {} : n[a], r[a]) : r[a] = !Qr(e[a], n[a]);
  return r;
}
var wa = (e, n) => nS(e, n, Ss(n));
const Ek = {
  value: !1,
  isValid: !1
}, Tk = { value: !0, isValid: !0 };
var tS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? Tk : { value: e[0].value, isValid: !0 } : Tk
    ) : Ek;
  }
  return Ek;
}, rS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : r && Tr(e) ? new Date(e) : i ? i(e) : e;
const $k = {
  isValid: !1,
  value: null
};
var iS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, $k) : $k;
function Dk(e) {
  const n = e.ref;
  return Rp(n) ? n.files : Op(n) ? iS(e.refs).value : Zx(n) ? [...n.selectedOptions].map(({ value: r }) => r) : lo(n) ? tS(e.refs).value : rS(it(n.value) ? e.ref.value : n.value, e);
}
var N3 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Ns = (e) => e instanceof RegExp, Ca = (e) => it(e) ? e : Ns(e) ? e.source : lt(e) ? Ns(e.value) ? e.value.source : e.value : e, Rk = (e) => ({
  isOnSubmit: !e || e === hr.onSubmit,
  isOnBlur: e === hr.onBlur,
  isOnChange: e === hr.onChange,
  isOnAll: e === hr.all,
  isOnTouch: e === hr.onTouched
});
const Ok = "AsyncFunction";
var j3 = (e) => !!e && !!e.validate && !!(yr(e.validate) && e.validate.constructor.name === Ok || lt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Ok)), w3 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Pk = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ma = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ma(l, n))
          break;
      } else if (lt(l) && Ma(l, n))
        break;
    }
  }
};
function Ak(e, n, r) {
  const i = Je(e, r);
  if (i || $p(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var C3 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Dt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || hr.all));
}, F3 = (e, n, r) => !e || !n || e === n || Ua(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), I3 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, E3 = (e, n) => !Ys(Je(e, n)).length && ht(e, n), T3 = (e, n, r) => {
  const i = Ua(Je(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, is = (e) => Tr(e);
function Lk(e, n, r = "validate") {
  if (is(e) || Array.isArray(e) && e.every(is) || Zt(e) && !e)
    return {
      type: r,
      message: is(e) ? e : "",
      ref: n
    };
}
var Ci = (e) => lt(e) && !Ns(e) ? e : {
  value: e,
  message: ""
}, Vk = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: N, name: S, valueAsNumber: w, mount: C } = e._f, g = Je(r, S);
  if (!C || n.has(S))
    return {};
  const q = l ? l[0] : s, $ = (B) => {
    a && q.reportValidity && (q.setCustomValidity(Zt(B) ? "" : B || ""), q.reportValidity());
  }, E = {}, D = Op(s), z = lo(s), Z = D || z, Q = (w || Rp(s)) && it(s.value) && it(g) || xs(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, te = b3.bind(null, S, i, E), Y = (B, R, H, ne = Ur.maxLength, ve = Ur.minLength) => {
    const de = B ? R : H;
    E[S] = {
      type: B ? ne : ve,
      message: de,
      ref: s,
      ...te(B ? ne : ve, de)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || Pt(g)) || Zt(g) && !g || z && !tS(l).isValid || D && !iS(l).isValid)) {
    const { value: B, message: R } = is(d) ? { value: !!d, message: d } : Ci(d);
    if (B && (E[S] = {
      type: Ur.required,
      message: R,
      ref: q,
      ...te(Ur.required, R)
    }, !i))
      return $(R), E;
  }
  if (!Q && (!Pt(f) || !Pt(h))) {
    let B, R;
    const H = Ci(h), ne = Ci(f);
    if (!Pt(g) && !isNaN(g)) {
      const ve = s.valueAsNumber || g && +g;
      Pt(H.value) || (B = ve > H.value), Pt(ne.value) || (R = ve < ne.value);
    } else {
      const ve = s.valueAsDate || new Date(g), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", fe = s.type == "week";
      Tr(H.value) && g && (B = le ? de(g) > de(H.value) : fe ? g > H.value : ve > new Date(H.value)), Tr(ne.value) && g && (R = le ? de(g) < de(ne.value) : fe ? g < ne.value : ve < new Date(ne.value));
    }
    if ((B || R) && (Y(!!B, H.message, ne.message, Ur.max, Ur.min), !i))
      return $(E[S].message), E;
  }
  if ((m || u) && !Q && (Tr(g) || o && Array.isArray(g))) {
    const B = Ci(m), R = Ci(u), H = !Pt(B.value) && g.length > +B.value, ne = !Pt(R.value) && g.length < +R.value;
    if ((H || ne) && (Y(H, B.message, R.message), !i))
      return $(E[S].message), E;
  }
  if (k && !Q && Tr(g)) {
    const { value: B, message: R } = Ci(k);
    if (Ns(B) && !g.match(B) && (E[S] = {
      type: Ur.pattern,
      message: R,
      ref: s,
      ...te(Ur.pattern, R)
    }, !i))
      return $(R), E;
  }
  if (N) {
    if (yr(N)) {
      const B = await N(g, r), R = Lk(B, q);
      if (R && (E[S] = {
        ...R,
        ...te(Ur.validate, R.message)
      }, !i))
        return $(R.message), E;
    } else if (lt(N)) {
      let B = {};
      for (const R in N) {
        if (!Dt(B) && !i)
          break;
        const H = Lk(await N[R](g, r), q, R);
        H && (B = {
          ...H,
          ...te(R, H.message)
        }, $(H.message), i && (E[S] = B));
      }
      if (!Dt(B) && (E[S] = {
        ref: q,
        ...B
      }, !i))
        return E;
    }
  }
  return $(!0), E;
};
const $3 = {
  mode: hr.onSubmit,
  reValidateMode: hr.onChange,
  shouldFocusError: !0
};
function D3(e = {}) {
  let n = {
    ...$3,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: yr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = lt(n.defaultValues) || lt(n.values) ? Nt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Nt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Ik(),
    state: Ik()
  }, k = Rk(n.mode), N = Rk(n.reValidateMode), S = n.criteriaMode === hr.all, w = (F) => (_) => {
    clearTimeout(m), m = setTimeout(F, _);
  }, C = async (F) => {
    if (!n.disabled && (u.isValid || f.isValid || F)) {
      const _ = n.resolver ? Dt((await Q()).errors) : await Y(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, g = (F, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((F || Array.from(l.mount)).forEach((T) => {
      T && (_ ? Yn(r.validatingFields, T, _) : ht(r.validatingFields, T));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Dt(r.validatingFields)
    }));
  }, q = (F, _ = [], T, G, J = !0, O = !0) => {
    if (G && T && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Je(i, F))) {
        const U = T(Je(i, F), G.argA, G.argB);
        J && Yn(i, F, U);
      }
      if (O && Array.isArray(Je(r.errors, F))) {
        const U = T(Je(r.errors, F), G.argA, G.argB);
        J && Yn(r.errors, F, U), E3(r.errors, F);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Je(r.touchedFields, F))) {
        const U = T(Je(r.touchedFields, F), G.argA, G.argB);
        J && Yn(r.touchedFields, F, U);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = wa(a, o)), h.state.next({
        name: F,
        isDirty: R(F, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, F, _);
  }, $ = (F, _) => {
    Yn(r.errors, F, _), h.state.next({
      errors: r.errors
    });
  }, E = (F) => {
    r.errors = F, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (F, _, T, G) => {
    const J = Je(i, F);
    if (J) {
      const O = Je(o, F, it(T) ? Je(a, F) : T);
      it(O) || G && G.defaultChecked || _ ? Yn(o, F, _ ? O : Dk(J._f)) : ve(F, O), s.mount && C();
    }
  }, z = (F, _, T, G, J) => {
    let O = !1, U = !1;
    const ie = {
      name: F
    };
    if (!n.disabled) {
      if (!T || G) {
        (u.isDirty || f.isDirty) && (U = r.isDirty, r.isDirty = ie.isDirty = R(), O = U !== ie.isDirty);
        const pe = Qr(Je(a, F), _);
        U = !!Je(r.dirtyFields, F), pe ? ht(r.dirtyFields, F) : Yn(r.dirtyFields, F, !0), ie.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && U !== !pe;
      }
      if (T) {
        const pe = Je(r.touchedFields, F);
        pe || (Yn(r.touchedFields, F, T), ie.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && pe !== T);
      }
      O && J && h.state.next(ie);
    }
    return O ? ie : {};
  }, Z = (F, _, T, G) => {
    const J = Je(r.errors, F), O = (u.isValid || f.isValid) && Zt(_) && r.isValid !== _;
    if (n.delayError && T ? (d = w(() => $(F, T)), d(n.delayError)) : (clearTimeout(m), d = null, T ? Yn(r.errors, F, T) : ht(r.errors, F)), (T ? !Qr(J, T) : J) || !Dt(G) || O) {
      const U = {
        ...G,
        ...O && Zt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: F
      };
      r = {
        ...r,
        ...U
      }, h.state.next(U);
    }
  }, Q = async (F) => {
    g(F, !0);
    const _ = await n.resolver(o, n.context, N3(F || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(F), _;
  }, te = async (F) => {
    const { errors: _ } = await Q(F);
    if (F)
      for (const T of F) {
        const G = Je(_, T);
        G ? Yn(r.errors, T, G) : ht(r.errors, T);
      }
    else
      r.errors = _;
    return _;
  }, Y = async (F, _, T = {
    valid: !0
  }) => {
    for (const G in F) {
      const J = F[G];
      if (J) {
        const { _f: O, ...U } = J;
        if (O) {
          const ie = l.array.has(O.name), pe = J._f && j3(J._f);
          pe && u.validatingFields && g([G], !0);
          const ke = await Vk(J, l.disabled, o, S, n.shouldUseNativeValidation && !_, ie);
          if (pe && u.validatingFields && g([G]), ke[O.name] && (T.valid = !1, _))
            break;
          !_ && (Je(ke, O.name) ? ie ? T3(r.errors, ke, O.name) : Yn(r.errors, O.name, ke[O.name]) : ht(r.errors, O.name));
        }
        !Dt(U) && await Y(U, _, T);
      }
    }
    return T.valid;
  }, B = () => {
    for (const F of l.unMount) {
      const _ = Je(i, F);
      _ && (_._f.refs ? _._f.refs.every((T) => !Ru(T)) : !Ru(_._f.ref)) && Le(F);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (F, _) => !n.disabled && (F && _ && Yn(o, F, _), !Qr(Ce(), a)), H = (F, _, T) => Qx(F, l, {
    ...s.mount ? o : it(_) ? a : Tr(F) ? { [F]: _ } : _
  }, T, _), ne = (F) => Ys(Je(s.mount ? o : a, F, n.shouldUnregister ? Je(a, F, []) : [])), ve = (F, _, T = {}) => {
    const G = Je(i, F);
    let J = _;
    if (G) {
      const O = G._f;
      O && (!O.disabled && Yn(o, F, rS(_, O)), J = xs(O.ref) && Pt(_) ? "" : _, Zx(O.ref) ? [...O.ref.options].forEach((U) => U.selected = J.includes(U.value)) : O.refs ? lo(O.ref) ? O.refs.length > 1 ? O.refs.forEach((U) => (!U.defaultChecked || !U.disabled) && (U.checked = Array.isArray(J) ? !!J.find((ie) => ie === U.value) : J === U.value)) : O.refs[0] && (O.refs[0].checked = !!J) : O.refs.forEach((U) => U.checked = U.value === J) : Rp(O.ref) ? O.ref.value = "" : (O.ref.value = J, O.ref.type || h.state.next({
        name: F,
        values: Nt(o)
      })));
    }
    (T.shouldDirty || T.shouldTouch) && z(F, J, T.shouldTouch, T.shouldDirty, !0), T.shouldValidate && be(F);
  }, de = (F, _, T) => {
    for (const G in _) {
      const J = _[G], O = `${F}.${G}`, U = Je(i, O);
      (l.array.has(F) || lt(J) || U && !U._f) && !ci(J) ? de(O, J, T) : ve(O, J, T);
    }
  }, le = (F, _, T = {}) => {
    const G = Je(i, F), J = l.array.has(F), O = Nt(_);
    Yn(o, F, O), J ? (h.array.next({
      name: F,
      values: Nt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && T.shouldDirty && h.state.next({
      name: F,
      dirtyFields: wa(a, o),
      isDirty: R(F, O)
    })) : G && !G._f && !Pt(O) ? de(F, O, T) : ve(F, O, T), Pk(F, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? F : void 0,
      values: Nt(o)
    });
  }, fe = async (F) => {
    s.mount = !0;
    const _ = F.target;
    let T = _.name, G = !0;
    const J = Je(i, T), O = (U) => {
      G = Number.isNaN(U) || ci(U) && isNaN(U.getTime()) || Qr(U, Je(o, T, U));
    };
    if (J) {
      let U, ie;
      const pe = _.type ? Dk(J._f) : Kx(F), ke = F.type === _s.BLUR || F.type === _s.FOCUS_OUT, en = !w3(J._f) && !n.resolver && !Je(r.errors, T) && !J._f.deps || I3(ke, Je(r.touchedFields, T), r.isSubmitted, N, k), mn = Pk(T, l, ke);
      Yn(o, T, pe), ke ? (J._f.onBlur && J._f.onBlur(F), d && d(0)) : J._f.onChange && J._f.onChange(F);
      const rn = z(T, pe, ke), dn = !Dt(rn) || mn;
      if (!ke && h.state.next({
        name: T,
        type: F.type,
        values: Nt(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? ke && C() : ke || C()), dn && h.state.next({ name: T, ...mn ? {} : rn });
      if (!ke && mn && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Q([T]);
        if (O(pe), G) {
          const ln = Ak(r.errors, i, T), vn = Ak(pn, i, ln.name || T);
          U = vn.error, T = vn.name, ie = Dt(pn);
        }
      } else
        g([T], !0), U = (await Vk(J, l.disabled, o, S, n.shouldUseNativeValidation))[T], g([T]), O(pe), G && (U ? ie = !1 : (u.isValid || f.isValid) && (ie = await Y(i, !0)));
      G && (J._f.deps && be(J._f.deps), Z(T, ie, U, rn));
    }
  }, W = (F, _) => {
    if (Je(r.errors, _) && F.focus)
      return F.focus(), 1;
  }, be = async (F, _ = {}) => {
    let T, G;
    const J = Ua(F);
    if (n.resolver) {
      const O = await te(it(F) ? F : J);
      T = Dt(O), G = F ? !J.some((U) => Je(O, U)) : T;
    } else F ? (G = (await Promise.all(J.map(async (O) => {
      const U = Je(i, O);
      return await Y(U && U._f ? { [O]: U } : U);
    }))).every(Boolean), !(!G && !r.isValid) && C()) : G = T = await Y(i);
    return h.state.next({
      ...!Tr(F) || (u.isValid || f.isValid) && T !== r.isValid ? {} : { name: F },
      ...n.resolver || !F ? { isValid: T } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Ma(i, W, F ? J : l.mount), G;
  }, Ce = (F) => {
    const _ = {
      ...s.mount ? o : a
    };
    return it(F) ? _ : Tr(F) ? Je(_, F) : F.map((T) => Je(_, T));
  }, K = (F, _) => ({
    invalid: !!Je((_ || r).errors, F),
    isDirty: !!Je((_ || r).dirtyFields, F),
    error: Je((_ || r).errors, F),
    isValidating: !!Je(r.validatingFields, F),
    isTouched: !!Je((_ || r).touchedFields, F)
  }), qe = (F) => {
    F && Ua(F).forEach((_) => ht(r.errors, _)), h.state.next({
      errors: F ? r.errors : {}
    });
  }, Be = (F, _, T) => {
    const G = (Je(i, F, { _f: {} })._f || {}).ref, J = Je(r.errors, F) || {}, { ref: O, message: U, type: ie, ...pe } = J;
    Yn(r.errors, F, {
      ...pe,
      ..._,
      ref: G
    }), h.state.next({
      name: F,
      errors: r.errors,
      isValid: !1
    }), T && T.shouldFocus && G && G.focus && G.focus();
  }, Pe = (F, _) => yr(F) ? h.state.subscribe({
    next: (T) => F(H(void 0, _), T)
  }) : H(F, _, !0), Me = (F) => h.state.subscribe({
    next: (_) => {
      F3(F.name, _.name, F.exact) && C3(_, F.formState || u, Re, F.reRenderRoot) && F.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, je = (F) => (s.mount = !0, f = {
    ...f,
    ...F.formState
  }, Me({
    ...F,
    formState: f
  })), Le = (F, _ = {}) => {
    for (const T of F ? Ua(F) : l.mount)
      l.mount.delete(T), l.array.delete(T), _.keepValue || (ht(i, T), ht(o, T)), !_.keepError && ht(r.errors, T), !_.keepDirty && ht(r.dirtyFields, T), !_.keepTouched && ht(r.touchedFields, T), !_.keepIsValidating && ht(r.validatingFields, T), !n.shouldUnregister && !_.keepDefaultValue && ht(a, T);
    h.state.next({
      values: Nt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: R() } : {}
    }), !_.keepIsValid && C();
  }, Te = ({ disabled: F, name: _ }) => {
    (Zt(F) && s.mount || F || l.disabled.has(_)) && (F ? l.disabled.add(_) : l.disabled.delete(_));
  }, an = (F, _ = {}) => {
    let T = Je(i, F);
    const G = Zt(_.disabled) || Zt(n.disabled);
    return Yn(i, F, {
      ...T || {},
      _f: {
        ...T && T._f ? T._f : { ref: { name: F } },
        name: F,
        mount: !0,
        ..._
      }
    }), l.mount.add(F), T ? Te({
      disabled: Zt(_.disabled) ? _.disabled : n.disabled,
      name: F
    }) : D(F, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ca(_.min),
        max: Ca(_.max),
        minLength: Ca(_.minLength),
        maxLength: Ca(_.maxLength),
        pattern: Ca(_.pattern)
      } : {},
      name: F,
      onChange: fe,
      onBlur: fe,
      ref: (J) => {
        if (J) {
          an(F, _), T = Je(i, F);
          const O = it(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, U = _3(O), ie = T._f.refs || [];
          if (U ? ie.find((pe) => pe === O) : O === T._f.ref)
            return;
          Yn(i, F, {
            _f: {
              ...T._f,
              ...U ? {
                refs: [
                  ...ie.filter(Ru),
                  O,
                  ...Array.isArray(Je(a, F)) ? [{}] : []
                ],
                ref: { type: O.type, name: F }
              } : { ref: O }
            }
          }), D(F, !1, void 0, O);
        } else
          T = Je(i, F, {}), T._f && (T._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(Gx(l.array, F) && s.action) && l.unMount.add(F);
      }
    };
  }, we = () => n.shouldFocusError && Ma(i, W, l.mount), Ke = (F) => {
    Zt(F) && (h.state.next({ disabled: F }), Ma(i, (_, T) => {
      const G = Je(i, T);
      G && (_.disabled = G._f.disabled || F, Array.isArray(G._f.refs) && G._f.refs.forEach((J) => {
        J.disabled = G._f.disabled || F;
      }));
    }, 0, !1));
  }, Ze = (F, _) => async (T) => {
    let G;
    T && (T.preventDefault && T.preventDefault(), T.persist && T.persist());
    let J = Nt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: U } = await Q();
      r.errors = O, J = U;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Yn(J, O, void 0);
    if (ht(r.errors, "root"), Dt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await F(J, T);
      } catch (O) {
        G = O;
      }
    } else
      _ && await _({ ...r.errors }, T), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Dt(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, me = (F, _ = {}) => {
    Je(i, F) && (it(_.defaultValue) ? le(F, Nt(Je(a, F))) : (le(F, _.defaultValue), Yn(a, F, Nt(_.defaultValue))), _.keepTouched || ht(r.touchedFields, F), _.keepDirty || (ht(r.dirtyFields, F), r.isDirty = _.defaultValue ? R(F, Nt(Je(a, F))) : R()), _.keepError || (ht(r.errors, F), u.isValid && C()), h.state.next({ ...r }));
  }, he = (F, _ = {}) => {
    const T = F ? Nt(F) : a, G = Nt(T), J = Dt(F), O = J ? a : G;
    if (_.keepDefaultValues || (a = T), !_.keepValues) {
      if (_.keepDirtyValues) {
        const U = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(wa(a, o))
        ]);
        for (const ie of Array.from(U))
          Je(r.dirtyFields, ie) ? Yn(O, ie, Je(o, ie)) : le(ie, Je(O, ie));
      } else {
        if (Tp && it(F))
          for (const U of l.mount) {
            const ie = Je(i, U);
            if (ie && ie._f) {
              const pe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (xs(pe)) {
                const ke = pe.closest("form");
                if (ke) {
                  ke.reset();
                  break;
                }
              }
            }
          }
        for (const U of l.mount)
          le(U, Je(O, U));
      }
      o = Nt(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: J ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Qr(F, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: J ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? wa(a, o) : r.dirtyFields : _.keepDefaultValues && F ? wa(a, F) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (F, _) => he(yr(F) ? F(o) : F, _), Ae = (F, _ = {}) => {
    const T = Je(i, F), G = T && T._f;
    if (G) {
      const J = G.refs ? G.refs[0] : G.ref;
      J.focus && (J.focus(), _.shouldSelect && yr(J.select) && J.select());
    }
  }, Re = (F) => {
    r = {
      ...r,
      ...F
    };
  }, Ue = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: H,
      _getDirty: R,
      _setValid: C,
      _setFieldArray: q,
      _setDisabledField: Te,
      _setErrors: E,
      _getFieldArray: ne,
      _reset: he,
      _resetDefaultValues: () => yr(n.defaultValues) && n.defaultValues().then((F) => {
        Ie(F, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ke,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(F) {
        s = F;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(F) {
        l = F;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(F) {
        n = {
          ...n,
          ...F
        };
      }
    },
    subscribe: je,
    trigger: be,
    register: an,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...Ue,
    formControl: Ue
  };
}
function R3(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: yr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: yr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : D3(e),
    formState: i
  }, e.formControl && e.defaultValues && !yr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Qr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Dt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Jx(i, o), n.current;
}
const O3 = "_modalBody_1clhs_1", P3 = {
  modalBody: O3
}, A3 = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = kn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: k } = R3({
    defaultValues: u,
    mode: "onChange"
  }), N = Xx({ control: f }), S = parseInt(N?.balance ?? "0", 10), w = m === S, C = w ? "Change the value to update the points" : "", g = S < 0, q = g ? "Points can not be negative" : "", $ = N.description === "", E = $ ? "Description can not be empty" : "";
  He(() => {
    S > m ? h(
      "transactionType",
      km.Addition
    ) : S < m && h(
      "transactionType",
      km.Deduction
    );
  }, [m, S, h]);
  const [D, { loading: z, error: Z, reset: Q }] = o(i3, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), te = () => {
    if (d) {
      const B = Pz();
      D({
        variables: {
          input: {
            accountId: d,
            transactionId: B,
            amount: Math.abs(S - m),
            transactionType: N.transactionType,
            description: N.description,
            source: Hx.UpdateBalance
          }
        }
      }).then(async (R) => {
        R?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), Y());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, Y = () => {
    k(u), Q(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    gt,
    {
      isOpen: e,
      onClose: Y,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx(vt, { title: "Update points balance", onClose: Y }),
        /* @__PURE__ */ M.jsxs(kt, { className: P3.modalBody, children: [
          /* @__PURE__ */ M.jsxs(Ut, { children: [
            /* @__PURE__ */ M.jsx(tn, { span: 6, children: /* @__PURE__ */ M.jsx(
              Fk,
              {
                name: "balance",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ M.jsx(
                  sr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: C || q
                    },
                    input: {
                      ...B,
                      value: B.value.toString(),
                      onChange: (R) => B.onChange(R)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(tn, { span: 6, children: /* @__PURE__ */ M.jsx(
              Fk,
              {
                name: "description",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ M.jsx(
                  sr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: B,
                    meta: {
                      warning: E
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ M.jsx(Fn, { error: Z })
        ] }),
        /* @__PURE__ */ M.jsx(
          Ct,
          {
            confirmName: "Save",
            confirmOnClick: () => te(),
            confirmProps: {
              isLoading: z,
              disabled: w || g || $,
              loadingIndicator: /* @__PURE__ */ M.jsx(cn, { size: 16 })
            },
            cancelOnClick: Y
          }
        )
      ]
    }
  );
}, L3 = "_wrapper_1ge6c_1", V3 = "_block_1ge6c_12", zk = {
  wrapper: L3,
  block: V3
}, z3 = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = un(), { isCopied: i, copy: a } = rs(), { isCopied: o, copy: s } = rs(), { isCopied: l, copy: d } = rs(), [m, u] = se(!1), [f, h] = se(), [k, N] = se(!1), {
    loading: S,
    data: w,
    refetch: C
  } = r(t3, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  He(() => {
    if (w) {
      const ne = w?.Voyado?.PointAccountV_GetPointAccounts;
      ne && ne?.length > 0 && h(ne[0]);
    }
  }, [w]);
  const g = !!f?.id, q = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: $,
    lastName: E,
    street: D,
    zipCode: z,
    city: Z,
    country: Q,
    isRegistrationCompleted: te,
    email: Y,
    mobilePhone: B
  } = e, R = 14, H = `${$ || ""} ${E || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", className: zk.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: zk.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: H }),
          S && /* @__PURE__ */ M.jsx(cn, { size: 12 }),
          g && !S && /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(Un, { size: "small", variant: "warning", children: [
              q,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(Ge, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              ue,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            k && /* @__PURE__ */ M.jsx(Ge, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              ue,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (D || Z || z || Q || B || Y) && /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
      B && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(ue, { size: R, name: "phone" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: B })
        ] }),
        /* @__PURE__ */ M.jsx(
          ue,
          {
            size: R,
            name: o ? "done" : "copy",
            onClick: () => s(B),
            className: nt.pointer
          }
        )
      ] }),
      Y && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(ue, { size: R, name: "mail" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Y })
        ] }),
        /* @__PURE__ */ M.jsx(
          ue,
          {
            size: R,
            name: i ? "done" : "copy",
            onClick: () => a(Y),
            className: nt.pointer
          }
        )
      ] }),
      (D || Z || z || Q) && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(ue, { size: R, name: "home" }),
          /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(Qn, { children: D }),
            /* @__PURE__ */ M.jsxs(Qn, { children: [
              z,
              " ",
              Z
            ] }),
            /* @__PURE__ */ M.jsx(Qn, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          ue,
          {
            size: R,
            name: l ? "done" : "copy",
            onClick: () => d(`${D}, ${z} ${Z}, ${Q}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(ue, { size: R, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          ue,
          {
            name: te ? "check-circle-filled" : "close-circle-filled",
            color: te ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ M.jsx(
      A3,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: N,
        refetchPointsQuery: C
      }
    )
  ] });
}, U3 = "_list_yud4a_7", M3 = "_listItem_yud4a_11", B3 = "_listItemTooltip_yud4a_15", q3 = "_listItemTimestamp_yud4a_18", Vo = {
  list: U3,
  listItem: M3,
  listItemTooltip: B3,
  listItemTimestamp: q3
}, H3 = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(We, { className: Vo.list, children: e.map((n, r) => /* @__PURE__ */ M.jsx(We.Text, { variant: "dense", className: Vo.listItem, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(Ge, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ut({
          [Vo.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { className: Vo.listItemTimestamp, children: An(n.date).format(dt) }),
          n?.comment && /* @__PURE__ */ M.jsx(ue, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      ue,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), W3 = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? An(e.latestChange).format(dt) : null, o = e?.expires ? `${An(e.expires).fromNow()} (${An(e.expires).format(dt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(Ge, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        ue,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(We, { className: nt.list, children: [
      s && /* @__PURE__ */ M.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ M.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(We.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, K3 = "_tagHover_kzbzk_1", G3 = "_channelUnsubscribed_kzbzk_6", Uk = {
  tagHover: K3,
  channelUnsubscribed: G3
}, Ou = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = kn(), { useMutation: l } = un(), [d, m] = se(!1), [u, { loading: f }] = l(r3), h = async ({
    newPreference: N,
    isSubscribed: S,
    channelType: w
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...N
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: w }) : s("voyado:channel:subscribe:succeeded", { channel: w }) : S ? s("voyado:channel:unsubscribe:failed", { channel: w }) : s("voyado:channel:subscribe:failed", { channel: w }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, k = d || f;
  return /* @__PURE__ */ M.jsx(Ge, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    Pn,
    {
      className: Uk.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ut({
            [Uk.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            k ? /* @__PURE__ */ M.jsx(cn, { size: 16 }) : /* @__PURE__ */ M.jsx(ue, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, Y3 = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        Ou,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Ou,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Ou,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, J3 = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = a3({ contactId: e }), {
    isLoading: k,
    error: N,
    memberLevel: S
  } = u3({ contactId: e, skip: !s }), w = k || l, C = Kn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return d || N ? Qa({
    errors: d?.graphQLErrors || N?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: d || N }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : w ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    r && /* @__PURE__ */ M.jsx(
      z3,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx(W3, { memberLevel: S }),
    i && /* @__PURE__ */ M.jsx(
      Y3,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(H3, { contactConsents: C })
  ] });
}, _m = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, Q3 = "_list_zu4s7_1", X3 = "_listItem_zu4s7_4", Z3 = "_listSum_zu4s7_7", zo = {
  list: Q3,
  listItem: X3,
  listSum: Z3
}, eU = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ M.jsxs(We, { className: zo.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(We.Text, { variant: "dense", className: zo.listItem, children: /* @__PURE__ */ M.jsx(Ge, { content: s, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flex: "auto", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: _m(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    We.Text,
    {
      variant: "dense",
      className: ut(zo.listItem, zo.listSum),
      children: /* @__PURE__ */ M.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: _m(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), nU = "_transaction_1kr8d_1", tU = "_transactionIsOpen_1kr8d_9", rU = "_transactionHeader_1kr8d_12", iU = "_transactionHeaderSubLine_1kr8d_15", aU = "_transactionHeaderAlignItemRight_1kr8d_19", Fi = {
  transaction: nU,
  transactionIsOpen: tU,
  transactionHeader: rU,
  transactionHeaderSubLine: iU,
  transactionHeaderAlignItemRight: aU
}, oU = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", k = f ?? 0, N = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ut(Fi.transaction, {
        [Fi.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Fi.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: An(o).format(dt) }),
                  /* @__PURE__ */ M.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: Fi.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Fi.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-4", children: _m(k, h) }),
                      /* @__PURE__ */ M.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: Fi.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(Cm, {}),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ M.jsx(Pn, { children: /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ M.jsx(
                  eU,
                  {
                    lineItems: N,
                    localCurrency: h,
                    localNetPriceSum: k
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, sU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = c3({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ M.jsx(Fn, { error: r }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ M.jsx(
            oU,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, lU = "_message_unsvt_48", cU = "_messageIsOpen_unsvt_56", dU = "_messageHeader_unsvt_60", uU = "_messageText_unsvt_64", mU = "_buttonLink_unsvt_86", Fa = {
  message: lU,
  messageIsOpen: cU,
  messageHeader: dU,
  messageText: uU,
  buttonLink: mU
}, Pu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Au = (e, n) => n && e in Pu && n in Pu[e] ? Pu[e][n] : null, pU = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = kn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, k = l ? Au("type", l) : null, N = d ? Au("source", d) : null, S = u ? Au("status", u) : null, w = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ut(Fa.message, {
        [Fa.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Fa.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
                  k && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(ue, { name: k, size: 16 }),
                    " ",
                    w
                  ] }),
                  s && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: An(s).format(dt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(Cm, {}),
          /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ M.jsx(Pn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(ue, { name: S }),
              " ",
              u
            ] }) }),
            N && /* @__PURE__ */ M.jsx(Pn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(ue, { name: N }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ M.jsx(Pn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(ue, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", className: Fa.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            wt,
            {
              slotEnd: /* @__PURE__ */ M.jsx(ue, { name: "external-link" }),
              variant: "tertiary",
              className: Fa.buttonLink,
              navigate: () => {
                w && a("voyado:message:external-link:opened", {
                  channel: w.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, fU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = s3({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ M.jsx(Fn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ M.jsx(
        pU,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Js = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Mk = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = rs(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = tt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(ue, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      ue,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, hU = "_order_19t4p_1", yU = "_orderIsOpen_19t4p_9", gU = "_orderHeader_19t4p_12", vU = "_orderIconColor_19t4p_15", Cr = {
  order: hU,
  orderIsOpen: yU,
  orderHeader: gU,
  orderIconColor: vU
}, kU = "_delivery_1m9nb_1", bU = "_deliveryCode_1m9nb_4", Lu = {
  delivery: kU,
  deliveryCode: bU
}, _U = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = nr();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      ue,
      {
        size: l,
        name: "eye",
        className: Cr.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        Ge,
        {
          content: /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            An(s).format(dt)
          ] }),
          children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Lu.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(ue, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: ut(Lu.delivery, Lu.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      ue,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, xU = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        ue,
        {
          size: 14,
          name: "file-text",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(We, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(We.Item, { className: nt.listItem, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Js({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, SU = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        ue,
        {
          size: 14,
          name: "tag",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(We, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ M.jsx(
      We.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          Ge,
          {
            content: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(b, { children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: Js({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          zi,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, NU = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        ue,
        {
          size: 14,
          name: "credit-card",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(We, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(
      We.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: An(i?.paidAt).format(dt) }),
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Js({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, jU = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: k,
    totalPrice: N
  } = e, S = 14;
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ut(Cr.order, {
        [Cr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Cr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: An(m).format(dt) }) }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              ue,
              {
                size: S,
                name: "activity",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(Ge, { content: "Internal status", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(Ge, { content: "External status", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(A.Paragraph, { as: "span", variant: "5", children: An(u).format(dt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              ue,
              {
                size: S,
                name: "chart-bar",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Js({
                value: N,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              ue,
              {
                size: S,
                name: "channels",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(Mk, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            Mk,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: k
            }
          ),
          /* @__PURE__ */ M.jsx(_U, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(SU, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(xU, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            NU,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, wU = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || Qa({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: r }), CU = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), [r, i] = se([]), { track: a } = kn(), {
    loading: o,
    error: s,
    data: l
  } = n(n3, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return He(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsx(wU, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ M.jsx(
      jU,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, FU = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = d3({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: k,
    showOrders: N
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Qa({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: o }) : !d && !m && !u && !f && !h && !k ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(J3, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(fU, { contactId: i }),
        k && /* @__PURE__ */ M.jsx(sU, { contactId: i }),
        N && /* @__PURE__ */ M.jsx(CU, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, IU = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Vu = { exports: {} }, Ia = {}, Bk;
function EU() {
  if (Bk) return Ia;
  Bk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ia.Fragment = r, Ia.jsx = s, Ia.jsxs = s, Ia;
}
var Uo = {}, qk;
function TU() {
  return qk || (qk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), N = Symbol.iterator, S = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[S];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = C.ReactDebugCurrentFrame, P = y.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, E = !1, D = !1, z = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || z || t === k || $ || E || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function Y(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return Y(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, ve, de, le, fe, W, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ne === 0) {
          ve = console.log, de = console.info, le = console.warn, fe = console.error, W = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: ve
            }),
            info: H({}, t, {
              value: de
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: fe
            }),
            group: H({}, t, {
              value: W
            }),
            groupCollapsed: H({}, t, {
              value: be
            }),
            groupEnd: H({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = C.ReactCurrentDispatcher, Me;
    function je(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var y = P.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ee) {
              y = ee;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var j = ee.stack.split(`
`), re = y.stack.split(`
`), x = j.length - 1, V = re.length - 1; x >= 1 && V >= 0 && j[x] !== re[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (j[x] !== re[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || j[x] !== re[V]) {
                    var X = `
` + j[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function Ke(t, c, p) {
      return we(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Ze(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ke(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var y = t, P = y._payload, L = y._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = C.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function Ue(t, c, p, y, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var j = void 0;
            try {
              if (typeof t[I] != "function") {
                var re = Error((y || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              j = t[I](c, I, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              j = x;
            }
            j && !(j instanceof Error) && (Re(P), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, I, typeof j), Re(null)), j instanceof Error && !(j.message in Ie) && (Ie[j.message] = !0, Re(P), g("Failed %s type: %s", p, j.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(t) {
      return F(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), J(t);
    }
    var U = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, ke;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && U.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          pe || (pe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, y, P, L, I) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function vn(t, c, p, y, P) {
      {
        var L, I = {}, j = null, re = null;
        p !== void 0 && (O(p), j = "" + p), mn(c) && (O(c.key), j = "" + c.key), en(c) && (re = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !ie.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (j || re) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && dn(I, V), re && pn(I, V);
        }
        return ln(t, j, re, P, y, U.current, I);
      }
    }
    var Xe = C.ReactCurrentOwner, xn = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Xe.current) {
          var t = R(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && fn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          Ue(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, y, P, L) {
      {
        var I = te(t);
        if (!I) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = qn();
          re ? j += re : j += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, j);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (y)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), nn = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var In = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, In, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Hn;
    Uo.Fragment = i, Uo.jsx = Rn, Uo.jsxs = Bn;
  })()), Uo;
}
var Hk;
function $U() {
  return Hk || (Hk = 1, process.env.NODE_ENV === "production" ? Vu.exports = EU() : Vu.exports = TU()), Vu.exports;
}
var ce = $U();
const DU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, RU = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": DU
};
function OU(e) {
  return RU[e] ?? {};
}
const PU = OU(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), AU = "_copyIcon_nr4rl_48", LU = "_list_nr4rl_53", VU = "_listItem_nr4rl_63", Dr = {
  copyIcon: AU,
  list: LU,
  listItem: VU
}, $n = ({
  description: e,
  content: n,
  tooltip: r
}) => {
  if (n == null)
    return null;
  const i = LS(n);
  return /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsx(Ge, { content: r, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: e }),
    i ? n : pb(n)
  ] }) }) });
}, Wk = ({
  channel: e
}) => {
  const n = (a) => Is(a.replace("_", " "));
  if (!e?.marketing)
    return null;
  const { marketing: r } = e, i = "suppressions" in r && !!r.suppressions;
  return /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
    /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(r?.timestamp).format(dt) }),
        r?.consent && /* @__PURE__ */ ce.jsx(Un, { variant: "primary", size: "small", children: n(r?.consent) })
      ] })
    ] }) }),
    i && /* @__PURE__ */ ce.jsx(We.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r.suppressions?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(r.suppressions?.timestamp).format(
          dt
        ) }),
        r.suppressions?.suppression_reason && /* @__PURE__ */ ce.jsx(Un, { variant: "warning", size: "small", children: r.suppressions?.suppression_reason })
      ] })
    ] }) })
  ] });
}, zU = "_channelHeadline_yeqqp_1", Kk = {
  channelHeadline: zU
}, UU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: r, yotpo_sms: i } = e;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: Kk.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "mail" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
        /* @__PURE__ */ ce.jsx(Wk, { channel: n?.email }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: r?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: r?.last_promotional_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: r?.last_delivered
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: r?.last_opened
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: r?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: r?.last_converted
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: r?.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: Kk.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
        /* @__PURE__ */ ce.jsx(Wk, { channel: n?.sms }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i?.last_converted
          }
        )
      ] })
    ] })
  ] });
}, MU = "_wrapper_1xucg_1", BU = "_externalLink_1xucg_7", zu = {
  wrapper: MU,
  externalLink: BU
}, qU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = nr(), { isCopied: i, copy: a } = nr(), { isCopied: o, copy: s } = nr();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: d,
    address: m,
    email: u,
    phone_number: f,
    account_created_at: h,
    account_status: k,
    accepts_sms_marketing: N,
    accepts_email_marketing: S
  } = e, w = 14, C = `${l || ""} ${d || ""}`.trim() || "A customer has no name", {
    address1: g,
    address2: q,
    city: $,
    company: E,
    state: D,
    zip: z,
    province_code: Z,
    country_code: Q
  } = m || {}, te = [
    g,
    q,
    [z, $].filter(Boolean).join(", "),
    [Q, D, Z].filter(Boolean).join(", "),
    E
  ].filter(Boolean);
  return /* @__PURE__ */ ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ce.jsxs(b, { className: zu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "space-between",
        className: zu.block,
        alignItems: "center",
        children: /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-2", children: C })
      }
    ),
    h && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: An(h).format(dt) })
    ] }),
    u && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "mail" }),
        /* @__PURE__ */ ce.jsx("span", { className: zu.externalLink, children: u })
      ] }),
      /* @__PURE__ */ ce.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: w,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "phone" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: f })
      ] }),
      /* @__PURE__ */ ce.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: w,
          name: i ? "done" : "copy",
          onClick: () => a(f),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    (g || $ || E || D || z || Q) && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "home" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: te.map((Y) => /* @__PURE__ */ ce.jsx(Qn, { children: Y }, Y)) })
      ] }),
      /* @__PURE__ */ ce.jsx(Ge, { content: "Copy address", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: w,
          name: o ? "done" : "copy",
          onClick: () => s(te.join(", ")),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: N ? "check-circle-filled" : "close-circle-filled",
          color: N ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "paper-plane" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: S ? "check-circle-filled" : "close-circle-filled",
          color: S ? "green.500" : "red.500"
        }
      )
    ] }),
    k && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ ce.jsx(Pn, { children: Is(k) })
    ] })
  ] }) });
}, HU = ({
  loyalty: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), WU = ({ tags: e }) => {
  const n = e?.split(","), r = n && n.length > 0;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
    !r && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    r && /* @__PURE__ */ ce.jsx(b, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ ce.jsx(Pn, { children: i }, a)) })
  ] });
}, KU = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ ce.jsxs(We, { className: Dr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: e.sentiment_avg_site
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: An(e.last_review_date).format(
          dt
        )
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: e.last_sentiment
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ ce.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ ce.jsx(Un, { variant: "info", size: "small", children: /* @__PURE__ */ ce.jsx(ce.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), GU = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), { track: i } = kn(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, k = n?.showTags ?? !1, N = n?.showChannels ?? !1, S = n?.showUserGeneratedContent ?? !1, w = n?.displayLoyalty ?? !1, C = n?.displayEmailData ?? !1, g = n?.displaySmsData ?? !1, q = n?.displaySubscriptions ?? !1, $ = !h && !k && !N && !S && !w && !C && !g && !q, {
    loading: E,
    error: D,
    data: z
  } = r(PU, {
    skip: !d || !f,
    variables: {
      ...d && { email: d },
      // eslint-disable-next-line camelcase
      ...!d && m && { phone_number: m },
      storeId: f,
      expand: "all"
    }
  });
  if (He(() => {
    const Z = z?.Yotpo?.getCustomers;
    Z?.customers && (Z?.customers?.length > 0 ? (o(Z?.customers[0]), l(!1), i("yotpo:customer:received")) : l(!0));
  }, [z?.Yotpo, E]), u)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (s)
    return /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if ($)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (D) {
    const Z = D.graphQLErrors;
    return Sm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Nm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ce.jsx(Fn, { error: D });
  }
  return E ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ce.jsx(cn, {}) }) : /* @__PURE__ */ ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ce.jsx(qU, { customerDetails: a }),
        k && /* @__PURE__ */ ce.jsx(WU, { tags: a?.tags }),
        N && /* @__PURE__ */ ce.jsx(UU, { customerDetails: a }),
        S && /* @__PURE__ */ ce.jsx(
          KU,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        w && /* @__PURE__ */ ce.jsx(HU, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var co = (e) => e.type === "checkbox", di = (e) => e instanceof Date, At = (e) => e == null;
const aS = (e) => typeof e == "object";
var ct = (e) => !At(e) && !Array.isArray(e) && aS(e) && !di(e), oS = (e) => ct(e) && e.target ? co(e.target) ? e.target.checked : e.target.value : e, YU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, sS = (e, n) => e.has(YU(n)), JU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ct(n) && n.hasOwnProperty("isPrototypeOf");
}, Pp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function jt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Pp && (e instanceof Blob || i)) && (r || ct(e)))
    if (n = r ? [] : {}, !r && !JU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = jt(e[a]));
  else
    return e;
  return n;
}
var Qs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], at = (e) => e === void 0, Qe = (e, n, r) => {
  if (!n || !ct(e))
    return r;
  const i = Qs(n.split(/[,[\].]+?/)).reduce((a, o) => At(a) ? a : a[o], e);
  return at(i) || i === e ? at(e[n]) ? r : e[n] : i;
}, er = (e) => typeof e == "boolean", Ap = (e) => /^\w*$/.test(e), lS = (e) => Qs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Jn = (e, n, r) => {
  let i = -1;
  const a = Ap(n) ? [n] : lS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ct(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const js = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, gr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Mr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, QU = Se.createContext(null), Lp = () => Se.useContext(QU);
var cS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== gr.all && (n._proxyFormState[s] = !i || gr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function XU(e) {
  const n = Lp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => cS(s, r, d.current, !1), [s, r]);
}
var $r = (e) => typeof e == "string", dS = (e, n, r, i, a) => $r(e) ? (i && n.watch.add(e), Qe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Qe(r, o))) : (i && (n.watchAll = !0), r);
function uS(e) {
  const n = Lp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(dS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function ZU(e) {
  const n = Lp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = sS(a._names.array, r), l = uS({
    control: a,
    name: r,
    defaultValue: Qe(a._formValues, r, Qe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = XU({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...er(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((w) => u.current.onChange({
    target: {
      value: oS(w),
      name: r
    },
    type: js.CHANGE
  }), [r]), k = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Qe(a._formValues, r),
      name: r
    },
    type: js.BLUR
  }), [r, a._formValues]), N = Se.useCallback((w) => {
    const C = Qe(a._fields, r);
    C && w && (C._f.ref = {
      focus: () => w.focus(),
      select: () => w.select(),
      setCustomValidity: (g) => w.setCustomValidity(g),
      reportValidity: () => w.reportValidity()
    });
  }, [a._fields, r]), S = Se.useMemo(() => ({
    name: r,
    value: l,
    ...er(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: N
  }), [r, i, d.disabled, h, k, N, l]);
  return Se.useEffect(() => {
    const w = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...er(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const C = (g, q) => {
      const $ = Qe(a._fields, g);
      $ && $._f && ($._f.mount = q);
    };
    if (C(r, !0), w) {
      const g = jt(Qe(a._options.defaultValues, r));
      Jn(a._defaultValues, r, g), at(Qe(a._formValues, r)) && Jn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? w && !a._state.action : w) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Gk = (e) => e.render(ZU(e));
var e4 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ba = (e) => Array.isArray(e) ? e : [e], Yk = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, xm = (e) => At(e) || !aS(e);
function Xr(e, n) {
  if (xm(e) || xm(n))
    return e === n;
  if (di(e) && di(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (di(o) && di(s) || ct(o) && ct(s) || Array.isArray(o) && Array.isArray(s) ? !Xr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Rt = (e) => ct(e) && !Object.keys(e).length, Vp = (e) => e.type === "file", vr = (e) => typeof e == "function", ws = (e) => {
  if (!Pp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, mS = (e) => e.type === "select-multiple", zp = (e) => e.type === "radio", n4 = (e) => zp(e) || co(e), Uu = (e) => ws(e) && e.isConnected;
function t4(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = at(e) ? i++ : e[n[i++]];
  return e;
}
function r4(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !at(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const r = Array.isArray(n) ? n : Ap(n) ? [n] : lS(n), i = r.length === 1 ? e : t4(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ct(i) && Rt(i) || Array.isArray(i) && r4(i)) && yt(e, r.slice(0, -1)), e;
}
var pS = (e) => {
  for (const n in e)
    if (vr(e[n]))
      return !0;
  return !1;
};
function Cs(e, n = {}) {
  const r = Array.isArray(e);
  if (ct(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ct(e[i]) && !pS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Cs(e[i], n[i])) : At(e[i]) || (n[i] = !0);
  return n;
}
function fS(e, n, r) {
  const i = Array.isArray(e);
  if (ct(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ct(e[a]) && !pS(e[a]) ? at(n) || xm(r[a]) ? r[a] = Array.isArray(e[a]) ? Cs(e[a], []) : { ...Cs(e[a]) } : fS(e[a], At(n) ? {} : n[a], r[a]) : r[a] = !Xr(e[a], n[a]);
  return r;
}
var Ea = (e, n) => fS(e, n, Cs(n));
const Jk = {
  value: !1,
  isValid: !1
}, Qk = { value: !0, isValid: !0 };
var hS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !at(e[0].attributes.value) ? at(e[0].value) || e[0].value === "" ? Qk : { value: e[0].value, isValid: !0 } : Qk
    ) : Jk;
  }
  return Jk;
}, yS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => at(e) ? e : n ? e === "" ? NaN : e && +e : r && $r(e) ? new Date(e) : i ? i(e) : e;
const Xk = {
  isValid: !1,
  value: null
};
var gS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Xk) : Xk;
function Zk(e) {
  const n = e.ref;
  return Vp(n) ? n.files : zp(n) ? gS(e.refs).value : mS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : co(n) ? hS(e.refs).value : yS(at(n.value) ? e.ref.value : n.value, e);
}
var i4 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Qe(n, o);
    s && Jn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Fs = (e) => e instanceof RegExp, Ta = (e) => at(e) ? e : Fs(e) ? e.source : ct(e) ? Fs(e.value) ? e.value.source : e.value : e, eb = (e) => ({
  isOnSubmit: !e || e === gr.onSubmit,
  isOnBlur: e === gr.onBlur,
  isOnChange: e === gr.onChange,
  isOnAll: e === gr.all,
  isOnTouch: e === gr.onTouched
});
const nb = "AsyncFunction";
var a4 = (e) => !!e && !!e.validate && !!(vr(e.validate) && e.validate.constructor.name === nb || ct(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === nb)), o4 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), tb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const qa = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Qe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (qa(l, n))
          break;
      } else if (ct(l) && qa(l, n))
        break;
    }
  }
};
function rb(e, n, r) {
  const i = Qe(e, r);
  if (i || Ap(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Qe(n, o), l = Qe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var s4 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Rt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || gr.all));
}, l4 = (e, n, r) => !e || !n || e === n || Ba(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), c4 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, d4 = (e, n) => !Qs(Qe(e, n)).length && yt(e, n), u4 = (e, n, r) => {
  const i = Ba(Qe(e, r));
  return Jn(i, "root", n[r]), Jn(e, r, i), e;
}, as = (e) => $r(e);
function ib(e, n, r = "validate") {
  if (as(e) || Array.isArray(e) && e.every(as) || er(e) && !e)
    return {
      type: r,
      message: as(e) ? e : "",
      ref: n
    };
}
var Ii = (e) => ct(e) && !Fs(e) ? e : {
  value: e,
  message: ""
}, ab = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: N, name: S, valueAsNumber: w, mount: C } = e._f, g = Qe(r, S);
  if (!C || n.has(S))
    return {};
  const q = l ? l[0] : s, $ = (B) => {
    a && q.reportValidity && (q.setCustomValidity(er(B) ? "" : B || ""), q.reportValidity());
  }, E = {}, D = zp(s), z = co(s), Z = D || z, Q = (w || Vp(s)) && at(s.value) && at(g) || ws(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, te = e4.bind(null, S, i, E), Y = (B, R, H, ne = Mr.maxLength, ve = Mr.minLength) => {
    const de = B ? R : H;
    E[S] = {
      type: B ? ne : ve,
      message: de,
      ref: s,
      ...te(B ? ne : ve, de)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || At(g)) || er(g) && !g || z && !hS(l).isValid || D && !gS(l).isValid)) {
    const { value: B, message: R } = as(d) ? { value: !!d, message: d } : Ii(d);
    if (B && (E[S] = {
      type: Mr.required,
      message: R,
      ref: q,
      ...te(Mr.required, R)
    }, !i))
      return $(R), E;
  }
  if (!Q && (!At(f) || !At(h))) {
    let B, R;
    const H = Ii(h), ne = Ii(f);
    if (!At(g) && !isNaN(g)) {
      const ve = s.valueAsNumber || g && +g;
      At(H.value) || (B = ve > H.value), At(ne.value) || (R = ve < ne.value);
    } else {
      const ve = s.valueAsDate || new Date(g), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", fe = s.type == "week";
      $r(H.value) && g && (B = le ? de(g) > de(H.value) : fe ? g > H.value : ve > new Date(H.value)), $r(ne.value) && g && (R = le ? de(g) < de(ne.value) : fe ? g < ne.value : ve < new Date(ne.value));
    }
    if ((B || R) && (Y(!!B, H.message, ne.message, Mr.max, Mr.min), !i))
      return $(E[S].message), E;
  }
  if ((m || u) && !Q && ($r(g) || o && Array.isArray(g))) {
    const B = Ii(m), R = Ii(u), H = !At(B.value) && g.length > +B.value, ne = !At(R.value) && g.length < +R.value;
    if ((H || ne) && (Y(H, B.message, R.message), !i))
      return $(E[S].message), E;
  }
  if (k && !Q && $r(g)) {
    const { value: B, message: R } = Ii(k);
    if (Fs(B) && !g.match(B) && (E[S] = {
      type: Mr.pattern,
      message: R,
      ref: s,
      ...te(Mr.pattern, R)
    }, !i))
      return $(R), E;
  }
  if (N) {
    if (vr(N)) {
      const B = await N(g, r), R = ib(B, q);
      if (R && (E[S] = {
        ...R,
        ...te(Mr.validate, R.message)
      }, !i))
        return $(R.message), E;
    } else if (ct(N)) {
      let B = {};
      for (const R in N) {
        if (!Rt(B) && !i)
          break;
        const H = ib(await N[R](g, r), q, R);
        H && (B = {
          ...H,
          ...te(R, H.message)
        }, $(H.message), i && (E[S] = B));
      }
      if (!Rt(B) && (E[S] = {
        ref: q,
        ...B
      }, !i))
        return E;
    }
  }
  return $(!0), E;
};
const m4 = {
  mode: gr.onSubmit,
  reValidateMode: gr.onChange,
  shouldFocusError: !0
};
function p4(e = {}) {
  let n = {
    ...m4,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: vr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ct(n.defaultValues) || ct(n.values) ? jt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : jt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Yk(),
    state: Yk()
  }, k = eb(n.mode), N = eb(n.reValidateMode), S = n.criteriaMode === gr.all, w = (F) => (_) => {
    clearTimeout(m), m = setTimeout(F, _);
  }, C = async (F) => {
    if (!n.disabled && (u.isValid || f.isValid || F)) {
      const _ = n.resolver ? Rt((await Q()).errors) : await Y(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, g = (F, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((F || Array.from(l.mount)).forEach((T) => {
      T && (_ ? Jn(r.validatingFields, T, _) : yt(r.validatingFields, T));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Rt(r.validatingFields)
    }));
  }, q = (F, _ = [], T, G, J = !0, O = !0) => {
    if (G && T && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Qe(i, F))) {
        const U = T(Qe(i, F), G.argA, G.argB);
        J && Jn(i, F, U);
      }
      if (O && Array.isArray(Qe(r.errors, F))) {
        const U = T(Qe(r.errors, F), G.argA, G.argB);
        J && Jn(r.errors, F, U), d4(r.errors, F);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Qe(r.touchedFields, F))) {
        const U = T(Qe(r.touchedFields, F), G.argA, G.argB);
        J && Jn(r.touchedFields, F, U);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ea(a, o)), h.state.next({
        name: F,
        isDirty: R(F, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Jn(o, F, _);
  }, $ = (F, _) => {
    Jn(r.errors, F, _), h.state.next({
      errors: r.errors
    });
  }, E = (F) => {
    r.errors = F, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (F, _, T, G) => {
    const J = Qe(i, F);
    if (J) {
      const O = Qe(o, F, at(T) ? Qe(a, F) : T);
      at(O) || G && G.defaultChecked || _ ? Jn(o, F, _ ? O : Zk(J._f)) : ve(F, O), s.mount && C();
    }
  }, z = (F, _, T, G, J) => {
    let O = !1, U = !1;
    const ie = {
      name: F
    };
    if (!n.disabled) {
      if (!T || G) {
        (u.isDirty || f.isDirty) && (U = r.isDirty, r.isDirty = ie.isDirty = R(), O = U !== ie.isDirty);
        const pe = Xr(Qe(a, F), _);
        U = !!Qe(r.dirtyFields, F), pe ? yt(r.dirtyFields, F) : Jn(r.dirtyFields, F, !0), ie.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && U !== !pe;
      }
      if (T) {
        const pe = Qe(r.touchedFields, F);
        pe || (Jn(r.touchedFields, F, T), ie.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && pe !== T);
      }
      O && J && h.state.next(ie);
    }
    return O ? ie : {};
  }, Z = (F, _, T, G) => {
    const J = Qe(r.errors, F), O = (u.isValid || f.isValid) && er(_) && r.isValid !== _;
    if (n.delayError && T ? (d = w(() => $(F, T)), d(n.delayError)) : (clearTimeout(m), d = null, T ? Jn(r.errors, F, T) : yt(r.errors, F)), (T ? !Xr(J, T) : J) || !Rt(G) || O) {
      const U = {
        ...G,
        ...O && er(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: F
      };
      r = {
        ...r,
        ...U
      }, h.state.next(U);
    }
  }, Q = async (F) => {
    g(F, !0);
    const _ = await n.resolver(o, n.context, i4(F || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(F), _;
  }, te = async (F) => {
    const { errors: _ } = await Q(F);
    if (F)
      for (const T of F) {
        const G = Qe(_, T);
        G ? Jn(r.errors, T, G) : yt(r.errors, T);
      }
    else
      r.errors = _;
    return _;
  }, Y = async (F, _, T = {
    valid: !0
  }) => {
    for (const G in F) {
      const J = F[G];
      if (J) {
        const { _f: O, ...U } = J;
        if (O) {
          const ie = l.array.has(O.name), pe = J._f && a4(J._f);
          pe && u.validatingFields && g([G], !0);
          const ke = await ab(J, l.disabled, o, S, n.shouldUseNativeValidation && !_, ie);
          if (pe && u.validatingFields && g([G]), ke[O.name] && (T.valid = !1, _))
            break;
          !_ && (Qe(ke, O.name) ? ie ? u4(r.errors, ke, O.name) : Jn(r.errors, O.name, ke[O.name]) : yt(r.errors, O.name));
        }
        !Rt(U) && await Y(U, _, T);
      }
    }
    return T.valid;
  }, B = () => {
    for (const F of l.unMount) {
      const _ = Qe(i, F);
      _ && (_._f.refs ? _._f.refs.every((T) => !Uu(T)) : !Uu(_._f.ref)) && Le(F);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (F, _) => !n.disabled && (F && _ && Jn(o, F, _), !Xr(Ce(), a)), H = (F, _, T) => dS(F, l, {
    ...s.mount ? o : at(_) ? a : $r(F) ? { [F]: _ } : _
  }, T, _), ne = (F) => Qs(Qe(s.mount ? o : a, F, n.shouldUnregister ? Qe(a, F, []) : [])), ve = (F, _, T = {}) => {
    const G = Qe(i, F);
    let J = _;
    if (G) {
      const O = G._f;
      O && (!O.disabled && Jn(o, F, yS(_, O)), J = ws(O.ref) && At(_) ? "" : _, mS(O.ref) ? [...O.ref.options].forEach((U) => U.selected = J.includes(U.value)) : O.refs ? co(O.ref) ? O.refs.length > 1 ? O.refs.forEach((U) => (!U.defaultChecked || !U.disabled) && (U.checked = Array.isArray(J) ? !!J.find((ie) => ie === U.value) : J === U.value)) : O.refs[0] && (O.refs[0].checked = !!J) : O.refs.forEach((U) => U.checked = U.value === J) : Vp(O.ref) ? O.ref.value = "" : (O.ref.value = J, O.ref.type || h.state.next({
        name: F,
        values: jt(o)
      })));
    }
    (T.shouldDirty || T.shouldTouch) && z(F, J, T.shouldTouch, T.shouldDirty, !0), T.shouldValidate && be(F);
  }, de = (F, _, T) => {
    for (const G in _) {
      const J = _[G], O = `${F}.${G}`, U = Qe(i, O);
      (l.array.has(F) || ct(J) || U && !U._f) && !di(J) ? de(O, J, T) : ve(O, J, T);
    }
  }, le = (F, _, T = {}) => {
    const G = Qe(i, F), J = l.array.has(F), O = jt(_);
    Jn(o, F, O), J ? (h.array.next({
      name: F,
      values: jt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && T.shouldDirty && h.state.next({
      name: F,
      dirtyFields: Ea(a, o),
      isDirty: R(F, O)
    })) : G && !G._f && !At(O) ? de(F, O, T) : ve(F, O, T), tb(F, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? F : void 0,
      values: jt(o)
    });
  }, fe = async (F) => {
    s.mount = !0;
    const _ = F.target;
    let T = _.name, G = !0;
    const J = Qe(i, T), O = (U) => {
      G = Number.isNaN(U) || di(U) && isNaN(U.getTime()) || Xr(U, Qe(o, T, U));
    };
    if (J) {
      let U, ie;
      const pe = _.type ? Zk(J._f) : oS(F), ke = F.type === js.BLUR || F.type === js.FOCUS_OUT, en = !o4(J._f) && !n.resolver && !Qe(r.errors, T) && !J._f.deps || c4(ke, Qe(r.touchedFields, T), r.isSubmitted, N, k), mn = tb(T, l, ke);
      Jn(o, T, pe), ke ? (J._f.onBlur && J._f.onBlur(F), d && d(0)) : J._f.onChange && J._f.onChange(F);
      const rn = z(T, pe, ke), dn = !Rt(rn) || mn;
      if (!ke && h.state.next({
        name: T,
        type: F.type,
        values: jt(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? ke && C() : ke || C()), dn && h.state.next({ name: T, ...mn ? {} : rn });
      if (!ke && mn && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Q([T]);
        if (O(pe), G) {
          const ln = rb(r.errors, i, T), vn = rb(pn, i, ln.name || T);
          U = vn.error, T = vn.name, ie = Rt(pn);
        }
      } else
        g([T], !0), U = (await ab(J, l.disabled, o, S, n.shouldUseNativeValidation))[T], g([T]), O(pe), G && (U ? ie = !1 : (u.isValid || f.isValid) && (ie = await Y(i, !0)));
      G && (J._f.deps && be(J._f.deps), Z(T, ie, U, rn));
    }
  }, W = (F, _) => {
    if (Qe(r.errors, _) && F.focus)
      return F.focus(), 1;
  }, be = async (F, _ = {}) => {
    let T, G;
    const J = Ba(F);
    if (n.resolver) {
      const O = await te(at(F) ? F : J);
      T = Rt(O), G = F ? !J.some((U) => Qe(O, U)) : T;
    } else F ? (G = (await Promise.all(J.map(async (O) => {
      const U = Qe(i, O);
      return await Y(U && U._f ? { [O]: U } : U);
    }))).every(Boolean), !(!G && !r.isValid) && C()) : G = T = await Y(i);
    return h.state.next({
      ...!$r(F) || (u.isValid || f.isValid) && T !== r.isValid ? {} : { name: F },
      ...n.resolver || !F ? { isValid: T } : {},
      errors: r.errors
    }), _.shouldFocus && !G && qa(i, W, F ? J : l.mount), G;
  }, Ce = (F) => {
    const _ = {
      ...s.mount ? o : a
    };
    return at(F) ? _ : $r(F) ? Qe(_, F) : F.map((T) => Qe(_, T));
  }, K = (F, _) => ({
    invalid: !!Qe((_ || r).errors, F),
    isDirty: !!Qe((_ || r).dirtyFields, F),
    error: Qe((_ || r).errors, F),
    isValidating: !!Qe(r.validatingFields, F),
    isTouched: !!Qe((_ || r).touchedFields, F)
  }), qe = (F) => {
    F && Ba(F).forEach((_) => yt(r.errors, _)), h.state.next({
      errors: F ? r.errors : {}
    });
  }, Be = (F, _, T) => {
    const G = (Qe(i, F, { _f: {} })._f || {}).ref, J = Qe(r.errors, F) || {}, { ref: O, message: U, type: ie, ...pe } = J;
    Jn(r.errors, F, {
      ...pe,
      ..._,
      ref: G
    }), h.state.next({
      name: F,
      errors: r.errors,
      isValid: !1
    }), T && T.shouldFocus && G && G.focus && G.focus();
  }, Pe = (F, _) => vr(F) ? h.state.subscribe({
    next: (T) => F(H(void 0, _), T)
  }) : H(F, _, !0), Me = (F) => h.state.subscribe({
    next: (_) => {
      l4(F.name, _.name, F.exact) && s4(_, F.formState || u, Re, F.reRenderRoot) && F.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, je = (F) => (s.mount = !0, f = {
    ...f,
    ...F.formState
  }, Me({
    ...F,
    formState: f
  })), Le = (F, _ = {}) => {
    for (const T of F ? Ba(F) : l.mount)
      l.mount.delete(T), l.array.delete(T), _.keepValue || (yt(i, T), yt(o, T)), !_.keepError && yt(r.errors, T), !_.keepDirty && yt(r.dirtyFields, T), !_.keepTouched && yt(r.touchedFields, T), !_.keepIsValidating && yt(r.validatingFields, T), !n.shouldUnregister && !_.keepDefaultValue && yt(a, T);
    h.state.next({
      values: jt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: R() } : {}
    }), !_.keepIsValid && C();
  }, Te = ({ disabled: F, name: _ }) => {
    (er(F) && s.mount || F || l.disabled.has(_)) && (F ? l.disabled.add(_) : l.disabled.delete(_));
  }, an = (F, _ = {}) => {
    let T = Qe(i, F);
    const G = er(_.disabled) || er(n.disabled);
    return Jn(i, F, {
      ...T || {},
      _f: {
        ...T && T._f ? T._f : { ref: { name: F } },
        name: F,
        mount: !0,
        ..._
      }
    }), l.mount.add(F), T ? Te({
      disabled: er(_.disabled) ? _.disabled : n.disabled,
      name: F
    }) : D(F, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ta(_.min),
        max: Ta(_.max),
        minLength: Ta(_.minLength),
        maxLength: Ta(_.maxLength),
        pattern: Ta(_.pattern)
      } : {},
      name: F,
      onChange: fe,
      onBlur: fe,
      ref: (J) => {
        if (J) {
          an(F, _), T = Qe(i, F);
          const O = at(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, U = n4(O), ie = T._f.refs || [];
          if (U ? ie.find((pe) => pe === O) : O === T._f.ref)
            return;
          Jn(i, F, {
            _f: {
              ...T._f,
              ...U ? {
                refs: [
                  ...ie.filter(Uu),
                  O,
                  ...Array.isArray(Qe(a, F)) ? [{}] : []
                ],
                ref: { type: O.type, name: F }
              } : { ref: O }
            }
          }), D(F, !1, void 0, O);
        } else
          T = Qe(i, F, {}), T._f && (T._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(sS(l.array, F) && s.action) && l.unMount.add(F);
      }
    };
  }, we = () => n.shouldFocusError && qa(i, W, l.mount), Ke = (F) => {
    er(F) && (h.state.next({ disabled: F }), qa(i, (_, T) => {
      const G = Qe(i, T);
      G && (_.disabled = G._f.disabled || F, Array.isArray(G._f.refs) && G._f.refs.forEach((J) => {
        J.disabled = G._f.disabled || F;
      }));
    }, 0, !1));
  }, Ze = (F, _) => async (T) => {
    let G;
    T && (T.preventDefault && T.preventDefault(), T.persist && T.persist());
    let J = jt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: U } = await Q();
      r.errors = O, J = U;
    } else
      await Y(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Jn(J, O, void 0);
    if (yt(r.errors, "root"), Rt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await F(J, T);
      } catch (O) {
        G = O;
      }
    } else
      _ && await _({ ...r.errors }, T), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Rt(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, me = (F, _ = {}) => {
    Qe(i, F) && (at(_.defaultValue) ? le(F, jt(Qe(a, F))) : (le(F, _.defaultValue), Jn(a, F, jt(_.defaultValue))), _.keepTouched || yt(r.touchedFields, F), _.keepDirty || (yt(r.dirtyFields, F), r.isDirty = _.defaultValue ? R(F, jt(Qe(a, F))) : R()), _.keepError || (yt(r.errors, F), u.isValid && C()), h.state.next({ ...r }));
  }, he = (F, _ = {}) => {
    const T = F ? jt(F) : a, G = jt(T), J = Rt(F), O = J ? a : G;
    if (_.keepDefaultValues || (a = T), !_.keepValues) {
      if (_.keepDirtyValues) {
        const U = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ea(a, o))
        ]);
        for (const ie of Array.from(U))
          Qe(r.dirtyFields, ie) ? Jn(O, ie, Qe(o, ie)) : le(ie, Qe(O, ie));
      } else {
        if (Pp && at(F))
          for (const U of l.mount) {
            const ie = Qe(i, U);
            if (ie && ie._f) {
              const pe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (ws(pe)) {
                const ke = pe.closest("form");
                if (ke) {
                  ke.reset();
                  break;
                }
              }
            }
          }
        for (const U of l.mount)
          le(U, Qe(O, U));
      }
      o = jt(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: J ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Xr(F, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: J ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Ea(a, o) : r.dirtyFields : _.keepDefaultValues && F ? Ea(a, F) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (F, _) => he(vr(F) ? F(o) : F, _), Ae = (F, _ = {}) => {
    const T = Qe(i, F), G = T && T._f;
    if (G) {
      const J = G.refs ? G.refs[0] : G.ref;
      J.focus && (J.focus(), _.shouldSelect && vr(J.select) && J.select());
    }
  }, Re = (F) => {
    r = {
      ...r,
      ...F
    };
  }, Ue = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Ze,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: H,
      _getDirty: R,
      _setValid: C,
      _setFieldArray: q,
      _setDisabledField: Te,
      _setErrors: E,
      _getFieldArray: ne,
      _reset: he,
      _resetDefaultValues: () => vr(n.defaultValues) && n.defaultValues().then((F) => {
        Ie(F, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ke,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(F) {
        s = F;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(F) {
        l = F;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(F) {
        n = {
          ...n,
          ...F
        };
      }
    },
    subscribe: je,
    trigger: be,
    register: an,
    handleSubmit: Ze,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...Ue,
    formControl: Ue
  };
}
function f4(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: vr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: vr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : p4(e),
    formState: i
  }, e.formControl && e.defaultValues && !vr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Xr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Rt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = cS(i, o), n.current;
}
const h4 = "_settingsWrapper_1ycvy_1", y4 = "_settingsWrapperHeader_1ycvy_6", g4 = "_settingsWrapperContent_1ycvy_10", v4 = "_settingsWrapperContentCode_1ycvy_18", k4 = "_settingsWrapperContentCURL_1ycvy_26", $a = {
  settingsWrapper: h4,
  settingsWrapperHeader: y4,
  settingsWrapperContent: g4,
  settingsWrapperContentCode: v4,
  settingsWrapperContentCURL: k4
}, b4 = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = nr(), { control: o } = f4({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = uS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = tt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsx(tn, { span: 6, children: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", className: $a.settingsWrapper, children: [
    /* @__PURE__ */ ce.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: $a.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ ce.jsx(ue, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ ce.jsxs(
      b,
      {
        flexDirection: "column",
        className: $a.settingsWrapperContent,
        children: [
          /* @__PURE__ */ ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ce.jsx(
            Ts,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ ce.jsxs("ol", { children: [
                /* @__PURE__ */ ce.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ ce.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ ce.jsx("span", { className: $a.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ ce.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ ce.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ ce.jsx(
            Gk,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                sr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ ce.jsx(
            Gk,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                sr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
            /* @__PURE__ */ ce.jsx(Ln, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ ce.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: $a.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ ce.jsx(b, { alignContent: "start", children: /* @__PURE__ */ ce.jsx(
              Ge,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ ce.jsx(
                  Wn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, _4 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], x4 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ja
  }
], S4 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: b4
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], N4 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, j4 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, w4 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: CL,
  featureSettings: []
} : n ? {
  authSettings: FL,
  featureSettings: [...Lx]
} : e ? {
  authSettings: [
    ...sk,
    ...jL
  ],
  featureSettings: [...lk]
} : {
  authSettings: [
    ...sk,
    ...wL
  ],
  featureSettings: [...lk]
}, C4 = ({
  hasYotpoOAuth: e = !1,
  isCreationMode: n = !1
}) => e || n ? x4 : S4, vS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = j4(a?.value, r), s = i !== void 0 ? i : N4(
    r
  );
  return o !== void 0 ? o : s;
}, kS = (e = {
  SHOPIFY: {},
  YOTPO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r } = e, {
    authSettings: i,
    featureSettings: a
  } = w4(n), o = C4(r);
  return {
    SHOPIFY: {
      widget: Tz,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...i,
        ...a
      ]
    },
    JIRA: {
      widget: LF,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...th ? [...th] : []
      ]
    },
    GITHUB: {
      widget: BC,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...qC]
    },
    MIUROS: {
      widget: HP,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...WP]
    },
    KLAVIYO: {
      widget: XI,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...ZI]
    },
    LINEAR: {
      widget: NO,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...jO]
    },
    VOYADO: {
      widget: FU,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...IU]
    },
    LOYALTYLION: {
      widget: tP,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...rP]
    },
    RECHARGE: {
      widget: gA,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...vA]
    },
    BRAZE: {
      widget: ew,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...nw]
    },
    YOTPO: {
      widget: GU,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...o, ..._4]
    },
    INGRID: {
      widget: y1,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...g1]
    }
  };
}, F4 = (e) => {
  const n = kS();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      integrationKey: l
    }) => {
      const m = n[i], { settingsConfiguration: u } = m, f = u?.filter(({ secret: h }) => !h)?.map(
        ({
          key: h,
          type: k,
          defaultValue: N
        }) => ({
          key: h,
          value: vS({
            key: h,
            configuration: o,
            settingType: k,
            settingDefault: N
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: f,
        misconfigured: s,
        icon: m.icon,
        iconColors: m.iconColors,
        widget: m.widget,
        integrationKey: l
      };
    }
  );
}, jM = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d
}) => {
  const m = ui(
    {}
  ), u = ($) => (m.current[$] || (m.current[$] = { current: null }), m.current[$]), { track: f } = kn(), h = Kn(
    () => F4(e),
    [e]
  ), k = {
    headline: "",
    text: "",
    onConfirm: () => q(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, S] = se(k), [w, C] = se(!1), g = ($) => {
    C(!0), S($);
  }, q = () => {
    C(!1), S(k);
  };
  return /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    h.map(
      ({
        id: $,
        name: E,
        type: D,
        widget: z,
        settings: Z,
        misconfigured: Q,
        icon: te,
        iconColors: Y,
        integrationKey: B
      }, R) => {
        const H = `partner-integration-${D}`, ne = /* @__PURE__ */ ze.jsx(Fm, { icon: te, color: Y }), ve = Z?.reduce(
          (de, le) => (de[le.key] = le.value, de),
          {}
        );
        return s ? /* @__PURE__ */ ze.jsx("div", { className: "icon-holder", children: ne }, `partner-icon-${$}`) : /* @__PURE__ */ ze.jsxs(
          or,
          {
            onToggle: () => {
              f(
                o(B) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: $,
                  widgetType: D.toLowerCase()
                }
              ), a(B);
            },
            isOpen: o(B),
            className: H,
            containerRef: (de) => {
              u(B).current = de;
            },
            children: [
              /* @__PURE__ */ ze.jsx(
                or.Header,
                {
                  wrap: "normal",
                  avatar: ne,
                  slotBeforeTitle: d?.(
                    R,
                    u(B)
                  ),
                  slotAfterTitle: l?.(B),
                  children: E
                }
              ),
              /* @__PURE__ */ ze.jsx(or.Content, { children: Q ? /* @__PURE__ */ ze.jsx(Fn, { isMisconfigured: !0 }) : /* @__PURE__ */ ze.jsx(
                gb.Provider,
                {
                  value: {
                    onError: (de, le) => console.warn(
                      `Something went wrong with a partner widget of type '${D}' and id '${$}'`,
                      de,
                      le
                    )
                  },
                  children: /* @__PURE__ */ ze.jsx(
                    Xb,
                    {
                      integrationId: $,
                      type: D,
                      configuration: n,
                      showNotification: i,
                      showModal: g,
                      children: VS(z, {
                        conversationContext: r,
                        settings: ve
                      })
                    }
                  )
                }
              ) })
            ]
          },
          B
        );
      }
    ),
    /* @__PURE__ */ ze.jsx(
      Zb,
      {
        isOpen: w,
        setIsOpen: C,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            C(!1), S(k);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            C(!1), S(k);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, I4 = Zr`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function wM(e, { skip: n = !1 } = {}) {
  const [r, i] = se([]), [a, o] = se(!1);
  return He(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Qb(e).query({
      query: I4
    }).then(({ data: l }) => {
      s || (i(
        l?.Management?.widgetConfigurations?.map(
          (d) => ({
            ...d,
            integrationKey: `partner-integration-${d.id}`
          })
        ) ?? []
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const E4 = ({
  widgetConfiguration: e
}) => {
  const n = Kn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Kn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, T4 = "FULL_ACCESS", $4 = "2", D4 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [T4],
        version: $4
      })
    }).then((l) => l.json())
  };
}, R4 = "dixaApiToken", Up = "dixaApiTokenId", bS = "dixaApiTokenName", ob = (e) => [Up, bS].every(
  (r) => e.find((i) => i?.key === r)
);
function O4({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = P4(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const P4 = (e) => [
  {
    key: R4,
    value: e.value,
    secret: !0
  },
  {
    key: Up,
    value: e.id,
    secret: !1
  },
  {
    key: bS,
    value: e.name,
    secret: !1
  }
], A4 = Zr`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, L4 = Zr`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, V4 = Zr`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, z4 = Zr`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, U4 = "_wrapper_1lmim_1", M4 = "_wrapperBox_1lmim_4", B4 = "_wrapperBoxErrorBorder_1lmim_9", Mu = {
  wrapper: U4,
  wrapperBox: M4,
  wrapperBoxErrorBorder: B4
}, q4 = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (q) => q.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: k } = f, N = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${k.label.toLowerCase()}`, [w, C] = se({
    username: "",
    password: ""
  }), g = tt(
    (q) => {
      m({
        target: {
          name: s,
          value: q
        }
      });
    },
    [s, m]
  );
  return He(() => {
    g(
      w.username !== "" && w.password !== "" ? window.btoa(`${w.username}:${w.password}`) : ""
    );
  }, [w]), /* @__PURE__ */ ze.jsx(
    Ln,
    {
      required: e,
      label: a,
      meta: l,
      className: Mu.wrapper,
      children: /* @__PURE__ */ ze.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: ut(Mu.wrapperBox, {
            [Mu.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ ze.jsx(
              sr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: N,
                input: {
                  name: s,
                  value: w.username,
                  onChange: (q) => C({
                    username: q?.target.value ?? "",
                    password: w.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ ze.jsx(
              sr,
              {
                noAlert: !0,
                required: e,
                label: k.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: w.password,
                  onChange: (q) => C({
                    username: w.username,
                    password: q?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function sb({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: k,
  isCreationMode: N,
  prefix: S,
  integrationId: w,
  integrationType: C,
  configuration: g,
  settings: q,
  otherProps: $
}) {
  const E = k === "custom" && $?.component, D = u(n)?.value;
  return E ? /* @__PURE__ */ ze.jsx(
    E,
    {
      configuration: g,
      integrationId: w,
      integrationType: C,
      label: r,
      settings: q,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    /* @__PURE__ */ ze.jsx(tn, { span: 3, children: /* @__PURE__ */ ze.jsx(
      H4,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: N,
        children: k === "input" ? /* @__PURE__ */ ze.jsx(
          sr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: D,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !N && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : k === "basicAuthInput" ? /* @__PURE__ */ ze.jsx(
          q4,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: N,
            label: r,
            widgetSettingsKey: n,
            settings: q,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : k === "switch" ? /* @__PURE__ */ ze.jsx(Ln, { label: r, children: /* @__PURE__ */ ze.jsx(
          vb,
          {
            input: {
              name: n,
              value: "",
              checked: D,
              onChange: l
            }
          }
        ) }) : k === "select" ? /* @__PURE__ */ ze.jsx(Ln, { label: r, children: /* @__PURE__ */ ze.jsx(
          Yr,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (z) => d(n, z),
            getItemTitleByValue: (z) => z ? /* @__PURE__ */ ze.jsx(A.Paragraph, { children: z.label }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {}),
            value: D ? [
              {
                label: ($?.selectItems || []).find(
                  (z) => z.value === D
                )?.label,
                value: D
              }
            ] : [],
            equalityFn: (z, Z) => z.value === Z.value,
            children: ($?.selectItems || []).map((z) => /* @__PURE__ */ ze.jsx(ot.Item, { value: z, children: z.label }, z.value))
          }
        ) }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ ze.jsx(tn, { span: 3 })
  ] });
}
function H4({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ ze.jsx(Ln, { label: n, children: /* @__PURE__ */ ze.jsxs(
    Wn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ha = "partner-integrations-widget-name-form-field", lb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: vS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), W4 = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = ($) => i($), l = ($) => !$ || $ === "", d = ($) => {
    const { [$]: E, ...D } = a;
    o(D);
  }, m = ($) => ({
    ...$,
    settings: $.settings.filter(({ isEditing: E }) => E).map(({ key: E, value: D, secret: z }) => ({
      key: E,
      value: D,
      secret: z
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = ($) => {
    if (!$)
      return;
    const {
      target: { name: E, value: D }
    } = $;
    a[E] && !l(D) && d(E), i({
      ...r,
      settings: r.settings.map(
        (z) => z.key === E ? { ...z, value: D } : z
      )
    });
  }, h = ($) => {
    if (!$)
      return;
    const {
      target: { name: E, checked: D }
    } = $;
    i({
      ...r,
      settings: r.settings.map(
        (z) => z.key === E ? { ...z, value: D } : z
      )
    });
  }, k = ($, E) => {
    if (!E)
      return;
    const { selectedValues: D } = E, z = D?.[0];
    if (z) {
      const Z = r.settings.map(
        (Q) => Q.key === $ ? { ...Q, value: z?.value } : Q
      );
      i({
        ...r,
        settings: Z
      });
    } else {
      const Z = r.settings.filter(
        (Q) => Q.key !== $
      );
      i({
        ...r,
        settings: Z
      });
    }
  }, N = ($) => {
    i({
      ...r,
      enabled: $
    });
  }, S = ($) => {
    if (!$)
      return;
    const {
      target: { value: E }
    } = $;
    a[Ha] && !l(E) && d(Ha), i({
      ...r,
      name: E
    });
  }, w = ($, E) => {
    const { settings: D } = r, z = D.map((Z) => Z.key === E ? {
      ...Z,
      isEditing: $,
      ...!$ && { value: "" }
    } : Z);
    a[E] && !$ && d(E), i({
      ...r,
      settings: z
    });
  }, C = ($) => r.settings.find(
    (E) => E.key === $
  ), g = async ($) => {
    $.preventDefault(), q() && n(m(r));
  }, q = () => {
    const $ = {}, { name: E, settings: D } = r;
    return l(E) && ($[Ha] = u.input), D.forEach(
      ({ key: z, value: Z, required: Q, isEditing: te, type: Y, customValidation: B }) => {
        if (Q && te)
          if (B) {
            const R = B(Z);
            typeof R == "string" && ($[z] = R);
          } else
            typeof Z == "string" && l(Z) && ($[z] = u[Y]);
      }
    ), o($), !Object.keys($)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: N,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: k,
    handleEditSecret: w,
    handleChangeName: S,
    handleSubmit: g,
    getSettingValueByKey: C,
    initializeFormData: s,
    validate: q
  };
}, K4 = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], cb = "The configuration of the integration is not correct. Please check the settings.", G4 = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o
}) => {
  const { track: s } = kn(), { deleteDixaApiToken: l, createDixaApiToken: d } = D4({
    type: n,
    baseUrl: a.baseUrl
  }), u = i0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), f = !e && !!n && !!u, h = K4.includes(n), [k, N] = se(), [S, w] = se(!1), [C, g] = se(!1), [q, $] = se(!1), [E, D] = se(null), [z, Z] = se(), { isInboundOAuth: Q } = OS(), te = Q && f ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: Y,
    isShopifyMarketplaceApp: B,
    initialValuesForShopify: R
  } = E4({
    featureFlags: a.featureFlags,
    widgetConfiguration: z
  }), H = n === "YOTPO" && !!z?.additionalProperties?.isUsingOAuth, ne = f && n === "SHOPIFY", le = kS({
    SHOPIFY: {
      hasShopifyOAuth: Y,
      isShopifyMarketplaceApp: B,
      isCreationMode: f
    },
    YOTPO: {
      hasYotpoOAuth: H,
      isCreationMode: f
    }
  })[n].settingsConfiguration, fe = le.filter(({ type: Ue }) => Ue !== "hidden").filter(({ hideOnCreate: Ue }) => f ? !Ue : !0), W = fe.filter(
    ({ additionalProperties: Ue }) => Ue?.renderAboveForm === !0
  ), be = fe.filter(
    ({ additionalProperties: Ue }) => Ue?.renderAboveForm !== !0
  ), {
    error: Ce,
    loading: K,
    refetch: qe
  } = n0(A4, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (Ue) => {
      if (Object.keys(Ue).length === 0)
        $(!0);
      else {
        $(!1);
        const F = Ue?.Management?.widgetConfigurations[0];
        F && Z(F);
      }
    }
  }), [Be, { error: Pe }] = qp(
    f ? V4 : L4,
    {
      onError: (Ue) => {
        N(Ue), w(!1), i({
          title: "Something went wrong",
          text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ue) => {
        if (w(!1), Object.keys(Ue).length !== 0) {
          if (f && r(Ue?.Management?.createWidgetConfiguration?.id), !f) {
            const F = Ue?.Management?.updateWidgetConfiguration;
            F.misconfigured ? D(
              F?.misconfigurationCause ?? cb
            ) : D(null);
          }
          i({
            title: `${f ? "Creating" : "Updating"} was successful`,
            text: `${f ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Me] = qp(z4, {
    onError: (Ue) => {
      N(Ue), w(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      w(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: je,
    handleIsEnabled: Le,
    errors: Te,
    handleChangeText: an,
    handleChangeBoolean: we,
    handleChangeSelect: Ke,
    handleEditSecret: Ze,
    handleChangeName: me,
    handleSubmit: he,
    getSettingValueByKey: Ie,
    initializeFormData: Ae
  } = W4({
    onSubmit: async (Ue) => {
      f ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), w(!0);
      const F = Ue.settings.map(
        (J) => typeof J.value == "boolean" ? { ...J, value: J.value.toString() } : J
      ), _ = ob(F) && f;
      let T = [];
      if (_) {
        const J = await d().catch(
          (O) => {
            w(!1), console.warn("API-Token (creation) error resonse", O), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        J?.data && (T = O4({
          token: J.data,
          settings: F
        }));
      }
      const G = {
        ...Ue,
        settings: [
          ...T.length > 0 ? T : F
        ]
      };
      (_ && T.length > 1 || !_ && T.length === 0) && (Be({
        variables: {
          ...!f && { id: e },
          ...f && { type: n },
          ...G
        }
      }), F.forEach(
        (J) => J.secret && Ze(!1, J.key)
      ));
    },
    ...f && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: lb({
          settingsFromBackend: R,
          settingsConfiguration: le,
          creating: !0
        })
      }
    }
  });
  He(() => {
    if (z) {
      const Ue = lb({
        settingsFromBackend: z.settings,
        settingsConfiguration: le
      });
      Ae({
        enabled: !!z.enabled,
        name: z.name,
        settings: Ue
      }), z.misconfigured ? D(
        z?.misconfigurationCause ?? cb
      ) : D(null);
    }
  }, [z]);
  const Re = Kn(() => o ? !o.isCoupled : !0, [o]);
  return Ce || Pe || k ? /* @__PURE__ */ ze.jsx(
    Fn,
    {
      error: Ce || k,
      retry: Ce ? qe : void 0
    }
  ) : S || K ? /* @__PURE__ */ ze.jsx(cn, { "data-testid": "widget-settings-loading" }) : q ? /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ ze.jsx(Pn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ ze.jsxs("form", { children: [
    E && /* @__PURE__ */ ze.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ze.jsx(
      Ts,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ ze.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ ze.jsx(A.Paragraph, { children: E }),
          /* @__PURE__ */ ze.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ ze.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ ze.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ ze.jsxs(
      Ut,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          W.map(
            ({ key: Ue, label: F, ..._ }) => /* @__PURE__ */ ze.jsx(
              sb,
              {
                widgetSettingsKey: Ue,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: Ie,
                isSecret: !1,
                label: F,
                placeholder: "",
                required: !1,
                errors: Te,
                type: "custom",
                isCreationMode: f,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: le,
                otherProps: _
              },
              Ue
            )
          ),
          !ne && /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
            /* @__PURE__ */ ze.jsx(tn, { children: /* @__PURE__ */ ze.jsx(Ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ze.jsx(
              vb,
              {
                input: {
                  name: "enabled",
                  checked: je.enabled,
                  value: "dummy",
                  onChange: (Ue) => Le(Ue.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ ze.jsx(tn, { span: 3, children: /* @__PURE__ */ ze.jsx(
              sr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Ha,
                  value: je.name,
                  onChange: me
                },
                meta: {
                  error: Te[Ha]
                }
              }
            ) }),
            /* @__PURE__ */ ze.jsx(tn, { span: 3 })
          ] }),
          be?.map(
            ({
              key: Ue,
              secret: F,
              label: _,
              placeholder: T = "",
              required: G = !1,
              type: J,
              prefix: O,
              readOnly: U,
              ...ie
            }) => {
              const { settings: pe } = je, ke = pe.find(
                (en) => en.key === Ue
              );
              return /* @__PURE__ */ ze.jsx(zS, { children: /* @__PURE__ */ ze.jsx(
                sb,
                {
                  widgetSettingsKey: Ue,
                  isEditingField: !!ke?.isEditing,
                  handleEditSecret: Ze,
                  handleChangeText: an,
                  handleChangeBoolean: we,
                  handleChangeSelect: Ke,
                  getValueByKey: Ie,
                  isSecret: F,
                  label: _,
                  placeholder: T,
                  required: G,
                  errors: Te,
                  type: J,
                  isCreationMode: f,
                  prefix: O,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: U,
                  settings: le,
                  otherProps: ie
                }
              ) }, Ue);
            }
          )
        ]
      }
    ),
    !ne && /* @__PURE__ */ ze.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ ze.jsx(Wn, { onClick: he, children: te }),
      !f && /* @__PURE__ */ ze.jsx(
        Ge,
        {
          content: "The widget is used in automations",
          disabled: Re,
          children: /* @__PURE__ */ ze.jsx(
            Wn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && s("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), g(!0);
              },
              disabled: !Re,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ ze.jsx(
      Zb,
      {
        isOpen: C,
        setIsOpen: g,
        confirmVariant: h ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), ob(je.settings)) {
            const Ue = je.settings.find(
              ({ key: F }) => F === Up
            )?.value;
            Ue && l(Ue).catch((F) => {
              console.warn("API-Token (deletion) error response", F), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Me({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ ze.jsx(b, { children: h ? /* @__PURE__ */ ze.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ ze.jsx(
            ue,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ ze.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ ze.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              je.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          je.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, CM = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o
}) => /* @__PURE__ */ ze.jsx(
  gb.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ ze.jsx(
      Xb,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ ze.jsx(
          G4,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o
          }
        )
      }
    )
  }
), db = "__PairingContext__", _S = globalThis[db] ?? (() => {
  const e = yb({});
  return globalThis[db] = e, e;
})(), FM = () => wm(_S), IM = ({
  value: e,
  children: n
}) => /* @__PURE__ */ ze.jsx(_S.Provider, { value: e, children: n });
var Mo = { exports: {} }, ub;
function Y4() {
  if (ub) return Mo.exports;
  ub = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(E, D, z) {
    return Function.prototype.apply.call(E, D, z);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(E) {
    return Object.getOwnPropertyNames(E).concat(Object.getOwnPropertySymbols(E));
  } : r = function(E) {
    return Object.getOwnPropertyNames(E);
  };
  function i($) {
    console && console.warn && console.warn($);
  }
  var a = Number.isNaN || function(E) {
    return E !== E;
  };
  function o() {
    o.init.call(this);
  }
  Mo.exports = o, Mo.exports.once = C, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l($) {
    if (typeof $ != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof $);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function($) {
      if (typeof $ != "number" || $ < 0 || a($))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + $ + ".");
      s = $;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(E) {
    if (typeof E != "number" || E < 0 || a(E))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + E + ".");
    return this._maxListeners = E, this;
  };
  function d($) {
    return $._maxListeners === void 0 ? o.defaultMaxListeners : $._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(E) {
    for (var D = [], z = 1; z < arguments.length; z++) D.push(arguments[z]);
    var Z = E === "error", Q = this._events;
    if (Q !== void 0)
      Z = Z && Q.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var te;
      if (D.length > 0 && (te = D[0]), te instanceof Error)
        throw te;
      var Y = new Error("Unhandled error." + (te ? " (" + te.message + ")" : ""));
      throw Y.context = te, Y;
    }
    var B = Q[E];
    if (B === void 0)
      return !1;
    if (typeof B == "function")
      n(B, this, D);
    else
      for (var R = B.length, H = N(B, R), z = 0; z < R; ++z)
        n(H[z], this, D);
    return !0;
  };
  function m($, E, D, z) {
    var Z, Q, te;
    if (l(D), Q = $._events, Q === void 0 ? (Q = $._events = /* @__PURE__ */ Object.create(null), $._eventsCount = 0) : (Q.newListener !== void 0 && ($.emit(
      "newListener",
      E,
      D.listener ? D.listener : D
    ), Q = $._events), te = Q[E]), te === void 0)
      te = Q[E] = D, ++$._eventsCount;
    else if (typeof te == "function" ? te = Q[E] = z ? [D, te] : [te, D] : z ? te.unshift(D) : te.push(D), Z = d($), Z > 0 && te.length > Z && !te.warned) {
      te.warned = !0;
      var Y = new Error("Possible EventEmitter memory leak detected. " + te.length + " " + String(E) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Y.name = "MaxListenersExceededWarning", Y.emitter = $, Y.type = E, Y.count = te.length, i(Y);
    }
    return $;
  }
  o.prototype.addListener = function(E, D) {
    return m(this, E, D, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(E, D) {
    return m(this, E, D, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f($, E, D) {
    var z = { fired: !1, wrapFn: void 0, target: $, type: E, listener: D }, Z = u.bind(z);
    return Z.listener = D, z.wrapFn = Z, Z;
  }
  o.prototype.once = function(E, D) {
    return l(D), this.on(E, f(this, E, D)), this;
  }, o.prototype.prependOnceListener = function(E, D) {
    return l(D), this.prependListener(E, f(this, E, D)), this;
  }, o.prototype.removeListener = function(E, D) {
    var z, Z, Q, te, Y;
    if (l(D), Z = this._events, Z === void 0)
      return this;
    if (z = Z[E], z === void 0)
      return this;
    if (z === D || z.listener === D)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[E], Z.removeListener && this.emit("removeListener", E, z.listener || D));
    else if (typeof z != "function") {
      for (Q = -1, te = z.length - 1; te >= 0; te--)
        if (z[te] === D || z[te].listener === D) {
          Y = z[te].listener, Q = te;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? z.shift() : S(z, Q), z.length === 1 && (Z[E] = z[0]), Z.removeListener !== void 0 && this.emit("removeListener", E, Y || D);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(E) {
    var D, z, Z;
    if (z = this._events, z === void 0)
      return this;
    if (z.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : z[E] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete z[E]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(z), te;
      for (Z = 0; Z < Q.length; ++Z)
        te = Q[Z], te !== "removeListener" && this.removeAllListeners(te);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (D = z[E], typeof D == "function")
      this.removeListener(E, D);
    else if (D !== void 0)
      for (Z = D.length - 1; Z >= 0; Z--)
        this.removeListener(E, D[Z]);
    return this;
  };
  function h($, E, D) {
    var z = $._events;
    if (z === void 0)
      return [];
    var Z = z[E];
    return Z === void 0 ? [] : typeof Z == "function" ? D ? [Z.listener || Z] : [Z] : D ? w(Z) : N(Z, Z.length);
  }
  o.prototype.listeners = function(E) {
    return h(this, E, !0);
  }, o.prototype.rawListeners = function(E) {
    return h(this, E, !1);
  }, o.listenerCount = function($, E) {
    return typeof $.listenerCount == "function" ? $.listenerCount(E) : k.call($, E);
  }, o.prototype.listenerCount = k;
  function k($) {
    var E = this._events;
    if (E !== void 0) {
      var D = E[$];
      if (typeof D == "function")
        return 1;
      if (D !== void 0)
        return D.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function N($, E) {
    for (var D = new Array(E), z = 0; z < E; ++z)
      D[z] = $[z];
    return D;
  }
  function S($, E) {
    for (; E + 1 < $.length; E++)
      $[E] = $[E + 1];
    $.pop();
  }
  function w($) {
    for (var E = new Array($.length), D = 0; D < E.length; ++D)
      E[D] = $[D].listener || $[D];
    return E;
  }
  function C($, E) {
    return new Promise(function(D, z) {
      function Z(te) {
        $.removeListener(E, Q), z(te);
      }
      function Q() {
        typeof $.removeListener == "function" && $.removeListener("error", Z), D([].slice.call(arguments));
      }
      q($, E, Q, { once: !0 }), E !== "error" && g($, Z, { once: !0 });
    });
  }
  function g($, E, D) {
    typeof $.on == "function" && q($, "error", E, D);
  }
  function q($, E, D, z) {
    if (typeof $.on == "function")
      z.once ? $.once(E, D) : $.on(E, D);
    else if (typeof $.addEventListener == "function")
      $.addEventListener(E, function Z(Q) {
        z.once && $.removeEventListener(E, Z), D(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof $);
  }
  return Mo.exports;
}
var J4 = Y4();
function EM() {
  const e = new J4.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  Sj as GraphQLClientProvider,
  Zb as IntegrationModal,
  _S as PairingContext,
  IM as PairingProvider,
  jM as PartnerIntegrations,
  CM as PartnerIntegrationsSettings,
  V4 as createWidgetConfigurationMutation,
  z4 as deleteWidgetConfigurationMutation,
  A4 as getWidgetConfigurationByIdQuery,
  kS as getWidgetDefinitions,
  EM as initializePartnerEventEmitter,
  L4 as updateWidgetConfigurationMutation,
  FM as usePairing,
  wM as usePartnerIntegrationWidgetConfigurations,
  E4 as useShopifyConfiguration
};
